/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "./";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 46);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(53);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(71);

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return path; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return report; });
/* unused harmony export asmItemPath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return loginPath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return storeImagePath; });
// const path = "./api/ajax/living_our_values.php";
// const mail = "./api/ajax/lovmailer.php";
// const report = "./api/ajax/Order_Report.php";
// const asmItemPath = "./api/ajax/asmPrizeCreate.php";
var path="https://mykeysatgf.com/api/ajax/living_our_values.php";var mail="https://mykeysatgf.com/api/ajax/lovmailer.php";var report="https://mykeysatgf.com/api/ajax/Order_Report.php";var asmItemPath="https://mykeysatgf.com/api/ajax/asmPrizeCreate.php";var loginPath="https://mykeysatgf.com/api/ajax/handle_login.php";var storeImagePath="https://mykeysatgf.com";// const path = "http://localhost/gf_work/LOV-ASM-Tool/backend/api/ajax/living_our_values.php";
// const mail = "http://localhost/gf_work/LOV-ASM-Tool/backend/api/ajax/lovmailer.php";
// const report = "http://localhost/gf_work/LOV-ASM-Tool/backend/api/ajax/Order_Report.php";
// const asmItemPath = "http://localhost/gf_work/LOV-ASM-Tool/backend/api/ajax/asmPrizeCreate.php";
// const loginPath = "http://localhost/gf_work/LOV-ASM-Tool/backend/api/ajax/handle_login.php";
// const storeImagePath = "https://mykeysatgf.com";


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Modal = __webpack_require__(113);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Modal2.default;
module.exports = exports["default"];

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SelectBox=function(_Component){_inherits(SelectBox,_Component);function SelectBox(props){_classCallCheck(this,SelectBox);var _this=_possibleConstructorReturn(this,(SelectBox.__proto__||Object.getPrototypeOf(SelectBox)).call(this,props));_this.handleChoice=_this.handleChoice.bind(_this);return _this;}_createClass(SelectBox,[{key:'handleChoice',value:function handleChoice(e){//method for handling user selection/change
var choice=e.target.value;this.props.onSelect(this.props.identity,choice);}},{key:'render',value:function render(){var disable=void 0;if(this.props.disable){disable=true;}else{disable=false;}var options=this.props.options;var firstOp=void 0;if(this.props.type!=="text"){//optional prop type allows for first disabled option to be something other than "Select"
firstOp=this.props.type;}else{firstOp="Select";}var select=options.map(function(options,i){//map out options
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:options},options);});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:this.props.styles,onChange:this.handleChoice,value:this.props.val,disabled:disable},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{disabled:true},firstOp),select));}}]);return SelectBox;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SelectBox);SelectBox.defaultProps={type:'text'};SelectBox.propTypes={disable:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,options:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,type:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,val:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),onSelect:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,styles:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,identity:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__container_Validation_js__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Input=function(_Component){_inherits(Input,_Component);function Input(props){_classCallCheck(this,Input);var _this=_possibleConstructorReturn(this,(Input.__proto__||Object.getPrototypeOf(Input)).call(this,props));_this.handleChange=_this.handleChange.bind(_this);_this.handleNumber=_this.handleNumber.bind(_this);return _this;}_createClass(Input,[{key:'handleChange',value:function handleChange(e){var input=e.target.value;this.props.onInput(this.props.identity,input);}},{key:'handleNumber',value:function handleNumber(e){var input=e.target.value;if(this.props.identity!=="price"&&Object(__WEBPACK_IMPORTED_MODULE_2__container_Validation_js__["a" /* default */])("posInteger",input)){input=input.replace(/\-/g,"");if(this.props.identity!=="price"){input=input.replace(/\./g,"");}var validInput=input===''?input:Number(input);this.props.onInput(this.props.identity,validInput);}else if(this.props.identity==="price"&&/^(\s*|[0]{1}|[1-9][0-9]*)(\.\d{0,2})?$/.test(input)){input=input.replace(/\-/g,"");var _validInput=input;this.props.onInput(this.props.identity,_validInput);}}},{key:'render',value:function render(){var textBox=void 0;if(this.props.type==="area"){textBox=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{className:this.props.styles,maxLength:'1000',onChange:this.handleChange,id:this.props.id,value:this.props.val,placeholder:this.props.placeholder});}else if(this.props.type==="number"){textBox=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:this.props.inputStyle,placeholder:this.props.placeholder,type:'text',id:this.props.id,onChange:this.handleNumber,value:this.props.val});}else if(this.props.type==="file"){textBox=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:this.props.inputStyle,placeholder:this.props.placeholder,type:'file',id:this.props.id,onChange:this.handleChange,value:this.props.val});}else if(this.props.type==="password"){textBox=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:this.props.inputStyle,onKeyDown:this.props.onKeyDown,placeholder:this.props.placeholder,type:'password',id:this.props.id,onChange:this.handleChange,value:this.props.val});}else{textBox=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:this.props.inputStyle,placeholder:this.props.placeholder,type:'text',id:this.props.id,onChange:this.handleChange,value:this.props.val});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:this.props.boxStyle},textBox);}}]);return Input;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Input);Input.defaultProps={type:'text'};Input.propTypes={type:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,val:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,palceholder:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,styles:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,inputStyle:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,handleChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,handleNumber:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Validation;
function Validation(name,value){var regex={'name':/^(?!\s)(?!.*\s$)(?=.*[a-zA-Z])[a-zA-Z '~?!@]{2,}$/g,//'lastName' : /^(?!\s)(?!.*\s$)(?=.*[a-zA-Z0-9])[a-zA-Z0-9 '~?!@]{2,}$/g,
'email':/^[a-zA-Z0-9](\.?[a-zA-Z0-9_-]){0,}@[A-Za-z0-9-]+\.([A-Za-z]{1,6}\.)?[a-zA-Z]{2,6}$/g,'uname':/^(?!\s)(?!.*\s$)(?=.*[a-zA-Z0-9])[a-zA-Z0-9~!@#$%^&*-_+=?.]{2,}$/g,'pword':/^(?!\s)(?!.*\s$)(?=.*[a-zA-Z0-9])[a-zA-Z0-9~!@#$%^&*-_+=?.]{2,}$/g,'answer1':/^(?!\s)(?!.*\s$)(?=.*[a-zA-Z0-9])[a-zA-Z0-9 '\s.#/$%@&)(^\-,!]{2,}$/g,'answer2':/^(?!\s)(?!.*\s$)(?=.*[a-zA-Z0-9])[a-zA-Z0-9 '\s.#/$%@&)(^\-,!]{2,}$/g,'projectname':/^(?!\s)(?!.*\s$)(?=[a-zA-Z0-9]*)[a-zA-Z0-9 ')(}{~!@#$^\-_+=]{2,}$/g,'projectcontact1':/^(?!\s)(?!.*\s$)(?=.*[a-zA-Z0-9])[a-zA-Z0-9 '~?!@]{2,}$/g,'projectcontactcompany':/^(?!\s)(?!.*\s$)(?=.*[a-zA-Z0-9])[a-zA-Z0-9 '~?!@]{2,}$/g,'projectcontactemail':/^[a-zA-Z0-9](\.?[a-zA-Z0-9_-]){0,}@[A-Za-z0-9-]+\.([A-Za-z]{1,6}\.)?[a-zA-Z]{2,6}$/g,'projectcontactphone':/^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/g,'pageRange':/^(([ 0-9]|\-[0-9]+)+(?!\s;$)(;?)){1,}$/g,'noPic':/^sizes:[A-Za-z]{1,}(,{1}[A-Za-z]{1,})*;{1}colors:[A-Za-z]{1,}(,{1}[A-Za-z]{1,})*$/,'color':/^[A-Za-z\s]{1,}$/,'size':/^[A-Za-z0-9]{1,}(,{1}\s*[A-Za-z0-9]{1,})*$/,// 'date' : /^\d{2}\/\d{2}\/\d{4}$/,
'date':/^((0?[13578]|10|12)(-|\/)(([1-9])|(0[1-9])|([12])([0-9]?)|(3[01]?))(-|\/)((19)([2-9])(\d{1})|(20)([012])(\d{1})|([89012])(\d{1}))|(0?[2469]|11)(-|\/)(([1-9])|(0[1-9])|([12])([0-9]?)|(3[0]?))(-|\/)((19)([2-9])(\d{1})|(20)([012])(\d{1})|([89012])(\d{1})))$/g,'reason':/^(?=.*[a-zA-Z0-9\s])[a-zA-Z0-9 '\s.#/$%:*@&)(^\-,!`~_=+{}\[\]\\|"><?]{2,}$/g,'prize':/^(?=.*[a-zA-Z0-9\s])[a-zA-Z0-9 '\*\.\-,#$%]{2,}$/g,'posInteger':/^(\s*|[0]|[1-9][0-9]*)$/,'callcenter':/^(\s*|[a-zA-Z0-9]*)$/g,'department':/^(\s*|[a-zA-Z]{1,}(((\-?[a-zA-Z]+)*|(\/?[a-zA-Z]+)*)?|[a-zA-Z]*))$/g,'street_address':/[\w',-\\/.\s#]{5,}/g,'city':/^([a-zA-Z\u0080-\u024F]+(?:. |-| |'))*[a-zA-Z\u0080-\u024F]*$/,'zipcode':/^\d{5}(?:[- ]\d{4})?$/};if(name in regex){return regex[name].test(value);}else{return true;}}

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(63)();
}


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/loader.f88f2976.gif";

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(25);

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/sparkles2.43f58c92.png";

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Submit=function(_Component){_inherits(Submit,_Component);function Submit(props){_classCallCheck(this,Submit);var _this=_possibleConstructorReturn(this,(Submit.__proto__||Object.getPrototypeOf(Submit)).call(this,props));_this.clickHandle=_this.clickHandle.bind(_this);return _this;}_createClass(Submit,[{key:'clickHandle',value:function clickHandle(e){//method for handling button click
this.props.onClick(this.props.identity);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:this.props.styles,onClick:this.clickHandle,disabled:this.props.disable},this.props.name));}}]);return Submit;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Submit);Submit.propTypes={onClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,disable:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool])};

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TableHead=function(_Component){_inherits(TableHead,_Component);function TableHead(){_classCallCheck(this,TableHead);return _possibleConstructorReturn(this,(TableHead.__proto__||Object.getPrototypeOf(TableHead)).apply(this,arguments));}_createClass(TableHead,[{key:'render',value:function render(){var _this2=this;var heads=this.props.columns;var header=heads.map(function(heads){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{key:heads,className:_this2.props.headstyle},heads);});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'br3'},header);}}]);return TableHead;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (TableHead);TableHead.propTypes={columns:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,headstyle:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(54);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NavButton=function(_Component){_inherits(NavButton,_Component);function NavButton(props){_classCallCheck(this,NavButton);var _this=_possibleConstructorReturn(this,(NavButton.__proto__||Object.getPrototypeOf(NavButton)).call(this,props));_this.handleClick=_this.handleClick.bind(_this);return _this;}_createClass(NavButton,[{key:'handleClick',value:function handleClick(e){//method for handling navbutton click
if(typeof this.props.onClick==='function'){var theName=this.props.name.replace(/\s/g,"_");this.props.onClick(theName,this.props.type);}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{style:{minHeight:'100%',marginTop:'0',marginBottom:'0'},className:this.props.styles,onClick:this.handleClick,disabled:this.props.disable},this.props.name));}}]);return NavButton;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (NavButton);NavButton.propTypes={styles:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,onClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__asset_img_remove_png__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__asset_img_remove_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__asset_img_remove_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__container_Validation_js__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TableData=function(_Component){_inherits(TableData,_Component);function TableData(props){_classCallCheck(this,TableData);var _this=_possibleConstructorReturn(this,(TableData.__proto__||Object.getPrototypeOf(TableData)).call(this,props));_this.inputChange=_this.inputChange.bind(_this);_this.buttonClick=_this.buttonClick.bind(_this);_this.state={columns:[],quantity:''};return _this;}_createClass(TableData,[{key:'inputChange',value:function inputChange(id){var value=this.state.quantity;if(value===''){value=0;}value=Number(value);this.props.change(id,value);}},{key:'handleInput',value:function handleInput(value){if(Object(__WEBPACK_IMPORTED_MODULE_2__container_Validation_js__["a" /* default */])("posInteger",value)){if(this.props.app==="lov"){this.setState({quantity:value});}else{if(value<=this.props.itemqty){this.setState({quantity:value});}else{this.setState({quantity:this.props.itemqty});}}}}},{key:'buttonClick',value:function buttonClick(item){this.props.remove(item);}},{key:'componentDidMount',value:function componentDidMount(){this.setState({columns:this.props.columns},function(){var _this2=this;if(this.props.type==="cart"){var cols=this.props.columns;Object.keys(cols).forEach(function(col){if(cols[col]===cols.quantity){_this2.setState({quantity:cols[col]});}});}});}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){var _this3=this;if(prevProps.columns!==this.props.columns){this.setState({columns:this.props.columns});if(this.props.type==="cart"){var cols=this.props.columns;Object.keys(cols).forEach(function(col){if(cols[col]===cols.quantity){_this3.setState({quantity:cols[col]});}});}}}},{key:'render',value:function render(){var _this4=this;var removeButton={backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_1__asset_img_remove_png___default.a+')',backgroundRepeat:'no-repeat',backgroundPosition:'center',backgroundSize:'contain',minWidth:'30px',minHeight:'24px'};var button=void 0;if(this.props.type==="cart"){button=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'tc bb pt1 pb1 b--silver'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{style:removeButton,className:'bg-white br2',id:this.props.id,onClick:function onClick(e){return _this4.buttonClick(e.target.id);}}));}var cols=this.state.columns;var tdata=Object.keys(cols).map(function(col,i){if(cols[col]===cols.quantity&&_this4.props.type==="cart"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:i,className:'tc mw2 bb pt1 pb1 b--silver'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{value:_this4.state.quantity,type:'text',id:_this4.props.id,onBlur:function onBlur(e){return _this4.inputChange(e.target.id);},onChange:function onChange(e){return _this4.handleInput(e.target.value);},className:'ma0 mw-100 w-50 center tc'}));}else{var text=cols[col];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:i,className:_this4.props.cellstyle,style:{maxWidth:'400px',wordWrap:'break-word'}},text);}});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:this.props.rowstyle},tdata,button);}}]);return TableData;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (TableData);

/***/ }),
/* 16 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(9);
var normalizeHeaderName = __webpack_require__(76);
var enhanceError = __webpack_require__(28);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(29);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(29);
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data) || (headers && headers['Content-Type'] === 'application/json')) {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw enhanceError(e, this, 'E_JSON_PARSE');
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canUseDOM = undefined;

var _exenv = __webpack_require__(118);

var _exenv2 = _interopRequireDefault(_exenv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EE = _exenv2.default;

var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};

var canUseDOM = exports.canUseDOM = EE.canUseDOM;

exports.default = SafeHTMLElement;

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Searchable=function(_Component){_inherits(Searchable,_Component);function Searchable(props){_classCallCheck(this,Searchable);var _this=_possibleConstructorReturn(this,(Searchable.__proto__||Object.getPrototypeOf(Searchable)).call(this,props));_this.state={has_focus:false,multi_selected:[]};_this.generateResults=_this.generateResults.bind(_this);_this.handleChange=_this.handleChange.bind(_this);_this.handleSelect=_this.handleSelect.bind(_this);_this.onFocus=_this.onFocus.bind(_this);_this.listToggle=_this.listToggle.bind(_this);_this.onFocusOut=_this.onFocusOut.bind(_this);return _this;}_createClass(Searchable,[{key:'handleChange',value:function handleChange(e){this.props.handleChange(e.target.value);}},{key:'handleSelect',value:function handleSelect(e){e.persist();if(!this.props.multiSelect){this.setState({has_focus:false});}this.props.handleSelect(e.target.textContent);}},{key:'onFocus',value:function onFocus(e){e.stopPropagation();if(!this.state.has_focus){this.setState({has_focus:true});}}},{key:'listToggle',value:function listToggle(){this.setState({has_focus:!this.state.has_focus});}},{key:'onFocusOut',value:function onFocusOut(e){if(this.props.onFocusOut){this.props.onFocusOut(e,this);}else if(this.state.has_focus){this.setState({has_focus:false});}}},{key:'componentDidMount',value:function componentDidMount(){window.addEventListener('click',this.onFocusOut);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('click',this.onFocusOut);}},{key:'generateResults',value:function generateResults(){var _this2=this;var results_list=void 0;if(this.state.has_focus){var props=this.props;var results=void 0;if(this.props.value&&this.props.value.length>1){var val=this.props.value.toString();var pattern=props.caseSensitive?new RegExp('^'+val):new RegExp('^'+val,'i');results=props.options.map(function(option,i){if(option.toString().match(pattern)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:i,index:i,value:option,onClick:_this2.handleSelect,className:props.listItemClass},option);}});}else{results=props.options.map(function(option,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:i,index:i,value:option,onClick:_this2.handleSelect,className:props.listItemClass},option);});}var top=props.style.input.height||'2rem';var zIndex=this.state.has_focus?'2':'0';var list_width=props.style.input.width||'100%';var list_container_style={margin:'0',backgroundColor:props.style.list.backgroundColor,padding:'15px',border:'1px solid gray',broderTop:'0',borderRadius:'2px 2px 5px 5px',position:'absolute',top:top,width:list_width,zIndex:zIndex};results_list=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:list_container_style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{style:props.style.list},results));}return results_list;}},{key:'render',value:function render(){var props=this.props;var results=this.generateResults();var inputStyle=Object.assign({},props.style.input);var itemClass=props.listItemClass;var zIndex=this.state.has_focus?'2':'0';var disabled=this.props.disabled?true:false;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:props.containerId,style:{position:'relative',width:props.style.input.width},onClick:this.onFocus},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{position:'relative',height:props.style.input.height,width:props.style.input.width}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'search',id:props.inputId,style:inputStyle,onChange:this.handleChange,onFocus:this.onFocus,value:this.props.value||'',placeholder:props.placeholder,disabled:disabled,autoComplete:'off'})),results);}}]);return Searchable;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Searchable);

/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFIAAABMCAIAAABxkncnAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAALYSURBVHhe7ZqxahwxEIb9goY8hh/Cbbr0AffBrUlpcJPGwZXdBBsXRwgm5MBwYA6Cm8sPEkIZaWbvViOtdNLH33h3A/4y0oz2zie7LhnaPTG0e2Jo98TQ7okj1L7frD49X9kfGI5Ke/O+hfDJ1QfkYnVtr8Y4Hu2b9YMRRk6/f0TN7Y0Yx6CNIp//+OKcz+4///m7sfcYmtdGVVFb5wx/e0Okbe3LX9+cMIIf7Y0pWtXGMvYX9kHOoEntp7cXf2Ef6gza0759ffSFZziDxrTJZp7nDFrSdkeRRGfQjDZpYCnOoAHtsGkjk6dumdq14UyaNrLnmUSgau2oM86e9nYC9WpHnXEF1+0TCVSqHXVGfm7X9ok0atTmnOV3yYOoTptzThlXIdVpo2MRYSRxXIXUpR3OZ0SldRMq0o46a7VuQi3a4TuGiWIb86lC++vvO2JrotvGfJbXRj2JrUn6CVRgYW3sW2JrkmlLOxbWjo5oJNOWduho36wfTB/GsLl9fbRXp4i2biTflnakakMyrNg+vzfXxnJM6ZAk7YvVNfmlXeRV+vT2Qp530XrZkJmvzS1REyyBzfvWPvo/uM5taWwW+1BmZmoLdXbhvnMMPwk0yTqxCPOrjWXMFc0lXLH+95IkWScWIWlvk68aw5A3J25KI8WWtyFJ2yDX3C84939Upnv7KGgLNUTcDheWd5nu7aOgDQQlBHsBIRddChxOQnS0QfRTEROcTLjujQ1i/31Z1LSFE4iw+fc/yeqipg24knIpOagJmtroTERMTvlO5tDUBsIOJ1H/MPQglLW5j0rCcCf2Mihrg8kTK7LI0PLR15ZnuMmypQb62sLJxGTxUgN9bQAxouqCobV4qUEWbW6SFX7NEsiiDcgkQ5FLvk5Pkkvb/6M5nMnt1WrIpW0aG4bZgkcxgVzaAI2thu4VJaN2zQztnhjaPTG0e2Jo98TQ7omh3RNDux92u3+9Q/7Gl6D7oAAAAABJRU5ErkJggg=="

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(49);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(9);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 27 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(9);
var settle = __webpack_require__(77);
var cookies = __webpack_require__(78);
var buildURL = __webpack_require__(26);
var buildFullPath = __webpack_require__(79);
var parseHeaders = __webpack_require__(82);
var isURLSameOrigin = __webpack_require__(83);
var createError = __webpack_require__(30);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(
        timeoutErrorMessage,
        config,
        config.transitional && config.transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (!requestData) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(28);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(9);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
  var defaultToConfig2Keys = [
    'baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress',
    'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'
  ];
  var directMergeKeys = ['validateStatus'];

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  }

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  utils.forEach(directMergeKeys, function merge(prop) {
    if (prop in config2) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys)
    .concat(directMergeKeys);

  var otherKeys = Object
    .keys(config1)
    .concat(Object.keys(config2))
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, mergeDeepProperties);

  return config;
};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SelectBase */
/* unused harmony export Async */
/* unused harmony export AsyncCreatable */
/* unused harmony export Creatable */
/* unused harmony export createFilter */
/* unused harmony export makeAnimated */
/* unused harmony export components */
/* unused harmony export mergeStyles */
/* unused harmony export defaultTheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raf__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_raf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_create_emotion__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_input_autosize__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_input_autosize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_input_autosize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_memoize_one__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_transition_group__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_transition_group__);









var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var taggedTemplateLiteral = function (strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
};

var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

// ==============================
// NO OP
// ==============================

var noop = function noop() {};

// ==============================
// Class Name Prefixer
// ==============================

/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/
function applyPrefixToName(prefix, name) {
  if (!name) {
    return prefix;
  } else if (name[0] === '-') {
    return prefix + name;
  } else {
    return prefix + '__' + name;
  }
}

function classNames(prefix, cssKey, state, className) {
  var arr = [cssKey, className];
  if (state && prefix) {
    for (var key in state) {
      if (state.hasOwnProperty(key) && state[key]) {
        arr.push('' + applyPrefixToName(prefix, key));
      }
    }
  }

  return arr.filter(function (i) {
    return i;
  }).map(function (i) {
    return String(i).trim();
  }).join(' ');
}
// ==============================
// Clean Value
// ==============================

var cleanValue = function cleanValue(value) {
  if (Array.isArray(value)) return value.filter(Boolean);
  if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value !== null) return [value];
  return [];
};

// ==============================
// Handle Input Change
// ==============================

function handleInputChange(inputValue, actionMeta, onInputChange) {
  if (onInputChange) {
    var newValue = onInputChange(inputValue, actionMeta);
    if (typeof newValue === 'string') return newValue;
  }
  return inputValue;
}

// ==============================
// Scroll Helpers
// ==============================

function isDocumentElement(el) {
  return [document.documentElement, document.body, window].indexOf(el) > -1;
}

// Normalized scrollTo & scrollTop
// ------------------------------

function getScrollTop(el) {
  if (isDocumentElement(el)) {
    return window.pageYOffset;
  }
  return el.scrollTop;
}

function scrollTo(el, top) {
  // with a scroll distance, we perform scroll on the element
  if (isDocumentElement(el)) {
    window.scrollTo(0, top);
    return;
  }

  el.scrollTop = top;
}

// Get Scroll Parent
// ------------------------------

function getScrollParent(element) {
  var style = getComputedStyle(element);
  var excludeStaticParent = style.position === 'absolute';
  var overflowRx = /(auto|scroll)/;
  var docEl = document.documentElement; // suck it, flow...

  if (style.position === 'fixed') return docEl;

  for (var parent = element; parent = parent.parentElement;) {
    style = getComputedStyle(parent);
    if (excludeStaticParent && style.position === 'static') {
      continue;
    }
    if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) {
      return parent;
    }
  }

  return docEl;
}

// Animated Scroll To
// ------------------------------

/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/
function easeOutCubic(t, b, c, d) {
  return c * ((t = t / d - 1) * t * t + 1) + b;
}

function animatedScrollTo(element, to) {
  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
  var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noop;

  var start = getScrollTop(element);
  var change = to - start;
  var increment = 10;
  var currentTime = 0;

  function animateScroll() {
    currentTime += increment;
    var val = easeOutCubic(currentTime, start, change, duration);
    scrollTo(element, val);
    if (currentTime < duration) {
      __WEBPACK_IMPORTED_MODULE_0_raf___default()(animateScroll);
    } else {
      callback(element);
    }
  }
  animateScroll();
}

// Scroll Into View
// ------------------------------

function scrollIntoView(menuEl, focusedEl) {
  var menuRect = menuEl.getBoundingClientRect();
  var focusedRect = focusedEl.getBoundingClientRect();
  var overScroll = focusedEl.offsetHeight / 3;

  if (focusedRect.bottom + overScroll > menuRect.bottom) {
    scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
  } else if (focusedRect.top - overScroll < menuRect.top) {
    scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
  }
}

// ==============================
// Get bounding client object
// ==============================

// cannot get keys using array notation with DOMRect
function getBoundingClientObj(element) {
  var rect = element.getBoundingClientRect();
  return {
    bottom: rect.bottom,
    height: rect.height,
    left: rect.left,
    right: rect.right,
    top: rect.top,
    width: rect.width
  };
}

// ==============================
// Touch Capability Detector
// ==============================

function isTouchCapable() {
  try {
    document.createEvent('TouchEvent');
    return true;
  } catch (e) {
    return false;
  }
}

// ==============================
// Mobile Device Detector
// ==============================

function isMobileDevice() {
  try {
    return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    );
  } catch (e) {
    return false;
  }
}

// ==============================
// Menu
// ==============================

// Get Menu Placement
// ------------------------------

function getMenuPlacement(_ref) {
  var maxHeight = _ref.maxHeight,
      menuEl = _ref.menuEl,
      minHeight = _ref.minHeight,
      placement = _ref.placement,
      shouldScroll = _ref.shouldScroll,
      isFixedPosition = _ref.isFixedPosition,
      theme = _ref.theme;
  var spacing = theme.spacing;

  var scrollParent = getScrollParent(menuEl);
  var defaultState = { placement: 'bottom', maxHeight: maxHeight };

  // something went wrong, return default state
  if (!menuEl || !menuEl.offsetParent) return defaultState;

  // we can't trust `scrollParent.scrollHeight` --> it may increase when
  // the menu is rendered

  var _scrollParent$getBoun = scrollParent.getBoundingClientRect(),
      scrollHeight = _scrollParent$getBoun.height;

  var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(),
      menuBottom = _menuEl$getBoundingCl.bottom,
      menuHeight = _menuEl$getBoundingCl.height,
      menuTop = _menuEl$getBoundingCl.top;

  // $FlowFixMe function returns above if there's no offsetParent


  var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(),
      containerTop = _menuEl$offsetParent$.top;

  var viewHeight = window.innerHeight;
  var scrollTop = getScrollTop(scrollParent);

  var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
  var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
  var viewSpaceAbove = containerTop - marginTop;
  var viewSpaceBelow = viewHeight - menuTop;
  var scrollSpaceAbove = viewSpaceAbove + scrollTop;
  var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;

  var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
  var scrollUp = scrollTop + menuTop - marginTop;
  var scrollDuration = 160;

  switch (placement) {
    case 'auto':
    case 'bottom':
      // 1: the menu will fit, do nothing
      if (viewSpaceBelow >= menuHeight) {
        return { placement: 'bottom', maxHeight: maxHeight };
      }

      // 2: the menu will fit, if scrolled
      if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }

        return { placement: 'bottom', maxHeight: maxHeight };
      }

      // 3: the menu will fit, if constrained
      if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }

        // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.
        var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;

        return {
          placement: 'bottom',
          maxHeight: constrainedHeight
        };
      }

      // 4. Forked beviour when there isn't enough space below

      // AUTO: flip the menu, render above
      if (placement === 'auto' || isFixedPosition) {
        // may need to be constrained after flipping
        var _constrainedHeight = maxHeight;

        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
          _constrainedHeight = isFixedPosition ? viewSpaceAbove - marginBottom - spacing.controlHeight : scrollSpaceAbove - marginBottom - spacing.controlHeight;
        }

        return { placement: 'top', maxHeight: _constrainedHeight };
      }

      // BOTTOM: allow browser to increase scrollable area and immediately set scroll
      if (placement === 'bottom') {
        scrollTo(scrollParent, scrollDown);
        return { placement: 'bottom', maxHeight: maxHeight };
      }
      break;
    case 'top':
      // 1: the menu will fit, do nothing
      if (viewSpaceAbove >= menuHeight) {
        return { placement: 'top', maxHeight: maxHeight };
      }

      // 2: the menu will fit, if scrolled
      if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }

        return { placement: 'top', maxHeight: maxHeight };
      }

      // 3: the menu will fit, if constrained
      if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
        var _constrainedHeight2 = maxHeight;

        // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.
        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
          _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
        }

        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }

        return {
          placement: 'top',
          maxHeight: _constrainedHeight2
        };
      }

      // 4. not enough space, the browser WILL NOT increase scrollable area when
      // absolutely positioned element rendered above the viewport (only below).
      // Flip the menu, render below
      return { placement: 'bottom', maxHeight: maxHeight };
    default:
      throw new Error('Invalid placement provided "' + placement + '".');
  }

  // fulfil contract with flow: implicit return value of undefined
  return defaultState;
}

// Menu Component
// ------------------------------

function alignToControl(placement) {
  var placementToCSSProp = { bottom: 'top', top: 'bottom' };
  return placement ? placementToCSSProp[placement] : 'bottom';
}
var coercePlacement = function coercePlacement(p) {
  return p === 'auto' ? 'bottom' : p;
};

var menuCSS = function menuCSS(_ref2) {
  var _ref3;

  var placement = _ref2.placement,
      _ref2$theme = _ref2.theme,
      borderRadius = _ref2$theme.borderRadius,
      spacing = _ref2$theme.spacing,
      colors = _ref2$theme.colors;
  return _ref3 = {}, defineProperty(_ref3, alignToControl(placement), '100%'), defineProperty(_ref3, 'backgroundColor', colors.neutral0), defineProperty(_ref3, 'borderRadius', borderRadius), defineProperty(_ref3, 'boxShadow', '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)'), defineProperty(_ref3, 'marginBottom', spacing.menuGutter), defineProperty(_ref3, 'marginTop', spacing.menuGutter), defineProperty(_ref3, 'position', 'absolute'), defineProperty(_ref3, 'width', '100%'), defineProperty(_ref3, 'zIndex', 1), _ref3;
};

// NOTE: internal only
var MenuPlacer = function (_Component) {
  inherits(MenuPlacer, _Component);

  function MenuPlacer() {
    var _ref4;

    var _temp, _this, _ret;

    classCallCheck(this, MenuPlacer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref4 = MenuPlacer.__proto__ || Object.getPrototypeOf(MenuPlacer)).call.apply(_ref4, [this].concat(args))), _this), _this.state = {
      maxHeight: _this.props.maxMenuHeight,
      placement: null
    }, _this.getPlacement = function (ref) {
      var _this$props = _this.props,
          minMenuHeight = _this$props.minMenuHeight,
          maxMenuHeight = _this$props.maxMenuHeight,
          menuPlacement = _this$props.menuPlacement,
          menuPosition = _this$props.menuPosition,
          menuShouldScrollIntoView = _this$props.menuShouldScrollIntoView,
          theme = _this$props.theme;
      var getPortalPlacement = _this.context.getPortalPlacement;


      if (!ref) return;

      // DO NOT scroll if position is fixed
      var isFixedPosition = menuPosition === 'fixed';
      var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;

      var state = getMenuPlacement({
        maxHeight: maxMenuHeight,
        menuEl: ref,
        minHeight: minMenuHeight,
        placement: menuPlacement,
        shouldScroll: shouldScroll,
        isFixedPosition: isFixedPosition,
        theme: theme
      });

      if (getPortalPlacement) getPortalPlacement(state);

      _this.setState(state);
    }, _this.getUpdatedProps = function () {
      var menuPlacement = _this.props.menuPlacement;

      var placement = _this.state.placement || coercePlacement(menuPlacement);

      return _extends({}, _this.props, { placement: placement, maxHeight: _this.state.maxHeight });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(MenuPlacer, [{
    key: 'render',
    value: function render() {
      var children = this.props.children;


      return children({
        ref: this.getPlacement,
        placerProps: this.getUpdatedProps()
      });
    }
  }]);
  return MenuPlacer;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

MenuPlacer.contextTypes = {
  getPortalPlacement: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func
};
var Menu = function Menu(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerRef = props.innerRef,
      innerProps = props.innerProps,
      emotion = props.emotion;

  var cn = cx(emotion.css(getStyles('menu', props)), { menu: true }, className);

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    _extends({ className: cn }, innerProps, { ref: innerRef }),
    children
  );
};

// ==============================
// Menu List
// ==============================

var menuListCSS = function menuListCSS(_ref5) {
  var maxHeight = _ref5.maxHeight,
      baseUnit = _ref5.theme.spacing.baseUnit;
  return {
    maxHeight: maxHeight,
    overflowY: 'auto',
    paddingBottom: baseUnit,
    paddingTop: baseUnit,
    position: 'relative', // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: 'touch'
  };
};
var MenuList = function MenuList(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isMulti = props.isMulti,
      innerRef = props.innerRef,
      emotion = props.emotion;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    {
      className: cx(emotion.css(getStyles('menuList', props)), {
        'menu-list': true,
        'menu-list--is-multi': isMulti
      }, className),
      ref: innerRef
    },
    children
  );
};

// ==============================
// Menu Notices
// ==============================

var noticeCSS = function noticeCSS(_ref6) {
  var _ref6$theme = _ref6.theme,
      baseUnit = _ref6$theme.spacing.baseUnit,
      colors = _ref6$theme.colors;
  return {
    color: colors.neutral40,
    padding: baseUnit * 2 + 'px ' + baseUnit * 3 + 'px',
    textAlign: 'center'
  };
};
var noOptionsMessageCSS = noticeCSS;
var loadingMessageCSS = noticeCSS;

var NoOptionsMessage = function NoOptionsMessage(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      emotion = props.emotion;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    _extends({
      className: cx(emotion.css(getStyles('noOptionsMessage', props)), {
        'menu-notice': true,
        'menu-notice--no-options': true
      }, className)
    }, innerProps),
    children
  );
};
NoOptionsMessage.defaultProps = {
  children: 'No options'
};

var LoadingMessage = function LoadingMessage(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      emotion = props.emotion;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    _extends({
      className: cx(emotion.css(getStyles('loadingMessage', props)), {
        'menu-notice': true,
        'menu-notice--loading': true
      }, className)
    }, innerProps),
    children
  );
};
LoadingMessage.defaultProps = {
  children: 'Loading...'
};

// ==============================
// Menu Portal
// ==============================

var menuPortalCSS = function menuPortalCSS(_ref7) {
  var rect = _ref7.rect,
      offset = _ref7.offset,
      position = _ref7.position;
  return {
    left: rect.left,
    position: position,
    top: offset,
    width: rect.width,
    zIndex: 1
  };
};

var MenuPortal = function (_Component2) {
  inherits(MenuPortal, _Component2);

  function MenuPortal() {
    var _ref8;

    var _temp2, _this2, _ret2;

    classCallCheck(this, MenuPortal);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this2 = possibleConstructorReturn(this, (_ref8 = MenuPortal.__proto__ || Object.getPrototypeOf(MenuPortal)).call.apply(_ref8, [this].concat(args))), _this2), _this2.state = { placement: null }, _this2.getPortalPlacement = function (_ref9) {
      var placement = _ref9.placement;

      var initialPlacement = coercePlacement(_this2.props.menuPlacement);

      // avoid re-renders if the placement has not changed
      if (placement !== initialPlacement) {
        _this2.setState({ placement: placement });
      }
    }, _temp2), possibleConstructorReturn(_this2, _ret2);
  }

  createClass(MenuPortal, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        getPortalPlacement: this.getPortalPlacement
      };
    }

    // callback for occassions where the menu must "flip"

  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          appendTo = _props.appendTo,
          children = _props.children,
          controlElement = _props.controlElement,
          menuPlacement = _props.menuPlacement,
          position = _props.menuPosition,
          getStyles = _props.getStyles,
          emotion = _props.emotion;

      var isFixed = position === 'fixed';

      // bail early if required elements aren't present
      if (!appendTo && !isFixed || !controlElement) {
        return null;
      }

      var placement = this.state.placement || coercePlacement(menuPlacement);
      var rect = getBoundingClientObj(controlElement);
      var scrollDistance = isFixed ? 0 : window.pageYOffset;
      var offset = rect[placement] + scrollDistance;
      var state = { offset: offset, position: position, rect: rect };

      // same wrapper element whether fixed or portalled
      var menuWrapper = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: emotion.css(getStyles('menuPortal', state)) },
        children
      );

      return appendTo ? Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["createPortal"])(menuWrapper, appendTo) : menuWrapper;
    }
  }]);
  return MenuPortal;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);
MenuPortal.childContextTypes = {
  getPortalPlacement: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func
};

var isArray = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;

function equal(a, b) {
  // fast-deep-equal index.js 2.0.1
  if (a === b) return true;

  if (a && b && (typeof a === 'undefined' ? 'undefined' : _typeof(a)) == 'object' && (typeof b === 'undefined' ? 'undefined' : _typeof(b)) == 'object') {
    var arrA = isArray(a),
        arrB = isArray(b),
        i,
        length,
        key;

    if (arrA && arrB) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;) {
        if (!equal(a[i], b[i])) return false;
      }
      return true;
    }

    if (arrA != arrB) return false;

    var dateA = a instanceof Date,
        dateB = b instanceof Date;
    if (dateA != dateB) return false;
    if (dateA && dateB) return a.getTime() == b.getTime();

    var regexpA = a instanceof RegExp,
        regexpB = b instanceof RegExp;
    if (regexpA != regexpB) return false;
    if (regexpA && regexpB) return a.toString() == b.toString();

    var keys = keyList(a);
    length = keys.length;

    if (length !== keyList(b).length) {
      return false;
    }

    for (i = length; i-- !== 0;) {
      if (!hasProp.call(b, keys[i])) return false;
    }
    // end fast-deep-equal

    // Custom handling for React
    for (i = length; i-- !== 0;) {
      key = keys[i];
      if (key === '_owner' && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner.
        //  _owner contains circular references
        // and is not needed when comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of a react element
        continue;
      } else {
        // all other properties should be traversed as usual
        if (!equal(a[key], b[key])) return false;
      }
    }

    // fast-deep-equal index.js 2.0.1
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

function exportedEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (error.message && error.message.match(/stack|recursion/i)) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
}

var diacritics = [{ base: 'A', letters: /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { base: 'AA', letters: /[\uA732]/g }, { base: 'AE', letters: /[\u00C6\u01FC\u01E2]/g }, { base: 'AO', letters: /[\uA734]/g }, { base: 'AU', letters: /[\uA736]/g }, { base: 'AV', letters: /[\uA738\uA73A]/g }, { base: 'AY', letters: /[\uA73C]/g }, { base: 'B', letters: /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { base: 'C', letters: /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { base: 'D', letters: /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { base: 'DZ', letters: /[\u01F1\u01C4]/g }, { base: 'Dz', letters: /[\u01F2\u01C5]/g }, { base: 'E', letters: /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { base: 'F', letters: /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { base: 'G', letters: /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { base: 'H', letters: /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { base: 'I', letters: /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { base: 'J', letters: /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { base: 'K', letters: /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { base: 'L', letters: /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { base: 'LJ', letters: /[\u01C7]/g }, { base: 'Lj', letters: /[\u01C8]/g }, { base: 'M', letters: /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { base: 'N', letters: /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { base: 'NJ', letters: /[\u01CA]/g }, { base: 'Nj', letters: /[\u01CB]/g }, { base: 'O', letters: /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { base: 'OI', letters: /[\u01A2]/g }, { base: 'OO', letters: /[\uA74E]/g }, { base: 'OU', letters: /[\u0222]/g }, { base: 'P', letters: /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { base: 'Q', letters: /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { base: 'R', letters: /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { base: 'S', letters: /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { base: 'T', letters: /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { base: 'TZ', letters: /[\uA728]/g }, { base: 'U', letters: /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { base: 'V', letters: /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { base: 'VY', letters: /[\uA760]/g }, { base: 'W', letters: /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { base: 'X', letters: /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { base: 'Y', letters: /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { base: 'Z', letters: /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { base: 'a', letters: /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { base: 'aa', letters: /[\uA733]/g }, { base: 'ae', letters: /[\u00E6\u01FD\u01E3]/g }, { base: 'ao', letters: /[\uA735]/g }, { base: 'au', letters: /[\uA737]/g }, { base: 'av', letters: /[\uA739\uA73B]/g }, { base: 'ay', letters: /[\uA73D]/g }, { base: 'b', letters: /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { base: 'c', letters: /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { base: 'd', letters: /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { base: 'dz', letters: /[\u01F3\u01C6]/g }, { base: 'e', letters: /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { base: 'f', letters: /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { base: 'g', letters: /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { base: 'h', letters: /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { base: 'hv', letters: /[\u0195]/g }, { base: 'i', letters: /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { base: 'j', letters: /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { base: 'k', letters: /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { base: 'l', letters: /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { base: 'lj', letters: /[\u01C9]/g }, { base: 'm', letters: /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { base: 'n', letters: /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { base: 'nj', letters: /[\u01CC]/g }, { base: 'o', letters: /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { base: 'oi', letters: /[\u01A3]/g }, { base: 'ou', letters: /[\u0223]/g }, { base: 'oo', letters: /[\uA74F]/g }, { base: 'p', letters: /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { base: 'q', letters: /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { base: 'r', letters: /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { base: 's', letters: /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { base: 't', letters: /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { base: 'tz', letters: /[\uA729]/g }, { base: 'u', letters: /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { base: 'v', letters: /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { base: 'vy', letters: /[\uA761]/g }, { base: 'w', letters: /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { base: 'x', letters: /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { base: 'y', letters: /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { base: 'z', letters: /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];

var stripDiacritics = function stripDiacritics(str) {
	for (var i = 0; i < diacritics.length; i++) {
		str = str.replace(diacritics[i].letters, diacritics[i].base);
	}
	return str;
};

var trimString = function trimString(str) {
  return str.replace(/^\s+|\s+$/g, '');
};
var defaultStringify = function defaultStringify(option) {
  return option.label + ' ' + option.value;
};

var createFilter = function createFilter(config) {
  return function (option, rawInput) {
    var _ignoreCase$ignoreAcc = _extends({
      ignoreCase: true,
      ignoreAccents: true,
      stringify: defaultStringify,
      trim: true,
      matchFrom: 'any'
    }, config),
        ignoreCase = _ignoreCase$ignoreAcc.ignoreCase,
        ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents,
        stringify = _ignoreCase$ignoreAcc.stringify,
        trim = _ignoreCase$ignoreAcc.trim,
        matchFrom = _ignoreCase$ignoreAcc.matchFrom;

    var input = trim ? trimString(rawInput) : rawInput;
    var candidate = trim ? trimString(stringify(option)) : stringify(option);
    if (ignoreCase) {
      input = input.toLowerCase();
      candidate = candidate.toLowerCase();
    }
    if (ignoreAccents) {
      input = stripDiacritics(input);
      candidate = stripDiacritics(candidate);
    }
    return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
  };
};

// Assistive text to describe visual elements. Hidden for sighted users.
var A11yText = function A11yText(props) {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', _extends({
    className: props.emotion.css({
      zIndex: 9999,
      border: 0,
      clip: 'rect(1px, 1px, 1px, 1px)',
      height: 1,
      width: 1,
      position: 'absolute',
      overflow: 'hidden',
      padding: 0,
      whiteSpace: 'nowrap',
      backgroundColor: 'red',
      color: 'blue'
    })
  }, props));
};

var DummyInput = function (_Component) {
  inherits(DummyInput, _Component);

  function DummyInput() {
    classCallCheck(this, DummyInput);
    return possibleConstructorReturn(this, (DummyInput.__proto__ || Object.getPrototypeOf(DummyInput)).apply(this, arguments));
  }

  createClass(DummyInput, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          inProp = _props.in,
          out = _props.out,
          onExited = _props.onExited,
          appear = _props.appear,
          enter = _props.enter,
          exit = _props.exit,
          innerRef = _props.innerRef,
          emotion = _props.emotion,
          props = objectWithoutProperties(_props, ['in', 'out', 'onExited', 'appear', 'enter', 'exit', 'innerRef', 'emotion']);

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', _extends({
        ref: innerRef
      }, props, {
        className: emotion.css({
          // get rid of any default styles
          background: 0,
          border: 0,
          fontSize: 'inherit',
          outline: 0,
          padding: 0,

          // important! without `width` browsers won't allow focus
          width: 1,

          // remove cursor on desktop
          color: 'transparent',

          // remove cursor on mobile whilst maintaining "scroll into view" behaviour
          left: -100,
          opacity: 0,
          position: 'relative',
          transform: 'scale(0)'
        })
      }));
    }
  }]);
  return DummyInput;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

var NodeResolver = function (_Component) {
  inherits(NodeResolver, _Component);

  function NodeResolver() {
    classCallCheck(this, NodeResolver);
    return possibleConstructorReturn(this, (NodeResolver.__proto__ || Object.getPrototypeOf(NodeResolver)).apply(this, arguments));
  }

  createClass(NodeResolver, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.innerRef(Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"])(this));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.innerRef(null);
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);
  return NodeResolver;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

var STYLE_KEYS = ['boxSizing', 'height', 'overflow', 'paddingRight', 'position'];

var LOCK_STYLES = {
  boxSizing: 'border-box', // account for possible declaration `width: 100%;` on body
  overflow: 'hidden',
  position: 'relative',
  height: '100%'
};

function preventTouchMove(e) {
  e.preventDefault();
}

function allowTouchMove(e) {
  e.stopPropagation();
}

function preventInertiaScroll() {
  var top = this.scrollTop;
  var totalScroll = this.scrollHeight;
  var currentScroll = top + this.offsetHeight;

  if (top === 0) {
    this.scrollTop = 1;
  } else if (currentScroll === totalScroll) {
    this.scrollTop = top - 1;
  }
}

// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var activeScrollLocks = 0;

var ScrollLock = function (_Component) {
  inherits(ScrollLock, _Component);

  function ScrollLock() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, ScrollLock);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = ScrollLock.__proto__ || Object.getPrototypeOf(ScrollLock)).call.apply(_ref, [this].concat(args))), _this), _this.originalStyles = {}, _this.listenerOptions = {
      capture: false,
      passive: false
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(ScrollLock, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (!canUseDOM) return;

      var _props = this.props,
          accountForScrollbars = _props.accountForScrollbars,
          touchScrollTarget = _props.touchScrollTarget;

      var target = document.body;
      var targetStyle = target && target.style;

      if (accountForScrollbars) {
        // store any styles already applied to the body
        STYLE_KEYS.forEach(function (key) {
          var val = targetStyle && targetStyle[key];
          _this2.originalStyles[key] = val;
        });
      }

      // apply the lock styles and padding if this is the first scroll lock
      if (accountForScrollbars && activeScrollLocks < 1) {
        var currentPadding = parseInt(this.originalStyles.paddingRight, 10) || 0;
        var clientWidth = document.body ? document.body.clientWidth : 0;
        var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;

        Object.keys(LOCK_STYLES).forEach(function (key) {
          var val = LOCK_STYLES[key];
          if (targetStyle) {
            targetStyle[key] = val;
          }
        });

        if (targetStyle) {
          targetStyle.paddingRight = adjustedPadding + 'px';
        }
      }

      // account for touch devices
      if (target && isTouchDevice()) {
        // Mobile Safari ignores { overflow: hidden } declaration on the body.
        target.addEventListener('touchmove', preventTouchMove, this.listenerOptions);

        // Allow scroll on provided target
        if (touchScrollTarget) {
          touchScrollTarget.addEventListener('touchstart', preventInertiaScroll, this.listenerOptions);
          touchScrollTarget.addEventListener('touchmove', allowTouchMove, this.listenerOptions);
        }
      }

      // increment active scroll locks
      activeScrollLocks += 1;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _this3 = this;

      if (!canUseDOM) return;

      var _props2 = this.props,
          accountForScrollbars = _props2.accountForScrollbars,
          touchScrollTarget = _props2.touchScrollTarget;

      var target = document.body;
      var targetStyle = target && target.style;

      // safely decrement active scroll locks
      activeScrollLocks = Math.max(activeScrollLocks - 1, 0);

      // reapply original body styles, if any
      if (accountForScrollbars && activeScrollLocks < 1) {
        STYLE_KEYS.forEach(function (key) {
          var val = _this3.originalStyles[key];
          if (targetStyle) {
            targetStyle[key] = val;
          }
        });
      }

      // remove touch listeners
      if (target && isTouchDevice()) {
        target.removeEventListener('touchmove', preventTouchMove, this.listenerOptions);

        if (touchScrollTarget) {
          touchScrollTarget.removeEventListener('touchstart', preventInertiaScroll, this.listenerOptions);
          touchScrollTarget.removeEventListener('touchmove', allowTouchMove, this.listenerOptions);
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);
  return ScrollLock;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

ScrollLock.defaultProps = {
  accountForScrollbars: true
};

// NOTE:
// We shouldn't need this after updating to React v16.3.0, which introduces:
// - createRef() https://reactjs.org/docs/react-api.html#reactcreateref
// - forwardRef() https://reactjs.org/docs/react-api.html#reactforwardref

var ScrollBlock = function (_PureComponent) {
  inherits(ScrollBlock, _PureComponent);

  function ScrollBlock() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, ScrollBlock);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = ScrollBlock.__proto__ || Object.getPrototypeOf(ScrollBlock)).call.apply(_ref, [this].concat(args))), _this), _this.state = { touchScrollTarget: null }, _this.getScrollTarget = function (ref) {
      if (ref === _this.state.touchScrollTarget) return;
      _this.setState({ touchScrollTarget: ref });
    }, _this.blurSelectInput = function () {
      if (document.activeElement) {
        document.activeElement.blur();
      }
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  // must be in state to trigger a re-render, only runs once per instance


  // this will close the menu when a user clicks outside


  createClass(ScrollBlock, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          isEnabled = _props.isEnabled,
          emotion = _props.emotion;
      var touchScrollTarget = this.state.touchScrollTarget;

      // bail early if not enabled

      if (!isEnabled) return children;

      /*
       * Div
       * ------------------------------
       * blocks scrolling on non-body elements behind the menu
        * NodeResolver
       * ------------------------------
       * we need a reference to the scrollable element to "unlock" scroll on
       * mobile devices
        * ScrollLock
       * ------------------------------
       * actually does the scroll locking
       */
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', {
          onClick: this.blurSelectInput,
          className: emotion.css({ position: 'fixed', left: 0, bottom: 0, right: 0, top: 0 })
        }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          NodeResolver,
          { innerRef: this.getScrollTarget },
          children
        ),
        touchScrollTarget ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ScrollLock, { touchScrollTarget: touchScrollTarget }) : null
      );
    }
  }]);
  return ScrollBlock;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]);

var ScrollCaptor = function (_Component) {
  inherits(ScrollCaptor, _Component);

  function ScrollCaptor() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, ScrollCaptor);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = ScrollCaptor.__proto__ || Object.getPrototypeOf(ScrollCaptor)).call.apply(_ref, [this].concat(args))), _this), _this.isBottom = false, _this.isTop = false, _this.cancelScroll = function (event) {
      event.preventDefault();
      event.stopPropagation();
    }, _this.handleEventDelta = function (event, delta) {
      var _this$props = _this.props,
          onBottomArrive = _this$props.onBottomArrive,
          onBottomLeave = _this$props.onBottomLeave,
          onTopArrive = _this$props.onTopArrive,
          onTopLeave = _this$props.onTopLeave;
      var _this$scrollTarget = _this.scrollTarget,
          scrollTop = _this$scrollTarget.scrollTop,
          scrollHeight = _this$scrollTarget.scrollHeight,
          clientHeight = _this$scrollTarget.clientHeight;

      var target = _this.scrollTarget;
      var isDeltaPositive = delta > 0;
      var availableScroll = scrollHeight - clientHeight - scrollTop;
      var shouldCancelScroll = false;

      // reset bottom/top flags
      if (availableScroll > delta && _this.isBottom) {
        if (onBottomLeave) onBottomLeave(event);
        _this.isBottom = false;
      }
      if (isDeltaPositive && _this.isTop) {
        if (onTopLeave) onTopLeave(event);
        _this.isTop = false;
      }

      // bottom limit
      if (isDeltaPositive && delta > availableScroll) {
        if (onBottomArrive && !_this.isBottom) {
          onBottomArrive(event);
        }
        target.scrollTop = scrollHeight;
        shouldCancelScroll = true;
        _this.isBottom = true;

        // top limit
      } else if (!isDeltaPositive && -delta > scrollTop) {
        if (onTopArrive && !_this.isTop) {
          onTopArrive(event);
        }
        target.scrollTop = 0;
        shouldCancelScroll = true;
        _this.isTop = true;
      }

      // cancel scroll
      if (shouldCancelScroll) {
        _this.cancelScroll(event);
      }
    }, _this.onWheel = function (event) {
      _this.handleEventDelta(event, event.deltaY);
    }, _this.onTouchStart = function (event) {
      // set touch start so we can calculate touchmove delta
      _this.touchStart = event.changedTouches[0].clientY;
    }, _this.onTouchMove = function (event) {
      var deltaY = _this.touchStart - event.changedTouches[0].clientY;
      _this.handleEventDelta(event, deltaY);
    }, _this.getScrollTarget = function (ref) {
      _this.scrollTarget = ref;
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(ScrollCaptor, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.startListening(this.scrollTarget);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stopListening(this.scrollTarget);
    }
  }, {
    key: 'startListening',
    value: function startListening(el) {
      // bail early if no scroll available
      if (el.scrollHeight <= el.clientHeight) return;

      // all the if statements are to appease Flow 😢
      if (typeof el.addEventListener === 'function') {
        el.addEventListener('wheel', this.onWheel, false);
      }
      if (typeof el.addEventListener === 'function') {
        el.addEventListener('touchstart', this.onTouchStart, false);
      }
      if (typeof el.addEventListener === 'function') {
        el.addEventListener('touchmove', this.onTouchMove, false);
      }
    }
  }, {
    key: 'stopListening',
    value: function stopListening(el) {
      // bail early if no scroll available
      if (el.scrollHeight <= el.clientHeight) return;

      // all the if statements are to appease Flow 😢
      if (typeof el.removeEventListener === 'function') {
        el.removeEventListener('wheel', this.onWheel, false);
      }
      if (typeof el.removeEventListener === 'function') {
        el.removeEventListener('touchstart', this.onTouchStart, false);
      }
      if (typeof el.removeEventListener === 'function') {
        el.removeEventListener('touchmove', this.onTouchMove, false);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        NodeResolver,
        { innerRef: this.getScrollTarget },
        this.props.children
      );
    }
  }]);
  return ScrollCaptor;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

var ScrollCaptorSwitch = function (_Component2) {
  inherits(ScrollCaptorSwitch, _Component2);

  function ScrollCaptorSwitch() {
    classCallCheck(this, ScrollCaptorSwitch);
    return possibleConstructorReturn(this, (ScrollCaptorSwitch.__proto__ || Object.getPrototypeOf(ScrollCaptorSwitch)).apply(this, arguments));
  }

  createClass(ScrollCaptorSwitch, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isEnabled = _props.isEnabled,
          props = objectWithoutProperties(_props, ['isEnabled']);

      return isEnabled ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ScrollCaptor, props) : this.props.children;
    }
  }]);
  return ScrollCaptorSwitch;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

ScrollCaptorSwitch.defaultProps = { isEnabled: true };

var instructionsAriaMessage = function instructionsAriaMessage(event) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var isSearchable = context.isSearchable,
      isMulti = context.isMulti,
      label = context.label;

  switch (event) {
    case 'menu':
      return 'Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu, press Tab to select the option and exit the menu.';
    case 'input':
      return (label ? label : 'Select') + ' is focused ' + (isSearchable ? ',type to refine list' : '') + ', press Down to open the menu, ' + (isMulti ? ' press left to focus selected values' : '');
    case 'value':
      return 'Use left and right to toggle between focused values, press Enter to remove the currently focused value';
  }
};

var valueEventAriaMessage = function valueEventAriaMessage(event, context) {
  var value = context.value;

  if (!value) return;
  switch (event) {
    case 'deselect-option':
    case 'pop-value':
    case 'remove-value':
      return 'option ' + value + ', deselected.';
    case 'select-option':
      return 'option ' + value + ', selected.';
  }
};

var valueFocusAriaMessage = function valueFocusAriaMessage(_ref) {
  var focusedValue = _ref.focusedValue,
      getOptionLabel = _ref.getOptionLabel,
      selectValue = _ref.selectValue;
  return 'value ' + getOptionLabel(focusedValue) + ' focused, ' + (selectValue.indexOf(focusedValue) + 1) + ' of ' + selectValue.length + '.';
};
var optionFocusAriaMessage = function optionFocusAriaMessage(_ref2) {
  var focusedOption = _ref2.focusedOption,
      getOptionLabel = _ref2.getOptionLabel,
      options = _ref2.options;
  return 'option ' + getOptionLabel(focusedOption) + ' focused, ' + (options.indexOf(focusedOption) + 1) + ' of ' + options.length + '.';
};
var resultsAriaMessage = function resultsAriaMessage(_ref3) {
  var inputValue = _ref3.inputValue,
      screenReaderMessage = _ref3.screenReaderMessage;
  return '' + screenReaderMessage + (inputValue ? ' for search term ' + inputValue : '') + '.';
};

var formatGroupLabel = function formatGroupLabel(group) {
  return group.label;
};

var getOptionLabel = function getOptionLabel(option) {
  return option.label;
};

var getOptionValue = function getOptionValue(option) {
  return option.value;
};

var isOptionDisabled = function isOptionDisabled(option) {
  return !!option.isDisabled;
};

// ==============================
// Root Container
// ==============================

var containerCSS = function containerCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      isRtl = _ref.isRtl;
  return {
    direction: isRtl ? 'rtl' : null,
    pointerEvents: isDisabled ? 'none' : null, // cancel mouse events when disabled
    position: 'relative'
  };
};
var SelectContainer = function SelectContainer(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isDisabled = props.isDisabled,
      isRtl = props.isRtl,
      emotion = props.emotion;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    _extends({
      className: cx(emotion.css(getStyles('container', props)), {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
      }, className)
    }, innerProps),
    children
  );
};

// ==============================
// Value Container
// ==============================

var valueContainerCSS = function valueContainerCSS(_ref2) {
  var spacing = _ref2.theme.spacing;
  return {
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    flexWrap: 'wrap',
    padding: spacing.baseUnit / 2 + 'px ' + spacing.baseUnit * 2 + 'px',
    WebkitOverflowScrolling: 'touch',
    position: 'relative',
    overflow: 'hidden'
  };
};
var ValueContainer = function (_Component) {
  inherits(ValueContainer, _Component);

  function ValueContainer() {
    classCallCheck(this, ValueContainer);
    return possibleConstructorReturn(this, (ValueContainer.__proto__ || Object.getPrototypeOf(ValueContainer)).apply(this, arguments));
  }

  createClass(ValueContainer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          cx = _props.cx,
          isMulti = _props.isMulti,
          getStyles = _props.getStyles,
          hasValue = _props.hasValue,
          emotion = _props.emotion;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        {
          className: cx(emotion.css(getStyles('valueContainer', this.props)), {
            'value-container': true,
            'value-container--is-multi': isMulti,
            'value-container--has-value': hasValue
          }, className)
        },
        children
      );
    }
  }]);
  return ValueContainer;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

// ==============================
// Indicator Container
// ==============================

var indicatorsContainerCSS = function indicatorsContainerCSS() {
  return {
    alignItems: 'center',
    alignSelf: 'stretch',
    display: 'flex',
    flexShrink: 0
  };
};
var IndicatorsContainer = function IndicatorsContainer(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      emotion = props.emotion;


  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    {
      className: cx(emotion.css(getStyles('indicatorsContainer', props)), {
        'indicators': true
      }, className)
    },
    children
  );
};

var _templateObject = taggedTemplateLiteral(['@keyframes ', ' {\n      0%, 80%, 100% { opacity: 0; }\n      40% { opacity: 1; }\n    };'], ['@keyframes ', ' {\n      0%, 80%, 100% { opacity: 0; }\n      40% { opacity: 1; }\n    };']);

// ==============================
// Dropdown & Clear Icons
// ==============================

var Svg = function Svg(_ref) {
  var size = _ref.size,
      emotion = _ref.emotion,
      props = objectWithoutProperties(_ref, ['size', 'emotion']);
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('svg', _extends({
    height: size,
    width: size,
    viewBox: '0 0 20 20',
    'aria-hidden': 'true',
    focusable: 'false',
    className: emotion.css({
      display: 'inline-block',
      fill: 'currentColor',
      lineHeight: 1,
      stroke: 'currentColor',
      strokeWidth: 0
    })
  }, props));
};

var CrossIcon = function CrossIcon(props) {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    Svg,
    _extends({ size: 20 }, props),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path', { d: 'M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z' })
  );
};
var DownChevron = function DownChevron(props) {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    Svg,
    _extends({ size: 20 }, props),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path', { d: 'M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z' })
  );
};

// ==============================
// Dropdown & Clear Buttons
// ==============================

var baseCSS = function baseCSS(_ref2) {
  var isFocused = _ref2.isFocused,
      _ref2$theme = _ref2.theme,
      baseUnit = _ref2$theme.spacing.baseUnit,
      colors = _ref2$theme.colors;
  return {
    color: isFocused ? colors.neutral60 : colors.neutral20,
    display: 'flex',
    padding: baseUnit * 2,
    transition: 'color 150ms',

    ':hover': {
      color: isFocused ? colors.neutral80 : colors.neutral40
    }
  };
};

var dropdownIndicatorCSS = baseCSS;
var DropdownIndicator = function DropdownIndicator(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      emotion = props.emotion;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    _extends({}, innerProps, {
      className: cx(emotion.css(getStyles('dropdownIndicator', props)), {
        'indicator': true,
        'dropdown-indicator': true
      }, className)
    }),
    children || __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(DownChevron, { emotion: emotion })
  );
};

var clearIndicatorCSS = baseCSS;
var ClearIndicator = function ClearIndicator(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      emotion = props.emotion;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    _extends({}, innerProps, {
      className: cx(emotion.css(getStyles('clearIndicator', props)), {
        'indicator': true,
        'clear-indicator': true
      }, className)
    }),
    children || __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(CrossIcon, { emotion: emotion })
  );
};

// ==============================
// Separator
// ==============================

var indicatorSeparatorCSS = function indicatorSeparatorCSS(_ref3) {
  var isDisabled = _ref3.isDisabled,
      _ref3$theme = _ref3.theme,
      baseUnit = _ref3$theme.spacing.baseUnit,
      colors = _ref3$theme.colors;
  return {
    alignSelf: 'stretch',
    backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
    marginBottom: baseUnit * 2,
    marginTop: baseUnit * 2,
    width: 1
  };
};

var IndicatorSeparator = function IndicatorSeparator(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      emotion = props.emotion;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', _extends({}, innerProps, {
    className: cx(emotion.css(getStyles('indicatorSeparator', props)), { 'indicator-separator': true }, className)
  }));
};

// ==============================
// Loading
// ==============================

var keyframesName = 'react-select-loading-indicator';
var keyframesInjected = false;

var loadingIndicatorCSS = function loadingIndicatorCSS(_ref4) {
  var isFocused = _ref4.isFocused,
      size = _ref4.size,
      _ref4$theme = _ref4.theme,
      colors = _ref4$theme.colors,
      baseUnit = _ref4$theme.spacing.baseUnit;
  return {
    color: isFocused ? colors.neutral60 : colors.neutral20,
    display: 'flex',
    padding: baseUnit * 2,
    transition: 'color 150ms',
    alignSelf: 'center',
    fontSize: size,
    lineHeight: 1,
    marginRight: size,
    textAlign: 'center',
    verticalAlign: 'middle'
  };
};

var LoadingDot = function LoadingDot(_ref5) {
  var color = _ref5.color,
      delay = _ref5.delay,
      offset = _ref5.offset,
      emotion = _ref5.emotion;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', {
    className: emotion.css({
      animationDuration: '1s',
      animationDelay: delay + 'ms',
      animationIterationCount: 'infinite',
      animationName: keyframesName,
      animationTimingFunction: 'ease-in-out',
      backgroundColor: color,
      borderRadius: '1em',
      display: 'inline-block',
      marginLeft: offset ? '1em' : null,
      height: '1em',
      verticalAlign: 'top',
      width: '1em'
    })
  });
};

var LoadingIndicator = function LoadingIndicator(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isFocused = props.isFocused,
      isRtl = props.isRtl,
      emotion = props.emotion,
      colors = props.theme.colors;

  var color = isFocused ? colors.neutral80 : colors.neutral20;

  if (!keyframesInjected) {
    // eslint-disable-next-line no-unused-expressions
    emotion.injectGlobal(_templateObject, keyframesName);
    keyframesInjected = true;
  }

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    _extends({}, innerProps, {
      className: cx(emotion.css(getStyles('loadingIndicator', props)), {
        'indicator': true,
        'loading-indicator': true
      }, className)
    }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(LoadingDot, { emotion: emotion, color: color, delay: 0, offset: isRtl }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(LoadingDot, { emotion: emotion, color: color, delay: 160, offset: true }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(LoadingDot, { emotion: emotion, color: color, delay: 320, offset: !isRtl })
  );
};
LoadingIndicator.defaultProps = { size: 4 };

var css = function css(_ref) {
  var isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused,
      _ref$theme = _ref.theme,
      colors = _ref$theme.colors,
      borderRadius = _ref$theme.borderRadius,
      spacing = _ref$theme.spacing;
  return {
    alignItems: 'center',
    backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
    borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
    borderRadius: borderRadius,
    borderStyle: 'solid',
    borderWidth: 1,
    boxShadow: isFocused ? '0 0 0 1px ' + colors.primary : null,
    cursor: 'default',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    minHeight: spacing.controlHeight,
    outline: '0 !important',
    position: 'relative',
    transition: 'all 100ms',

    '&:hover': {
      borderColor: isFocused ? colors.primary : colors.neutral30
    }
  };
};

var Control = function Control(props) {
  var children = props.children,
      cx = props.cx,
      getStyles = props.getStyles,
      className = props.className,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      innerRef = props.innerRef,
      innerProps = props.innerProps,
      emotion = props.emotion;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    _extends({
      ref: innerRef,
      className: cx(emotion.css(getStyles('control', props)), {
        'control': true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused
      }, className)
    }, innerProps),
    children
  );
};

var groupCSS = function groupCSS(_ref) {
  var spacing = _ref.theme.spacing;
  return {
    paddingBottom: spacing.baseUnit * 2,
    paddingTop: spacing.baseUnit * 2
  };
};

var Group = function Group(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      Heading = props.Heading,
      headingProps = props.headingProps,
      label = props.label,
      theme = props.theme,
      emotion = props.emotion,
      selectProps = props.selectProps;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    {
      className: cx(emotion.css(getStyles('group', props)), { 'group': true }, className)
    },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      Heading,
      _extends({}, headingProps, {
        selectProps: selectProps,
        emotion: emotion,
        theme: theme,
        getStyles: getStyles,
        cx: cx
      }),
      label
    ),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      null,
      children
    )
  );
};

var groupHeadingCSS = function groupHeadingCSS(_ref2) {
  var spacing = _ref2.theme.spacing;
  return {
    color: '#999',
    cursor: 'default',
    display: 'block',
    fontSize: '75%',
    fontWeight: '500',
    marginBottom: '0.25em',
    paddingLeft: spacing.baseUnit * 3,
    paddingRight: spacing.baseUnit * 3,
    textTransform: 'uppercase'
  };
};

var GroupHeading = function GroupHeading(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      theme = props.theme,
      emotion = props.emotion,
      selectProps = props.selectProps,
      cleanProps = objectWithoutProperties(props, ['className', 'cx', 'getStyles', 'theme', 'emotion', 'selectProps']);

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', _extends({
    className: cx(emotion.css(getStyles('groupHeading', _extends({ theme: theme }, cleanProps))), { 'group-heading': true }, className)
  }, cleanProps));
};

var inputCSS = function inputCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    margin: spacing.baseUnit / 2,
    paddingBottom: spacing.baseUnit / 2,
    paddingTop: spacing.baseUnit / 2,
    visibility: isDisabled ? 'hidden' : 'visible',
    color: colors.neutral80
  };
};
var inputStyle = function inputStyle(isHidden) {
  return {
    background: 0,
    border: 0,
    fontSize: 'inherit',
    opacity: isHidden ? 0 : 1,
    outline: 0,
    padding: 0,
    color: 'inherit'
  };
};

var Input = function Input(_ref2) {
  var className = _ref2.className,
      cx = _ref2.cx,
      getStyles = _ref2.getStyles,
      innerRef = _ref2.innerRef,
      isHidden = _ref2.isHidden,
      isDisabled = _ref2.isDisabled,
      theme = _ref2.theme,
      emotion = _ref2.emotion,
      selectProps = _ref2.selectProps,
      props = objectWithoutProperties(_ref2, ['className', 'cx', 'getStyles', 'innerRef', 'isHidden', 'isDisabled', 'theme', 'emotion', 'selectProps']);
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    { className: emotion.css(getStyles('input', _extends({ theme: theme }, props))) },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_input_autosize___default.a, _extends({
      className: cx(null, { 'input': true }, className),
      inputRef: innerRef,
      inputStyle: inputStyle(isHidden),
      disabled: isDisabled
    }, props))
  );
};

var multiValueCSS = function multiValueCSS(_ref) {
  var _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      borderRadius = _ref$theme.borderRadius,
      colors = _ref$theme.colors;
  return {
    backgroundColor: colors.neutral10,
    borderRadius: borderRadius / 2,
    display: 'flex',
    margin: spacing.baseUnit / 2,
    minWidth: 0 // resolves flex/text-overflow bug
  };
};

var multiValueLabelCSS = function multiValueLabelCSS(_ref2) {
  var _ref2$theme = _ref2.theme,
      borderRadius = _ref2$theme.borderRadius,
      colors = _ref2$theme.colors,
      cropWithEllipsis = _ref2.cropWithEllipsis;
  return {
    borderRadius: borderRadius / 2,
    color: colors.neutral80,
    fontSize: '85%',
    overflow: 'hidden',
    padding: 3,
    paddingLeft: 6,
    textOverflow: cropWithEllipsis ? 'ellipsis' : null,
    whiteSpace: 'nowrap'
  };
};

var multiValueRemoveCSS = function multiValueRemoveCSS(_ref3) {
  var _ref3$theme = _ref3.theme,
      spacing = _ref3$theme.spacing,
      borderRadius = _ref3$theme.borderRadius,
      colors = _ref3$theme.colors,
      isFocused = _ref3.isFocused;
  return {
    alignItems: 'center',
    borderRadius: borderRadius / 2,
    backgroundColor: isFocused && colors.dangerLight,
    display: 'flex',
    paddingLeft: spacing.baseUnit,
    paddingRight: spacing.baseUnit,
    ':hover': {
      backgroundColor: colors.dangerLight,
      color: colors.danger
    }
  };
};

var MultiValueGeneric = function MultiValueGeneric(_ref4) {
  var children = _ref4.children,
      innerProps = _ref4.innerProps;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    innerProps,
    children
  );
};

var MultiValueContainer = MultiValueGeneric;
var MultiValueLabel = MultiValueGeneric;

var MultiValueRemove = function (_Component) {
  inherits(MultiValueRemove, _Component);

  function MultiValueRemove() {
    classCallCheck(this, MultiValueRemove);
    return possibleConstructorReturn(this, (MultiValueRemove.__proto__ || Object.getPrototypeOf(MultiValueRemove)).apply(this, arguments));
  }

  createClass(MultiValueRemove, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          innerProps = _props.innerProps,
          emotion = _props.emotion;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        innerProps,
        children || __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(CrossIcon, { size: 14, emotion: emotion })
      );
    }
  }]);
  return MultiValueRemove;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

var MultiValue = function (_Component2) {
  inherits(MultiValue, _Component2);

  function MultiValue() {
    classCallCheck(this, MultiValue);
    return possibleConstructorReturn(this, (MultiValue.__proto__ || Object.getPrototypeOf(MultiValue)).apply(this, arguments));
  }

  createClass(MultiValue, [{
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          children = _props2.children,
          className = _props2.className,
          components = _props2.components,
          cx = _props2.cx,
          data = _props2.data,
          getStyles = _props2.getStyles,
          innerProps = _props2.innerProps,
          isDisabled = _props2.isDisabled,
          removeProps = _props2.removeProps,
          selectProps = _props2.selectProps,
          emotion = _props2.emotion;
      var Container = components.Container,
          Label = components.Label,
          Remove = components.Remove;


      var containerInnerProps = _extends({
        className: cx(emotion.css(getStyles('multiValue', this.props)), {
          'multi-value': true,
          'multi-value--is-disabled': isDisabled
        }, className)
      }, innerProps);

      var labelInnerProps = {
        className: cx(emotion.css(getStyles('multiValueLabel', this.props)), {
          'multi-value__label': true
        }, className)
      };

      var removeInnerProps = _extends({
        className: cx(emotion.css(getStyles('multiValueRemove', this.props)), {
          'multi-value__remove': true
        }, className)
      }, removeProps);

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        Container,
        {
          data: data,
          innerProps: containerInnerProps,
          selectProps: selectProps
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          Label,
          {
            data: data,
            innerProps: labelInnerProps,
            selectProps: selectProps
          },
          children
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Remove, {
          data: data,
          innerProps: removeInnerProps,
          selectProps: selectProps,
          emotion: emotion
        })
      );
    }
  }]);
  return MultiValue;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

MultiValue.defaultProps = {
  cropWithEllipsis: true
};

var optionCSS = function optionCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused,
      isSelected = _ref.isSelected,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
    color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
    cursor: 'default',
    display: 'block',
    fontSize: 'inherit',
    padding: spacing.baseUnit * 2 + 'px ' + spacing.baseUnit * 3 + 'px',
    width: '100%',
    userSelect: 'none',
    WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',

    // provide some affordance on touch devices
    ':active': {
      backgroundColor: isSelected ? colors.primary : colors.primary50
    }
  };
};

var Option = function Option(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      isSelected = props.isSelected,
      innerRef = props.innerRef,
      innerProps = props.innerProps,
      emotion = props.emotion;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    _extends({
      ref: innerRef,
      className: cx(emotion.css(getStyles('option', props)), {
        'option': true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
      }, className)
    }, innerProps),
    children
  );
};

var placeholderCSS = function placeholderCSS(_ref) {
  var _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    color: colors.neutral50,
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2,
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)'
  };
};

var Placeholder = function Placeholder(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      emotion = props.emotion;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    _extends({
      className: cx(emotion.css(getStyles('placeholder', props)), {
        'placeholder': true
      }, className)
    }, innerProps),
    children
  );
};

var css$1 = function css(_ref) {
  var isDisabled = _ref.isDisabled,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    color: isDisabled ? colors.neutral40 : colors.neutral80,
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2,
    maxWidth: 'calc(100% - ' + spacing.baseUnit * 2 + 'px)',
    overflow: 'hidden',
    position: 'absolute',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    top: '50%',
    transform: 'translateY(-50%)'
  };
};

var SingleValue = function SingleValue(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isDisabled = props.isDisabled,
      innerProps = props.innerProps,
      emotion = props.emotion;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    _extends({
      className: cx(emotion.css(getStyles('singleValue', props)), {
        'single-value': true,
        'single-value--is-disabled': isDisabled
      }, className)
    }, innerProps),
    children
  );
};

var components = {
  ClearIndicator: ClearIndicator,
  Control: Control,
  DropdownIndicator: DropdownIndicator,
  DownChevron: DownChevron,
  CrossIcon: CrossIcon,
  Group: Group,
  GroupHeading: GroupHeading,
  IndicatorsContainer: IndicatorsContainer,
  IndicatorSeparator: IndicatorSeparator,
  Input: Input,
  LoadingIndicator: LoadingIndicator,
  Menu: Menu,
  MenuList: MenuList,
  MenuPortal: MenuPortal,
  LoadingMessage: LoadingMessage,
  NoOptionsMessage: NoOptionsMessage,
  MultiValue: MultiValue,
  MultiValueContainer: MultiValueContainer,
  MultiValueLabel: MultiValueLabel,
  MultiValueRemove: MultiValueRemove,
  Option: Option,
  Placeholder: Placeholder,
  SelectContainer: SelectContainer,
  SingleValue: SingleValue,
  ValueContainer: ValueContainer
};

var defaultComponents = function defaultComponents(props) {
  return _extends({}, components, props.components);
};

var defaultStyles = {
  clearIndicator: clearIndicatorCSS,
  container: containerCSS,
  control: css,
  dropdownIndicator: dropdownIndicatorCSS,
  group: groupCSS,
  groupHeading: groupHeadingCSS,
  indicatorsContainer: indicatorsContainerCSS,
  indicatorSeparator: indicatorSeparatorCSS,
  input: inputCSS,
  loadingIndicator: loadingIndicatorCSS,
  loadingMessage: loadingMessageCSS,
  menu: menuCSS,
  menuList: menuListCSS,
  menuPortal: menuPortalCSS,
  multiValue: multiValueCSS,
  multiValueLabel: multiValueLabelCSS,
  multiValueRemove: multiValueRemoveCSS,
  noOptionsMessage: noOptionsMessageCSS,
  option: optionCSS,
  placeholder: placeholderCSS,
  singleValue: css$1,
  valueContainer: valueContainerCSS
};

// Merge Utility
// Allows consumers to extend a base Select with additional styles

function mergeStyles(source) {
  var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  // initialize with source styles
  var styles = _extends({}, source);

  // massage in target styles
  Object.keys(target).forEach(function (key) {
    if (source[key]) {
      styles[key] = function (rsCss, props) {
        return target[key](source[key](rsCss, props), props);
      };
    } else {
      styles[key] = target[key];
    }
  });

  return styles;
}

var colors = {
  primary: '#2684FF',
  primary75: '#4C9AFF',
  primary50: '#B2D4FF',
  primary25: '#DEEBFF',

  danger: '#DE350B',
  dangerLight: '#FFBDAD',

  neutral0: 'hsl(0, 0%, 100%)',
  neutral5: 'hsl(0, 0%, 95%)',
  neutral10: 'hsl(0, 0%, 90%)',
  neutral20: 'hsl(0, 0%, 80%)',
  neutral30: 'hsl(0, 0%, 70%)',
  neutral40: 'hsl(0, 0%, 60%)',
  neutral50: 'hsl(0, 0%, 50%)',
  neutral60: 'hsl(0, 0%, 40%)',
  neutral70: 'hsl(0, 0%, 30%)',
  neutral80: 'hsl(0, 0%, 20%)',
  neutral90: 'hsl(0, 0%, 10%)'
};

var borderRadius = 4;
var baseUnit = 4; /* Used to calculate consistent margin/padding on elements */
var controlHeight = 38; /* The minimum height of the control */
var menuGutter = baseUnit * 2; /* The amount of space between the control and menu */

var spacing = {
  baseUnit: baseUnit,
  controlHeight: controlHeight,
  menuGutter: menuGutter
};

var defaultTheme = {
  borderRadius: borderRadius,
  colors: colors,
  spacing: spacing
};

var defaultProps = {
  backspaceRemovesValue: true,
  blurInputOnSelect: isTouchCapable(),
  captureMenuScroll: !isTouchCapable(),
  closeMenuOnSelect: true,
  closeMenuOnScroll: false,
  components: {},
  controlShouldRenderValue: true,
  escapeClearsValue: false,
  filterOption: createFilter(),
  formatGroupLabel: formatGroupLabel,
  getOptionLabel: getOptionLabel,
  getOptionValue: getOptionValue,
  isDisabled: false,
  isLoading: false,
  isMulti: false,
  isRtl: false,
  isSearchable: true,
  isOptionDisabled: isOptionDisabled,
  loadingMessage: function loadingMessage() {
    return 'Loading...';
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: false,
  menuPlacement: 'bottom',
  menuPosition: 'absolute',
  menuShouldBlockScroll: false,
  menuShouldScrollIntoView: !isMobileDevice(),
  noOptionsMessage: function noOptionsMessage() {
    return 'No options';
  },
  openMenuOnFocus: false,
  openMenuOnClick: true,
  options: [],
  pageSize: 5,
  placeholder: 'Select...',
  screenReaderStatus: function screenReaderStatus(_ref) {
    var count = _ref.count;
    return count + ' result' + (count !== 1 ? 's' : '') + ' available';
  },
  styles: {},
  tabIndex: '0',
  tabSelectsValue: true
};

var instanceId = 1;

var getEmotion = Object(__WEBPACK_IMPORTED_MODULE_6_memoize_one__["a" /* default */])(function (nonce) {
  return Object(__WEBPACK_IMPORTED_MODULE_4_create_emotion__["a" /* default */])(nonce ? { nonce: nonce } : {});
});

var Select = function (_Component) {
  inherits(Select, _Component);

  // Lifecycle
  // ------------------------------

  // Refs
  // ------------------------------

  // TODO
  function Select(props) {
    classCallCheck(this, Select);

    var _this = possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));

    _initialiseProps.call(_this);

    var value = props.value;

    _this.cacheComponents = Object(__WEBPACK_IMPORTED_MODULE_6_memoize_one__["a" /* default */])(_this.cacheComponents, exportedEqual).bind(_this);
    _this.cacheComponents(props.components);
    _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++instanceId);

    var selectValue = cleanValue(value);
    var menuOptions = _this.buildMenuOptions(props, selectValue);

    _this.emotion = getEmotion(props.nonce);

    _this.state.menuOptions = menuOptions;
    _this.state.selectValue = selectValue;
    return _this;
  }

  // Misc. Instance Properties
  // ------------------------------

  createClass(Select, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.startListeningComposition();
      this.startListeningToTouch();

      if (this.props.closeMenuOnScroll && document && document.addEventListener) {
        // Listen to all scroll events, and filter them out inside of 'onScroll'
        document.addEventListener('scroll', this.onScroll, true);
      }

      if (this.props.autoFocus) {
        this.focusInput();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _props = this.props,
          options = _props.options,
          value = _props.value,
          inputValue = _props.inputValue;
      // re-cache custom components

      this.cacheComponents(nextProps.components);
      // rebuild the menu options
      if (nextProps.value !== value || nextProps.options !== options || nextProps.inputValue !== inputValue) {
        var _selectValue = cleanValue(nextProps.value);
        var _menuOptions = this.buildMenuOptions(nextProps, _selectValue);
        var _focusedValue = this.getNextFocusedValue(_selectValue);
        var _focusedOption = this.getNextFocusedOption(_menuOptions.focusable);
        this.setState({ menuOptions: _menuOptions, selectValue: _selectValue, focusedOption: _focusedOption, focusedValue: _focusedValue });
      }
      // some updates should toggle the state of the input visibility
      if (this.inputIsHiddenAfterUpdate != null) {
        this.setState({
          inputIsHidden: this.inputIsHiddenAfterUpdate
        });
        delete this.inputIsHiddenAfterUpdate;
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _props2 = this.props,
          isDisabled = _props2.isDisabled,
          menuIsOpen = _props2.menuIsOpen;
      var isFocused = this.state.isFocused;


      if (
      // ensure focus is restored correctly when the control becomes enabled
      isFocused && !isDisabled && prevProps.isDisabled ||
      // ensure focus is on the Input when the menu opens
      isFocused && menuIsOpen && !prevProps.menuIsOpen) {
        this.focusInput();
      }

      // scroll the focused option into view if necessary
      if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
        scrollIntoView(this.menuListRef, this.focusedOptionRef);
      }
      this.scrollToFocusedOptionOnUpdate = false;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stopListeningComposition();
      this.stopListeningToTouch();
      document.removeEventListener('scroll', this.onScroll, true);
    }
  }, {
    key: 'onMenuOpen',

    // ==============================
    // Consumer Handlers
    // ==============================

    value: function onMenuOpen() {
      this.props.onMenuOpen();
    }
  }, {
    key: 'onMenuClose',
    value: function onMenuClose() {
      var _props3 = this.props,
          isSearchable = _props3.isSearchable,
          isMulti = _props3.isMulti;

      this.announceAriaLiveContext({
        event: 'input',
        context: { isSearchable: isSearchable, isMulti: isMulti }
      });
      this.onInputChange('', { action: 'menu-close' });
      this.props.onMenuClose();
    }
  }, {
    key: 'onInputChange',
    value: function onInputChange(newValue, actionMeta) {
      this.props.onInputChange(newValue, actionMeta);
    }

    // ==============================
    // Methods
    // ==============================

  }, {
    key: 'focusInput',
    value: function focusInput() {
      if (!this.inputRef) return;
      this.inputRef.focus();
    }
  }, {
    key: 'blurInput',
    value: function blurInput() {
      if (!this.inputRef) return;
      this.inputRef.blur();
    }

    // aliased for consumers

  }, {
    key: 'openMenu',
    value: function openMenu(focusOption) {
      var _state = this.state,
          menuOptions = _state.menuOptions,
          selectValue = _state.selectValue;
      var isMulti = this.props.isMulti;

      var openAtIndex = focusOption === 'first' ? 0 : menuOptions.focusable.length - 1;

      if (!isMulti) {
        var selectedIndex = menuOptions.focusable.indexOf(selectValue[0]);
        if (selectedIndex > -1) {
          openAtIndex = selectedIndex;
        }
      }

      this.scrollToFocusedOptionOnUpdate = true;
      this.inputIsHiddenAfterUpdate = false;

      this.onMenuOpen();
      this.setState({
        focusedValue: null,
        focusedOption: menuOptions.focusable[openAtIndex]
      });

      this.announceAriaLiveContext({ event: 'menu' });
    }
  }, {
    key: 'focusValue',
    value: function focusValue(direction) {
      var _props4 = this.props,
          isMulti = _props4.isMulti,
          isSearchable = _props4.isSearchable;
      var _state2 = this.state,
          selectValue = _state2.selectValue,
          focusedValue = _state2.focusedValue;

      // Only multiselects support value focusing

      if (!isMulti) return;

      this.setState({
        focusedOption: null
      });

      var focusedIndex = selectValue.indexOf(focusedValue);
      if (!focusedValue) {
        focusedIndex = -1;
        this.announceAriaLiveContext({ event: 'value' });
      }

      var lastIndex = selectValue.length - 1;
      var nextFocus = -1;
      if (!selectValue.length) return;

      switch (direction) {
        case 'previous':
          if (focusedIndex === 0) {
            // don't cycle from the start to the end
            nextFocus = 0;
          } else if (focusedIndex === -1) {
            // if nothing is focused, focus the last value first
            nextFocus = lastIndex;
          } else {
            nextFocus = focusedIndex - 1;
          }
          break;
        case 'next':
          if (focusedIndex > -1 && focusedIndex < lastIndex) {
            nextFocus = focusedIndex + 1;
          }
          break;
      }

      if (nextFocus === -1) {
        this.announceAriaLiveContext({
          event: 'input',
          context: { isSearchable: isSearchable, isMulti: isMulti }
        });
      }

      this.setState({
        inputIsHidden: nextFocus === -1 ? false : true,
        focusedValue: selectValue[nextFocus]
      });
    }
  }, {
    key: 'focusOption',
    value: function focusOption() {
      var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
      var pageSize = this.props.pageSize;
      var _state3 = this.state,
          focusedOption = _state3.focusedOption,
          menuOptions = _state3.menuOptions;

      var options = menuOptions.focusable;

      if (!options.length) return;
      var nextFocus = 0; // handles 'first'
      var focusedIndex = options.indexOf(focusedOption);
      if (!focusedOption) {
        focusedIndex = -1;
        this.announceAriaLiveContext({ event: 'menu' });
      }

      if (direction === 'up') {
        nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
      } else if (direction === 'down') {
        nextFocus = (focusedIndex + 1) % options.length;
      } else if (direction === 'pageup') {
        nextFocus = focusedIndex - pageSize;
        if (nextFocus < 0) nextFocus = 0;
      } else if (direction === 'pagedown') {
        nextFocus = focusedIndex + pageSize;
        if (nextFocus > options.length - 1) nextFocus = options.length - 1;
      } else if (direction === 'last') {
        nextFocus = options.length - 1;
      }
      this.scrollToFocusedOptionOnUpdate = true;
      this.setState({
        focusedOption: options[nextFocus],
        focusedValue: null
      });
    }
  }, {
    key: 'getTheme',


    // ==============================
    // Getters
    // ==============================

    value: function getTheme() {
      // Use the default theme if there are no customizations.
      if (!this.props.theme) {
        return defaultTheme;
      }
      // If the theme prop is a function, assume the function
      // knows how to merge the passed-in default theme with
      // its own modifications.
      if (typeof this.props.theme === 'function') {
        return this.props.theme(defaultTheme);
      }
      // Otherwise, if a plain theme object was passed in,
      // overlay it with the default theme.
      return _extends({}, defaultTheme, this.props.theme);
    }
  }, {
    key: 'getCommonProps',
    value: function getCommonProps() {
      var clearValue = this.clearValue,
          getStyles = this.getStyles,
          setValue = this.setValue,
          selectOption = this.selectOption,
          props = this.props;
      var classNamePrefix = props.classNamePrefix,
          isMulti = props.isMulti,
          isRtl = props.isRtl,
          options = props.options;
      var selectValue = this.state.selectValue;

      var hasValue = this.hasValue();
      var getValue = function getValue() {
        return selectValue;
      };
      var cxPrefix = classNamePrefix;

      var cx = classNames.bind(null, cxPrefix);
      return {
        cx: cx,
        clearValue: clearValue,
        getStyles: getStyles,
        getValue: getValue,
        hasValue: hasValue,
        isMulti: isMulti,
        isRtl: isRtl,
        options: options,
        selectOption: selectOption,
        setValue: setValue,
        selectProps: props,
        theme: this.getTheme(),
        emotion: this.emotion
      };
    }
  }, {
    key: 'getNextFocusedValue',
    value: function getNextFocusedValue(nextSelectValue) {
      if (this.clearFocusValueOnUpdate) {
        this.clearFocusValueOnUpdate = false;
        return null;
      }
      var _state4 = this.state,
          focusedValue = _state4.focusedValue,
          lastSelectValue = _state4.selectValue;

      var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
      if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) {
          // the focused value is still in the selectValue, return it
          return focusedValue;
        } else if (lastFocusedIndex < nextSelectValue.length) {
          // the focusedValue is not present in the next selectValue array by
          // reference, so return the new value at the same index
          return nextSelectValue[lastFocusedIndex];
        }
      }
      return null;
    }
  }, {
    key: 'getNextFocusedOption',
    value: function getNextFocusedOption(options) {
      var lastFocusedOption = this.state.focusedOption;

      return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
    }

    // ==============================
    // Helpers
    // ==============================

  }, {
    key: 'hasValue',
    value: function hasValue() {
      var selectValue = this.state.selectValue;

      return selectValue.length > 0;
    }
  }, {
    key: 'hasOptions',
    value: function hasOptions() {
      return !!this.state.menuOptions.render.length;
    }
  }, {
    key: 'countOptions',
    value: function countOptions() {
      return this.state.menuOptions.focusable.length;
    }
  }, {
    key: 'isClearable',
    value: function isClearable() {
      var _props5 = this.props,
          isClearable = _props5.isClearable,
          isMulti = _props5.isMulti;

      // single select, by default, IS NOT clearable
      // multi select, by default, IS clearable

      if (isClearable === undefined) return isMulti;

      return isClearable;
    }
  }, {
    key: 'isOptionDisabled',
    value: function isOptionDisabled$$1(option, selectValue) {
      return typeof this.props.isOptionDisabled === 'function' ? this.props.isOptionDisabled(option, selectValue) : false;
    }
  }, {
    key: 'isOptionSelected',
    value: function isOptionSelected(option, selectValue) {
      var _this2 = this;

      if (selectValue.indexOf(option) > -1) return true;
      if (typeof this.props.isOptionSelected === 'function') {
        return this.props.isOptionSelected(option, selectValue);
      }
      var candidate = this.getOptionValue(option);
      return selectValue.some(function (i) {
        return _this2.getOptionValue(i) === candidate;
      });
    }
  }, {
    key: 'filterOption',
    value: function filterOption(option, inputValue) {
      return this.props.filterOption ? this.props.filterOption(option, inputValue) : true;
    }
  }, {
    key: 'formatOptionLabel',
    value: function formatOptionLabel(data, context) {
      if (typeof this.props.formatOptionLabel === 'function') {
        var _inputValue = this.props.inputValue;
        var _selectValue2 = this.state.selectValue;

        return this.props.formatOptionLabel(data, {
          context: context,
          inputValue: _inputValue,
          selectValue: _selectValue2
        });
      } else {
        return this.getOptionLabel(data);
      }
    }
  }, {
    key: 'formatGroupLabel',
    value: function formatGroupLabel$$1(data) {
      return this.props.formatGroupLabel(data);
    }

    // ==============================
    // Mouse Handlers
    // ==============================

  }, {
    key: 'startListeningComposition',


    // ==============================
    // Composition Handlers
    // ==============================

    value: function startListeningComposition() {
      if (document && document.addEventListener) {
        document.addEventListener('compositionstart', this.onCompositionStart, false);
        document.addEventListener('compositionend', this.onCompositionEnd, false);
      }
    }
  }, {
    key: 'stopListeningComposition',
    value: function stopListeningComposition() {
      if (document && document.removeEventListener) {
        document.removeEventListener('compositionstart', this.onCompositionStart);
        document.removeEventListener('compositionend', this.onCompositionEnd);
      }
    }
  }, {
    key: 'startListeningToTouch',


    // ==============================
    // Touch Handlers
    // ==============================

    value: function startListeningToTouch() {
      if (document && document.addEventListener) {
        document.addEventListener('touchstart', this.onTouchStart, false);
        document.addEventListener('touchmove', this.onTouchMove, false);
        document.addEventListener('touchend', this.onTouchEnd, false);
      }
    }
  }, {
    key: 'stopListeningToTouch',
    value: function stopListeningToTouch() {
      if (document && document.removeEventListener) {
        document.removeEventListener('touchstart', this.onTouchStart);
        document.removeEventListener('touchmove', this.onTouchMove);
        document.removeEventListener('touchend', this.onTouchEnd);
      }
    }

    // ==============================
    // Focus Handlers
    // ==============================

    // ==============================
    // Keyboard Handlers
    // ==============================

  }, {
    key: 'buildMenuOptions',


    // ==============================
    // Menu Options
    // ==============================

    value: function buildMenuOptions(props, selectValue) {
      var _this3 = this;

      var _props$inputValue = props.inputValue,
          inputValue = _props$inputValue === undefined ? '' : _props$inputValue,
          options = props.options;


      var toOption = function toOption(option, id) {
        var isDisabled = _this3.isOptionDisabled(option, selectValue);
        var isSelected = _this3.isOptionSelected(option, selectValue);
        var label = _this3.getOptionLabel(option);
        var value = _this3.getOptionValue(option);

        if (_this3.shouldHideSelectedOptions() && isSelected || !_this3.filterOption({ label: label, value: value, data: option }, inputValue)) {
          return;
        }

        var onHover = isDisabled ? undefined : function () {
          return _this3.onOptionHover(option);
        };
        var onSelect = isDisabled ? undefined : function () {
          return _this3.selectOption(option);
        };
        var optionId = _this3.getElementId('option') + '-' + id;

        return {
          innerProps: {
            id: optionId,
            onClick: onSelect,
            onMouseMove: onHover,
            onMouseOver: onHover,
            role: 'option',
            tabIndex: -1
          },
          data: option,
          isDisabled: isDisabled,
          isSelected: isSelected,
          key: optionId,
          label: label,
          type: 'option',
          value: value
        };
      };

      return options.reduce(function (acc, item, itemIndex) {
        if (item.options) {
          // TODO needs a tidier implementation
          if (!_this3.hasGroups) _this3.hasGroups = true;

          var items = item.options;

          var children = items.map(function (child, i) {
            var option = toOption(child, itemIndex + '-' + i);
            if (option && !option.isDisabled) acc.focusable.push(child);
            return option;
          }).filter(Boolean);
          if (children.length) {
            var groupId = _this3.getElementId('group') + '-' + itemIndex;
            acc.render.push({
              type: 'group',
              key: groupId,
              data: item,
              options: children
            });
          }
        } else {
          var option = toOption(item, '' + itemIndex);
          if (option) {
            acc.render.push(option);
            if (!option.isDisabled) acc.focusable.push(item);
          }
        }
        return acc;
      }, { render: [], focusable: [] });
    }

    // ==============================
    // Renderers
    // ==============================

  }, {
    key: 'constructAriaLiveMessage',
    value: function constructAriaLiveMessage() {
      var _state5 = this.state,
          ariaLiveContext = _state5.ariaLiveContext,
          selectValue = _state5.selectValue,
          focusedValue = _state5.focusedValue,
          focusedOption = _state5.focusedOption;
      var _props6 = this.props,
          options = _props6.options,
          menuIsOpen = _props6.menuIsOpen,
          inputValue = _props6.inputValue,
          screenReaderStatus = _props6.screenReaderStatus;

      // An aria live message representing the currently focused value in the select.

      var focusedValueMsg = focusedValue ? valueFocusAriaMessage({
        focusedValue: focusedValue,
        getOptionLabel: this.getOptionLabel,
        selectValue: selectValue
      }) : '';
      // An aria live message representing the currently focused option in the select.
      var focusedOptionMsg = focusedOption && menuIsOpen ? optionFocusAriaMessage({
        focusedOption: focusedOption,
        getOptionLabel: this.getOptionLabel,
        options: options
      }) : '';
      // An aria live message representing the set of focusable results and current searchterm/inputvalue.
      var resultsMsg = resultsAriaMessage({
        inputValue: inputValue,
        screenReaderMessage: screenReaderStatus({ count: this.countOptions() })
      });

      return focusedValueMsg + ' ' + focusedOptionMsg + ' ' + resultsMsg + ' ' + ariaLiveContext;
    }
  }, {
    key: 'renderInput',
    value: function renderInput() {
      var _props7 = this.props,
          isDisabled = _props7.isDisabled,
          isSearchable = _props7.isSearchable,
          inputId = _props7.inputId,
          inputValue = _props7.inputValue,
          tabIndex = _props7.tabIndex;
      var Input = this.components.Input;
      var inputIsHidden = this.state.inputIsHidden;


      var id = inputId || this.getElementId('input');

      if (!isSearchable) {
        // use a dummy input to maintain focus/blur functionality
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(DummyInput, {
          id: id,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: noop,
          onFocus: this.onInputFocus,
          readOnly: true,
          disabled: isDisabled,
          tabIndex: tabIndex,
          value: '',
          emotion: this.emotion
        });
      }

      // aria attributes makes the JSX "noisy", separated for clarity
      var ariaAttributes = {
        'aria-autocomplete': 'list',
        'aria-label': this.props['aria-label'],
        'aria-labelledby': this.props['aria-labelledby']
      };

      var _commonProps = this.commonProps,
          cx = _commonProps.cx,
          theme = _commonProps.theme,
          selectProps = _commonProps.selectProps;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Input, _extends({
        autoCapitalize: 'none',
        autoComplete: 'off',
        autoCorrect: 'off',
        cx: cx,
        getStyles: this.getStyles,
        id: id,
        innerRef: this.getInputRef,
        isDisabled: isDisabled,
        isHidden: inputIsHidden,
        onBlur: this.onInputBlur,
        onChange: this.handleInputChange,
        onFocus: this.onInputFocus,
        selectProps: selectProps,
        spellCheck: 'false',
        tabIndex: tabIndex,
        theme: theme,
        type: 'text',
        value: inputValue,
        emotion: this.emotion
      }, ariaAttributes));
    }
  }, {
    key: 'renderPlaceholderOrValue',
    value: function renderPlaceholderOrValue() {
      var _this4 = this;

      var _components = this.components,
          MultiValue = _components.MultiValue,
          MultiValueContainer = _components.MultiValueContainer,
          MultiValueLabel = _components.MultiValueLabel,
          MultiValueRemove = _components.MultiValueRemove,
          SingleValue = _components.SingleValue,
          Placeholder = _components.Placeholder;
      var commonProps = this.commonProps;
      var _props8 = this.props,
          controlShouldRenderValue = _props8.controlShouldRenderValue,
          isDisabled = _props8.isDisabled,
          isMulti = _props8.isMulti,
          inputValue = _props8.inputValue,
          placeholder = _props8.placeholder;
      var _state6 = this.state,
          selectValue = _state6.selectValue,
          focusedValue = _state6.focusedValue,
          isFocused = _state6.isFocused;


      if (!this.hasValue() || !controlShouldRenderValue) {
        return inputValue ? null : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          Placeholder,
          _extends({}, commonProps, {
            key: 'placeholder',
            isDisabled: isDisabled,
            isFocused: isFocused
          }),
          placeholder
        );
      }

      if (isMulti) {
        var selectValues = selectValue.map(function (opt) {
          var isFocused = opt === focusedValue;
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            MultiValue,
            _extends({}, commonProps, {
              components: {
                Container: MultiValueContainer,
                Label: MultiValueLabel,
                Remove: MultiValueRemove
              },
              isFocused: isFocused,
              isDisabled: isDisabled,
              key: _this4.getOptionValue(opt),
              removeProps: {
                onClick: function onClick() {
                  return _this4.removeValue(opt);
                },
                onTouchEnd: function onTouchEnd() {
                  return _this4.removeValue(opt);
                },
                onMouseDown: function onMouseDown(e) {
                  e.preventDefault();
                  e.stopPropagation();
                }
              },
              data: opt
            }),
            _this4.formatOptionLabel(opt, 'value')
          );
        });
        return selectValues;
      }

      if (inputValue) {
        return null;
      }

      var singleValue = selectValue[0];
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        SingleValue,
        _extends({}, commonProps, { data: singleValue, isDisabled: isDisabled }),
        this.formatOptionLabel(singleValue, 'value')
      );
    }
  }, {
    key: 'renderClearIndicator',
    value: function renderClearIndicator() {
      var ClearIndicator = this.components.ClearIndicator;
      var commonProps = this.commonProps;
      var _props9 = this.props,
          isDisabled = _props9.isDisabled,
          isLoading = _props9.isLoading;
      var isFocused = this.state.isFocused;


      if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) {
        return null;
      }

      var innerProps = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        'aria-hidden': 'true'
      };

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ClearIndicator, _extends({}, commonProps, {
        innerProps: innerProps,
        isFocused: isFocused
      }));
    }
  }, {
    key: 'renderLoadingIndicator',
    value: function renderLoadingIndicator() {
      var LoadingIndicator = this.components.LoadingIndicator;
      var commonProps = this.commonProps;
      var _props10 = this.props,
          isDisabled = _props10.isDisabled,
          isLoading = _props10.isLoading;
      var isFocused = this.state.isFocused;


      if (!LoadingIndicator || !isLoading) return null;

      var innerProps = { 'aria-hidden': 'true' };
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(LoadingIndicator, _extends({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: 'renderIndicatorSeparator',
    value: function renderIndicatorSeparator() {
      var _components2 = this.components,
          DropdownIndicator = _components2.DropdownIndicator,
          IndicatorSeparator = _components2.IndicatorSeparator;

      // separator doesn't make sense without the dropdown indicator

      if (!DropdownIndicator || !IndicatorSeparator) return null;

      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(IndicatorSeparator, _extends({}, commonProps, {
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: 'renderDropdownIndicator',
    value: function renderDropdownIndicator() {
      var DropdownIndicator = this.components.DropdownIndicator;

      if (!DropdownIndicator) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;


      var innerProps = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        'aria-hidden': 'true'
      };

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(DropdownIndicator, _extends({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: 'renderMenu',
    value: function renderMenu() {
      var _this5 = this;

      var _components3 = this.components,
          Group = _components3.Group,
          GroupHeading = _components3.GroupHeading,
          Menu$$1 = _components3.Menu,
          MenuList$$1 = _components3.MenuList,
          MenuPortal$$1 = _components3.MenuPortal,
          LoadingMessage$$1 = _components3.LoadingMessage,
          NoOptionsMessage$$1 = _components3.NoOptionsMessage,
          Option = _components3.Option;
      var commonProps = this.commonProps;
      var _state7 = this.state,
          focusedOption = _state7.focusedOption,
          menuOptions = _state7.menuOptions;
      var _props11 = this.props,
          captureMenuScroll = _props11.captureMenuScroll,
          inputValue = _props11.inputValue,
          isLoading = _props11.isLoading,
          loadingMessage = _props11.loadingMessage,
          minMenuHeight = _props11.minMenuHeight,
          maxMenuHeight = _props11.maxMenuHeight,
          menuIsOpen = _props11.menuIsOpen,
          menuPlacement = _props11.menuPlacement,
          menuPosition = _props11.menuPosition,
          menuPortalTarget = _props11.menuPortalTarget,
          menuShouldBlockScroll = _props11.menuShouldBlockScroll,
          menuShouldScrollIntoView = _props11.menuShouldScrollIntoView,
          noOptionsMessage = _props11.noOptionsMessage,
          onMenuScrollToTop = _props11.onMenuScrollToTop,
          onMenuScrollToBottom = _props11.onMenuScrollToBottom;


      if (!menuIsOpen) return null;

      // TODO: Internal Option Type here
      var render = function render(props) {
        // for performance, the menu options in state aren't changed when the
        // focused option changes so we calculate additional props based on that
        var isFocused = focusedOption === props.data;
        props.innerRef = isFocused ? _this5.getFocusedOptionRef : undefined;

        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          Option,
          _extends({}, commonProps, props, { isFocused: isFocused }),
          _this5.formatOptionLabel(props.data, 'menu')
        );
      };

      var menuUI = void 0;

      if (this.hasOptions()) {
        menuUI = menuOptions.render.map(function (item) {
          if (item.type === 'group') {
            var type = item.type,
                group = objectWithoutProperties(item, ['type']);

            var headingId = item.key + '-heading';

            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              Group,
              _extends({}, commonProps, group, {
                Heading: GroupHeading,
                headingProps: {
                  id: headingId
                },
                label: _this5.formatGroupLabel(item.data)
              }),
              item.options.map(function (option) {
                return render(option);
              })
            );
          } else if (item.type === 'option') {
            return render(item);
          }
        });
      } else if (isLoading) {
        var message = loadingMessage({ inputValue: inputValue });
        if (message === null) return null;
        menuUI = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          LoadingMessage$$1,
          commonProps,
          message
        );
      } else {
        var _message = noOptionsMessage({ inputValue: inputValue });
        if (_message === null) return null;
        menuUI = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          NoOptionsMessage$$1,
          commonProps,
          _message
        );
      }
      var menuPlacementProps = {
        minMenuHeight: minMenuHeight,
        maxMenuHeight: maxMenuHeight,
        menuPlacement: menuPlacement,
        menuPosition: menuPosition,
        menuShouldScrollIntoView: menuShouldScrollIntoView
      };

      var menuElement = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        MenuPlacer,
        _extends({}, commonProps, menuPlacementProps),
        function (_ref2) {
          var ref = _ref2.ref,
              _ref2$placerProps = _ref2.placerProps,
              placement = _ref2$placerProps.placement,
              maxHeight = _ref2$placerProps.maxHeight;
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            Menu$$1,
            _extends({}, commonProps, menuPlacementProps, {
              innerRef: ref,
              innerProps: {
                onMouseDown: _this5.onMenuMouseDown,
                onMouseMove: _this5.onMenuMouseMove
              },
              isLoading: isLoading,
              placement: placement
            }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              ScrollCaptorSwitch,
              {
                isEnabled: captureMenuScroll,
                onTopArrive: onMenuScrollToTop,
                onBottomArrive: onMenuScrollToBottom
              },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                ScrollBlock,
                { emotion: _this5.emotion, isEnabled: menuShouldBlockScroll },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  MenuList$$1,
                  _extends({}, commonProps, {
                    innerRef: _this5.getMenuListRef,
                    isLoading: isLoading,
                    maxHeight: maxHeight
                  }),
                  menuUI
                )
              )
            )
          );
        }
      );

      // positioning behaviour is almost identical for portalled and fixed,
      // so we use the same component. the actual portalling logic is forked
      // within the component based on `menuPosition`
      return menuPortalTarget || menuPosition === 'fixed' ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        MenuPortal$$1,
        _extends({}, commonProps, {
          appendTo: menuPortalTarget,
          controlElement: this.controlRef,
          menuPlacement: menuPlacement,
          menuPosition: menuPosition
        }),
        menuElement
      ) : menuElement;
    }
  }, {
    key: 'renderFormField',
    value: function renderFormField() {
      var _this6 = this;

      var _props12 = this.props,
          delimiter = _props12.delimiter,
          isDisabled = _props12.isDisabled,
          isMulti = _props12.isMulti,
          name = _props12.name;
      var selectValue = this.state.selectValue;


      if (!name || isDisabled) return;

      if (isMulti) {
        if (delimiter) {
          var _value = selectValue.map(function (opt) {
            return _this6.getOptionValue(opt);
          }).join(delimiter);
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', { name: name, type: 'hidden', value: _value });
        } else {
          var input = selectValue.length > 0 ? selectValue.map(function (opt, i) {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', {
              key: 'i-' + i,
              name: name,
              type: 'hidden',
              value: _this6.getOptionValue(opt)
            });
          }) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', { name: name, type: 'hidden' });

          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            null,
            input
          );
        }
      } else {
        var _value2 = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', { name: name, type: 'hidden', value: _value2 });
      }
    }
  }, {
    key: 'renderLiveRegion',
    value: function renderLiveRegion() {
      if (!this.state.isFocused) return null;
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        A11yText,
        { emotion: this.emotion, 'aria-live': 'assertive' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          { id: 'aria-selection-event' },
          '\xA0',
          this.state.ariaLiveSelection
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          { id: 'aria-context' },
          '\xA0',
          this.constructAriaLiveMessage()
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _components4 = this.components,
          Control = _components4.Control,
          IndicatorsContainer = _components4.IndicatorsContainer,
          SelectContainer = _components4.SelectContainer,
          ValueContainer = _components4.ValueContainer;
      var _props13 = this.props,
          className = _props13.className,
          id = _props13.id,
          isDisabled = _props13.isDisabled;
      var isFocused = this.state.isFocused;


      var commonProps = this.commonProps = this.getCommonProps();

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        SelectContainer,
        _extends({}, commonProps, {
          className: className,
          innerProps: {
            id: id,
            onKeyDown: this.onKeyDown
          },
          isDisabled: isDisabled,
          isFocused: isFocused
        }),
        this.renderLiveRegion(),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          Control,
          _extends({}, commonProps, {
            innerRef: this.getControlRef,
            innerProps: {
              onMouseDown: this.onControlMouseDown,
              onTouchEnd: this.onControlTouchEnd
            },
            isDisabled: isDisabled,
            isFocused: isFocused
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            ValueContainer,
            _extends({}, commonProps, { isDisabled: isDisabled }),
            this.renderPlaceholderOrValue(),
            this.renderInput()
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            IndicatorsContainer,
            _extends({}, commonProps, { isDisabled: isDisabled }),
            this.renderClearIndicator(),
            this.renderLoadingIndicator(),
            this.renderIndicatorSeparator(),
            this.renderDropdownIndicator()
          )
        ),
        this.renderMenu(),
        this.renderFormField()
      );
    }
  }]);
  return Select;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

Select.defaultProps = defaultProps;

var _initialiseProps = function _initialiseProps() {
  var _this7 = this;

  this.state = {
    ariaLiveSelection: '',
    ariaLiveContext: '',
    focusedOption: null,
    focusedValue: null,
    inputIsHidden: false,
    isFocused: false,
    isComposing: false,
    menuOptions: { render: [], focusable: [] },
    selectValue: []
  };
  this.blockOptionHover = false;
  this.clearFocusValueOnUpdate = false;
  this.hasGroups = false;
  this.initialTouchX = 0;
  this.initialTouchY = 0;
  this.instancePrefix = '';
  this.openAfterFocus = false;
  this.scrollToFocusedOptionOnUpdate = false;
  this.controlRef = null;

  this.getControlRef = function (ref) {
    _this7.controlRef = ref;
  };

  this.focusedOptionRef = null;

  this.getFocusedOptionRef = function (ref) {
    _this7.focusedOptionRef = ref;
  };

  this.menuListRef = null;

  this.getMenuListRef = function (ref) {
    _this7.menuListRef = ref;
  };

  this.inputRef = null;

  this.getInputRef = function (ref) {
    _this7.inputRef = ref;
  };

  this.cacheComponents = function (components$$1) {
    _this7.components = defaultComponents({ components: components$$1 });
  };

  this.focus = this.focusInput;
  this.blur = this.blurInput;

  this.onChange = function (newValue, actionMeta) {
    var _props14 = _this7.props,
        onChange = _props14.onChange,
        name = _props14.name;

    onChange(newValue, _extends({}, actionMeta, { name: name }));
  };

  this.setValue = function (newValue) {
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'set-value';
    var option = arguments[2];
    var _props15 = _this7.props,
        closeMenuOnSelect = _props15.closeMenuOnSelect,
        isMulti = _props15.isMulti;

    _this7.onInputChange('', { action: 'set-value' });
    if (closeMenuOnSelect) {
      _this7.inputIsHiddenAfterUpdate = !isMulti;
      _this7.onMenuClose();
    }
    // when the select value should change, we should reset focusedValue
    _this7.clearFocusValueOnUpdate = true;
    _this7.onChange(newValue, { action: action, option: option });
  };

  this.selectOption = function (newValue) {
    var _props16 = _this7.props,
        blurInputOnSelect = _props16.blurInputOnSelect,
        isMulti = _props16.isMulti;


    if (isMulti) {
      var _selectValue3 = _this7.state.selectValue;

      if (_this7.isOptionSelected(newValue, _selectValue3)) {
        var candidate = _this7.getOptionValue(newValue);
        _this7.setValue(_selectValue3.filter(function (i) {
          return _this7.getOptionValue(i) !== candidate;
        }), 'deselect-option', newValue);
        _this7.announceAriaLiveSelection({
          event: 'deselect-option',
          context: { value: _this7.getOptionLabel(newValue) }
        });
      } else {
        _this7.setValue([].concat(toConsumableArray(_selectValue3), [newValue]), 'select-option', newValue);
        _this7.announceAriaLiveSelection({
          event: 'select-option',
          context: { value: _this7.getOptionLabel(newValue) }
        });
      }
    } else {
      _this7.setValue(newValue, 'select-option');
      _this7.announceAriaLiveSelection({
        event: 'select-option',
        context: { value: _this7.getOptionLabel(newValue) }
      });
    }

    if (blurInputOnSelect) {
      _this7.blurInput();
    }
  };

  this.removeValue = function (removedValue) {
    var selectValue = _this7.state.selectValue;

    var candidate = _this7.getOptionValue(removedValue);
    _this7.onChange(selectValue.filter(function (i) {
      return _this7.getOptionValue(i) !== candidate;
    }), {
      action: 'remove-value',
      removedValue: removedValue
    });
    _this7.announceAriaLiveSelection({
      event: 'remove-value',
      context: {
        value: removedValue ? _this7.getOptionLabel(removedValue) : undefined
      }
    });
    _this7.focusInput();
  };

  this.clearValue = function () {
    var isMulti = _this7.props.isMulti;

    _this7.onChange(isMulti ? [] : null, { action: 'clear' });
  };

  this.popValue = function () {
    var selectValue = _this7.state.selectValue;

    var lastSelectedValue = selectValue[selectValue.length - 1];
    _this7.announceAriaLiveSelection({
      event: 'pop-value',
      context: {
        value: lastSelectedValue ? _this7.getOptionLabel(lastSelectedValue) : undefined
      }
    });
    _this7.onChange(selectValue.slice(0, selectValue.length - 1), {
      action: 'pop-value',
      removedValue: lastSelectedValue
    });
  };

  this.getOptionLabel = function (data) {
    return _this7.props.getOptionLabel(data);
  };

  this.getOptionValue = function (data) {
    return _this7.props.getOptionValue(data);
  };

  this.getStyles = function (key, props) {
    var base = defaultStyles[key](props);
    base.boxSizing = 'border-box';
    var custom = _this7.props.styles[key];
    return custom ? custom(base, props) : base;
  };

  this.getElementId = function (element) {
    return _this7.instancePrefix + '-' + element;
  };

  this.getActiveDescendentId = function () {
    var menuIsOpen = _this7.props.menuIsOpen;
    var _state8 = _this7.state,
        menuOptions = _state8.menuOptions,
        focusedOption = _state8.focusedOption;


    if (!focusedOption || !menuIsOpen) return undefined;

    var index = menuOptions.focusable.indexOf(focusedOption);
    var option = menuOptions.render[index];

    return option && option.key;
  };

  this.announceAriaLiveSelection = function (_ref3) {
    var event = _ref3.event,
        context = _ref3.context;

    _this7.setState({
      ariaLiveSelection: valueEventAriaMessage(event, context)
    });
  };

  this.announceAriaLiveContext = function (_ref4) {
    var event = _ref4.event,
        context = _ref4.context;

    _this7.setState({
      ariaLiveContext: instructionsAriaMessage(event, _extends({}, context, {
        label: _this7.props['aria-label']
      }))
    });
  };

  this.onMenuMouseDown = function (event) {
    if (event.button !== 0) {
      return;
    }
    event.stopPropagation();
    event.preventDefault();
    _this7.focusInput();
  };

  this.onMenuMouseMove = function (event) {
    _this7.blockOptionHover = false;
  };

  this.onControlMouseDown = function (event) {
    var openMenuOnClick = _this7.props.openMenuOnClick;

    if (!_this7.state.isFocused) {
      if (openMenuOnClick) {
        _this7.openAfterFocus = true;
      }
      _this7.focusInput();
    } else if (!_this7.props.menuIsOpen) {
      _this7.openMenu('first');
    } else {
      // $FlowFixMe HTMLElement type does not have tagName property
      if (event.target.tagName !== 'INPUT') {
        _this7.onMenuClose();
      }
    }
    // $FlowFixMe HTMLElement type does not have tagName property
    if (event.target.tagName !== 'INPUT') {
      event.preventDefault();
    }
  };

  this.onDropdownIndicatorMouseDown = function (event) {
    // ignore mouse events that weren't triggered by the primary button
    if (event && event.type === 'mousedown' && event.button !== 0) {
      return;
    }
    if (_this7.props.isDisabled) return;
    var _props17 = _this7.props,
        isMulti = _props17.isMulti,
        menuIsOpen = _props17.menuIsOpen;

    _this7.focusInput();
    if (menuIsOpen) {
      _this7.inputIsHiddenAfterUpdate = !isMulti;
      _this7.onMenuClose();
    } else {
      _this7.openMenu('first');
    }
    event.preventDefault();
    event.stopPropagation();
  };

  this.onClearIndicatorMouseDown = function (event) {
    // ignore mouse events that weren't triggered by the primary button
    if (event && event.type === 'mousedown' && event.button !== 0) {
      return;
    }
    _this7.clearValue();
    event.stopPropagation();
    _this7.openAfterFocus = false;
    setTimeout(function () {
      return _this7.focusInput();
    });
  };

  this.onScroll = function (event) {
    if (typeof _this7.props.closeMenuOnScroll === 'boolean') {
      if (event.target instanceof HTMLElement && isDocumentElement(event.target)) {
        _this7.props.onMenuClose();
      }
    } else if (typeof _this7.props.closeMenuOnScroll === 'function') {
      if (_this7.props.closeMenuOnScroll(event)) {
        _this7.props.onMenuClose();
      }
    }
  };

  this.onCompositionStart = function () {
    _this7.setState({
      isComposing: true
    });
  };

  this.onCompositionEnd = function () {
    _this7.setState({
      isComposing: false
    });
  };

  this.onTouchStart = function (_ref5) {
    var touches = _ref5.touches;

    var touch = touches.item(0);
    if (!touch) {
      return;
    }

    _this7.initialTouchX = touch.clientX;
    _this7.initialTouchY = touch.clientY;
    _this7.userIsDragging = false;
  };

  this.onTouchMove = function (_ref6) {
    var touches = _ref6.touches;

    var touch = touches.item(0);
    if (!touch) {
      return;
    }

    var deltaX = Math.abs(touch.clientX - _this7.initialTouchX);
    var deltaY = Math.abs(touch.clientY - _this7.initialTouchY);
    var moveThreshold = 5;

    _this7.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
  };

  this.onTouchEnd = function (event) {
    if (_this7.userIsDragging) return;

    // type cast the EventTarget
    var target = event.target;

    // close the menu if the user taps outside
    if (_this7.controlRef && !_this7.controlRef.contains(target) && _this7.menuListRef && !_this7.menuListRef.contains(target)) {
      _this7.blurInput();
    }

    // reset move vars
    _this7.initialTouchX = 0;
    _this7.initialTouchY = 0;
  };

  this.onControlTouchEnd = function (event) {
    if (_this7.userIsDragging) return;

    _this7.onControlMouseDown(event);
  };

  this.onClearIndicatorTouchEnd = function (event) {
    if (_this7.userIsDragging) return;

    _this7.onClearIndicatorMouseDown(event);
  };

  this.onDropdownIndicatorTouchEnd = function (event) {
    if (_this7.userIsDragging) return;

    _this7.onDropdownIndicatorMouseDown(event);
  };

  this.handleInputChange = function (event) {
    var inputValue = event.currentTarget.value;
    _this7.inputIsHiddenAfterUpdate = false;
    _this7.onInputChange(inputValue, { action: 'input-change' });
    _this7.onMenuOpen();
  };

  this.onInputFocus = function (event) {
    var _props18 = _this7.props,
        isSearchable = _props18.isSearchable,
        isMulti = _props18.isMulti;

    if (_this7.props.onFocus) {
      _this7.props.onFocus(event);
    }
    _this7.inputIsHiddenAfterUpdate = false;
    _this7.announceAriaLiveContext({
      event: 'input',
      context: { isSearchable: isSearchable, isMulti: isMulti }
    });
    _this7.setState({
      isFocused: true
    });
    if (_this7.openAfterFocus || _this7.props.openMenuOnFocus) {
      _this7.openMenu('first');
    }
    _this7.openAfterFocus = false;
  };

  this.onInputBlur = function (event) {
    if (_this7.menuListRef && _this7.menuListRef.contains(document.activeElement)) {
      _this7.inputRef.focus();
      return;
    }
    if (_this7.props.onBlur) {
      _this7.props.onBlur(event);
    }
    _this7.onInputChange('', { action: 'input-blur' });
    _this7.onMenuClose();
    _this7.setState({
      focusedValue: null,
      isFocused: false
    });
  };

  this.onOptionHover = function (focusedOption) {
    if (_this7.blockOptionHover || _this7.state.focusedOption === focusedOption) {
      return;
    }
    _this7.setState({ focusedOption: focusedOption });
  };

  this.shouldHideSelectedOptions = function () {
    var _props19 = _this7.props,
        hideSelectedOptions = _props19.hideSelectedOptions,
        isMulti = _props19.isMulti;

    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
  };

  this.onKeyDown = function (event) {
    var _props20 = _this7.props,
        isMulti = _props20.isMulti,
        backspaceRemovesValue = _props20.backspaceRemovesValue,
        escapeClearsValue = _props20.escapeClearsValue,
        inputValue = _props20.inputValue,
        isClearable = _props20.isClearable,
        isDisabled = _props20.isDisabled,
        menuIsOpen = _props20.menuIsOpen,
        onKeyDown = _props20.onKeyDown,
        tabSelectsValue = _props20.tabSelectsValue,
        openMenuOnFocus = _props20.openMenuOnFocus;
    var _state9 = _this7.state,
        isComposing = _state9.isComposing,
        focusedOption = _state9.focusedOption,
        focusedValue = _state9.focusedValue,
        selectValue = _state9.selectValue;


    if (isDisabled) return;

    if (typeof onKeyDown === 'function') {
      onKeyDown(event);
      if (event.defaultPrevented) {
        return;
      }
    }

    // Block option hover events when the user has just pressed a key
    _this7.blockOptionHover = true;
    switch (event.key) {
      case 'ArrowLeft':
        if (!isMulti || inputValue) return;
        _this7.focusValue('previous');
        break;
      case 'ArrowRight':
        if (!isMulti || inputValue) return;
        _this7.focusValue('next');
        break;
      case 'Delete':
      case 'Backspace':
        if (inputValue) return;
        if (focusedValue) {
          _this7.removeValue(focusedValue);
        } else {
          if (!backspaceRemovesValue) return;
          if (isMulti) {
            _this7.popValue();
          } else if (isClearable) {
            _this7.clearValue();
          }
        }
        break;
      case 'Tab':
        if (isComposing) return;

        if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption ||
        // don't capture the event if the menu opens on focus and the focused
        // option is already selected; it breaks the flow of navigation
        openMenuOnFocus && _this7.isOptionSelected(focusedOption, selectValue)) {
          return;
        }
        _this7.selectOption(focusedOption);
        break;
      case 'Enter':
        if (menuIsOpen) {
          if (!focusedOption) return;
          if (isComposing) return;
          _this7.selectOption(focusedOption);
        } else {
          _this7.focusOption('first');
        }
        break;
      case 'Escape':
        if (menuIsOpen) {
          _this7.inputIsHiddenAfterUpdate = false;
          _this7.onInputChange('', { action: 'menu-close' });
          _this7.onMenuClose();
        } else if (isClearable && escapeClearsValue) {
          _this7.clearValue();
        }
        break;
      case ' ':
        // space
        if (inputValue) {
          return;
        }
        if (!menuIsOpen) {
          _this7.openMenu('first');
          break;
        }
        if (!focusedOption) return;
        _this7.selectOption(focusedOption);
        break;
      case 'ArrowUp':
        if (menuIsOpen) {
          _this7.focusOption('up');
        } else {
          _this7.openMenu('last');
        }
        break;
      case 'ArrowDown':
        if (menuIsOpen) {
          _this7.focusOption('down');
        } else {
          _this7.openMenu('first');
        }
        break;
      case 'PageUp':
        if (!menuIsOpen) return;
        _this7.focusOption('pageup');
        break;
      case 'PageDown':
        if (!menuIsOpen) return;
        _this7.focusOption('pagedown');
        break;
      case 'Home':
        if (!menuIsOpen) return;
        _this7.focusOption('first');
        break;
      case 'End':
        if (!menuIsOpen) return;
        _this7.focusOption('last');
        break;
      default:
        return;
    }
    event.preventDefault();
  };
};

var manageState = function manageState(SelectComponent) {
  var _class, _temp2;

  return _temp2 = _class = function (_Component) {
    inherits(StateManager, _Component);

    function StateManager() {
      var _ref;

      var _temp, _this, _ret;

      classCallCheck(this, StateManager);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = StateManager.__proto__ || Object.getPrototypeOf(StateManager)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        inputValue: _this.props.inputValue !== undefined ? _this.props.inputValue : _this.props.defaultInputValue,
        menuIsOpen: _this.props.menuIsOpen !== undefined ? _this.props.menuIsOpen : _this.props.defaultMenuIsOpen,
        value: _this.props.value !== undefined ? _this.props.value : _this.props.defaultValue
      }, _this.onChange = function (value, actionMeta) {
        _this.callProp('onChange', value, actionMeta);
        _this.setState({ value: value });
      }, _this.onInputChange = function (value, actionMeta) {
        // TODO: for backwards compatibility, we allow the prop to return a new
        // value, but now inputValue is a controllable prop we probably shouldn't
        var newValue = _this.callProp('onInputChange', value, actionMeta);
        _this.setState({
          inputValue: newValue !== undefined ? newValue : value
        });
      }, _this.onMenuOpen = function () {
        _this.callProp('onMenuOpen');
        _this.setState({ menuIsOpen: true });
      }, _this.onMenuClose = function () {
        _this.callProp('onMenuClose');
        _this.setState({ menuIsOpen: false });
      }, _temp), possibleConstructorReturn(_this, _ret);
    }

    createClass(StateManager, [{
      key: 'focus',
      value: function focus() {
        this.select.focus();
      }
    }, {
      key: 'blur',
      value: function blur() {
        this.select.blur();
      }
    }, {
      key: 'getProp',
      value: function getProp(key) {
        return this.props[key] !== undefined ? this.props[key] : this.state[key];
      }
    }, {
      key: 'callProp',
      value: function callProp(name) {
        if (typeof this.props[name] === 'function') {
          var _props;

          for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          return (_props = this.props)[name].apply(_props, toConsumableArray(args));
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SelectComponent, _extends({}, this.props, {
          ref: function ref(_ref2) {
            _this2.select = _ref2;
          },
          inputValue: this.getProp('inputValue'),
          menuIsOpen: this.getProp('menuIsOpen'),
          onChange: this.onChange,
          onInputChange: this.onInputChange,
          onMenuClose: this.onMenuClose,
          onMenuOpen: this.onMenuOpen,
          value: this.getProp('value')
        }));
      }
    }]);
    return StateManager;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class.defaultProps = {
    defaultInputValue: '',
    defaultMenuIsOpen: false,
    defaultValue: null
  }, _temp2;
};

var defaultProps$1 = {
  cacheOptions: false,
  defaultOptions: false
};

var makeAsyncSelect = function makeAsyncSelect(SelectComponent) {
  var _class, _temp;

  return _temp = _class = function (_Component) {
    inherits(Async, _Component);

    function Async(props) {
      classCallCheck(this, Async);

      var _this = possibleConstructorReturn(this, (Async.__proto__ || Object.getPrototypeOf(Async)).call(this));

      _this.mounted = false;
      _this.optionsCache = {};

      _this.handleInputChange = function (newValue, actionMeta) {
        var _this$props = _this.props,
            cacheOptions = _this$props.cacheOptions,
            onInputChange = _this$props.onInputChange;
        // TODO

        var inputValue = handleInputChange(newValue, actionMeta, onInputChange);
        if (!inputValue) {
          delete _this.lastRequest;
          _this.setState({
            inputValue: '',
            loadedInputValue: '',
            loadedOptions: [],
            isLoading: false,
            passEmptyOptions: false
          });
          return;
        }
        if (cacheOptions && _this.optionsCache[inputValue]) {
          _this.setState({
            inputValue: inputValue,
            loadedInputValue: inputValue,
            loadedOptions: _this.optionsCache[inputValue],
            isLoading: false,
            passEmptyOptions: false
          });
        } else {
          var request = _this.lastRequest = {};
          _this.setState({
            inputValue: inputValue,
            isLoading: true,
            passEmptyOptions: !_this.state.loadedInputValue
          }, function () {
            _this.loadOptions(inputValue, function (options) {
              if (!_this.mounted) return;
              if (options) {
                _this.optionsCache[inputValue] = options;
              }
              if (request !== _this.lastRequest) return;
              delete _this.lastRequest;
              _this.setState({
                isLoading: false,
                loadedInputValue: inputValue,
                loadedOptions: options || [],
                passEmptyOptions: false
              });
            });
          });
        }
        return inputValue;
      };

      _this.state = {
        defaultOptions: Array.isArray(props.defaultOptions) ? props.defaultOptions : undefined,
        inputValue: props.inputValue,
        isLoading: props.defaultOptions === true ? true : false,
        loadedOptions: [],
        passEmptyOptions: false
      };
      return _this;
    }

    createClass(Async, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;

        this.mounted = true;
        var defaultOptions = this.props.defaultOptions;
        var inputValue = this.state.inputValue;

        if (defaultOptions === true) {
          this.loadOptions(inputValue, function (options) {
            if (!_this2.mounted) return;
            var isLoading = !!_this2.lastRequest;
            _this2.setState({ defaultOptions: options || [], isLoading: isLoading });
          });
        }
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        // if the cacheOptions prop changes, clear the cache
        if (nextProps.cacheOptions !== this.props.cacheOptions) {
          this.optionsCache = {};
        }
        if (nextProps.defaultOptions !== this.props.defaultOptions) {
          this.setState({
            defaultOptions: Array.isArray(nextProps.defaultOptions) ? nextProps.defaultOptions : undefined
          });
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.mounted = false;
      }
    }, {
      key: 'focus',
      value: function focus() {
        this.select.focus();
      }
    }, {
      key: 'blur',
      value: function blur() {
        this.select.blur();
      }
    }, {
      key: 'loadOptions',
      value: function loadOptions(inputValue, callback) {
        var loadOptions = this.props.loadOptions;

        if (!loadOptions) return callback();
        var loader = loadOptions(inputValue, callback);
        if (loader && typeof loader.then === 'function') {
          loader.then(callback, function () {
            return callback();
          });
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _this3 = this;

        var _props = this.props,
            loadOptions = _props.loadOptions,
            props = objectWithoutProperties(_props, ['loadOptions']);
        var _state = this.state,
            defaultOptions = _state.defaultOptions,
            inputValue = _state.inputValue,
            isLoading = _state.isLoading,
            loadedInputValue = _state.loadedInputValue,
            loadedOptions = _state.loadedOptions,
            passEmptyOptions = _state.passEmptyOptions;

        var options = passEmptyOptions ? [] : inputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
        return (
          // $FlowFixMe
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SelectComponent, _extends({}, props, {
            filterOption: this.props.filterOption || null,
            ref: function ref(_ref) {
              _this3.select = _ref;
            },
            options: options,
            isLoading: isLoading,
            onInputChange: this.handleInputChange
          }))
        );
      }
    }]);
    return Async;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class.defaultProps = defaultProps$1, _temp;
};
var Async = makeAsyncSelect(manageState(Select));

var compareOption = function compareOption(inputValue, option) {
  var candidate = inputValue.toLowerCase();
  return option.value.toLowerCase() === candidate || option.label.toLowerCase() === candidate;
};

var builtins = {
  formatCreateLabel: function formatCreateLabel(inputValue) {
    return 'Create "' + inputValue + '"';
  },
  isValidNewOption: function isValidNewOption(inputValue, selectValue, selectOptions) {
    return !(!inputValue || selectValue.some(function (option) {
      return compareOption(inputValue, option);
    }) || selectOptions.some(function (option) {
      return compareOption(inputValue, option);
    }));
  },
  getNewOptionData: function getNewOptionData(inputValue, optionLabel) {
    return {
      label: optionLabel,
      value: inputValue,
      __isNew__: true
    };
  }
};

var defaultProps$2 = _extends({
  allowCreateWhileLoading: false,
  createOptionPosition: 'last'
}, builtins);

var makeCreatableSelect = function makeCreatableSelect(SelectComponent) {
  var _class, _temp;

  return _temp = _class = function (_Component) {
    inherits(Creatable, _Component);

    function Creatable(props) {
      classCallCheck(this, Creatable);

      var _this = possibleConstructorReturn(this, (Creatable.__proto__ || Object.getPrototypeOf(Creatable)).call(this, props));

      _this.onChange = function (newValue, actionMeta) {
        var _this$props = _this.props,
            getNewOptionData = _this$props.getNewOptionData,
            inputValue = _this$props.inputValue,
            isMulti = _this$props.isMulti,
            onChange = _this$props.onChange,
            onCreateOption = _this$props.onCreateOption,
            value = _this$props.value;

        if (actionMeta.action !== 'select-option') {
          return onChange(newValue, actionMeta);
        }
        var newOption = _this.state.newOption;

        var valueArray = Array.isArray(newValue) ? newValue : [newValue];

        if (valueArray[valueArray.length - 1] === newOption) {
          if (onCreateOption) onCreateOption(inputValue);else {
            var newOptionData = getNewOptionData(inputValue, inputValue);
            var newActionMeta = { action: 'create-option' };
            if (isMulti) {
              onChange([].concat(toConsumableArray(cleanValue(value)), [newOptionData]), newActionMeta);
            } else {
              onChange(newOptionData, newActionMeta);
            }
          }
          return;
        }
        onChange(newValue, actionMeta);
      };

      var options = props.options || [];
      _this.state = {
        newOption: undefined,
        options: options
      };
      return _this;
    }

    createClass(Creatable, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var allowCreateWhileLoading = nextProps.allowCreateWhileLoading,
            createOptionPosition = nextProps.createOptionPosition,
            formatCreateLabel = nextProps.formatCreateLabel,
            getNewOptionData = nextProps.getNewOptionData,
            inputValue = nextProps.inputValue,
            isLoading = nextProps.isLoading,
            isValidNewOption = nextProps.isValidNewOption,
            value = nextProps.value;

        var options = nextProps.options || [];
        var newOption = this.state.newOption;

        if (isValidNewOption(inputValue, cleanValue(value), options)) {
          newOption = getNewOptionData(inputValue, formatCreateLabel(inputValue));
        } else {
          newOption = undefined;
        }
        this.setState({
          newOption: newOption,
          options: (allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [newOption].concat(toConsumableArray(options)) : [].concat(toConsumableArray(options), [newOption]) : options
        });
      }
    }, {
      key: 'focus',
      value: function focus() {
        this.select.focus();
      }
    }, {
      key: 'blur',
      value: function blur() {
        this.select.blur();
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        var props = objectWithoutProperties(this.props, []);
        var options = this.state.options;

        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SelectComponent, _extends({}, props, {
          ref: function ref(_ref) {
            _this2.select = _ref;
          },
          options: options,
          onChange: this.onChange
        }));
      }
    }]);
    return Creatable;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class.defaultProps = defaultProps$2, _temp;
};
var Creatable = manageState(makeCreatableSelect(Select));

var AsyncCreatable = makeAsyncSelect(manageState(makeCreatableSelect(Select)));

// ==============================
// Fade Transition
// ==============================

var Fade = function Fade(_ref) {
  var Tag = _ref.component,
      _ref$duration = _ref.duration,
      duration = _ref$duration === undefined ? 1 : _ref$duration,
      inProp = _ref.in,
      onExited = _ref.onExited,
      props = objectWithoutProperties(_ref, ['component', 'duration', 'in', 'onExited']);

  var transition = {
    entering: { opacity: 0 },
    entered: { opacity: 1, transition: 'opacity ' + duration + 'ms' },
    exiting: { opacity: 0 },
    exited: { opacity: 0 }
  };

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_7_react_transition_group__["Transition"],
    { mountOnEnter: true, unmountOnExit: true, 'in': inProp, timeout: duration },
    function (state) {
      var innerProps = {
        style: _extends({}, transition[state])
      };
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Tag, _extends({ innerProps: innerProps }, props));
    }
  );
};
var collapseDuration = 260;

// wrap each MultiValue with a collapse transition; decreases width until
// finally removing from DOM
var Collapse = function (_Component) {
  inherits(Collapse, _Component);

  function Collapse() {
    var _ref2;

    var _temp, _this, _ret;

    classCallCheck(this, Collapse);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref2 = Collapse.__proto__ || Object.getPrototypeOf(Collapse)).call.apply(_ref2, [this].concat(args))), _this), _this.duration = collapseDuration, _this.state = { width: 'auto' }, _this.transition = {
      exiting: { width: 0, transition: 'width ' + _this.duration + 'ms ease-out' },
      exited: { width: 0 }
    }, _this.getWidth = function (ref) {
      if (ref && isNaN(_this.state.width)) {
        // cannot use `offsetWidth` because it is rounded
        var _ref$getBoundingClien = ref.getBoundingClientRect(),
            _width = _ref$getBoundingClien.width;

        _this.setState({ width: _width });
      }
    }, _this.getStyle = function (width) {
      return {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        width: width
      };
    }, _this.getTransition = function (state) {
      return _this.transition[state];
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  // width must be calculated; cannot transition from `undefined` to `number`


  // get base styles


  // get transition styles


  createClass(Collapse, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          inProp = _props.in;
      var width = this.state.width;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_transition_group__["Transition"],
        {
          enter: false,
          mountOnEnter: true,
          unmountOnExit: true,
          'in': inProp,
          timeout: this.duration
        },
        function (state) {
          var style = _extends({}, _this2.getStyle(width), _this2.getTransition(state));
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { ref: _this2.getWidth, style: style },
            children
          );
        }
      );
    }
  }]);
  return Collapse;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

// strip transition props off before spreading onto select component
// note we need to be explicit about innerRef for flow
var AnimatedInput = function AnimatedInput(WrappedComponent) {
  return function (_ref) {
    var inProp = _ref.in,
        onExited = _ref.onExited,
        appear = _ref.appear,
        enter = _ref.enter,
        exit = _ref.exit,
        innerRef = _ref.innerRef,
        props = objectWithoutProperties(_ref, ['in', 'onExited', 'appear', 'enter', 'exit', 'innerRef']);
    return (
      // $FlowFixMe
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedComponent, _extends({ innerRef: innerRef }, props))
    );
  };
};

// strip transition props off before spreading onto actual component


var AnimatedMultiValue = function AnimatedMultiValue(WrappedComponent) {
  return function (_ref) {
    var inProp = _ref.in,
        onExited = _ref.onExited,
        props = objectWithoutProperties(_ref, ['in', 'onExited']);
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      Collapse,
      { 'in': inProp, onExited: onExited },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedComponent, _extends({ cropWithEllipsis: inProp }, props))
    );
  };
};

// fade in when last multi-value removed, otherwise instant
var AnimatedPlaceholder = function AnimatedPlaceholder(WrappedComponent) {
  return function (props) {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Fade, _extends({
      component: WrappedComponent,
      duration: props.isMulti ? collapseDuration : 1
    }, props));
  };
};

// instant fade; all transition-group children must be transitions

var AnimatedSingleValue = function AnimatedSingleValue(WrappedComponent) {
  return function (props) {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Fade, _extends({ component: WrappedComponent }, props));
  };
};

// make ValueContainer a transition group
var AnimatedValueContainer = function AnimatedValueContainer(WrappedComponent) {
  return function (props) {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_transition_group__["TransitionGroup"], _extends({ component: WrappedComponent }, props));
  };
};

var makeAnimated = function makeAnimated(externalComponents) {
  var components$$1 = defaultComponents({ components: externalComponents });
  var Input = components$$1.Input,
      MultiValue = components$$1.MultiValue,
      Placeholder = components$$1.Placeholder,
      SingleValue = components$$1.SingleValue,
      ValueContainer = components$$1.ValueContainer,
      rest = objectWithoutProperties(components$$1, ['Input', 'MultiValue', 'Placeholder', 'SingleValue', 'ValueContainer']);

  return _extends({
    Input: AnimatedInput(Input),
    MultiValue: AnimatedMultiValue(MultiValue),
    Placeholder: AnimatedPlaceholder(Placeholder),
    SingleValue: AnimatedSingleValue(SingleValue),
    ValueContainer: AnimatedValueContainer(ValueContainer)
  }, rest);
};

var AnimatedComponents = makeAnimated();

var Input$1 = AnimatedComponents.Input;
var MultiValue$1 = AnimatedComponents.MultiValue;
var Placeholder$1 = AnimatedComponents.Placeholder;
var SingleValue$1 = AnimatedComponents.SingleValue;
var ValueContainer$1 = AnimatedComponents.ValueContainer;

var index = Object(__WEBPACK_IMPORTED_MODULE_6_memoize_one__["a" /* default */])(makeAnimated, exportedEqual);

var index$1 = manageState(Select);

/* unused harmony default export */ var _unused_webpack_default_export = (index$1);



/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(13));

var _reactLifecyclesCompat = __webpack_require__(19);

var _PropTypes = __webpack_require__(36);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var UNMOUNTED = 'unmounted';
exports.UNMOUNTED = UNMOUNTED;
var EXITED = 'exited';
exports.EXITED = EXITED;
var ENTERING = 'entering';
exports.ENTERING = ENTERING;
var ENTERED = 'entered';
exports.ENTERED = ENTERED;
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the components.
 * It's up to you to give meaning and effect to those states. For example we can
 * add styles to a component when it enters or exits:
 *
 * ```jsx
 * import Transition from 'react-transition-group/Transition';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {(state) => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
 * What it does do is track transition states over time so you can update the
 * component (such as by adding styles or classes) when it changes states.
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component begins the
 * "Enter" stage. During this stage, the component will shift from its current transition state,
 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
 * it's complete. Let's take the following example:
 *
 * ```jsx
 * state = { in: false };
 *
 * toggleEnterState = () => {
 *   this.setState({ in: true });
 * }
 *
 * render() {
 *   return (
 *     <div>
 *       <Transition in={this.state.in} timeout={500} />
 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state and
 * stay there for 500ms (the value of `timeout`) before it finally switches to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
 *
 * ## Timing
 *
 * Timing is often the trickiest part of animation, mistakes can result in slight delays
 * that are hard to pin down. A common example is when you want to add an exit transition,
 * you should set the desired final styles when the state is `'exiting'`. That's when the
 * transition to those styles will start and, if you matched the `timeout` prop with the
 * CSS Transition duration, it will end exactly when the state changes to `'exited'`.
 *
 * > **Note**: For simpler transitions the `Transition` component might be enough, but
 * > take into account that it's platform-agnostic, while the `CSSTransition` component
 * > [forces reflows](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * > in order to make more complex transitions more predictable. For example, even though
 * > classes `example-enter` and `example-enter-active` are applied immediately one after
 * > another, you can still transition from one to the other because of the forced reflow
 * > (read [this issue](https://github.com/reactjs/react-transition-group/issues/159#issuecomment-322761171)
 * > for more info). Take this into account when choosing between `Transition` and
 * > `CSSTransition`.
 */

exports.EXITING = EXITING;

var Transition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  var _proto = Transition.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: null // allows for nested Transitions

    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter;
      appear = timeout.appear;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      var node = _reactDom.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
    var timeouts = this.getTimeouts(); // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing); // FIXME: appear timeout?


      _this2.onTransitionEnd(node, timeouts.enter, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);

    if (node) {
      if (this.props.addEndListener) {
        this.props.addEndListener(node, this.nextCallback);
      }

      if (timeout != null) {
        setTimeout(this.nextCallback, timeout);
      }
    } else {
      setTimeout(this.nextCallback, 0);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react.default.Children.only(children);

    return _react.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};
Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element.
   * This function is called with the current transition status
   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can be used
   * to apply context specific props to a component.
   *
   * ```jsx
   * <Transition timeout={150}>
   *   {(status) => (
   *     <MyComponent className={`fade fade-${status}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided
   *
   * You may specify a single timeout for all transitions like: `timeout={500}`,
   * or individually like:
   *
   * ```jsx
   * timeout={{
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * @type {number | { enter?: number, exit?: number }}
   */
  timeout: function timeout(props) {
    var pt = process.env.NODE_ENV !== "production" ? _PropTypes.timeoutsShape : {};;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func // Name the function so it is clearer in the documentation

} : {};

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);

exports.default = _default;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(7));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
  enter: _propTypes.default.number,
  exit: _propTypes.default.number
}).isRequired]) : null;
exports.timeoutsShape = timeoutsShape;
var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
  enter: _propTypes.default.string,
  exit: _propTypes.default.string,
  active: _propTypes.default.string
}), _propTypes.default.shape({
  enter: _propTypes.default.string,
  enterDone: _propTypes.default.string,
  enterActive: _propTypes.default.string,
  exit: _propTypes.default.string,
  exitDone: _propTypes.default.string,
  exitActive: _propTypes.default.string
})]) : null;
exports.classNamesShape = classNamesShape;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactLifecyclesCompat = __webpack_require__(19);

var _ChildMapping = __webpack_require__(112);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
  /**
   * The `<TransitionGroup>` component manages a set of transition components
   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
   * components, `<TransitionGroup>` is a state machine for managing the mounting
   * and unmounting of components over time.
   *
   * Consider the example below. As items are removed or added to the TodoList the
   * `in` prop is toggled automatically by the `<TransitionGroup>`.
   *
   * Note that `<TransitionGroup>`  does not define any animation behavior!
   * Exactly _how_ a list item animates is up to the individual transition
   * component. This means you can mix and match animations across different list
   * items.
   */

};

var TransitionGroup =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear


    _this.state = {
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: {
        isMounting: !this.appeared
      }
    };
  };

  _proto.componentDidMount = function componentDidMount() {
    this.appeared = true;
    this.mounted = true;
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);

    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return children;
    }

    return _react.default.createElement(Component, props, children);
  };

  return TransitionGroup;
}(_react.default.Component);

TransitionGroup.childContextTypes = {
  transitionGroup: _propTypes.default.object.isRequired
};
TransitionGroup.propTypes =  false ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: _propTypes.default.any,

  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   */
  children: _propTypes.default.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: _propTypes.default.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: _propTypes.default.func
} : {};
TransitionGroup.defaultProps = defaultProps;

var _default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

var tabbableNode = /input|select|textarea|button|object/;

function hidesContents(element) {
  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;

  // If the node is empty, this is good enough
  if (zeroSize && !element.innerHTML) return true;

  // Otherwise we need to check some styles
  var style = window.getComputedStyle(element);
  return zeroSize ? style.getPropertyValue("overflow") !== "visible" : style.getPropertyValue("display") == "none";
}

function visible(element) {
  var parentElement = element;
  while (parentElement) {
    if (parentElement === document.body) break;
    if (hidesContents(parentElement)) return false;
    parentElement = parentElement.parentNode;
  }
  return true;
}

function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
  return res && visible(element);
}

function tabbable(element) {
  var tabIndex = element.getAttribute("tabindex");
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
  return [].slice.call(element.querySelectorAll("*"), 0).filter(tabbable);
}
module.exports = exports["default"];

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assertNodeList = assertNodeList;
exports.setElement = setElement;
exports.validateElement = validateElement;
exports.hide = hide;
exports.show = show;
exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;
exports.resetForTesting = resetForTesting;

var _warning = __webpack_require__(117);

var _warning2 = _interopRequireDefault(_warning);

var _safeHTMLElement = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var globalElement = null;

function assertNodeList(nodeList, selector) {
  if (!nodeList || !nodeList.length) {
    throw new Error("react-modal: No elements were found for selector " + selector + ".");
  }
}

function setElement(element) {
  var useElement = element;
  if (typeof useElement === "string" && _safeHTMLElement.canUseDOM) {
    var el = document.querySelectorAll(useElement);
    assertNodeList(el, useElement);
    useElement = "length" in el ? el[0] : el;
  }
  globalElement = useElement || globalElement;
  return globalElement;
}

function validateElement(appElement) {
  if (!appElement && !globalElement) {
    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));

    return false;
  }

  return true;
}

function hide(appElement) {
  if (validateElement(appElement)) {
    (appElement || globalElement).setAttribute("aria-hidden", "true");
  }
}

function show(appElement) {
  if (validateElement(appElement)) {
    (appElement || globalElement).removeAttribute("aria-hidden");
  }
}

function documentNotReadyOrSSRTesting() {
  globalElement = null;
}

function resetForTesting() {
  globalElement = null;
}

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component_TableData_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__component_TableHead_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__component_Submit_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__component_Input_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__component_Select_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Validation_js__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//table row component
//component used for headers of table columns
var ShoppingCart=function(_Component){_inherits(ShoppingCart,_Component);function ShoppingCart(props){_classCallCheck(this,ShoppingCart);var _this=_possibleConstructorReturn(this,(ShoppingCart.__proto__||Object.getPrototypeOf(ShoppingCart)).call(this,props));_this.handleRemove=_this.handleRemove.bind(_this);_this.handleChange=_this.handleChange.bind(_this);_this.handleOrder=_this.handleOrder.bind(_this);_this.state={enough:true};return _this;}_createClass(ShoppingCart,[{key:'handleRemove',value:function handleRemove(item){//method that handles removing item from cart
this.props.remove(item);}},{key:'handleChange',value:function handleChange(id,newQuant){//method that handles a quantity change for a specific line item
this.props.quantChange(id,newQuant);}},{key:'handleOrder',value:function handleOrder(){//method for handling an order, sets order submit in motion in prizeshop/gift shop
if(this.props.total<=this.props.limit){//checks to make sure user has enough points/budget before setting order in motion
this.setState({enough:true});this.props.order();}else{this.setState({enough:false});}}},{key:'render',value:function render(){var _this2=this;var totalColor=void 0;var tableHeads=void 0;var notes=void 0;var total=this.props.total;var inputStyle="pa2 br2 h2 bw1 w-100-ns w-100 shadow-3";var areaStyle="pa2 br2 bw1 w-100-ns w-100 shadow-3";var selectStyle="w-100 h2 shadow-2 pa1 br2 b--gray bw1";var dollarSign=void 0;if(this.props.app==="lov"){tableHeads=["Prize","Size","Color","Quantity","Price","Remove"];}else{//asm shopping cart contains call center and additional notes while lov shopping cart does not
total=total.toFixed(2);dollarSign="$";tableHeads=["Gift","Size","Color","Quantity","Price","Remove"];notes=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 mv3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'w-100',style:{maxWidth:'520px',margin:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pb3 pt1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 pa1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'b'},'Street Address:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'b red f4'},'*'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'red',id:'street_address_span'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__component_Input_js__["a" /* default */],{type:'text',id:'street_address',identity:'street_address',onInput:this.props.notes,inputStyle:inputStyle}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pt4 pb4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50 pa1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'b'},'City:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'b red f4'},'*'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'red',id:'city_span'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__component_Input_js__["a" /* default */],{type:'text',id:'city',identity:'city',onInput:this.props.notes,inputStyle:inputStyle}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-20 pa1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'b'},'State:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'b red f4'},'*'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__component_Select_js__["a" /* default */],{name:'state',id:'state',identity:'state',onSelect:this.props.notes,options:this.props.states,styles:selectStyle}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-30 pa1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'b'},'Zip:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'b red f4'},'*'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'red',id:'zipcode_span'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__component_Input_js__["a" /* default */],{type:'text',id:'zipcode',identity:'zipcode',onInput:this.props.notes,inputStyle:inputStyle}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 pa1 pb2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'b'},'Shipping Instructions:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'red',id:'shipping_instructions_span'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__component_Input_js__["a" /* default */],{type:'area',identity:'shipping_instructions',id:'shipping_instructions',onInput:this.props.notes,styles:areaStyle}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 pa1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'b'},'Event Description: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'b red f4'},'*'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'red',id:'notes_span'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__component_Input_js__["a" /* default */],{type:'area',identity:'notes',id:'notes',onInput:this.props.notes,styles:areaStyle})))));}var items=this.props.items;var itemquant=void 0;var columns=void 0;var cart=items.map(function(item,i){if(_this2.props.app==='lov'){columns=item;}else{//for asm, need to track item inventory level for each item
columns={prize:item.prize,size:item.size,color:item.color,quantity:item.quantity,total:item.total};itemquant=item.totalAvailable;}return(//returns a table row for each line item
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_TableData_js__["a" /* default */],{key:i,id:i,columns:columns,app:_this2.props.app,itemqty:itemquant,type:'cart',remove:_this2.handleRemove,change:_this2.handleChange,cellstyle:'tc bb pt2 pb2 b--silver'}));});var orderButton=void 0;if(total>0){//only display order button if there are items in the cart
orderButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 mt3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__component_Submit_js__["a" /* default */],{name:'Order',onClick:this.handleOrder,styles:'bg-dark-blue white b br3 h2 w-20 mt2'}));if(this.props.limit<this.props.total){totalColor="red";}}var prompt=void 0;if(!this.state.enough){prompt=this.props.app==="lov"?"*Not enough points.":"*Not enough in budget";}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-40'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'blue'},'Shopping Cart')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-30 tc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'red b'},prompt)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-30'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'tr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'b mid-gray'},'Total: '),dollarSign,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:totalColor},total))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'fl w-100 collapse'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',{className:'collapse'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__component_TableHead_js__["a" /* default */],{columns:tableHeads,headstyle:'bb pt1 pb1 f4 b--silver mid-gray'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,cart)),notes,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mt3'},orderButton));}}]);return ShoppingCart;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ShoppingCart);

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/shoppingCart.75df6aa5.png";

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CreateTiers_js__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EditTiers_js__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_modal__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__asset_img_loader_gif__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__asset_img_loader_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__asset_img_loader_gif__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//component for creating new tiers
//component for editing current tiers
var ManageTiers=function(_Component){_inherits(ManageTiers,_Component);function ManageTiers(props){_classCallCheck(this,ManageTiers);var _this=_possibleConstructorReturn(this,(ManageTiers.__proto__||Object.getPrototypeOf(ManageTiers)).call(this,props));_this.state={rows:6,newTiers:[],editTiers:[],failedTiers:[],loading:false,modalIsOpen:false,modalPrompt:'',success:false};_this.addRows=_this.addRows.bind(_this);_this.onCreate=_this.onCreate.bind(_this);_this.onEdit=_this.onEdit.bind(_this);_this.openModal=_this.openModal.bind(_this);_this.closeModal=_this.closeModal.bind(_this);_this.loadingFunc=_this.loadingFunc.bind(_this);return _this;}_createClass(ManageTiers,[{key:'loadingFunc',value:function loadingFunc(loading){//method to open modal and display loading gif
if(loading){this.setState({loading:true},function(){this.openModal();});}else{this.setState({loading:false});}}},{key:'addRows',value:function addRows(){//method to add more rows for creating tiers
var rows=this.state.rows+3;this.setState({rows:rows});}},{key:'onCreate',value:function onCreate(tiers){//method grabs all new tier information from each instance of CreateTiers component and adds it to the state, passed down as a prop
this.setState(function(oldState){return{newTiers:[].concat(_toConsumableArray(oldState.newTiers),[tiers])};});}},{key:'onEdit',value:function onEdit(tiers){//method grabs all edited tier information from each instance of EditTiers component and adds it to the state,passed down as a prop
this.setState(function(oldState){return{editTiers:[].concat(_toConsumableArray(oldState.editTiers),[tiers])};});}},{key:'openModal',value:function openModal(){//open the modal
this.setState({modalIsOpen:true});}},{key:'closeModal',value:function closeModal(){//method for closing the modal
if(this.state.modalPrompt==='Tiers created successfully!'||this.state.modalPrompt==='Tiers updated successfully!'){this.props.reset("tiers");//retrieve new/edited tier information for DB
}else{this.props.revertSave();}this.setState({modalIsOpen:false,modalPrompt:'',success:false,newTiers:[],failedTiers:[],editTiers:[]});//clear state
}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){var _this2=this;if(this.props.create&&this.state.newTiers!==prevState.newTiers&&this.state.newTiers.length!==0){(function(){//if user has chosen to create/save new tiers
_this2.loadingFunc(true);var newTiers=_this2.state.newTiers;var failures=[];var failed=false;var newTierscheck=[];var alreadyExists=[];var _loop=function _loop(i){//loop through and validate each new tier
if(newTiers[i].tier===''||newTiers[i].points===''){//make sure all tier information is filled out (points and tier number)
failures.push(newTiers[i]);}for(var j=0;j<newTiers.length;j++){//make sure that the user is not creating duplicate tiers
if(i!==j&&newTiers[i].tier===newTiers[j].tier){newTierscheck.push(newTiers[i].index);}}_this2.props.tiers.forEach(function(t){//make sure that tiers being created do not already exist
if(Number(newTiers[i].tier)===Number(t.tier)){alreadyExists.push(newTiers[i]);}});};for(var i=0;i<newTiers.length;i++){_loop(i);}if(newTierscheck.length<1&&failures.length<1&&alreadyExists.length<1){//if all three types of the above validation were passed, create the new tiers
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.all(newTiers.map(function(tiers){return __WEBPACK_IMPORTED_MODULE_1_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_2__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'create',table:'tiers',misc:'create',firstID:tiers.tier,secondID:_this2.props.year,status:_this2.props.app,quantity:tiers.points}});})).then(function(){_this2.setState({failedTiers:[],newTiers:[]},function(){this.loadingFunc(false);this.setState({success:true,modalPrompt:'Tiers created successfully!'});});});}else{//one or more of the above validations were not passed
var prompt='';if(alreadyExists.length>0){//one or more tier already exists
prompt='The following tiers already exist for the current year: ';prompt+=alreadyExists[0].tier;var tID=alreadyExists[0].index.toString()+"_tier";document.getElementById(tID).style.borderColor="red";if(alreadyExists.length>1){for(var k=1;k<alreadyExists.length;k++){prompt+=", "+alreadyExists[k].tier;tID=alreadyExists[k].index.toString()+"_tier";document.getElementById(tID).style.borderColor="red";}}prompt+=". ";}var tierID=void 0;if(newTierscheck.length>0){//user is attempting to create duplicate tiers
newTierscheck.forEach(function(duplicate){tierID=duplicate.toString()+"_tier";document.getElementById(tierID).style.borderColor="red";});prompt+='Duplicate tiers are not permitted. ';}if(failures.length>0){//one or more tier is not completely filled out
prompt+='Each tier must be completely filled out or completely blank. ';}_this2.setState({modalPrompt:prompt,newTiers:[]},function(){this.loadingFunc(false);});_this2.props.revertSave();}})();}else if(this.props.create&&this.props.save&&prevState.newTiers===this.state.newTiers&&this.state.newTiers.length===0&&this.state.modalPrompt===''){//user hit submit when there was no information entered
this.setState({modalPrompt:'Please enter at least one tier.'},function(){this.openModal();});}else if(this.props.edit&&this.state.editTiers!==prevState.editTiers&&this.state.editTiers.length!==0){//user has chosen to save edited tier information
this.loadingFunc(true);var editTiers=this.state.editTiers;var failures=[];for(var i=0;i<editTiers.length;i++){//loop through and make sure that edited tier information is filled out correctly
if(editTiers[i].quantity===''||editTiers[i].quantity===0){failures.push(editTiers[i]);}}if(failures.length<1){//if all values are correct, update tier information in DB
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.all(editTiers.map(function(tiers){var params=Object.assign({endpoint:'create',table:'tiers'},tiers);return __WEBPACK_IMPORTED_MODULE_1_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_2__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:params}).catch(function(error){failures.push(tiers);});})).then(function(){_this2.setState({failedTiers:failures,editTiers:[]},function(){var modalPrompt=void 0;if(failures.length<1){modalPrompt='Tiers updated successfully!';}else{modalPrompt='There seems to have been a problem during editing.';}this.setState({modalPrompt:modalPrompt},function(){this.loadingFunc(false);});});});}else{this.setState({modalPrompt:'Cannot have blank fields.'},function(){this.loadingFunc(false);});}}}},{key:'render',value:function render(){var _this3=this;var customStyles={content:{top:'50%',left:'50%',right:'auto',bottom:'auto',width:'400px',minWidth:'300px',borderStyle:'solid',borderWidth:'2px',borderColor:'gray',transform:'translate(-50%, -50%)',boxShadow:'0.5px 0.5px 1px 0.5px'},overlay:{backgroundColor:'rgba(105,105,105,0.8)'}};var pStyle="fl w-33 tc f4 pb1";var tiers=void 0;var priceType=this.props.app==="lov"?"Points: ":"Max Price: $";if(this.props.tiers!==undefined){if(this.props.tiers.length>0){if(this.props.tiers!==undefined&&!(this.props.create||this.props.edit)){//display all current tier information for selected year
tiers=this.props.tiers.map(function(tiers){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'fl w-100 bb b--light-silver',key:tiers.ID},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:pStyle},'Tier: ',tiers.tier),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:pStyle},priceType,tiers.points),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:pStyle},'Status: ',tiers.tier_status));});}else if(this.props.create){//display CreateTiers components
tiers=[];for(var i=0;i<this.state.rows;i++){tiers.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:i,id:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__CreateTiers_js__["a" /* default */],{id:i,onSave:this.onCreate,success:this.state.success,save:this.props.save,app:this.props.app})));}}else if(this.props.edit){//display EditTiers components
tiers=this.props.tiers.map(function(tiers){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:tiers.ID},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__EditTiers_js__["a" /* default */],{tiers:tiers,success:_this3.state.success,id:tiers.ID,onSave:_this3.onEdit,save:_this3.props.save,app:_this3.props.app}));});}}else{//there are no tiers for the current year selected
if(this.props.create){//display CreateTiers components
tiers=[];for(var _i=0;_i<this.state.rows;_i++){tiers.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:_i,id:_i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__CreateTiers_js__["a" /* default */],{id:_i,onSave:this.onCreate,success:this.state.success,save:this.props.save,app:this.props.app})));}}else{tiers=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'w-100 f3 tc'},'There is nothing to view at this time.'));}}}var modalContent=void 0;if(this.state.loading){//display loading gif
modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tc',style:{width:'150px',margin:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_6__asset_img_loader_gif___default.a,alt:'Loading'}));}else{//display message
modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'b navy f4 tc'},this.state.modalPrompt);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{maxWidth:'90%',margin:'auto',height:'100%'},className:'pb2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'list pb3'},tiers),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_modal___default.a,{isOpen:this.state.modalIsOpen,style:customStyles,contentLabel:'loading/message',shouldCloseOnOverlayClick:false,shouldCloseOnEsc:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 tr pb2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'bg-white gray b br3',onClick:this.closeModal},'X')),modalContent)));}}]);return ManageTiers;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ManageTiers);

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CreateAdminMessages_js__ = __webpack_require__(143);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//component for creating admin messages
var ManageAdminMessages=function(_Component){_inherits(ManageAdminMessages,_Component);function ManageAdminMessages(props){_classCallCheck(this,ManageAdminMessages);var _this=_possibleConstructorReturn(this,(ManageAdminMessages.__proto__||Object.getPrototypeOf(ManageAdminMessages)).call(this,props));_this.state={newMessage:''};return _this;}_createClass(ManageAdminMessages,[{key:'render',value:function render(){var messages=this.props.messages;var content=void 0;if(this.props.create){//display CreateAdminMessages if user chooses create
content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__CreateAdminMessages_js__["a" /* default */],{year:this.props.year,reset:this.props.reset,years:this.props.years,userInfo:this.props.userInfo,save:this.props.save,revertSave:this.props.revertSave});}else if(messages!==undefined&&messages.length>0){//display all admin message information for current year selected
content=messages.map(function(messages,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'fl w-100 bb b--light-silver',key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'b fl w-20'},'Message:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-80'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'ml3'},messages.message))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fl w-20 b'},'End Date: '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-80'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'ml3'},messages.end_date)))));});}else{//display messages if there are currently no admin messages for selected year
content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'w-100 f3 tc'},'There is nothing to view at this time.'));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{maxWidth:'700px',margin:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'list'},content));}}]);return ManageAdminMessages;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ManageAdminMessages);

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component_TableData_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__component_TableHead_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__routes_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__asset_img_checkmark_png__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__asset_img_checkmark_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__asset_img_checkmark_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__asset_img_denied_png__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__asset_img_denied_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__asset_img_denied_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_modal__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__component_Input_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__asset_img_loader_gif__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__asset_img_loader_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__asset_img_loader_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Validation_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__component_Select_js__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ViewASMOrders=function(_Component){_inherits(ViewASMOrders,_Component);function ViewASMOrders(props){_classCallCheck(this,ViewASMOrders);var _this=_possibleConstructorReturn(this,(ViewASMOrders.__proto__||Object.getPrototypeOf(ViewASMOrders)).call(this,props));_this.openModal=_this.openModal.bind(_this);_this.closeModal=_this.closeModal.bind(_this);_this.onclick=_this.onclick.bind(_this);_this.cancelOrder=_this.cancelOrder.bind(_this);_this.changeStatus=_this.changeStatus.bind(_this);_this.getOrders=_this.getOrders.bind(_this);_this.handleInput=_this.handleInput.bind(_this);_this.loadingFunc=_this.loadingFunc.bind(_this);_this.orderChangeEmail=_this.orderChangeEmail.bind(_this);_this.createDateObject=_this.createDateObject.bind(_this);_this.editTrackingNumber=_this.editTrackingNumber.bind(_this);_this.handleSubmit=_this.handleSubmit.bind(_this);_this.state={orders:[],cancelID:0,modalIsOpen:false,approval:'',startDate:'',endDate:'',year:'',loading:false};return _this;}_createClass(ViewASMOrders,[{key:'createDateObject',value:function createDateObject(dateStringOne){//method that creates a date object after it has passed the date validation format. used to determine whether or not a date is real, and to compare dates against eachother
var datepartsOne=void 0;var dateOne=void 0;var dateConcat=void 0;var dateYear=void 0;var dateparts=void 0;if(dateStringOne.indexOf("/")!==-1){//check to see if a date contains a slash. split date string on slash if it does
datepartsOne=dateStringOne.split("/");if(datepartsOne.length===3){//if the length of the array that contains the split string is 3, then the date only contained slashes
if(datepartsOne[2].length===4){//check to see if year given was full year (i.e. 2019) or abreviated (i.e. 19)
dateOne=new Date(dateStringOne);}else{dateConcat=datepartsOne[0]+"/"+datepartsOne[1]+"/20"+datepartsOne[2];//if abbreviated, make it full length
dateOne=new Date(dateConcat);}}else{//date contains a slash and a dash
if(datepartsOne[0].indexOf("-")!==-1){//dash is contained in the first part of date string
dateYear=datepartsOne[1];if(dateYear.length===2){//check whether or not year was abbreviated
dateYear="20"+dateYear;}var monthDay=datepartsOne[0].split("-");dateConcat=dateYear+"-"+monthDay[0]+"-"+monthDay[1];//ISO format for date object
dateOne=new Date(dateConcat);}else{//dash is contained in second part of date string
var dateparts2=datepartsOne[1].split("-");dateYear=dateparts2[1];if(dateYear.length===2){//check whether or not year was abbreviated
dateYear="20"+dateYear;}dateConcat=dateYear+"-"+datepartsOne[0]+"-"+dateparts2[0];//ISO format for date object
dateOne=new Date(dateConcat);}}}else{datepartsOne=dateStringOne.split("-");if(datepartsOne.length===3){//date only contains dashes
dateYear=datepartsOne[2];if(dateYear.length===2){//check for abbreviated date
dateYear="20"+dateYear;}dateConcat=dateYear+"-"+datepartsOne[0]+"-"+datepartsOne[1];dateOne=new Date(dateConcat);}else{if(datepartsOne[0].indexOf("/")!==-1){//same operations as above
dateYear=datepartsOne[1];if(dateYear.length===2){dateYear="20"+dateYear;}var _monthDay=datepartsOne[0].split("/");dateConcat=dateYear+"-"+_monthDay[0]+"-"+_monthDay[1];dateOne=new Date(dateConcat);}else{var _dateparts=datepartsOne[1].split("/");dateYear=_dateparts[1];if(dateYear.length===2){dateYear="20"+dateYear;}dateConcat=dateYear+"-"+datepartsOne[0]+"-"+_dateparts[0];dateOne=new Date(dateConcat);}}}return dateOne;}},{key:'componentDidMount',value:function componentDidMount(){this.getOrders();}},{key:'getOrders',value:function getOrders(){var _this2=this;var parameters=void 0;var d=new Date();if(this.state.year===''){//if year is not set, set year
this.setState({year:d.getFullYear()});}if(this.props.userInfo.userType!=="asm_admin"&&this.props.userInfo.userType!=="sys_admin"&&this.props.view!=="regional"){//parameters for an asm or asm_regional to view their personal orders
parameters={endpoint:'info',table:'asm_orders',action:'user',userID:this.props.userInfo.userID,year:d.getFullYear()};}else if(this.props.userInfo.userType==="asm_regional"&&this.props.view==="regional"){//parameters for asm_regional to view pending orders that have passed their threshold
parameters={endpoint:'info',table:'asm_orders',action:'regional',year:d.getFullYear(),userID:this.props.userInfo.userID};}else if(this.props.userInfo.userType==="asm_admin"||this.props.userInfo.userType==="sys_admin"){//parameters or asm_admin to view orders
if(this.props.view==="history"){//parameters for asm_admin viewing order history (orders that have already been accepted/fulfilled)
var year=void 0,month=void 0,day=void 0,start=void 0,end=void 0;if(this.state.startDate===''&&this.state.endDate===''){year=d.getFullYear();month=d.getMonth()<=2?1:d.getMonth()-2;day=d.getDate();if(month==1){day=1;}start=month+"/"+day+"/"+year;month=Number(month)+3;month=month.toString();end=month+"/"+day+"/"+year;this.setState({startDate:start,endDate:end});}else{start=this.state.startDate;end=this.state.endDate;}var startDate=start;var endDate=end;parameters={endpoint:'info',table:'asm_orders',action:'history',year:year,kind:startDate,name:endDate};}else{//parameters for asm_admin to view pending orders
parameters={endpoint:'info',table:'asm_orders',action:'admin',year:d.getFullYear()};}}__WEBPACK_IMPORTED_MODULE_3_axios___default()({//retrieve orders from database 
method:'post',url:__WEBPACK_IMPORTED_MODULE_4__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:parameters}).then(function(response){var orderitem={};var orderInfo=[];var userInfo=_this2.props.userInfo;var data=response.data.data;if(data!==undefined){data.forEach(function(item){//consolidate general order info and order line items
if(userInfo.userType==="asm"){var status=item.order_status==="pending_admin"?"pending (admin order)":item.order_status;orderInfo.push({ID:item.ID,cost:item.cost,Date:item.Date,status:status,notes:item.notes,costcenter:item.costcenter,address:item.address,city:item.city,state:item.state,zipcode:item.zipcode,instructions:item.instructions,tracking_number:item.tracking_number,items:[]});}else{orderInfo.push({ID:item.ID,cost:item.cost,Date:item.Date,status:item.order_status,notes:item.notes,name:item.name,email:item.email,costcenter:item.costcenter,address:item.address,city:item.city,state:item.state,zipcode:item.zipcode,instructions:item.instructions,tracking_number:item.tracking_number,items:[]});}});var orders=orderInfo.filter(function(obj){return!orderitem[obj.ID]&&(orderitem[obj.ID]=true);});var orderSize=void 0,orderColor=void 0;orders.forEach(function(order){data.forEach(function(orderItem){if(orderItem.ID===order.ID){orderSize=orderItem.size===null?"N/A":orderItem.size;orderColor=orderItem.color===null?"N/A":orderItem.color;order.items.push({prize:orderItem.prize,item_cost:orderItem.item_cost,quantity:orderItem.quantity,prizeID:orderItem.prizeID,variantID:orderItem.variantID,size:orderSize,color:orderColor.replace(/_/g," ")});}});});_this2.setState({orders:orders});}});}// componentDidUpdate(prevProps){ //if an order is placed in gift shop or cancelled, retrieve updated order information
// 	if(prevProps.submitted !== this.props.submitted){
// 		this.getOrders();
// 	}
// }
},{key:'handleInput',value:function handleInput(identity,value){//method for handling start and end date input fields
var theState={};if(/^(\s*|[0-9/-]*)$/g.test(value)){//only allow blank input or numbers, slashes, and dashes
theState[identity]=value;this.setState(theState);}}},{key:'handleSubmit',value:function handleSubmit(){var modalPrompt='';if(Object(__WEBPACK_IMPORTED_MODULE_10__Validation_js__["a" /* default */])("date",this.state.startDate)&&Object(__WEBPACK_IMPORTED_MODULE_10__Validation_js__["a" /* default */])("date",this.state.endDate)){//make sure start date and end date are valid date formats
if(this.createDateObject(this.state.startDate)<=this.createDateObject(this.state.endDate)){//make sure dates are real and start date is before end date
this.getOrders();//get orders in that date range
}else{modalPrompt+='End date must be the same as, or greater than the Start date.';this.setState({modalPrompt:modalPrompt,modalIsOpen:true});}}else{//error messages for invalid date formats
if(!Object(__WEBPACK_IMPORTED_MODULE_10__Validation_js__["a" /* default */])("date",this.state.startDate)){modalPrompt+='Start Date is invalid. ';}if(!Object(__WEBPACK_IMPORTED_MODULE_10__Validation_js__["a" /* default */])("date",this.state.endDate)){modalPrompt+='End Date is invalid. ';}this.setState({modalPrompt:modalPrompt,modalIsOpen:true});}}},{key:'loadingFunc',value:function loadingFunc(loading){//method for opening modal and displaying loading gif
if(loading){this.setState({loading:true},function(){this.openModal();});}else{this.setState({loading:false},function(){this.closeModal();});}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){if(prevProps.approval!==this.props.approval){//retrieve new set of orders if asm_regional updates their settings for approval (manual or automatic)
this.setState({approval:this.props.approval});if(prevProps.approval!==''){this.getOrders();}}if(prevProps.view!==this.props.view&&this.props.active){//get orders based on view change since component is used in multiple views (i.e. asm_regional viewing their personal orders or pending orders)
this.getOrders();}if(prevProps.submitted!==this.props.submitted){//if user submits or cancels an order, retrieve updated order info
this.getOrders();}}},{key:'orderChangeEmail',value:function orderChangeEmail(status,order){//method for sending email once an order is fulfilled, denied, or cancelled
var params=void 0,date=void 0,name=void 0,email=void 0;// this.state.orders.forEach((order)=>{
// 	if(Number(order.ID) === Number(id)){
// 		date = order.Date;
// 	}
// });
date=order.Date;var thestatus=status==="cancel"?"cancelled":status;if(this.props.userInfo.userType==='asm'){//email asm confirmation that their order has been cancelled
params={'action':'asmOrder','name':this.props.userInfo.name,'email':this.props.userInfo.email,'status':thestatus,'date':date,'orderItems':order.items,'shippingInfo':{'street_address':order.address,'city':order.city,'state':order.state,'zipcode':order.zipcode,'shipping_instructions':order.instructions},'notes':order.notes};}else{//email the asm who's order has just been fulfilled or denied
// this.state.orders.forEach((order)=>{
// 	if(Number(order.ID) === Number(id)){
// 		name = order.name;
// 		email = order.email;
// 	}
// });
name=order.name;email=order.email;params={'action':'asmOrder','name':name,'email':email,'status':thestatus,'date':date,'orderItems':order.items,'shippingInfo':{'street_address':order.address,'city':order.city,'state':order.state,'zipcode':order.zipcode,'shipping_instructions':order.instructions},'notes':order.notes};}__WEBPACK_IMPORTED_MODULE_3_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_4__routes_js__["b" /* mail */],headers:{'Content-Type':'application/json'},data:params});}},{key:'changeStatus',value:function changeStatus(status,order){var _this3=this;//method that handles changing the status of an order
this.loadingFunc(true);var orders=this.state.orders;__WEBPACK_IMPORTED_MODULE_3_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_4__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'create',table:'asm_order',misc:'status',status:status,firstID:order.ID//firstID:id}
}}).then(function(response){_this3.loadingFunc(false);_this3.orderChangeEmail(status,order);//ORDER CHANGE EMAIL
if(_this3.props.userInfo.userType!=='asm_admin'&&_this3.props.userInfo.userType!=="sys_admin"&&_this3.props.userInfo.userType!=='user'){_this3.props.budgetUpdate("add",order.cost,false);}if(status==="cancel"||status==="denied"){var canceled=[order];// orders.map((order)=>{
// 	if(order.ID == id){
// 		canceled.push(order);
// 	}
// });
var cancelItems=[];canceled[0].items.forEach(function(item){//update the available quantity of each gift in an order that has been denied or cancelled
cancelItems.push(__WEBPACK_IMPORTED_MODULE_3_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_4__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'create',table:'inventory',misc:'_cancel',quantity:item.quantity,firstID:item.variantID}}));});__WEBPACK_IMPORTED_MODULE_3_axios___default.a.all(cancelItems).then(function(res){_this3.props.logChange();});}else{_this3.props.logChange();}});}},{key:'onclick',value:function onclick(e){//method that handles button click (cancel, deny, or fulfill)
var val=e.currentTarget.value;var orderID=e.currentTarget.name;if(val==="cancel"){this.setState({cancelID:orderID},function(){this.openModal();});}else{var theorder=void 0;var newOrders=[];this.state.orders.forEach(function(order){if(Number(order.ID)!==Number(orderID)){newOrders.push(order);}else{theorder=order;}});this.changeStatus(val,theorder);this.setState({orders:newOrders});}}},{key:'openModal',value:function openModal(){//open the modal
this.setState({modalIsOpen:true});}},{key:'closeModal',value:function closeModal(){//close the modal
this.setState({modalIsOpen:false});}},{key:'cancelOrder',value:function cancelOrder(){//method that handles cancel order operations, called when user confirms they wish to cancel an order
this.closeModal();var theorder=void 0;var _state=this.state,orders=_state.orders,cancelID=_state.cancelID;var newOrders=[];orders.forEach(function(order){if(Number(order.ID)!==Number(cancelID)){newOrders.push(order);}else{theorder=order;}});this.changeStatus("cancel",theorder);this.setState({orders:newOrders});}},{key:'editTrackingNumber',value:function editTrackingNumber(e){var id_strings=e.target.id.split("_");var id=id_strings[0];var orderID=id_strings[1];var tracking_number=document.getElementById(e.target.id).textContent;document.getElementById(e.target.id).style.fontWeight="bold";if(/^[a-zA-Z0-9\-\/]{1,}$/g.test(tracking_number)){document.getElementById(e.target.id).style.color="green";var orders=this.state.orders;orders[id].tracking_number=tracking_number;this.setState({orders:orders});__WEBPACK_IMPORTED_MODULE_3_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_4__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'create',table:'asm_order',misc:'tracking',status:tracking_number,firstID:orderID}});}else{document.getElementById(e.target.id).style.color="red";}}},{key:'render',value:function render(){var _this4=this;var content=void 0;var cutoffDate=void 0;var inputStyles="pl2 pr2 h2 br2 bw1 w-90 shadow-3";if(this.props.view==="history"){//start date and end date input fields for asm_admin to filter orders
cutoffDate=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 pb3 mb3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-40 pr2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'b navy mt2'},'Start Date:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__component_Input_js__["a" /* default */],{type:'text',id:'start',inputStyle:inputStyles,identity:'startDate',onInput:this.handleInput,val:this.state.startDate})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-40'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'b navy mt2'},'End Date:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__component_Input_js__["a" /* default */],{type:'text',id:'end',inputStyle:inputStyles,identity:'endDate',onInput:this.handleInput,val:this.state.endDate})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-20'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:this.handleSubmit,className:'b white bg-navy pa2 br3 tc w-100 mt3'},'Submit'))));}var columnsTop=void 0;var customStyles={content:{top:'50%',left:'50%',right:'auto',bottom:'auto',width:'400px',minWidth:'300px',borderStyle:'solid',borderWidth:'2px',borderColor:'gray',//backgroundColor:'#F4F4F4',
transform:'translate(-50%, -50%)',boxShadow:'0.5px 0.5px 1px 0.5px'},overlay:{backgroundColor:'rgba(105,105,105,0.8)'}};var approve={backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_5__asset_img_checkmark_png___default.a+')',backgroundRepeat:'no-repeat',backgroundPosition:'center',backgroundColor:'white',backgroundSize:'35px 25px',minWidth:'40px',minHeight:'30px'};var deny={backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_6__asset_img_denied_png___default.a+')',backgroundRepeat:'no-repeat',backgroundPosition:'center',backgroundColor:'white',backgroundSize:'35px 25px',minWidth:'40px',minHeight:'30px'};var orders=this.state.orders;var columnHeads=["Gift","Unit Cost","Quantity","size","color"];var orderhistory=void 0;if(orders.length>0){var tracking=void 0;orderhistory=orders.map(function(orders,i){//map and consolidate orders 
var costcenter=orders.costcenter;var address_city_state_zip=orders.address+", "+orders.city+", "+orders.state+" "+orders.zipcode;var notes=orders.notes===null||orders.notes===''?"None":orders.notes;var instructions=orders.instructions===null||orders.instructions===''?"None":orders.instructions;var tracking_number=orders.tracking_number===null||orders.tracking_number===''?"None":orders.tracking_number;var items=orders.items.map(function(item){//get relevant line item information
return{prize:item.prize,cost:"$"+item.item_cost,quantity:item.quantity,size:item.size,color:item.color};});var orderitems=items.map(function(items,i){//display line items in table format
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_TableData_js__["a" /* default */],{key:i,columns:items,cellstyle:'ba tc pa1',rowstyle:'stripe-blue'});});if(_this4.props.userInfo.userType!=="asm"){//following block is for asm_regionals and asm_admin viewing pending orders
var buttonVal=_this4.props.view==="regional"?"pending":"fulfilled";var buttons=void 0;if(orders.status!=="fulfilled"&&_this4.props.view!=="user"){//display fulfill and deny buttons
if(_this4.props.approval!=="automatic"){//if asm_regional has chosen to manually approve orders that pass their threshold
buttons=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-25 b mt2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'fr br3',name:orders.ID,value:buttonVal,onClick:_this4.onclick,style:approve}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'fr br3',name:orders.ID,value:'denied',onClick:_this4.onclick,style:deny}));}columnsTop=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 ba br--top br3 br bl pl2 pr2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fl w-25 b'},'Date: ',orders.Date),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fl w-25 b'},'Total Cost: $',orders.cost),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fl w-25 b'},'Name: ',orders.name),buttons);}else if(_this4.props.view==="user"){//order headers for viewing personal orders
if(orders.status!=="pending"){columnsTop=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 ba br--top br3 br bl pl2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fl w-33 b'},'Date: ',orders.Date),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fl w-33 b'},'Total Cost: $',orders.cost),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fl w-33 b'},'Status: ',orders.status));}else{columnsTop=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 ba br--top br3 br bl pl2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fl w-30 b'},'Date: ',orders.Date),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fl w-30 b'},'Total Cost: $',orders.cost),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fl w-30 b'},'Status: ',orders.status),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-10 pr2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'fr br3 mt2 white bg-navy b',name:orders.ID,value:'cancel',onClick:_this4.onclick},'cancel')));}}else if(_this4.props.view==="history"){//order headers for asm_admin viewing fulfilled orders
var track_id=i+"_"+orders.ID;tracking=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'bb pl2 pr2 pb3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'b pr1',style:{display:'inline-block'}},'Tracking Number: '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{display:'inline-block'},id:track_id,onBlur:_this4.editTrackingNumber,contentEditable:true},tracking_number));columnsTop=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 ba br--top br3 br bl pl2 pr2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fl w-25 b'},'Date: ',orders.Date),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fl w-25 b'},'Total Cost: $',orders.cost),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fl w-25 b'},'Name: ',orders.name),buttons);}}else{if(orders.status!=="pending"){//headers for already fulfilled orders
if(orders.status==="fulfilled"){tracking=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'bb pl2 pr2 pb3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'b'},'Tracking Number: '),tracking_number);}columnsTop=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 ba br--top br3 br bl pl2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fl w-33 b'},'Date: ',orders.Date),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fl w-33 b'},'Total Cost: $',orders.cost),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fl w-33 b'},'Status: ',orders.status));}else{//headers for pending orders
columnsTop=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 ba br--top br3 br bl pl2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fl w-30 b'},'Date: ',orders.Date),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fl w-30 b'},'Total Cost: $',orders.cost),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fl w-30 b'},'Status: ',orders.status),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-10 pr2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'fr br3 mt2 white bg-navy b',name:orders.ID,value:'cancel',onClick:_this4.onclick},'cancel')));}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 mv3 br3 shadow-3 bg-white',key:i},columnsTop,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'fl w-100 collapse mb2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',{className:'collapse'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__component_TableHead_js__["a" /* default */],{columns:columnHeads,headstyle:'ba pa1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',{className:'bb bw1'},orderitems)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bl br bb br--bottom br3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'bb pl2 pr2 pb1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'b'},'Cost center: '),costcenter),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'bb pl2 pr2 pb3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'b'},'Ship To: '),address_city_state_zip),tracking,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt3 pl2 pr2 bb pb3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'b'},'Shipping Instructions: '),instructions),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt3 pl2 pr2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'b'},'Event Details: '),notes)));});}var modalContent=void 0;if(this.state.loading){//display loading gif
modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tc',style:{width:'150px',margin:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_9__asset_img_loader_gif___default.a,alt:'Loading'}));}else if(this.props.view!=="history"){//modal prompt for when a user wishes to cancel an order
modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 tr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'bg-white gray b br3',onClick:this.closeModal},'X')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'navy b tc f4'},'Are you sure you would like to cancel this order?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50 tc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:this.cancelOrder,className:'w-50-ns w-100 bg-navy b white br2'},'Yes')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50 tc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:this.closeModal,className:'w-50-ns w-100 bg-navy b white br2'},'No')))));}else{//display message
modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 tr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'bg-white gray b br3',onClick:this.closeModal},'X')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'navy b f4 tc pt2'},this.state.modalPrompt));}if(this.props.active){if(orders.length<1){orderhistory=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'w-100 f3 tc mv3'},'There is nothing to view at this time.');}content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,cutoffDate,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,orderhistory),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_modal___default.a,{isOpen:this.state.modalIsOpen,style:customStyles,contentLabel:'shopping cart Modal',shouldCloseOnOverlayClick:false,shouldCloseOnEsc:false},modalContent)));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,content);}}]);return ViewASMOrders;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);// <div className="fl w-33">
// 												<div className="fl w-100">
// 													<label className="b navy mt2">Cut-off Month:</label>
// 												</div>
// 												<div className="fl w-100 pr2">
// 													<SelectBox identity="month" options={months} onSelect={this.handleInput} styles={inputStyles} val={this.state.month} type="Month"/>
// 												</div>
// 											</div>
// 											<div className="fl w-33">
// 												<div className="fl w-100">
// 													<label className="b navy mt2">Cut-off Day:</label>
// 												</div>
// 												<div className="fl w-100 pr2">
// 													<SelectBox identity="day" options={this.state.days} onSelect={this.handleInput} styles={inputStyles} val={this.state.day} type="Day"/>
// 												</div>
// 											</div>
// 											<div className="fl w-33">
// 												<div className="fl w-100">
// 													<label className="b navy mt2">Year:</label>
// 												</div>
// 												<div className="fl w-100 pr2">
// 													<SelectBox identity="year" options={this.state.years} onSelect={this.handleInput} styles={inputStyles} val={this.state.year} type="Year"/>
// 												</div>
// 											</div>
// console.log(identity,value);
// if(identity === "month"){
// 	let year = this.state.year;
// 	theState['days'] = this.getDays(value,year);
// 	theState['day'] = '01';
// }else if(identity === "year"){
// 	theState['days'] = this.getDays(theState['month'],value);
// 	theState['day'] = '01';
// 	theState['year'] = value;
// }
/* harmony default export */ __webpack_exports__["a"] = (ViewASMOrders);

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__component_Select_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__component_Input_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ViewASMOrders_js__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_modal__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__component_TableHead_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__asset_img_settingsGear_png__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__asset_img_settingsGear_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__asset_img_settingsGear_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__asset_img_loader_gif__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__asset_img_loader_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__asset_img_loader_gif__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//component that contains all order information to be viewed
var ASMRegionalCenter=function(_Component){_inherits(ASMRegionalCenter,_Component);function ASMRegionalCenter(props){_classCallCheck(this,ASMRegionalCenter);var _this=_possibleConstructorReturn(this,(ASMRegionalCenter.__proto__||Object.getPrototypeOf(ASMRegionalCenter)).call(this,props));_this.handleSelection=_this.handleSelection.bind(_this);_this.handleBudget=_this.handleBudget.bind(_this);_this.handleAnnualBudget=_this.handleAnnualBudget.bind(_this);_this.individualAnnualBudget=_this.individualAnnualBudget.bind(_this);_this.setAnnualBudgets=_this.setAnnualBudgets.bind(_this);_this.getAnnualBudgets=_this.getAnnualBudgets.bind(_this);_this.onSave=_this.onSave.bind(_this);_this.departmentInfo=_this.departmentInfo.bind(_this);_this.openModal=_this.openModal.bind(_this);_this.closeModal=_this.closeModal.bind(_this);_this.hoverTab=_this.hoverTab.bind(_this);_this.state={threshold:0,approval:'',current:'',modalIsOpen:false,loading:false,saved:false,NSD:false,departmentInfo:[],updateInfo:[],currentDepartmentInfo:[],initialBudget:0,remainingBudget:0,spent:0,initialAllocated:0,allocated:0,regionalID:0,department:'',departmentNames:[],annualBudgetInfo:[],annualBudgetUpdate:[],individualAnnualBudgetUpdate:[],modalPrompt:'',modalView:'departments'};return _this;}_createClass(ASMRegionalCenter,[{key:'componentDidMount',value:function componentDidMount(){//when component mounts, grab their settings
if(this.props.userInfo.userType!=='asm'){this.departmentInfo();}}},{key:'departmentInfo',value:function departmentInfo(){var _this2=this;var onComponentMount=arguments.length>0&&arguments[0]!==undefined?arguments[0]:true;//method that grabs settings (price threshold and approval) that asm_regional has set for their region
var action=this.props.userInfo.userType==='asm_regional'?'regional_budget_settings':'admin_budget_settings';//const action = 'admin_budget_settings';
__WEBPACK_IMPORTED_MODULE_1_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_2__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'info',table:'department',action:action,userID:this.props.userInfo.userID}}).then(function(response){var data=response.data.data;var members=[];var membersCopy=[];var memberNames=[];var departmentNames=[];var initial_budget=void 0;if(data!==undefined&&data[0]!==undefined){data.forEach(function(member){if(departmentNames.indexOf(member.department)<0){departmentNames.push(member.department);}if(member.userID!==_this2.props.userInfo.userID&&memberNames.indexOf(member.name)<0&&member.department!=='RSD'){members.push(member);initial_budget=member.user_type==='asm'?member.budget+member.spent:member.dept_budget+member.additional_alloc;membersCopy.push({name:member.name,userID:member.userID,budget:member.budget,spent:member.spent,userType:member.user_type,dept_budget:member.dept_budget,additional_alloc:member.additional_alloc,initial_budget:initial_budget});memberNames.push(member.name);}else if(member.userID===_this2.props.userInfo.userID){var NSD=false;if((member.department==="MSM"||member.department==="RSD")&&member.managerID===_this2.props.userInfo.userID){NSD=true;_this2.getAnnualBudgets();}var amtAllocated=member.dept_budget-member.spent-member.budget+member.additional_alloc;_this2.setState({initialBudget:member.dept_budget,remainingBudget:member.budget,spent:member.spent,initialAllocated:amtAllocated,allocated:amtAllocated,NSD:NSD});}});_this2.setState({departmentInfo:members,updateInfo:membersCopy,departmentNames:departmentNames},function(){if(this.props.userInfo.userType!=='asm_regional'&&onComponentMount){this.handleSelection("department",departmentNames[0]);this.getAnnualBudgets();}else{this.handleSelection("department",this.state.department);this.getAnnualBudgets();}});}});}},{key:'openModal',value:function openModal(){//method for opening the modal
this.setState({modalIsOpen:true});}},{key:'closeModal',value:function closeModal(){//method for closing the modal
this.setState({modalIsOpen:false,saved:false,modalPrompt:'',modalView:'departments'});}},{key:'handleSelection',value:function handleSelection(identity,value){//standard method for updating the state based on user input
var theState={};theState[identity]=value;if(identity==="department"){var currentUpdateInfo=[];//information that will actually be manipulated
var currentDepartmentInfo=[];//information with inital values to compare new information against
var currentAnnualUpdateInfo=[];if(value==="RSD"){this.state.departmentInfo.forEach(function(member){if(member.user_type==="asm_regional"){if(member.userID===member.managerID&&(member.department==="RSD"||member.department==="MSM")){var amtAllocated=member.dept_budget-member.spent-member.budget+member.additional_alloc;theState['remainingBudget']=member.budget;theState['initialBudget']=member.dept_budget;theState['spent']=member.spent;theState['initialAllocated']=amtAllocated;theState['allocated']=amtAllocated;theState['regionalID']=member.managerID;}else{currentUpdateInfo.push({name:member.name,userID:member.userID,budget:member.budget,spent:member.spent,userType:member.user_type,dept_budget:member.dept_budget,additional_alloc:member.additional_alloc});currentDepartmentInfo.push({name:member.name,userID:member.userID,budget:member.budget,spent:member.spent,userType:member.user_type,dept_budget:member.dept_budget,additional_alloc:member.additional_alloc});currentAnnualUpdateInfo.push({name:member.name,userID:member.userID,budget:member.budget,spent:member.spent,userType:member.user_type,dept_budget:member.dept_budget,additional_alloc:member.additional_alloc});}}});}else{this.state.departmentInfo.forEach(function(member){if(member.department===value){if(member.user_type!=="asm_regional"){currentUpdateInfo.push({name:member.name,userID:member.userID,budget:member.budget,spent:member.spent,userType:member.user_type,dept_budget:member.dept_budget,additional_alloc:member.additional_alloc});currentDepartmentInfo.push({name:member.name,userID:member.userID,budget:member.budget,spent:member.spent,userType:member.user_type,dept_budget:member.dept_budget,additional_alloc:member.additional_alloc});currentAnnualUpdateInfo.push({name:member.name,userID:member.userID,budget:member.budget,spent:member.spent,userType:member.user_type,dept_budget:member.dept_budget,additional_alloc:member.additional_alloc});}else{var amtAllocated=member.dept_budget-member.spent-member.budget+member.additional_alloc;theState['remainingBudget']=member.budget;theState['initialBudget']=member.dept_budget;theState['spent']=member.spent;theState['initialAllocated']=amtAllocated;theState['allocated']=amtAllocated;theState['regionalID']=member.managerID;}}});}theState['updateInfo']=currentUpdateInfo;theState['currentDepartmentInfo']=currentDepartmentInfo;theState['individualAnnualBudgetUpdate']=currentAnnualUpdateInfo;}this.setState(theState);}},{key:'handleBudget',value:function handleBudget(identity,value){//method that handles updating asm budget in the state
var _state=this.state,updateInfo=_state.updateInfo,departmentInfo=_state.departmentInfo,currentDepartmentInfo=_state.currentDepartmentInfo,initialBudget=_state.initialBudget,initialAllocated=_state.initialAllocated,remainingBudget=_state.remainingBudget,spent=_state.spent;//value = Number(value);
if(value!==''){value=Number(value);}updateInfo[identity].budget=value;//if(/^(\s*|[1-9][0-9]*)$/.test(value)){
//value = Number(value);
if(Number(remainingBudget)>-1){var department=this.props.userInfo.userType==='asm_regional'?departmentInfo:currentDepartmentInfo;//value === ''?0:value;
//updateInfo[identity].budget = department[identity].budget + value;
//updateInfo[identity].budget = value;
var allocated=initialAllocated;for(var i=0;i<updateInfo.length;i++){allocated+=updateInfo[i].budget-department[i].budget;}var remaining=initialBudget-spent-allocated;if(remaining>=0){this.setState({updateInfo:updateInfo,remainingBudget:remaining,allocated:allocated});//document.getElementById((identity+"_budget")).style.borderColor = "inherit";
}else{//document.getElementById((identity+"_budget")).style.borderColor = "red";
document.getElementById(identity+"_budget").value=Number(value.toString().slice(0,-1));}}else{document.getElementById(identity+"_budget").value='';}// }else{
// 	document.getElementById((identity+"_budget")).value = '';
// }
}},{key:'onSave',value:function onSave(){var _this3=this;//method for updating user budgets in database
this.setState({loading:true,modalIsOpen:true});var budgetChanges=[];var inputsToClear=[];var _state2=this.state,updateInfo=_state2.updateInfo,departmentInfo=_state2.departmentInfo;var secondID=this.props.userInfo.userType!=='asm_regional'?this.state.regionalID:this.props.userInfo.userID;for(var i=0;i<updateInfo.length;i++){if(updateInfo[i].budget!==departmentInfo[i].budget){inputsToClear.push(i+"_budget");budgetChanges.push(__WEBPACK_IMPORTED_MODULE_1_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_2__routes_js__["c" /* path */],data:{endpoint:'create',table:'points',misc:'budget',firstID:updateInfo[i].userID,cost:updateInfo[i].budget,secondID:secondID}}));}}var prompt=void 0;if(inputsToClear.length<1){prompt='No new information was entered';}__WEBPACK_IMPORTED_MODULE_1_axios___default.a.all(budgetChanges).then(function(response){for(var j=0;j<inputsToClear.length;j++){document.getElementById(inputsToClear[j]).value='';}_this3.departmentInfo(false);prompt='Budgets successfully updated';_this3.setState({loading:false,modalPrompt:prompt});}).catch(function(error){prompt='There was a problem updating the budgets';_this3.setState({loading:false,modalPrompt:prompt});});}},{key:'getAnnualBudgets',value:function getAnnualBudgets(){var _this4=this;__WEBPACK_IMPORTED_MODULE_1_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_2__routes_js__["c" /* path */],data:{endpoint:'info',table:'budgets'}}).then(function(response){var data=response.data.data;var budgetsOne=[];var budgetsTwo=[];data.forEach(function(department){budgetsOne.push(department);budgetsTwo.push({deptID:department.deptID,asm_budget:department.asm_budget,rsd_budget:department.rsd_budget,department:department.department});});_this4.setState({annualBudgetInfo:budgetsOne,annualBudgetUpdate:budgetsTwo});});}},{key:'setAnnualBudgets',value:function setAnnualBudgets(){var _this5=this;this.setState({loading:true});var update=void 0;var prompt=void 0;//let current = this.state.annualBudgetInfo;
var budgetUpdates=[];if(this.state.modalView==='departments'){update=this.state.annualBudgetUpdate;for(var i=0;i<update.length;i++){if(update[i].asm_budget>0||update[i].rsd_budget>0){budgetUpdates.push(__WEBPACK_IMPORTED_MODULE_1_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_2__routes_js__["c" /* path */],data:{endpoint:'create',table:'budget',firstID:update[i].deptID,cost:update[i].asm_budget,costTwo:update[i].rsd_budget,name:update[i].department}}));// if(update[i].department !== "RSD"){
// 	document.getElementById(i+"_asm").value = '';
// 	document.getElementById(i+"_rsd").value = '';
// }else{
// 	document.getElementById(i+"_rsd").value = '';
// }
}}}else{update=this.state.individualAnnualBudgetUpdate;for(var _i=0;_i<update.length;_i++){if(update[_i].budget!==''&&update[_i].budget!==this.state.updateInfo[_i].budget){budgetUpdates.push(__WEBPACK_IMPORTED_MODULE_1_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_2__routes_js__["c" /* path */],data:{endpoint:'create',table:'points',misc:'individual_annual',cost:update[_i].budget,firstID:update[_i].userID}}));}}}if(budgetUpdates.length>0){__WEBPACK_IMPORTED_MODULE_1_axios___default.a.all(budgetUpdates).then(function(response){prompt='Annual budgets set';_this5.setState({loading:false,modalPrompt:prompt});_this5.departmentInfo(false);}).catch(function(error){prompt='There was a problem updating the annual budgets';_this5.setState({loading:false,modalPrompt:prompt});});}else{prompt='No budget info was entered.';this.setState({loading:false,modalPrompt:prompt});}}},{key:'handleAnnualBudget',value:function handleAnnualBudget(identity,value){if(/^(\s*|[1-9][0-9]*)$/.test(value)){var info=identity.split("_");var index=Number(info[0]);var theState=this.state.annualBudgetUpdate;value=value===''?value:Number(value);if(info[1]==='rsd'){theState[index].rsd_budget=value;}else{theState[index].asm_budget=value;}this.setState({annualBudgetUpdate:theState});}else{document.getElementById(identity).value='';}}},{key:'individualAnnualBudget',value:function individualAnnualBudget(identity,value){if(/^(\s*|[1-9][0-9]*)$/.test(value)){var info=identity.split("_");var index=Number(info[0]);var theState=this.state.individualAnnualBudgetUpdate;if(value!==''){value=Number(value);}theState[index].budget=value;this.setState({individualAnnualBudgetUpdate:theState});}else{document.getElementById(identity).value='';}}},{key:'hoverTab',value:function hoverTab(e){if(e.target.id==='hoverTabOne'){document.getElementById(e.target.id).classList.remove("hoverTab");document.getElementById("hoverTabTwo").classList.add("hoverTab");document.getElementById("hoverTabTwo").classList.remove("hoverTabClicked");document.getElementById(e.target.id).classList.add("hoverTabClicked");this.setState({modalView:'departments'});}else{document.getElementById(e.target.id).classList.remove("hoverTab");document.getElementById("hoverTabOne").classList.add("hoverTab");document.getElementById("hoverTabOne").classList.remove("hoverTabClicked");document.getElementById(e.target.id).classList.add("hoverTabClicked");this.setState({modalView:'individuals'});}}},{key:'render',value:function render(){var _this6=this;var customStyles={content:{top:'50%',left:'50%',right:'auto',bottom:'auto',width:'100%',maxWidth:'700px',minWidth:'320px',height:'auto',maxHeight:'530px',padding:'10px',transform:'translate(-50%, -50%)',boxShadow:'0.5px 0.5px 1px 0.5px',backgroundColor:'#f1f1f1'},overlay:{backgroundColor:'rgba(105,105,105,0.8)'}};if(this.state.modalPrompt===''&&!this.state.loading){customStyles.height='530px';}var content=void 0;var buttonstyle="dim pb2 mt2 pt2 b white w-100 center bg-dark-blue br2 shadow-2";var buttonstyleTwo="dim pb2 mt2 pt2 b white w-100 center bg-dark-blue br2 shadow-2";var selectStyle="h2 pa1 br2 bw1 w-100 truncate shadow-2";var inputStyle="h2 br2 bw1 shadow-3 w-100 pl2 pr2";var mainDivStyle={boxShadow:'0px 0px 5px 5px #aaaaaa inset',backgroundColor:'white',minWidth:'300px',margin:'auto',maxHeight:'580px',height:'580px',width:'90%',maxWidth:'800px'};var memberUlDivStyle={maxHeight:'300px'};var memberUlStyle={maxHeight:'290px'};var memberUlDivClassName="fl w-100 overflow-y-auto bb b--gray pb1 mb3";//let totalAllocated = 0;
var modalContent=void 0;var spent=void 0;var id=void 0;var button=void 0;var departmentMemberInputs=this.state.updateInfo.map(function(members,i){//loop through asms and create input fields
//totalAllocated += Number(this.state.departmentMembers[i].budget);
id=i+"_budget";spent=members.userType==='asm'?members.spent:members.dept_budget-members.budget;var totalBudget=spent+members.budget;var input_val=void 0;//= (members.budget === null || members.budget === undefined || members.budget === '')?'':members.budget.toFixed(2);
if(members.budget===null||members.budget===undefined){input_val=0.00;}else if(members.budget!==''){input_val=Number(members.budget.toFixed(2));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'mb2 mt0 fl w-100',key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-33 center pa0 pt2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mt1 tl'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'navy b pa0 ma0'},members.name,' '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-33 pa0 pt2 tl'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'navy pa0 ma0'},'$',totalBudget))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-33 pa0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pr2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__component_Input_js__["a" /* default */],{name:'budget',id:id,identity:i,onInput:_this6.handleBudget,inputStyle:inputStyle,placeholder:'0',val:input_val}))));});if(this.state.NSD){button=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50 pt1 pl2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:this.openModal,className:'dim h2 ml2 mt3 b white w-100 center bg-navy br2 shadow-2'},'Annual Budgets'));}var asmRegionalBudgetInfo=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'f5 ma0 pt2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'b navy'},'Initial Budget:'),' $',this.state.initialBudget)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'f5 ma0 pt2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'b navy'},'Remaining Budget:'),' $',this.state.remainingBudget))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-30'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'f5 ma0 pt2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'b navy'},'Amount Spent:'),' $',this.state.spent)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'f5 ma0 pt2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'b navy'},'Amount Allocated:'),' $',this.state.allocated))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50'},button));if(this.props.userInfo.userType!=='asm_regional'){memberUlDivStyle.maxHeight='230px';if(this.props.userInfo.userType==='asm_admin'||this.props.userInfo.userType==='sys_admin'){mainDivStyle.boxShadow='';mainDivStyle.backgroundColor='';mainDivStyle.height='inherit';mainDivStyle.maxHeight='inherit';memberUlDivStyle.maxHeight='';memberUlStyle.maxHeight='';memberUlDivClassName="fl w-100 bb b--gray pb1";}asmRegionalBudgetInfo=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pb1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'navy b'},'Region/Department: ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__component_Select_js__["a" /* default */],{name:'department',identity:'department',onSelect:this.handleSelection,options:this.state.departmentNames,styles:selectStyle,val:this.state.department})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-25 pt1 pl2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:this.openModal,className:'dim h2 ml2 mt3 b white w-100 center bg-navy br2 shadow-2'},'Annual Budgets'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 mt2 pb2 pt2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'f5 ma0 pt2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'b navy'},'Initial Budget:'),' $',this.state.initialBudget.toFixed(2))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'f5 ma0 pt2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'b navy'},'Remaining Budget:'),' $',this.state.remainingBudget.toFixed(2)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'f5 ma0 pt2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'b navy'},'Amount Spent:'),' $',this.state.spent.toFixed(2))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'f5 ma0 pt2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'b navy'},'Amount Allocated:'),'$',this.state.allocated.toFixed(2)))))));}if(this.props.userInfo.userType!=='asm_regional'||this.state.NSD){var theinputs=void 0;if(this.state.modalView==='departments'){theinputs=this.state.annualBudgetUpdate.map(function(department,i){var asm=i+"_asm";var rsd=i+"_rsd";var inputs=void 0;if(department.department!=="RSD"&&department.department!=="MSM"){inputs=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:i,className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-33 tc pa2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'navy b pa0 ma0'},department.department)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-33 pa2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__component_Input_js__["a" /* default */],{name:'rsd_budget',identity:rsd,id:rsd,onInput:_this6.handleAnnualBudget,inputStyle:inputStyle,val:department.rsd_budget})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-33 pa2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__component_Input_js__["a" /* default */],{name:'asm_budget',identity:asm,id:asm,onInput:_this6.handleAnnualBudget,inputStyle:inputStyle,val:department.asm_budget})));}else{if(department.department==="RSD"){inputs=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:i,className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-33 tc pa2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'navy b pa0 ma0'},department.department)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-33 pa2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__component_Input_js__["a" /* default */],{name:'rsd_budget',identity:rsd,id:rsd,onInput:_this6.handleAnnualBudget,inputStyle:inputStyle,val:department.rsd_budget})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-33 tc pt2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'navy b pa0 ma0 pt2'},'N/A')));}else{inputs=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:i,className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-33 tc pa2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'navy b pa0 ma0'},department.department)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-33 tc pt2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'navy b pa0 ma0 pt2'},'N/A')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-33 pa2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__component_Input_js__["a" /* default */],{name:'asm_budget',identity:asm,id:asm,onInput:_this6.handleAnnualBudget,inputStyle:inputStyle,val:department.asm_budget})));}}return inputs;});}else{theinputs=this.state.individualAnnualBudgetUpdate.map(function(asminfo,i){var annualBudget='';//if(asminfo.department === this.state.department){
if(asminfo.budget!==''){annualBudget=Number(asminfo.budget+asminfo.spent);}else{asminfo.budget=0;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:i,className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-33 tc pa2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'navy b pa0 ma0'},asminfo.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-33 tc pt2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'navy b pa0 ma0 pt2'},asminfo.budget.toFixed(2))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-33 pa2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__component_Input_js__["a" /* default */],{name:'asm_budget',identity:i+"_asmbudget",id:i+"_asmbudget",onInput:_this6.individualAnnualBudget,inputStyle:inputStyle,val:annualBudget})));//}
});}var budgetHeaders=void 0,departmentSelect=void 0;var inputsDivStyle={};if(this.state.modalView==="departments"){budgetHeaders=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'fl w-100 tc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-33'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'navy b pa0 ma0'},'Department')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-33'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'navy b pa0 ma0'},'Regional')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-33'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'navy b pa0 ma0'},'ASM')));}else{inputsDivStyle={maxHeight:'273px'};departmentSelect=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 pt3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__component_Select_js__["a" /* default */],{name:'department',identity:'department',onSelect:this.handleSelection,options:this.state.departmentNames,styles:selectStyle,val:this.state.department}));budgetHeaders=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'fl w-100 tc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-33'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'navy b pa0 ma0'},'Name')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-33'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'navy b pa0 ma0'},'Remaining Budget')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-33'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'navy b pa0 ma0'},'Annual Budget')));}modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'br3',style:{backgroundColor:'#f1f1f1'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 bb b--gray'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'w-50',style:{maxWidth:'340px',margin:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'hoverTabOne',className:'fl w-50 f3 tc pt2 pb2 hoverTabClicked',onClick:this.hoverTab},'Departments'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'hoverTabTwo',className:'fl w-50 f3 tc pt2 pb2 hoverTab',onClick:this.hoverTab},'Individuals'),departmentSelect),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'fl w-100 list mb1 pl2 pt3'},budgetHeaders)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:inputsDivStyle,className:'fl w-100 bb b--gray mb2 overflow-y-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'fl list w-100 pl2'},theinputs)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pa2 mt3 w-30 center ',style:{minWidth:'180px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:this.setAnnualBudgets,className:buttonstyle},'Set Budgets')));}if(this.state.loading&&this.state.modalPrompt===''){modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tc',style:{width:'150px',margin:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_9__asset_img_loader_gif___default.a,alt:'Loading'}));}else if(!this.state.loading&&this.state.modalPrompt!==''){modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'w-100 tc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'navy b f3'},this.state.modalPrompt));}if(this.props.active){content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:mainDivStyle,className:'br3 pa3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 mb2 pb2 ',style:{maxHeight:'450px'}},asmRegionalBudgetInfo,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 bb b--gray'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'fl w-100 list mb1 pl2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'fl w-100',style:{paddingRight:'18px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-33'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'ma0 pa0 b'},'Team Member')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-33'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'ma0 pa0 b'},'Budget')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-33'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'ma0 pa0 b'},'Remaining'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:memberUlDivClassName,style:memberUlDivStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'fl list w-100 pl2',style:memberUlStyle},departmentMemberInputs)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 mt3 mb3 pb4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'w-100 center tc',style:{maxWidth:'220px',marginLeft:'auto',marginRight:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:this.onSave,className:buttonstyleTwo},'Update')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_modal___default.a,{isOpen:this.state.modalIsOpen,style:customStyles,contentLabel:'confirmation',shouldCloseOnOverlayClick:false,shouldCloseOnEsc:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 tr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'b br3',style:{backgroundColor:'#f1f1f1'},onClick:this.closeModal},'X')),modalContent)));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,content);}}]);return ASMRegionalCenter;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);// content = <div>
// 									<div className="w-100 center">
// 										<div className="w-100 tc">
// 											<button className="br2 h3 shadow-3 br3 pt1 pb1" onClick={this.openModal} style={buttonStyles}><span className="navy b" style={{marginLeft:'65px',marginRight:'10px'}}>Notification Settings</span></button>
// 										</div>
// 									</div>
// 									<div className="fl w-100 mt3">
// 										<ViewASMOrders userInfo={this.props.userInfo} app={this.props.app} view="regional" approval={this.state.current} active={true} logChange={this.props.logChange}/>
// 									</div>
// 								</div>;
// <div>
// 	<p className="f5"><span className="b navy">Total Budget For {this.state.region}:</span> ${this.state.regionBudget}</p>
// </div>
// <div className="pa2">
// 							        	<div>
// 							        		<label className="navy b pb3">RSD Annual Budget: </label>
// 							        	</div>
// 							        	<div>
// 							        		<Input name="RSD_yearly_budget" id="rsd_yearly_budget" identity="rsd_yearly_budget" onInput={this.handleAnnualBudget} inputStyle={inputStyle} type="number" placeholder="0"/>
// 							        	</div>
// 							        </div>
// 							        <div className="pa2">
// 							        	<div>
// 							        		<label className="navy b pb3">ASM/MSM Annual Budget: </label>
// 							        	</div>
// 							        	<div>
// 							        		<Input name="ASM_yearly_budget" id="asm_yearly_budget" identity="asm_yearly_budget" onInput={this.handleAnnualBudget} inputStyle={inputStyle} type="number" placeholder="0"/>
// 							        	</div>
// 							        </div>
// <div className="fl w-30">
// 														<p className="ma0 pa0 b">Team Member</p>
// 													</div>
// 													<div className="fl w-25">
// 														<p className="ma0 pa0 b">Total Spent</p>
// 													</div>
// 													<div className="fl w-25">
// 														<p className="ma0 pa0 b">Remaining Budget</p>
// 													</div>
// 													<div className="fl w-20">
// 														<p className="ma0 pa0 b">Amt. to Allocate</p>
// 													</div>
// <div className="fl w-25 pa0 pt2 tl">
// 						<div>
// 							<p className="navy pa0 ma0">${members.budget}</p>
// 						</div>
// 					</div>
/* harmony default export */ __webpack_exports__["a"] = (ASMRegionalCenter);

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(47);
module.exports = __webpack_require__(52);


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(48).enable();
  window.Promise = __webpack_require__(50);
}

// fetch() polyfill for making API calls.
__webpack_require__(51);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(17);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(24);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)))

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(24);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 51 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tachyons__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tachyons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_tachyons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__container_App__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__registerServiceWorker__ = __webpack_require__(162);
__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__container_App__["a" /* default */],null),document.getElementById('root'));Object(__WEBPACK_IMPORTED_MODULE_5__registerServiceWorker__["a" /* default */])();

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.12.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var h=__webpack_require__(17),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113;n&&Symbol.for("react.suspense_list");
var z=n?Symbol.for("react.memo"):60115,aa=n?Symbol.for("react.lazy"):60116;n&&Symbol.for("react.fundamental");n&&Symbol.for("react.responder");n&&Symbol.for("react.scope");var A="function"===typeof Symbol&&Symbol.iterator;
function B(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}var C={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},D={};
function E(a,b,c){this.props=a;this.context=b;this.refs=D;this.updater=c||C}E.prototype.isReactComponent={};E.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(B(85));this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,c){this.props=a;this.context=b;this.refs=D;this.updater=c||C}var H=G.prototype=new F;
H.constructor=G;h(H,E.prototype);H.isPureReactComponent=!0;var I={current:null},J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,l=null;if(null!=b)for(e in void 0!==b.ref&&(l=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var k=Array(f),m=0;m<f;m++)k[m]=arguments[m+2];d.children=k}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:l,props:d,_owner:J.current}}
function ba(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,c,e){if(P.length){var d=P.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
function S(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var l=0;l<a.length;l++){d=a[l];var f=b+T(d,l);g+=S(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=A&&a[A]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),l=
0;!(d=a.next()).done;)d=d.value,f=b+T(d,l++),g+=S(d,f,c,e);else if("object"===d)throw c=""+a,Error(B(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function U(a,b,c){return null==a?0:S(a,"",b,c)}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ca(a,b){a.func.call(a.context,b,a.count++)}
function da(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,e,c,function(a){return a}):null!=a&&(N(a)&&(a=ba(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+c)),e.push(a))}function V(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(O,"$&/")+"/");b=Q(b,g,e,d);U(a,da,b);R(b)}function W(){var a=I.current;if(null===a)throw Error(B(321));return a}
var X={Children:{map:function(a,b,c){if(null==a)return a;var e=[];V(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=Q(null,null,b,c);U(a,ca,b);R(b)},count:function(a){return U(a,function(){return null},null)},toArray:function(a){var b=[];V(a,b,null,function(a){return a});return b},only:function(a){if(!N(a))throw Error(B(143));return a}},createRef:function(){return{current:null}},Component:E,PureComponent:G,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:x,render:a}},lazy:function(a){return{$$typeof:aa,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}},useCallback:function(a,b){return W().useCallback(a,b)},useContext:function(a,b){return W().useContext(a,b)},useEffect:function(a,b){return W().useEffect(a,b)},useImperativeHandle:function(a,
b,c){return W().useImperativeHandle(a,b,c)},useDebugValue:function(){},useLayoutEffect:function(a,b){return W().useLayoutEffect(a,b)},useMemo:function(a,b){return W().useMemo(a,b)},useReducer:function(a,b,c){return W().useReducer(a,b,c)},useRef:function(a){return W().useRef(a)},useState:function(a){return W().useState(a)},Fragment:r,Profiler:u,StrictMode:t,Suspense:y,createElement:M,cloneElement:function(a,b,c){if(null===a||void 0===a)throw Error(B(267,a));var e=h({},a.props),d=a.key,g=a.ref,l=a._owner;
if(null!=b){void 0!==b.ref&&(g=b.ref,l=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(k in b)K.call(b,k)&&!L.hasOwnProperty(k)&&(e[k]=void 0===b[k]&&void 0!==f?f[k]:b[k])}var k=arguments.length-2;if(1===k)e.children=c;else if(1<k){f=Array(k);for(var m=0;m<k;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,key:d,ref:g,props:e,_owner:l}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.12.0",
__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentDispatcher:I,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:h}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.7.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(17),ba=__webpack_require__(55);function ca(a,b,c,d,e,f,g,h){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var k=[c,d,e,f,g,h],l=0;a=Error(b.replace(/%s/g,function(){return k[l++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
function t(a){for(var b=arguments.length-1,c="https://reactjs.org/docs/error-decoder.html?invariant="+a,d=0;d<b;d++)c+="&args[]="+encodeURIComponent(arguments[d+1]);ca(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}aa?void 0:t("227");function da(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}
var ea=!1,fa=null,ha=!1,ia=null,ja={onError:function(a){ea=!0;fa=a}};function ka(a,b,c,d,e,f,g,h,k){ea=!1;fa=null;da.apply(ja,arguments)}function la(a,b,c,d,e,f,g,h,k){ka.apply(this,arguments);if(ea){if(ea){var l=fa;ea=!1;fa=null}else t("198"),l=void 0;ha||(ha=!0,ia=l)}}var ma=null,na={};
function oa(){if(ma)for(var a in na){var b=na[a],c=ma.indexOf(a);-1<c?void 0:t("96",a);if(!pa[c]){b.extractEvents?void 0:t("97",a);pa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;qa.hasOwnProperty(h)?t("99",h):void 0;qa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ra(k[e],g,h);e=!0}else f.registrationName?(ra(f.registrationName,g,h),e=!0):e=!1;e?void 0:t("98",d,a)}}}}
function ra(a,b,c){sa[a]?t("100",a):void 0;sa[a]=b;ta[a]=b.eventTypes[c].dependencies}var pa=[],qa={},sa={},ta={},ua=null,va=null,wa=null;function xa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=wa(c);la(d,b,void 0,a);a.currentTarget=null}function ya(a,b){null==b?t("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
function za(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var Aa=null;function Ba(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)xa(a,b[d],c[d]);else b&&xa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}
var Ca={injectEventPluginOrder:function(a){ma?t("101"):void 0;ma=Array.prototype.slice.call(a);oa()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];na.hasOwnProperty(c)&&na[c]===d||(na[c]?t("102",c):void 0,na[c]=d,b=!0)}b&&oa()}};
function Da(a,b){var c=a.stateNode;if(!c)return null;var d=ua(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?t("231",b,typeof c):void 0;
return c}function Ea(a){null!==a&&(Aa=ya(Aa,a));a=Aa;Aa=null;if(a&&(za(a,Ba),Aa?t("95"):void 0,ha))throw a=ia,ha=!1,ia=null,a;}var Fa=Math.random().toString(36).slice(2),Ga="__reactInternalInstance$"+Fa,Ha="__reactEventHandlers$"+Fa;function Ia(a){if(a[Ga])return a[Ga];for(;!a[Ga];)if(a.parentNode)a=a.parentNode;else return null;a=a[Ga];return 5===a.tag||6===a.tag?a:null}function Ja(a){a=a[Ga];return!a||5!==a.tag&&6!==a.tag?null:a}
function Ka(a){if(5===a.tag||6===a.tag)return a.stateNode;t("33")}function La(a){return a[Ha]||null}function Ma(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Na(a,b,c){if(b=Da(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ya(c._dispatchListeners,b),c._dispatchInstances=ya(c._dispatchInstances,a)}
function Oa(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Ma(b);for(b=c.length;0<b--;)Na(c[b],"captured",a);for(b=0;b<c.length;b++)Na(c[b],"bubbled",a)}}function Pa(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Da(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ya(c._dispatchListeners,b),c._dispatchInstances=ya(c._dispatchInstances,a))}function Qa(a){a&&a.dispatchConfig.registrationName&&Pa(a._targetInst,null,a)}
function Ra(a){za(a,Oa)}var Sa=!("undefined"===typeof window||!window.document||!window.document.createElement);function Ta(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Ua={animationend:Ta("Animation","AnimationEnd"),animationiteration:Ta("Animation","AnimationIteration"),animationstart:Ta("Animation","AnimationStart"),transitionend:Ta("Transition","TransitionEnd")},Va={},Wa={};
Sa&&(Wa=document.createElement("div").style,"AnimationEvent"in window||(delete Ua.animationend.animation,delete Ua.animationiteration.animation,delete Ua.animationstart.animation),"TransitionEvent"in window||delete Ua.transitionend.transition);function Xa(a){if(Va[a])return Va[a];if(!Ua[a])return a;var b=Ua[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Wa)return Va[a]=b[c];return a}
var Ya=Xa("animationend"),Za=Xa("animationiteration"),$a=Xa("animationstart"),ab=Xa("transitionend"),bb="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),cb=null,eb=null,fb=null;
function gb(){if(fb)return fb;var a,b=eb,c=b.length,d,e="value"in cb?cb.value:cb.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return fb=e.slice(a,1<d?1-d:void 0)}function hb(){return!0}function ib(){return!1}
function z(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?hb:ib;this.isPropagationStopped=ib;return this}
n(z.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=hb)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=hb)},persist:function(){this.isPersistent=hb},isPersistent:ib,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ib;this._dispatchInstances=this._dispatchListeners=null}});z.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
z.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;jb(c);return c};jb(z);function kb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function lb(a){a instanceof this?void 0:t("279");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}
function jb(a){a.eventPool=[];a.getPooled=kb;a.release=lb}var mb=z.extend({data:null}),nb=z.extend({data:null}),ob=[9,13,27,32],pb=Sa&&"CompositionEvent"in window,qb=null;Sa&&"documentMode"in document&&(qb=document.documentMode);
var rb=Sa&&"TextEvent"in window&&!qb,sb=Sa&&(!pb||qb&&8<qb&&11>=qb),tb=String.fromCharCode(32),ub={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},vb=!1;
function wb(a,b){switch(a){case "keyup":return-1!==ob.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function xb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var yb=!1;function zb(a,b){switch(a){case "compositionend":return xb(b);case "keypress":if(32!==b.which)return null;vb=!0;return tb;case "textInput":return a=b.data,a===tb&&vb?null:a;default:return null}}
function Ab(a,b){if(yb)return"compositionend"===a||!pb&&wb(a,b)?(a=gb(),fb=eb=cb=null,yb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return sb&&"ko"!==b.locale?null:b.data;default:return null}}
var Bb={eventTypes:ub,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(pb)b:{switch(a){case "compositionstart":e=ub.compositionStart;break b;case "compositionend":e=ub.compositionEnd;break b;case "compositionupdate":e=ub.compositionUpdate;break b}e=void 0}else yb?wb(a,c)&&(e=ub.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=ub.compositionStart);e?(sb&&"ko"!==c.locale&&(yb||e!==ub.compositionStart?e===ub.compositionEnd&&yb&&(f=gb()):(cb=d,eb="value"in cb?cb.value:cb.textContent,yb=
!0)),e=mb.getPooled(e,b,c,d),f?e.data=f:(f=xb(c),null!==f&&(e.data=f)),Ra(e),f=e):f=null;(a=rb?zb(a,c):Ab(a,c))?(b=nb.getPooled(ub.beforeInput,b,c,d),b.data=a,Ra(b)):b=null;return null===f?b:null===b?f:[f,b]}},Cb=null,Db=null,Eb=null;function Hb(a){if(a=va(a)){"function"!==typeof Cb?t("280"):void 0;var b=ua(a.stateNode);Cb(a.stateNode,a.type,b)}}function Ib(a){Db?Eb?Eb.push(a):Eb=[a]:Db=a}function Jb(){if(Db){var a=Db,b=Eb;Eb=Db=null;Hb(a);if(b)for(a=0;a<b.length;a++)Hb(b[a])}}
function Kb(a,b){return a(b)}function Lb(a,b,c){return a(b,c)}function Mb(){}var Nb=!1;function Ob(a,b){if(Nb)return a(b);Nb=!0;try{return Kb(a,b)}finally{if(Nb=!1,null!==Db||null!==Eb)Mb(),Jb()}}var Pb={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Qb(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Pb[a.type]:"textarea"===b?!0:!1}
function Rb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function Sb(a){if(!Sa)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function Tb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function Ub(a){var b=Tb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function Vb(a){a._valueTracker||(a._valueTracker=Ub(a))}function Wb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=Tb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}
var Xb=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,Yb=/^(.*)[\\\/]/,D="function"===typeof Symbol&&Symbol.for,Zb=D?Symbol.for("react.element"):60103,$b=D?Symbol.for("react.portal"):60106,ac=D?Symbol.for("react.fragment"):60107,bc=D?Symbol.for("react.strict_mode"):60108,cc=D?Symbol.for("react.profiler"):60114,dc=D?Symbol.for("react.provider"):60109,ec=D?Symbol.for("react.context"):60110,fc=D?Symbol.for("react.concurrent_mode"):60111,gc=D?Symbol.for("react.forward_ref"):60112,hc=D?Symbol.for("react.suspense"):
60113,ic=D?Symbol.for("react.memo"):60115,jc=D?Symbol.for("react.lazy"):60116,kc="function"===typeof Symbol&&Symbol.iterator;function lc(a){if(null===a||"object"!==typeof a)return null;a=kc&&a[kc]||a["@@iterator"];return"function"===typeof a?a:null}
function mc(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case fc:return"ConcurrentMode";case ac:return"Fragment";case $b:return"Portal";case cc:return"Profiler";case bc:return"StrictMode";case hc:return"Suspense"}if("object"===typeof a)switch(a.$$typeof){case ec:return"Context.Consumer";case dc:return"Context.Provider";case gc:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+
")":"ForwardRef");case ic:return mc(a.type);case jc:if(a=1===a._status?a._result:null)return mc(a)}return null}function nc(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=mc(a.type);c=null;d&&(c=mc(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Yb,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
var oc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,pc=Object.prototype.hasOwnProperty,qc={},rc={};
function sc(a){if(pc.call(rc,a))return!0;if(pc.call(qc,a))return!1;if(oc.test(a))return rc[a]=!0;qc[a]=!0;return!1}function tc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function uc(a,b,c,d){if(null===b||"undefined"===typeof b||tc(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function E(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var F={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){F[a]=new E(a,0,!1,a,null)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];F[b]=new E(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){F[a]=new E(a,2,!1,a.toLowerCase(),null)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){F[a]=new E(a,2,!1,a,null)});"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){F[a]=new E(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){F[a]=new E(a,3,!0,a,null)});
["capture","download"].forEach(function(a){F[a]=new E(a,4,!1,a,null)});["cols","rows","size","span"].forEach(function(a){F[a]=new E(a,6,!1,a,null)});["rowSpan","start"].forEach(function(a){F[a]=new E(a,5,!1,a.toLowerCase(),null)});var vc=/[\-:]([a-z])/g;function wc(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(vc,
wc);F[b]=new E(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(vc,wc);F[b]=new E(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(vc,wc);F[b]=new E(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});F.tabIndex=new E("tabIndex",1,!1,"tabindex",null);
function xc(a,b,c,d){var e=F.hasOwnProperty(b)?F[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(uc(b,c,e,d)&&(c=null),d||null===e?sc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function yc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function zc(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Ac(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=yc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bc(a,b){b=b.checked;null!=b&&xc(a,"checked",b,!1)}
function Cc(a,b){Bc(a,b);var c=yc(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Dc(a,b.type,c):b.hasOwnProperty("defaultValue")&&Dc(a,b.type,yc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Ec(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Dc(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}var Fc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Gc(a,b,c){a=z.getPooled(Fc.change,a,b,c);a.type="change";Ib(c);Ra(a);return a}var Jc=null,Kc=null;function Lc(a){Ea(a)}
function Mc(a){var b=Ka(a);if(Wb(b))return a}function Nc(a,b){if("change"===a)return b}var Oc=!1;Sa&&(Oc=Sb("input")&&(!document.documentMode||9<document.documentMode));function Pc(){Jc&&(Jc.detachEvent("onpropertychange",Qc),Kc=Jc=null)}function Qc(a){"value"===a.propertyName&&Mc(Kc)&&(a=Gc(Kc,a,Rb(a)),Ob(Lc,a))}function Rc(a,b,c){"focus"===a?(Pc(),Jc=b,Kc=c,Jc.attachEvent("onpropertychange",Qc)):"blur"===a&&Pc()}function Sc(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Mc(Kc)}
function Tc(a,b){if("click"===a)return Mc(b)}function Uc(a,b){if("input"===a||"change"===a)return Mc(b)}
var Vc={eventTypes:Fc,_isInputEventSupported:Oc,extractEvents:function(a,b,c,d){var e=b?Ka(b):window,f=void 0,g=void 0,h=e.nodeName&&e.nodeName.toLowerCase();"select"===h||"input"===h&&"file"===e.type?f=Nc:Qb(e)?Oc?f=Uc:(f=Sc,g=Rc):(h=e.nodeName)&&"input"===h.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=Tc);if(f&&(f=f(a,b)))return Gc(f,c,d);g&&g(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Dc(e,"number",e.value)}},Wc=z.extend({view:null,detail:null}),Xc={Alt:"altKey",
Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Yc(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Xc[a])?!!b[a]:!1}function Zc(){return Yc}
var $c=0,ad=0,bd=!1,cd=!1,dd=Wc.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Zc,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=$c;$c=a.screenX;return bd?"mousemove"===a.type?a.screenX-b:0:(bd=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=ad;ad=a.screenY;return cd?"mousemove"===a.type?a.screenY-b:0:(cd=!0,0)}}),ed=dd.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),fd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},gd={eventTypes:fd,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Ia(b):null):f=null;if(f===b)return null;var g=void 0,h=void 0,k=void 0,l=void 0;if("mouseout"===a||"mouseover"===a)g=dd,h=fd.mouseLeave,k=fd.mouseEnter,l="mouse";
else if("pointerout"===a||"pointerover"===a)g=ed,h=fd.pointerLeave,k=fd.pointerEnter,l="pointer";var m=null==f?e:Ka(f);e=null==b?e:Ka(b);a=g.getPooled(h,f,c,d);a.type=l+"leave";a.target=m;a.relatedTarget=e;c=g.getPooled(k,b,c,d);c.type=l+"enter";c.target=e;c.relatedTarget=m;d=b;if(f&&d)a:{b=f;e=d;l=0;for(g=b;g;g=Ma(g))l++;g=0;for(k=e;k;k=Ma(k))g++;for(;0<l-g;)b=Ma(b),l--;for(;0<g-l;)e=Ma(e),g--;for(;l--;){if(b===e||b===e.alternate)break a;b=Ma(b);e=Ma(e)}b=null}else b=null;e=b;for(b=[];f&&f!==e;){l=
f.alternate;if(null!==l&&l===e)break;b.push(f);f=Ma(f)}for(f=[];d&&d!==e;){l=d.alternate;if(null!==l&&l===e)break;f.push(d);d=Ma(d)}for(d=0;d<b.length;d++)Pa(b[d],"bubbled",a);for(d=f.length;0<d--;)Pa(f[d],"captured",c);return[a,c]}},hd=Object.prototype.hasOwnProperty;function id(a,b){return a===b?0!==a||0!==b||1/a===1/b:a!==a&&b!==b}
function jd(a,b){if(id(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!hd.call(b,c[d])||!id(a[c[d]],b[c[d]]))return!1;return!0}function kd(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function ld(a){2!==kd(a)?t("188"):void 0}
function md(a){var b=a.alternate;if(!b)return b=kd(a),3===b?t("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c.return,f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return ld(e),a;if(g===d)return ld(e),b;g=g.sibling}t("188")}if(c.return!==d.return)c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:t("189")}}c.alternate!==d?t("190"):void 0}3!==c.tag?t("188"):void 0;return c.stateNode.current===c?a:b}function nd(a){a=md(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
var od=z.extend({animationName:null,elapsedTime:null,pseudoElement:null}),pd=z.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),qd=Wc.extend({relatedTarget:null});function rd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var sd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},td={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},ud=Wc.extend({key:function(a){if(a.key){var b=sd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=rd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?td[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Zc,charCode:function(a){return"keypress"===
a.type?rd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?rd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),vd=dd.extend({dataTransfer:null}),wd=Wc.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Zc}),xd=z.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),yd=dd.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),zd=[["abort","abort"],[Ya,"animationEnd"],[Za,"animationIteration"],[$a,"animationStart"],["canplay","canPlay"],["canplaythrough","canPlayThrough"],["drag","drag"],["dragenter","dragEnter"],["dragexit","dragExit"],["dragleave","dragLeave"],["dragover","dragOver"],["durationchange","durationChange"],["emptied","emptied"],["encrypted","encrypted"],
["ended","ended"],["error","error"],["gotpointercapture","gotPointerCapture"],["load","load"],["loadeddata","loadedData"],["loadedmetadata","loadedMetadata"],["loadstart","loadStart"],["lostpointercapture","lostPointerCapture"],["mousemove","mouseMove"],["mouseout","mouseOut"],["mouseover","mouseOver"],["playing","playing"],["pointermove","pointerMove"],["pointerout","pointerOut"],["pointerover","pointerOver"],["progress","progress"],["scroll","scroll"],["seeking","seeking"],["stalled","stalled"],
["suspend","suspend"],["timeupdate","timeUpdate"],["toggle","toggle"],["touchmove","touchMove"],[ab,"transitionEnd"],["waiting","waiting"],["wheel","wheel"]],Ad={},Bd={};function Cd(a,b){var c=a[0];a=a[1];var d="on"+(a[0].toUpperCase()+a.slice(1));b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};Ad[a]=b;Bd[c]=b}
[["blur","blur"],["cancel","cancel"],["click","click"],["close","close"],["contextmenu","contextMenu"],["copy","copy"],["cut","cut"],["auxclick","auxClick"],["dblclick","doubleClick"],["dragend","dragEnd"],["dragstart","dragStart"],["drop","drop"],["focus","focus"],["input","input"],["invalid","invalid"],["keydown","keyDown"],["keypress","keyPress"],["keyup","keyUp"],["mousedown","mouseDown"],["mouseup","mouseUp"],["paste","paste"],["pause","pause"],["play","play"],["pointercancel","pointerCancel"],
["pointerdown","pointerDown"],["pointerup","pointerUp"],["ratechange","rateChange"],["reset","reset"],["seeked","seeked"],["submit","submit"],["touchcancel","touchCancel"],["touchend","touchEnd"],["touchstart","touchStart"],["volumechange","volumeChange"]].forEach(function(a){Cd(a,!0)});zd.forEach(function(a){Cd(a,!1)});
var Dd={eventTypes:Ad,isInteractiveTopLevelEventType:function(a){a=Bd[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=Bd[a];if(!e)return null;switch(a){case "keypress":if(0===rd(c))return null;case "keydown":case "keyup":a=ud;break;case "blur":case "focus":a=qd;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=dd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
vd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=wd;break;case Ya:case Za:case $a:a=od;break;case ab:a=xd;break;case "scroll":a=Wc;break;case "wheel":a=yd;break;case "copy":case "cut":case "paste":a=pd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=ed;break;default:a=z}b=a.getPooled(e,b,c,d);Ra(b);return b}},Ed=Dd.isInteractiveTopLevelEventType,
Fd=[];function Gd(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d;for(d=c;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo;if(!d)break;a.ancestors.push(c);c=Ia(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=Rb(a.nativeEvent);d=a.topLevelType;for(var f=a.nativeEvent,g=null,h=0;h<pa.length;h++){var k=pa[h];k&&(k=k.extractEvents(d,b,f,e))&&(g=ya(g,k))}Ea(g)}}var Hd=!0;
function H(a,b){if(!b)return null;var c=(Ed(a)?Id:Jd).bind(null,a);b.addEventListener(a,c,!1)}function Kd(a,b){if(!b)return null;var c=(Ed(a)?Id:Jd).bind(null,a);b.addEventListener(a,c,!0)}function Id(a,b){Lb(Jd,a,b)}
function Jd(a,b){if(Hd){var c=Rb(b);c=Ia(c);null===c||"number"!==typeof c.tag||2===kd(c)||(c=null);if(Fd.length){var d=Fd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{Ob(Gd,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>Fd.length&&Fd.push(a)}}}var Ld={},Md=0,Nd="_reactListenersID"+(""+Math.random()).slice(2);
function Od(a){Object.prototype.hasOwnProperty.call(a,Nd)||(a[Nd]=Md++,Ld[a[Nd]]={});return Ld[a[Nd]]}function Pd(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function Qd(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Rd(a,b){var c=Qd(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Qd(c)}}function Sd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?Sd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}
function Td(){for(var a=window,b=Pd();b instanceof a.HTMLIFrameElement;){try{a=b.contentDocument.defaultView}catch(c){break}b=Pd(a.document)}return b}function Ud(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
var Vd=Sa&&"documentMode"in document&&11>=document.documentMode,Wd={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},Xd=null,Yd=null,Zd=null,$d=!1;
function ae(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if($d||null==Xd||Xd!==Pd(c))return null;c=Xd;"selectionStart"in c&&Ud(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return Zd&&jd(Zd,c)?null:(Zd=c,a=z.getPooled(Wd.select,Yd,a,b),a.type="select",a.target=Xd,Ra(a),a)}
var be={eventTypes:Wd,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Od(e);f=ta.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Ka(b):window;switch(a){case "focus":if(Qb(e)||"true"===e.contentEditable)Xd=e,Yd=b,Zd=null;break;case "blur":Zd=Yd=Xd=null;break;case "mousedown":$d=!0;break;case "contextmenu":case "mouseup":case "dragend":return $d=!1,ae(c,d);case "selectionchange":if(Vd)break;
case "keydown":case "keyup":return ae(c,d)}return null}};Ca.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ua=La;va=Ja;wa=Ka;Ca.injectEventPluginsByName({SimpleEventPlugin:Dd,EnterLeaveEventPlugin:gd,ChangeEventPlugin:Vc,SelectEventPlugin:be,BeforeInputEventPlugin:Bb});function de(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}
function ee(a,b){a=n({children:void 0},b);if(b=de(b.children))a.children=b;return a}function fe(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+yc(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function ge(a,b){null!=b.dangerouslySetInnerHTML?t("91"):void 0;return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function he(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?t("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:t("93"),b=b[0]),c=b),null==c&&(c=""));a._wrapperState={initialValue:yc(c)}}
function ie(a,b){var c=yc(b.value),d=yc(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function je(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var ke={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function le(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function me(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?le(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var ne=void 0,oe=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==ke.svg||"innerHTML"in a)a.innerHTML=b;else{ne=ne||document.createElement("div");ne.innerHTML="<svg>"+b+"</svg>";for(b=ne.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function pe(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var qe={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},re=["Webkit","ms","Moz","O"];Object.keys(qe).forEach(function(a){re.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);qe[b]=qe[a]})});function se(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||qe.hasOwnProperty(a)&&qe[a]?(""+b).trim():b+"px"}
function te(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=se(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var ue=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function ve(a,b){b&&(ue[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?t("137",a,""):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?t("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:t("61")),null!=b.style&&"object"!==typeof b.style?t("62",""):void 0)}
function we(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}
function xe(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Od(a);b=ta[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.hasOwnProperty(e)||!c[e]){switch(e){case "scroll":Kd("scroll",a);break;case "focus":case "blur":Kd("focus",a);Kd("blur",a);c.blur=!0;c.focus=!0;break;case "cancel":case "close":Sb(e)&&Kd(e,a);break;case "invalid":case "submit":case "reset":break;default:-1===bb.indexOf(e)&&H(e,a)}c[e]=!0}}}function ye(){}var ze=null,Ae=null;
function Be(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}function Ce(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var De="function"===typeof setTimeout?setTimeout:void 0,Ee="function"===typeof clearTimeout?clearTimeout:void 0;
function Fe(a,b,c,d,e){a[Ha]=e;"input"===c&&"radio"===e.type&&null!=e.name&&Bc(a,e);we(c,d);d=we(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?te(a,h):"dangerouslySetInnerHTML"===g?oe(a,h):"children"===g?pe(a,h):xc(a,g,h,d)}switch(c){case "input":Cc(a,e);break;case "textarea":ie(a,e);break;case "select":b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?fe(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?fe(a,!!e.multiple,e.defaultValue,
!0):fe(a,!!e.multiple,e.multiple?[]:"",!1))}}function Ge(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}function He(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}new Set;var Ie=[],Je=-1;function I(a){0>Je||(a.current=Ie[Je],Ie[Je]=null,Je--)}function J(a,b){Je++;Ie[Je]=a.current;a.current=b}var Ke={},K={current:Ke},L={current:!1},Le=Ke;
function Me(a,b){var c=a.type.contextTypes;if(!c)return Ke;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function M(a){a=a.childContextTypes;return null!==a&&void 0!==a}function Ne(a){I(L,a);I(K,a)}function Oe(a){I(L,a);I(K,a)}
function Pe(a,b,c){K.current!==Ke?t("168"):void 0;J(K,b,a);J(L,c,a)}function Qe(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)e in a?void 0:t("108",mc(b)||"Unknown",e);return n({},c,d)}function Re(a){var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||Ke;Le=K.current;J(K,b,a);J(L,L.current,a);return!0}
function Se(a,b,c){var d=a.stateNode;d?void 0:t("169");c?(b=Qe(a,b,Le),d.__reactInternalMemoizedMergedChildContext=b,I(L,a),I(K,a),J(K,b,a)):I(L,a);J(L,c,a)}var Te=null,Ue=null;function Ve(a){return function(b){try{return a(b)}catch(c){}}}
function We(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Te=Ve(function(a){return b.onCommitFiberRoot(c,a)});Ue=Ve(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}
function Xe(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.firstContextDependency=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function N(a,b,c,d){return new Xe(a,b,c,d)}
function Ye(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Ze(a){if("function"===typeof a)return Ye(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gc)return 11;if(a===ic)return 14}return 2}
function $e(a,b){var c=a.alternate;null===c?(c=N(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;c.firstContextDependency=a.firstContextDependency;c.sibling=a.sibling;
c.index=a.index;c.ref=a.ref;return c}
function af(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)Ye(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ac:return bf(c.children,e,f,b);case fc:return cf(c,e|3,f,b);case bc:return cf(c,e|2,f,b);case cc:return a=N(12,c,b,e|4),a.elementType=cc,a.type=cc,a.expirationTime=f,a;case hc:return a=N(13,c,b,e),a.elementType=hc,a.type=hc,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case dc:g=10;break a;case ec:g=9;break a;case gc:g=11;break a;case ic:g=
14;break a;case jc:g=16;d=null;break a}t("130",null==a?a:typeof a,"")}b=N(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function bf(a,b,c,d){a=N(7,a,d,b);a.expirationTime=c;return a}function cf(a,b,c,d){a=N(8,a,d,b);b=0===(b&1)?bc:fc;a.elementType=b;a.type=b;a.expirationTime=c;return a}function df(a,b,c){a=N(6,a,null,b);a.expirationTime=c;return a}
function ef(a,b,c){b=N(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}function ff(a,b){a.didError=!1;var c=a.earliestPendingTime;0===c?a.earliestPendingTime=a.latestPendingTime=b:c<b?a.earliestPendingTime=b:a.latestPendingTime>b&&(a.latestPendingTime=b);gf(b,a)}
function hf(a,b){a.didError=!1;a.latestPingedTime>=b&&(a.latestPingedTime=0);var c=a.earliestPendingTime,d=a.latestPendingTime;c===b?a.earliestPendingTime=d===b?a.latestPendingTime=0:d:d===b&&(a.latestPendingTime=c);c=a.earliestSuspendedTime;d=a.latestSuspendedTime;0===c?a.earliestSuspendedTime=a.latestSuspendedTime=b:c<b?a.earliestSuspendedTime=b:d>b&&(a.latestSuspendedTime=b);gf(b,a)}function jf(a,b){var c=a.earliestPendingTime;a=a.earliestSuspendedTime;c>b&&(b=c);a>b&&(b=a);return b}
function gf(a,b){var c=b.earliestSuspendedTime,d=b.latestSuspendedTime,e=b.earliestPendingTime,f=b.latestPingedTime;e=0!==e?e:f;0===e&&(0===a||d<a)&&(e=d);a=e;0!==a&&c>a&&(a=c);b.nextExpirationTimeToWorkOn=e;b.expirationTime=a}var kf=!1;function lf(a){return{baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function mf(a){return{baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function nf(a){return{expirationTime:a,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function of(a,b){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b)}
function pf(a,b){var c=a.alternate;if(null===c){var d=a.updateQueue;var e=null;null===d&&(d=a.updateQueue=lf(a.memoizedState))}else d=a.updateQueue,e=c.updateQueue,null===d?null===e?(d=a.updateQueue=lf(a.memoizedState),e=c.updateQueue=lf(c.memoizedState)):d=a.updateQueue=mf(e):null===e&&(e=c.updateQueue=mf(d));null===e||d===e?of(d,b):null===d.lastUpdate||null===e.lastUpdate?(of(d,b),of(e,b)):(of(d,b),e.lastUpdate=b)}
function qf(a,b){var c=a.updateQueue;c=null===c?a.updateQueue=lf(a.memoizedState):rf(a,c);null===c.lastCapturedUpdate?c.firstCapturedUpdate=c.lastCapturedUpdate=b:(c.lastCapturedUpdate.next=b,c.lastCapturedUpdate=b)}function rf(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=mf(b));return b}
function sf(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-2049|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return n({},d,e);case 2:kf=!0}return d}
function tf(a,b,c,d,e){kf=!1;b=rf(a,b);for(var f=b.baseState,g=null,h=0,k=b.firstUpdate,l=f;null!==k;){var m=k.expirationTime;m<e?(null===g&&(g=k,f=l),h<m&&(h=m)):(l=sf(a,b,k,l,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=k:(b.lastEffect.nextEffect=k,b.lastEffect=k)));k=k.next}m=null;for(k=b.firstCapturedUpdate;null!==k;){var r=k.expirationTime;r<e?(null===m&&(m=k,null===g&&(f=l)),h<r&&(h=r)):(l=sf(a,b,k,l,c,d),null!==k.callback&&(a.effectTag|=
32,k.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=k:(b.lastCapturedEffect.nextEffect=k,b.lastCapturedEffect=k)));k=k.next}null===g&&(b.lastUpdate=null);null===m?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===m&&(f=l);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=m;a.expirationTime=h;a.memoizedState=l}
function uf(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);vf(b.firstEffect,c);b.firstEffect=b.lastEffect=null;vf(b.firstCapturedEffect,c);b.firstCapturedEffect=b.lastCapturedEffect=null}function vf(a,b){for(;null!==a;){var c=a.callback;if(null!==c){a.callback=null;var d=b;"function"!==typeof c?t("191",c):void 0;c.call(d)}a=a.nextEffect}}
function wf(a,b){return{value:a,source:b,stack:nc(b)}}var xf={current:null},yf=null,zf=null,Af=null;function Bf(a,b){var c=a.type._context;J(xf,c._currentValue,a);c._currentValue=b}function Cf(a){var b=xf.current;I(xf,a);a.type._context._currentValue=b}function Df(a){yf=a;Af=zf=null;a.firstContextDependency=null}
function Ef(a,b){if(Af!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)Af=a,b=1073741823;b={context:a,observedBits:b,next:null};null===zf?(null===yf?t("293"):void 0,yf.firstContextDependency=zf=b):zf=zf.next=b}return a._currentValue}var Ff={},O={current:Ff},Gf={current:Ff},Hf={current:Ff};function If(a){a===Ff?t("174"):void 0;return a}
function Jf(a,b){J(Hf,b,a);J(Gf,a,a);J(O,Ff,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:me(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=me(b,c)}I(O,a);J(O,b,a)}function Kf(a){I(O,a);I(Gf,a);I(Hf,a)}function Lf(a){If(Hf.current);var b=If(O.current);var c=me(b,a.type);b!==c&&(J(Gf,a,a),J(O,c,a))}function Mf(a){Gf.current===a&&(I(O,a),I(Gf,a))}
function P(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}function Nf(a){var b=a._result;switch(a._status){case 1:return b;case 2:throw b;case 0:throw b;default:throw a._status=0,b=a._ctor,b=b(),b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)}),a._result=b,b;}}var Of=Xb.ReactCurrentOwner,Pf=(new aa.Component).refs;
function Qf(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;d=a.updateQueue;null!==d&&0===a.expirationTime&&(d.baseState=c)}
var Vf={isMounted:function(a){return(a=a._reactInternalFiber)?2===kd(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Rf();d=Sf(d,a);var e=nf(d);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Tf();pf(a,e);Uf(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Rf();d=Sf(d,a);var e=nf(d);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Tf();pf(a,e);Uf(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Rf();c=Sf(c,a);var d=nf(c);d.tag=
2;void 0!==b&&null!==b&&(d.callback=b);Tf();pf(a,d);Uf(a,c)}};function Wf(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!jd(c,d)||!jd(e,f):!0}
function Xf(a,b,c){var d=!1,e=Ke;var f=b.contextType;"object"===typeof f&&null!==f?f=Of.currentDispatcher.readContext(f):(e=M(b)?Le:K.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Me(a,e):Ke);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Vf;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Zf(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Vf.enqueueReplaceState(b,b.state,null)}
function $f(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Pf;var f=b.contextType;"object"===typeof f&&null!==f?e.context=Of.currentDispatcher.readContext(f):(f=M(b)?Le:K.current,e.context=Me(a,f));f=a.updateQueue;null!==f&&(tf(a,f,c,e,d),e.state=a.memoizedState);f=b.getDerivedStateFromProps;"function"===typeof f&&(Qf(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&
"function"!==typeof e.componentWillMount||(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Vf.enqueueReplaceState(e,e.state,null),f=a.updateQueue,null!==f&&(tf(a,f,c,e,d),e.state=a.memoizedState));"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var ag=Array.isArray;
function bg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(1!==c.tag?t("289"):void 0,d=c.stateNode);d?void 0:t("147",a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Pf&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?t("284"):void 0;c._owner?void 0:t("290",a)}return a}
function cg(a,b){"textarea"!==a.type&&t("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function dg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=$e(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=df(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props,d),d.ref=bg(a,b,c),d.return=a,d;d=af(c.type,c.key,c.props,null,a.mode,d);d.ref=bg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=ef(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function m(a,b,c,d,g){if(null===b||7!==b.tag)return b=bf(c,a.mode,d,g),b.return=a,b;b=e(b,c,d);b.return=a;return b}function r(a,b,c){if("string"===typeof b||"number"===typeof b)return b=df(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Zb:return c=af(b.type,b.key,b.props,null,a.mode,c),c.ref=bg(a,null,b),c.return=a,c;case $b:return b=ef(b,a.mode,c),b.return=a,b}if(ag(b)||
lc(b))return b=bf(b,a.mode,c,null),b.return=a,b;cg(a,b)}return null}function w(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Zb:return c.key===e?c.type===ac?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $b:return c.key===e?l(a,b,c,d):null}if(ag(c)||lc(c))return null!==e?null:m(a,b,c,d,null);cg(a,c)}return null}function y(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Zb:return a=a.get(null===d.key?c:d.key)||null,d.type===ac?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $b:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(ag(d)||lc(d))return a=a.get(c)||null,m(b,a,d,e,null);cg(b,d)}return null}function B(e,g,h,k){for(var l=null,q=null,m=g,u=g=0,p=null;null!==m&&u<h.length;u++){m.index>u?(p=m,m=null):p=m.sibling;var v=w(e,m,h[u],k);if(null===v){null===m&&(m=p);break}a&&
m&&null===v.alternate&&b(e,m);g=f(v,g,u);null===q?l=v:q.sibling=v;q=v;m=p}if(u===h.length)return c(e,m),l;if(null===m){for(;u<h.length;u++)if(m=r(e,h[u],k))g=f(m,g,u),null===q?l=m:q.sibling=m,q=m;return l}for(m=d(e,m);u<h.length;u++)if(p=y(m,e,u,h[u],k))a&&null!==p.alternate&&m.delete(null===p.key?u:p.key),g=f(p,g,u),null===q?l=p:q.sibling=p,q=p;a&&m.forEach(function(a){return b(e,a)});return l}function R(e,g,h,k){var l=lc(h);"function"!==typeof l?t("150"):void 0;h=l.call(h);null==h?t("151"):void 0;
for(var m=l=null,q=g,u=g=0,p=null,v=h.next();null!==q&&!v.done;u++,v=h.next()){q.index>u?(p=q,q=null):p=q.sibling;var A=w(e,q,v.value,k);if(null===A){q||(q=p);break}a&&q&&null===A.alternate&&b(e,q);g=f(A,g,u);null===m?l=A:m.sibling=A;m=A;q=p}if(v.done)return c(e,q),l;if(null===q){for(;!v.done;u++,v=h.next())v=r(e,v.value,k),null!==v&&(g=f(v,g,u),null===m?l=v:m.sibling=v,m=v);return l}for(q=d(e,q);!v.done;u++,v=h.next())v=y(q,e,u,v.value,k),null!==v&&(a&&null!==v.alternate&&q.delete(null===v.key?u:
v.key),g=f(v,g,u),null===m?l=v:m.sibling=v,m=v);a&&q.forEach(function(a){return b(e,a)});return l}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ac&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Zb:a:{l=f.key;for(k=d;null!==k;){if(k.key===l)if(7===k.tag?f.type===ac:k.elementType===f.type){c(a,k.sibling);d=e(k,f.type===ac?f.props.children:f.props,h);d.ref=bg(a,k,f);d.return=a;a=d;break a}else{c(a,k);break}else b(a,k);k=
k.sibling}f.type===ac?(d=bf(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=af(f.type,f.key,f.props,null,a.mode,h),h.ref=bg(a,d,f),h.return=a,a=h)}return g(a);case $b:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=ef(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=
""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=a,a=d):(c(a,d),d=df(f,a.mode,h),d.return=a,a=d),g(a);if(ag(f))return B(a,d,f,h);if(lc(f))return R(a,d,f,h);l&&cg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:h=a.type,t("152",h.displayName||h.name||"Component")}return c(a,d)}}var eg=dg(!0),fg=dg(!1),gg=null,hg=null,ig=!1;
function jg(a,b){var c=N(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function kg(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;default:return!1}}
function lg(a){if(ig){var b=hg;if(b){var c=b;if(!kg(a,b)){b=Ge(c);if(!b||!kg(a,b)){a.effectTag|=2;ig=!1;gg=a;return}jg(gg,c)}gg=a;hg=He(b)}else a.effectTag|=2,ig=!1,gg=a}}function mg(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag;)a=a.return;gg=a}function ng(a){if(a!==gg)return!1;if(!ig)return mg(a),ig=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Ce(b,a.memoizedProps))for(b=hg;b;)jg(a,b),b=Ge(b);mg(a);hg=gg?Ge(a.stateNode):null;return!0}function og(){hg=gg=null;ig=!1}var pg=Xb.ReactCurrentOwner;
function Q(a,b,c,d){b.child=null===a?fg(b,null,c,d):eg(b,a.child,c,d)}function qg(a,b,c,d,e){c=c.render;var f=b.ref;Df(b,e);d=c(d,f);b.effectTag|=1;Q(a,b,d,e);return b.child}
function rg(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!Ye(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,sg(a,b,g,d,e,f);a=af(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:jd,c(e,d)&&a.ref===b.ref))return tg(a,b,f);b.effectTag|=1;a=$e(g,d,f);a.ref=b.ref;a.return=b;return b.child=a}
function sg(a,b,c,d,e,f){return null!==a&&e<f&&jd(a.memoizedProps,d)&&a.ref===b.ref?tg(a,b,f):ug(a,b,c,d,f)}function vg(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function ug(a,b,c,d,e){var f=M(c)?Le:K.current;f=Me(b,f);Df(b,e);c=c(d,f);b.effectTag|=1;Q(a,b,c,e);return b.child}
function wg(a,b,c,d,e){if(M(c)){var f=!0;Re(b)}else f=!1;Df(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Xf(b,c,d,e),$f(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=Of.currentDispatcher.readContext(l):(l=M(c)?Le:K.current,l=Me(b,l));var m=c.getDerivedStateFromProps,r="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;r||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Zf(b,g,d,l);kf=!1;var w=b.memoizedState;k=g.state=w;var y=b.updateQueue;null!==y&&(tf(b,y,d,g,e),k=b.memoizedState);h!==d||w!==k||L.current||kf?("function"===typeof m&&(Qf(b,c,m,d),k=b.memoizedState),(h=kf||Wf(b,c,h,d,w,k,l))?(r||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&
g.UNSAFE_componentWillMount()),"function"===typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,h=b.memoizedProps,g.props=b.type===b.elementType?h:P(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=Of.currentDispatcher.readContext(l):(l=M(c)?Le:K.current,l=Me(b,l)),m=c.getDerivedStateFromProps,
(r="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Zf(b,g,d,l),kf=!1,k=b.memoizedState,w=g.state=k,y=b.updateQueue,null!==y&&(tf(b,y,d,g,e),w=b.memoizedState),h!==d||k!==w||L.current||kf?("function"===typeof m&&(Qf(b,c,m,d),w=b.memoizedState),(m=kf||Wf(b,c,h,d,k,w,l))?(r||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||
("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,w,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,w,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=
d,b.memoizedState=w),g.props=d,g.state=w,g.context=l,d=m):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return xg(a,b,c,d,f,e)}
function xg(a,b,c,d,e,f){vg(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Se(b,c,!1),tg(a,b,f);d=b.stateNode;pg.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=eg(b,a.child,null,f),b.child=eg(b,null,h,f)):Q(a,b,h,f);b.memoizedState=d.state;e&&Se(b,c,!0);return b.child}function yg(a){var b=a.stateNode;b.pendingContext?Pe(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Pe(a,b.context,!1);Jf(a,b.containerInfo)}
function zg(a,b,c){var d=b.mode,e=b.pendingProps,f=b.memoizedState;if(0===(b.effectTag&64)){f=null;var g=!1}else f={timedOutAt:null!==f?f.timedOutAt:0},g=!0,b.effectTag&=-65;if(null===a)if(g){var h=e.fallback;a=bf(null,d,0,null);0===(b.mode&1)&&(a.child=null!==b.memoizedState?b.child.child:b.child);d=bf(h,d,c,null);a.sibling=d;c=a;c.return=d.return=b}else c=d=fg(b,null,e.children,c);else null!==a.memoizedState?(d=a.child,h=d.sibling,g?(c=e.fallback,e=$e(d,d.pendingProps,0),0===(b.mode&1)&&(g=null!==
b.memoizedState?b.child.child:b.child,g!==d.child&&(e.child=g)),d=e.sibling=$e(h,c,h.expirationTime),c=e,e.childExpirationTime=0,c.return=d.return=b):c=d=eg(b,d.child,e.children,c)):(h=a.child,g?(g=e.fallback,e=bf(null,d,0,null),e.child=h,0===(b.mode&1)&&(e.child=null!==b.memoizedState?b.child.child:b.child),d=e.sibling=bf(g,d,c,null),d.effectTag|=2,c=e,e.childExpirationTime=0,c.return=d.return=b):d=c=eg(b,h,e.children,c)),b.stateNode=a.stateNode;b.memoizedState=f;b.child=c;return d}
function tg(a,b,c){null!==a&&(b.firstContextDependency=a.firstContextDependency);if(b.childExpirationTime<c)return null;null!==a&&b.child!==a.child?t("153"):void 0;if(null!==b.child){a=b.child;c=$e(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=$e(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}
function Ag(a,b,c){var d=b.expirationTime;if(null!==a&&a.memoizedProps===b.pendingProps&&!L.current&&d<c){switch(b.tag){case 3:yg(b);og();break;case 5:Lf(b);break;case 1:M(b.type)&&Re(b);break;case 4:Jf(b,b.stateNode.containerInfo);break;case 10:Bf(b,b.memoizedProps.value);break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;if(0!==d&&d>=c)return zg(a,b,c);b=tg(a,b,c);return null!==b?b.sibling:null}}return tg(a,b,c)}b.expirationTime=0;switch(b.tag){case 2:d=b.elementType;null!==
a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;var e=Me(b,K.current);Df(b,c);e=d(a,e);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;if(M(d)){var f=!0;Re(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;var g=d.getDerivedStateFromProps;"function"===typeof g&&Qf(b,d,g,a);e.updater=Vf;b.stateNode=e;e._reactInternalFiber=b;$f(b,d,a,c);b=xg(null,b,d,!0,f,c)}else b.tag=0,Q(null,b,e,c),b=b.child;
return b;case 16:e=b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);f=b.pendingProps;a=Nf(e);b.type=a;e=b.tag=Ze(a);f=P(a,f);g=void 0;switch(e){case 0:g=ug(null,b,a,f,c);break;case 1:g=wg(null,b,a,f,c);break;case 11:g=qg(null,b,a,f,c);break;case 14:g=rg(null,b,a,P(a.type,f),d,c);break;default:t("306",a,"")}return g;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:P(d,e),ug(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:P(d,e),wg(a,b,
d,e,c);case 3:yg(b);d=b.updateQueue;null===d?t("282"):void 0;e=b.memoizedState;e=null!==e?e.element:null;tf(b,d,b.pendingProps,null,c);d=b.memoizedState.element;if(d===e)og(),b=tg(a,b,c);else{e=b.stateNode;if(e=(null===a||null===a.child)&&e.hydrate)hg=He(b.stateNode.containerInfo),gg=b,e=ig=!0;e?(b.effectTag|=2,b.child=fg(b,null,d,c)):(Q(a,b,d,c),og());b=b.child}return b;case 5:return Lf(b),null===a&&lg(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,g=e.children,Ce(d,e)?g=null:null!==
f&&Ce(d,f)&&(b.effectTag|=16),vg(a,b),1!==c&&b.mode&1&&e.hidden?(b.expirationTime=1,b=null):(Q(a,b,g,c),b=b.child),b;case 6:return null===a&&lg(b),null;case 13:return zg(a,b,c);case 4:return Jf(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=eg(b,null,d,c):Q(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:P(d,e),qg(a,b,d,e,c);case 7:return Q(a,b,b.pendingProps,c),b.child;case 8:return Q(a,b,b.pendingProps.children,c),b.child;case 12:return Q(a,b,b.pendingProps.children,
c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;Bf(b,f);if(null!==g){var h=g.value;f=h===f&&(0!==h||1/h===1/f)||h!==h&&f!==f?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0;if(0===f){if(g.children===e.children&&!L.current){b=tg(a,b,c);break a}}else for(g=b.child,null!==g&&(g.return=b);null!==g;){h=g.firstContextDependency;if(null!==h){do{if(h.context===d&&0!==(h.observedBits&f)){if(1===g.tag){var k=nf(c);k.tag=2;pf(g,k)}g.expirationTime<
c&&(g.expirationTime=c);k=g.alternate;null!==k&&k.expirationTime<c&&(k.expirationTime=c);for(var l=g.return;null!==l;){k=l.alternate;if(l.childExpirationTime<c)l.childExpirationTime=c,null!==k&&k.childExpirationTime<c&&(k.childExpirationTime=c);else if(null!==k&&k.childExpirationTime<c)k.childExpirationTime=c;else break;l=l.return}}k=g.child;h=h.next}while(null!==h)}else k=10===g.tag?g.type===b.type?null:g.child:g.child;if(null!==k)k.return=g;else for(k=g;null!==k;){if(k===b){k=null;break}g=k.sibling;
if(null!==g){g.return=k.return;k=g;break}k=k.return}g=k}}Q(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,Df(b,c),e=Ef(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,Q(a,b,d,c),b.child;case 14:return e=b.type,f=P(e,b.pendingProps),f=P(e.type,f),rg(a,b,e,f,d,c);case 15:return sg(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:P(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,M(d)?(a=
!0,Re(b)):a=!1,Df(b,c),Xf(b,d,e,c),$f(b,d,e,c),xg(null,b,d,!0,a,c);default:t("156")}}function Bg(a){a.effectTag|=4}var Cg=void 0,Gg=void 0,Hg=void 0,Ig=void 0;Cg=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};Gg=function(){};
Hg=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;If(O.current);a=null;switch(c){case "input":f=zc(g,f);d=zc(g,d);a=[];break;case "option":f=ee(g,f);d=ee(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=ge(g,f);d=ge(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=ye)}ve(c,d);g=c=void 0;var h=null;for(c in f)if(!d.hasOwnProperty(c)&&f.hasOwnProperty(c)&&null!=f[c])if("style"===
c){var k=f[c];for(g in k)k.hasOwnProperty(g)&&(h||(h={}),h[g]="")}else"dangerouslySetInnerHTML"!==c&&"children"!==c&&"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&"autoFocus"!==c&&(sa.hasOwnProperty(c)?a||(a=[]):(a=a||[]).push(c,null));for(c in d){var l=d[c];k=null!=f?f[c]:void 0;if(d.hasOwnProperty(c)&&l!==k&&(null!=l||null!=k))if("style"===c)if(k){for(g in k)!k.hasOwnProperty(g)||l&&l.hasOwnProperty(g)||(h||(h={}),h[g]="");for(g in l)l.hasOwnProperty(g)&&k[g]!==l[g]&&(h||
(h={}),h[g]=l[g])}else h||(a||(a=[]),a.push(c,h)),h=l;else"dangerouslySetInnerHTML"===c?(l=l?l.__html:void 0,k=k?k.__html:void 0,null!=l&&k!==l&&(a=a||[]).push(c,""+l)):"children"===c?k===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(c,""+l):"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&(sa.hasOwnProperty(c)?(null!=l&&xe(e,c),a||k===l||(a=[])):(a=a||[]).push(c,l))}h&&(a=a||[]).push("style",h);e=a;(b.updateQueue=e)&&Bg(b)}};Ig=function(a,b,c,d){c!==d&&Bg(b)};
var Jg="function"===typeof WeakSet?WeakSet:Set;function Kg(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=nc(c));null!==c&&mc(c.type);b=b.value;null!==a&&1===a.tag&&mc(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Lg(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Mg(a,c)}else b.current=null}
function Ng(a,b){for(var c=a;;){if(5===c.tag){var d=c.stateNode;if(b)d.style.display="none";else{d=c.stateNode;var e=c.memoizedProps.style;e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null;d.style.display=se("display",e)}}else if(6===c.tag)c.stateNode.nodeValue=b?"":c.memoizedProps;else if(13===c.tag&&null!==c.memoizedState){d=c.child.sibling;d.return=c;c=d;continue}else if(null!==c.child){c.child.return=c;c=c.child;continue}if(c===a)break;for(;null===c.sibling;){if(null===c.return||
c.return===a)return;c=c.return}c.sibling.return=c.return;c=c.sibling}}
function Og(a){"function"===typeof Ue&&Ue(a);switch(a.tag){case 0:case 11:case 14:case 15:var b=a.updateQueue;if(null!==b&&(b=b.lastEffect,null!==b)){var c=b=b.next;do{var d=c.destroy;if(null!==d){var e=a;try{d()}catch(f){Mg(e,f)}}c=c.next}while(c!==b)}break;case 1:Lg(a);b=a.stateNode;if("function"===typeof b.componentWillUnmount)try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(f){Mg(a,f)}break;case 5:Lg(a);break;case 4:Pg(a)}}
function Qg(a){return 5===a.tag||3===a.tag||4===a.tag}
function Rg(a){a:{for(var b=a.return;null!==b;){if(Qg(b)){var c=b;break a}b=b.return}t("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:t("161")}c.effectTag&16&&(pe(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Qg(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)if(c)if(d){var f=b,g=e.stateNode,h=c;8===f.nodeType?f.parentNode.insertBefore(g,h):f.insertBefore(g,h)}else b.insertBefore(e.stateNode,c);else d?(g=b,h=e.stateNode,8===g.nodeType?(f=g.parentNode,f.insertBefore(h,g)):(f=g,f.appendChild(h)),g=g._reactRootContainer,null!==g&&void 0!==g||null!==f.onclick||(f.onclick=ye)):b.appendChild(e.stateNode);
else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function Pg(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b.return;a:for(;;){null===c?t("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c.return}c=!0}if(5===b.tag||6===b.tag){a:for(var f=b,g=f;;)if(Og(g),null!==g.child&&4!==g.tag)g.child.return=g,g=g.child;else{if(g===f)break;for(;null===g.sibling;){if(null===g.return||g.return===f)break a;g=g.return}g.sibling.return=g.return;g=g.sibling}e?
(f=d,g=b.stateNode,8===f.nodeType?f.parentNode.removeChild(g):f.removeChild(g)):d.removeChild(b.stateNode)}else if(4===b.tag?(d=b.stateNode.containerInfo,e=!0):Og(b),null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return;b=b.return;4===b.tag&&(c=!1)}b.sibling.return=b.return;b=b.sibling}}
function Sg(a,b){switch(b.tag){case 0:case 11:case 14:case 15:break;case 1:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&Fe(c,f,e,a,d,b)}break;case 6:null===b.stateNode?t("162"):void 0;b.stateNode.nodeValue=b.memoizedProps;break;case 3:break;case 12:break;case 13:c=b.memoizedState;d=void 0;a=b;null===c?d=!1:(d=!0,a=b.child,0===c.timedOutAt&&(c.timedOutAt=Rf()));null!==a&&Ng(a,d);c=b.updateQueue;
if(null!==c){b.updateQueue=null;var g=b.stateNode;null===g&&(g=b.stateNode=new Jg);c.forEach(function(a){var c=Tg.bind(null,b,a);g.has(a)||(g.add(a),a.then(c,c))})}break;case 17:break;default:t("163")}}var Ug="function"===typeof WeakMap?WeakMap:Map;function Vg(a,b,c){c=nf(c);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Wg(d);Kg(a,b)};return c}
function Xg(a,b,c){c=nf(c);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===Yg?Yg=new Set([this]):Yg.add(this));var c=b.value,e=b.stack;Kg(a,b);this.componentDidCatch(c,{componentStack:null!==e?e:""})});return c}
function Zg(a){switch(a.tag){case 1:M(a.type)&&Ne(a);var b=a.effectTag;return b&2048?(a.effectTag=b&-2049|64,a):null;case 3:return Kf(a),Oe(a),b=a.effectTag,0!==(b&64)?t("285"):void 0,a.effectTag=b&-2049|64,a;case 5:return Mf(a),null;case 13:return b=a.effectTag,b&2048?(a.effectTag=b&-2049|64,a):null;case 4:return Kf(a),null;case 10:return Cf(a),null;default:return null}}
var $g={readContext:Ef},ah=Xb.ReactCurrentOwner,bh=1073741822,ch=0,dh=!1,S=null,T=null,U=0,eh=-1,fh=!1,V=null,gh=!1,hh=null,ih=null,Yg=null;function jh(){if(null!==S)for(var a=S.return;null!==a;){var b=a;switch(b.tag){case 1:var c=b.type.childContextTypes;null!==c&&void 0!==c&&Ne(b);break;case 3:Kf(b);Oe(b);break;case 5:Mf(b);break;case 4:Kf(b);break;case 10:Cf(b)}a=a.return}T=null;U=0;eh=-1;fh=!1;S=null}function Tf(){null!==ih&&(ba.unstable_cancelCallback(hh),ih())}
function kh(a){for(;;){var b=a.alternate,c=a.return,d=a.sibling;if(0===(a.effectTag&1024)){S=a;a:{var e=b;b=a;var f=U;var g=b.pendingProps;switch(b.tag){case 2:break;case 16:break;case 15:case 0:break;case 1:M(b.type)&&Ne(b);break;case 3:Kf(b);Oe(b);g=b.stateNode;g.pendingContext&&(g.context=g.pendingContext,g.pendingContext=null);if(null===e||null===e.child)ng(b),b.effectTag&=-3;Gg(b);break;case 5:Mf(b);var h=If(Hf.current);f=b.type;if(null!==e&&null!=b.stateNode)Hg(e,b,f,g,h),e.ref!==b.ref&&(b.effectTag|=
128);else if(g){var k=If(O.current);if(ng(b)){g=b;e=g.stateNode;var l=g.type,m=g.memoizedProps,r=h;e[Ga]=g;e[Ha]=m;f=void 0;h=l;switch(h){case "iframe":case "object":H("load",e);break;case "video":case "audio":for(l=0;l<bb.length;l++)H(bb[l],e);break;case "source":H("error",e);break;case "img":case "image":case "link":H("error",e);H("load",e);break;case "form":H("reset",e);H("submit",e);break;case "details":H("toggle",e);break;case "input":Ac(e,m);H("invalid",e);xe(r,"onChange");break;case "select":e._wrapperState=
{wasMultiple:!!m.multiple};H("invalid",e);xe(r,"onChange");break;case "textarea":he(e,m),H("invalid",e),xe(r,"onChange")}ve(h,m);l=null;for(f in m)m.hasOwnProperty(f)&&(k=m[f],"children"===f?"string"===typeof k?e.textContent!==k&&(l=["children",k]):"number"===typeof k&&e.textContent!==""+k&&(l=["children",""+k]):sa.hasOwnProperty(f)&&null!=k&&xe(r,f));switch(h){case "input":Vb(e);Ec(e,m,!0);break;case "textarea":Vb(e);je(e,m);break;case "select":case "option":break;default:"function"===typeof m.onClick&&
(e.onclick=ye)}f=l;g.updateQueue=f;g=null!==f?!0:!1;g&&Bg(b)}else{m=b;e=f;r=g;l=9===h.nodeType?h:h.ownerDocument;k===ke.html&&(k=le(e));k===ke.html?"script"===e?(e=l.createElement("div"),e.innerHTML="<script>\x3c/script>",l=e.removeChild(e.firstChild)):"string"===typeof r.is?l=l.createElement(e,{is:r.is}):(l=l.createElement(e),"select"===e&&r.multiple&&(l.multiple=!0)):l=l.createElementNS(k,e);e=l;e[Ga]=m;e[Ha]=g;Cg(e,b,!1,!1);r=e;l=f;m=g;var w=h,y=we(l,m);switch(l){case "iframe":case "object":H("load",
r);h=m;break;case "video":case "audio":for(h=0;h<bb.length;h++)H(bb[h],r);h=m;break;case "source":H("error",r);h=m;break;case "img":case "image":case "link":H("error",r);H("load",r);h=m;break;case "form":H("reset",r);H("submit",r);h=m;break;case "details":H("toggle",r);h=m;break;case "input":Ac(r,m);h=zc(r,m);H("invalid",r);xe(w,"onChange");break;case "option":h=ee(r,m);break;case "select":r._wrapperState={wasMultiple:!!m.multiple};h=n({},m,{value:void 0});H("invalid",r);xe(w,"onChange");break;case "textarea":he(r,
m);h=ge(r,m);H("invalid",r);xe(w,"onChange");break;default:h=m}ve(l,h);k=void 0;var B=l,R=r,v=h;for(k in v)if(v.hasOwnProperty(k)){var q=v[k];"style"===k?te(R,q):"dangerouslySetInnerHTML"===k?(q=q?q.__html:void 0,null!=q&&oe(R,q)):"children"===k?"string"===typeof q?("textarea"!==B||""!==q)&&pe(R,q):"number"===typeof q&&pe(R,""+q):"suppressContentEditableWarning"!==k&&"suppressHydrationWarning"!==k&&"autoFocus"!==k&&(sa.hasOwnProperty(k)?null!=q&&xe(w,k):null!=q&&xc(R,k,q,y))}switch(l){case "input":Vb(r);
Ec(r,m,!1);break;case "textarea":Vb(r);je(r,m);break;case "option":null!=m.value&&r.setAttribute("value",""+yc(m.value));break;case "select":h=r;h.multiple=!!m.multiple;r=m.value;null!=r?fe(h,!!m.multiple,r,!1):null!=m.defaultValue&&fe(h,!!m.multiple,m.defaultValue,!0);break;default:"function"===typeof h.onClick&&(r.onclick=ye)}(g=Be(f,g))&&Bg(b);b.stateNode=e}null!==b.ref&&(b.effectTag|=128)}else null===b.stateNode?t("166"):void 0;break;case 6:e&&null!=b.stateNode?Ig(e,b,e.memoizedProps,g):("string"!==
typeof g&&(null===b.stateNode?t("166"):void 0),e=If(Hf.current),If(O.current),ng(b)?(g=b,f=g.stateNode,e=g.memoizedProps,f[Ga]=g,(g=f.nodeValue!==e)&&Bg(b)):(f=b,g=(9===e.nodeType?e:e.ownerDocument).createTextNode(g),g[Ga]=b,f.stateNode=g));break;case 11:break;case 13:g=b.memoizedState;if(0!==(b.effectTag&64)){b.expirationTime=f;S=b;break a}g=null!==g;f=null!==e&&null!==e.memoizedState;null!==e&&!g&&f&&(e=e.child.sibling,null!==e&&(h=b.firstEffect,null!==h?(b.firstEffect=e,e.nextEffect=h):(b.firstEffect=
b.lastEffect=e,e.nextEffect=null),e.effectTag=8));if(g!==f||0===(b.effectTag&1)&&g)b.effectTag|=4;break;case 7:break;case 8:break;case 12:break;case 4:Kf(b);Gg(b);break;case 10:Cf(b);break;case 9:break;case 14:break;case 17:M(b.type)&&Ne(b);break;default:t("156")}S=null}b=a;if(1===U||1!==b.childExpirationTime){g=0;for(f=b.child;null!==f;)e=f.expirationTime,h=f.childExpirationTime,e>g&&(g=e),h>g&&(g=h),f=f.sibling;b.childExpirationTime=g}if(null!==S)return S;null!==c&&0===(c.effectTag&1024)&&(null===
c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a))}else{a=Zg(a,U);if(null!==a)return a.effectTag&=1023,a;null!==c&&(c.firstEffect=c.lastEffect=null,c.effectTag|=1024)}if(null!==d)return d;if(null!==c)a=c;else break}return null}
function lh(a){var b=Ag(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=kh(a));ah.current=null;return b}
function mh(a,b){dh?t("243"):void 0;Tf();dh=!0;ah.currentDispatcher=$g;var c=a.nextExpirationTimeToWorkOn;if(c!==U||a!==T||null===S)jh(),T=a,U=c,S=$e(T.current,null,U),a.pendingCommitExpirationTime=0;var d=!1;do{try{if(b)for(;null!==S&&!nh();)S=lh(S);else for(;null!==S;)S=lh(S)}catch(B){if(Af=zf=yf=null,null===S)d=!0,Wg(B);else{null===S?t("271"):void 0;var e=S,f=e.return;if(null===f)d=!0,Wg(B);else{a:{var g=a,h=f,k=e,l=B;f=U;k.effectTag|=1024;k.firstEffect=k.lastEffect=null;if(null!==l&&"object"===
typeof l&&"function"===typeof l.then){var m=l;l=h;var r=-1,w=-1;do{if(13===l.tag){var y=l.alternate;if(null!==y&&(y=y.memoizedState,null!==y)){w=10*(1073741822-y.timedOutAt);break}y=l.pendingProps.maxDuration;if("number"===typeof y)if(0>=y)r=0;else if(-1===r||y<r)r=y}l=l.return}while(null!==l);l=h;do{if(y=13===l.tag)y=void 0===l.memoizedProps.fallback?!1:null===l.memoizedState;if(y){h=l.updateQueue;null===h?l.updateQueue=new Set([m]):h.add(m);if(0===(l.mode&1)){l.effectTag|=64;k.effectTag&=-1957;
1===k.tag&&(null===k.alternate?k.tag=17:(f=nf(1073741823),f.tag=2,pf(k,f)));k.expirationTime=1073741823;break a}k=g.pingCache;null===k?(k=g.pingCache=new Ug,h=new Set,k.set(m,h)):(h=k.get(m),void 0===h&&(h=new Set,k.set(m,h)));h.has(f)||(h.add(f),k=oh.bind(null,g,m,f),m.then(k,k));-1===r?g=1073741823:(-1===w&&(w=10*(1073741822-jf(g,f))-5E3),g=w+r);0<=g&&eh<g&&(eh=g);l.effectTag|=2048;l.expirationTime=f;break a}l=l.return}while(null!==l);l=Error((mc(k.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+
nc(k))}fh=!0;l=wf(l,k);g=h;do{switch(g.tag){case 3:g.effectTag|=2048;g.expirationTime=f;f=Vg(g,l,f);qf(g,f);break a;case 1:if(m=l,r=g.type,w=g.stateNode,0===(g.effectTag&64)&&("function"===typeof r.getDerivedStateFromError||null!==w&&"function"===typeof w.componentDidCatch&&(null===Yg||!Yg.has(w)))){g.effectTag|=2048;g.expirationTime=f;f=Xg(g,m,f);qf(g,f);break a}}g=g.return}while(null!==g)}S=kh(e);continue}}}break}while(1);dh=!1;Af=zf=yf=ah.currentDispatcher=null;if(d)T=null,a.finishedWork=null;
else if(null!==S)a.finishedWork=null;else{d=a.current.alternate;null===d?t("281"):void 0;T=null;if(fh){e=a.latestPendingTime;f=a.latestSuspendedTime;g=a.latestPingedTime;if(0!==e&&e<c||0!==f&&f<c||0!==g&&g<c){hf(a,c);ph(a,d,c,a.expirationTime,-1);return}if(!a.didError&&b){a.didError=!0;c=a.nextExpirationTimeToWorkOn=c;b=a.expirationTime=1073741823;ph(a,d,c,b,-1);return}}b&&-1!==eh?(hf(a,c),b=10*(1073741822-jf(a,c)),b<eh&&(eh=b),b=10*(1073741822-Rf()),b=eh-b,ph(a,d,c,a.expirationTime,0>b?0:b)):(a.pendingCommitExpirationTime=
c,a.finishedWork=d)}}function Mg(a,b){for(var c=a.return;null!==c;){switch(c.tag){case 1:var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===Yg||!Yg.has(d))){a=wf(b,a);a=Xg(c,a,1073741823);pf(c,a);Uf(c,1073741823);return}break;case 3:a=wf(b,a);a=Vg(c,a,1073741823);pf(c,a);Uf(c,1073741823);return}c=c.return}3===a.tag&&(c=wf(b,a),c=Vg(a,c,1073741823),pf(a,c),Uf(a,1073741823))}
function Sf(a,b){0!==ch?a=ch:dh?a=gh?1073741823:U:b.mode&1?(a=qh?1073741822-10*(((1073741822-a+15)/10|0)+1):1073741822-25*(((1073741822-a+500)/25|0)+1),null!==T&&a===U&&--a):a=1073741823;qh&&(0===rh||a<rh)&&(rh=a);return a}function oh(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);if(null!==T&&U===c)T=null;else if(b=a.earliestSuspendedTime,d=a.latestSuspendedTime,0!==b&&c<=b&&c>=d){a.didError=!1;b=a.latestPingedTime;if(0===b||b>c)a.latestPingedTime=c;gf(c,a);c=a.expirationTime;0!==c&&sh(a,c)}}
function Tg(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=Rf();b=Sf(b,a);a=th(a,b);null!==a&&(ff(a,b),b=a.expirationTime,0!==b&&sh(a,b))}
function th(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}return e}
function Uf(a,b){a=th(a,b);null!==a&&(!dh&&0!==U&&b>U&&jh(),ff(a,b),dh&&!gh&&T===a||sh(a,a.expirationTime),uh>vh&&(uh=0,t("185")))}function wh(a,b,c,d,e){var f=ch;ch=1073741823;try{return a(b,c,d,e)}finally{ch=f}}var xh=null,W=null,yh=0,zh=void 0,X=!1,Ah=null,Y=0,rh=0,Bh=!1,Ch=null,Z=!1,Dh=!1,qh=!1,Eh=null,Fh=ba.unstable_now(),Gh=1073741822-(Fh/10|0),Hh=Gh,vh=50,uh=0,Ih=null;function Jh(){Gh=1073741822-((ba.unstable_now()-Fh)/10|0)}
function Kh(a,b){if(0!==yh){if(b<yh)return;null!==zh&&ba.unstable_cancelCallback(zh)}yh=b;a=ba.unstable_now()-Fh;zh=ba.unstable_scheduleCallback(Lh,{timeout:10*(1073741822-b)-a})}function ph(a,b,c,d,e){a.expirationTime=d;0!==e||nh()?0<e&&(a.timeoutHandle=De(Mh.bind(null,a,b,c),e)):(a.pendingCommitExpirationTime=c,a.finishedWork=b)}function Mh(a,b,c){a.pendingCommitExpirationTime=c;a.finishedWork=b;Jh();Hh=Gh;Nh(a,c)}function Rf(){if(X)return Hh;Oh();if(0===Y||1===Y)Jh(),Hh=Gh;return Hh}
function sh(a,b){null===a.nextScheduledRoot?(a.expirationTime=b,null===W?(xh=W=a,a.nextScheduledRoot=a):(W=W.nextScheduledRoot=a,W.nextScheduledRoot=xh)):b>a.expirationTime&&(a.expirationTime=b);X||(Z?Dh&&(Ah=a,Y=1073741823,Ph(a,1073741823,!1)):1073741823===b?Qh(1073741823,!1):Kh(a,b))}
function Oh(){var a=0,b=null;if(null!==W)for(var c=W,d=xh;null!==d;){var e=d.expirationTime;if(0===e){null===c||null===W?t("244"):void 0;if(d===d.nextScheduledRoot){xh=W=d.nextScheduledRoot=null;break}else if(d===xh)xh=e=d.nextScheduledRoot,W.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===W){W=c;W.nextScheduledRoot=xh;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{e>a&&(a=e,b=d);if(d===W)break;if(1073741823===
a)break;c=d;d=d.nextScheduledRoot}}Ah=b;Y=a}var Rh=!1;function nh(){return Rh?!0:ba.unstable_shouldYield()?Rh=!0:!1}function Lh(){try{if(!nh()&&null!==xh){Jh();var a=xh;do{var b=a.expirationTime;0!==b&&Gh<=b&&(a.nextExpirationTimeToWorkOn=Gh);a=a.nextScheduledRoot}while(a!==xh)}Qh(0,!0)}finally{Rh=!1}}
function Qh(a,b){Oh();if(b)for(Jh(),Hh=Gh;null!==Ah&&0!==Y&&a<=Y&&!(Rh&&Gh>Y);)Ph(Ah,Y,Gh>Y),Oh(),Jh(),Hh=Gh;else for(;null!==Ah&&0!==Y&&a<=Y;)Ph(Ah,Y,!1),Oh();b&&(yh=0,zh=null);0!==Y&&Kh(Ah,Y);uh=0;Ih=null;if(null!==Eh)for(a=Eh,Eh=null,b=0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(d){Bh||(Bh=!0,Ch=d)}}if(Bh)throw a=Ch,Ch=null,Bh=!1,a;}function Nh(a,b){X?t("253"):void 0;Ah=a;Y=b;Ph(a,b,!1);Qh(1073741823,!1)}
function Ph(a,b,c){X?t("245"):void 0;X=!0;if(c){var d=a.finishedWork;null!==d?Sh(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,-1!==d&&(a.timeoutHandle=-1,Ee(d)),mh(a,c),d=a.finishedWork,null!==d&&(nh()?a.finishedWork=d:Sh(a,d,b)))}else d=a.finishedWork,null!==d?Sh(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,-1!==d&&(a.timeoutHandle=-1,Ee(d)),mh(a,c),d=a.finishedWork,null!==d&&Sh(a,d,b));X=!1}
function Sh(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime>=c&&(null===Eh?Eh=[d]:Eh.push(d),d._defer)){a.finishedWork=b;a.expirationTime=0;return}a.finishedWork=null;a===Ih?uh++:(Ih=a,uh=0);gh=dh=!0;a.current===b?t("177"):void 0;c=a.pendingCommitExpirationTime;0===c?t("261"):void 0;a.pendingCommitExpirationTime=0;d=b.expirationTime;var e=b.childExpirationTime;d=e>d?e:d;a.didError=!1;0===d?(a.earliestPendingTime=0,a.latestPendingTime=0,a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=
0):(d<a.latestPingedTime&&(a.latestPingedTime=0),e=a.latestPendingTime,0!==e&&(e>d?a.earliestPendingTime=a.latestPendingTime=0:a.earliestPendingTime>d&&(a.earliestPendingTime=a.latestPendingTime)),e=a.earliestSuspendedTime,0===e?ff(a,d):d<a.latestSuspendedTime?(a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=0,ff(a,d)):d>e&&ff(a,d));gf(0,a);ah.current=null;1<b.effectTag?null!==b.lastEffect?(b.lastEffect.nextEffect=b,d=b.firstEffect):d=b:d=b.firstEffect;ze=Hd;e=Td();if(Ud(e)){if("selectionStart"in
e)var f={start:e.selectionStart,end:e.selectionEnd};else a:{f=(f=e.ownerDocument)&&f.defaultView||window;var g=f.getSelection&&f.getSelection();if(g&&0!==g.rangeCount){f=g.anchorNode;var h=g.anchorOffset,k=g.focusNode;g=g.focusOffset;try{f.nodeType,k.nodeType}catch(db){f=null;break a}var l=0,m=-1,r=-1,w=0,y=0,B=e,R=null;b:for(;;){for(var v;;){B!==f||0!==h&&3!==B.nodeType||(m=l+h);B!==k||0!==g&&3!==B.nodeType||(r=l+g);3===B.nodeType&&(l+=B.nodeValue.length);if(null===(v=B.firstChild))break;R=B;B=v}for(;;){if(B===
e)break b;R===f&&++w===h&&(m=l);R===k&&++y===g&&(r=l);if(null!==(v=B.nextSibling))break;B=R;R=B.parentNode}B=v}f=-1===m||-1===r?null:{start:m,end:r}}else f=null}f=f||{start:0,end:0}}else f=null;Ae={focusedElem:e,selectionRange:f};Hd=!1;for(V=d;null!==V;){e=!1;f=void 0;try{for(;null!==V;){if(V.effectTag&256)a:{var q=V.alternate;h=V;switch(h.tag){case 0:case 11:case 15:break a;case 1:if(h.effectTag&256&&null!==q){var u=q.memoizedProps,A=q.memoizedState,Yf=h.stateNode,Vh=Yf.getSnapshotBeforeUpdate(h.elementType===
h.type?u:P(h.type,u),A);Yf.__reactInternalSnapshotBeforeUpdate=Vh}break a;case 3:case 5:case 6:case 4:case 17:break a;default:t("163")}}V=V.nextEffect}}catch(db){e=!0,f=db}e&&(null===V?t("178"):void 0,Mg(V,f),null!==V&&(V=V.nextEffect))}for(V=d;null!==V;){q=!1;u=void 0;try{for(;null!==V;){var x=V.effectTag;x&16&&pe(V.stateNode,"");if(x&128){var C=V.alternate;if(null!==C){var p=C.ref;null!==p&&("function"===typeof p?p(null):p.current=null)}}switch(x&14){case 2:Rg(V);V.effectTag&=-3;break;case 6:Rg(V);
V.effectTag&=-3;Sg(V.alternate,V);break;case 4:Sg(V.alternate,V);break;case 8:A=V;Pg(A);A.return=null;A.child=null;A.memoizedState=null;A.updateQueue=null;var G=A.alternate;null!==G&&(G.return=null,G.child=null,G.memoizedState=null,G.updateQueue=null)}V=V.nextEffect}}catch(db){q=!0,u=db}q&&(null===V?t("178"):void 0,Mg(V,u),null!==V&&(V=V.nextEffect))}p=Ae;C=Td();x=p.focusedElem;q=p.selectionRange;if(C!==x&&x&&x.ownerDocument&&Sd(x.ownerDocument.documentElement,x)){null!==q&&Ud(x)&&(C=q.start,p=q.end,
void 0===p&&(p=C),"selectionStart"in x?(x.selectionStart=C,x.selectionEnd=Math.min(p,x.value.length)):(p=(C=x.ownerDocument||document)&&C.defaultView||window,p.getSelection&&(p=p.getSelection(),u=x.textContent.length,G=Math.min(q.start,u),q=void 0===q.end?G:Math.min(q.end,u),!p.extend&&G>q&&(u=q,q=G,G=u),u=Rd(x,G),A=Rd(x,q),u&&A&&(1!==p.rangeCount||p.anchorNode!==u.node||p.anchorOffset!==u.offset||p.focusNode!==A.node||p.focusOffset!==A.offset)&&(C=C.createRange(),C.setStart(u.node,u.offset),p.removeAllRanges(),
G>q?(p.addRange(C),p.extend(A.node,A.offset)):(C.setEnd(A.node,A.offset),p.addRange(C))))));C=[];for(p=x;p=p.parentNode;)1===p.nodeType&&C.push({element:p,left:p.scrollLeft,top:p.scrollTop});"function"===typeof x.focus&&x.focus();for(x=0;x<C.length;x++)p=C[x],p.element.scrollLeft=p.left,p.element.scrollTop=p.top}Ae=null;Hd=!!ze;ze=null;a.current=b;for(V=d;null!==V;){d=!1;x=void 0;try{for(C=c;null!==V;){var Fb=V.effectTag;if(Fb&36){var Gb=V.alternate;p=V;G=C;switch(p.tag){case 0:case 11:case 15:break;
case 1:var Hc=p.stateNode;if(p.effectTag&4)if(null===Gb)Hc.componentDidMount();else{var ii=p.elementType===p.type?Gb.memoizedProps:P(p.type,Gb.memoizedProps);Hc.componentDidUpdate(ii,Gb.memoizedState,Hc.__reactInternalSnapshotBeforeUpdate)}var Dg=p.updateQueue;null!==Dg&&uf(p,Dg,Hc,G);break;case 3:var Eg=p.updateQueue;if(null!==Eg){q=null;if(null!==p.child)switch(p.child.tag){case 5:q=p.child.stateNode;break;case 1:q=p.child.stateNode}uf(p,Eg,q,G)}break;case 5:var ji=p.stateNode;null===Gb&&p.effectTag&
4&&Be(p.type,p.memoizedProps)&&ji.focus();break;case 6:break;case 4:break;case 12:break;case 13:break;case 17:break;default:t("163")}}if(Fb&128){var Ic=V.ref;if(null!==Ic){var Fg=V.stateNode;switch(V.tag){case 5:var ce=Fg;break;default:ce=Fg}"function"===typeof Ic?Ic(ce):Ic.current=ce}}V=V.nextEffect}}catch(db){d=!0,x=db}d&&(null===V?t("178"):void 0,Mg(V,x),null!==V&&(V=V.nextEffect))}dh=gh=!1;"function"===typeof Te&&Te(b.stateNode);Fb=b.expirationTime;b=b.childExpirationTime;b=b>Fb?b:Fb;0===b&&(Yg=
null);a.expirationTime=b;a.finishedWork=null}function Wg(a){null===Ah?t("246"):void 0;Ah.expirationTime=0;Bh||(Bh=!0,Ch=a)}function Th(a,b){var c=Z;Z=!0;try{return a(b)}finally{(Z=c)||X||Qh(1073741823,!1)}}function Uh(a,b){if(Z&&!Dh){Dh=!0;try{return a(b)}finally{Dh=!1}}return a(b)}function Wh(a,b,c){if(qh)return a(b,c);Z||X||0===rh||(Qh(rh,!1),rh=0);var d=qh,e=Z;Z=qh=!0;try{return a(b,c)}finally{qh=d,(Z=e)||X||Qh(1073741823,!1)}}
function Xh(a,b,c,d,e){var f=b.current;a:if(c){c=c._reactInternalFiber;b:{2===kd(c)&&1===c.tag?void 0:t("170");var g=c;do{switch(g.tag){case 3:g=g.stateNode.context;break b;case 1:if(M(g.type)){g=g.stateNode.__reactInternalMemoizedMergedChildContext;break b}}g=g.return}while(null!==g);t("171");g=void 0}if(1===c.tag){var h=c.type;if(M(h)){c=Qe(c,h,g);break a}}c=g}else c=Ke;null===b.context?b.context=c:b.pendingContext=c;b=e;e=nf(d);e.payload={element:a};b=void 0===b?null:b;null!==b&&(e.callback=b);
Tf();pf(f,e);Uf(f,d);return d}function Yh(a,b,c,d){var e=b.current,f=Rf();e=Sf(f,e);return Xh(a,b,c,e,d)}function Zh(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function $h(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$b,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
Cb=function(a,b,c){switch(b){case "input":Cc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=La(d);e?void 0:t("90");Wb(d);Cc(d,e)}}}break;case "textarea":ie(a,c);break;case "select":b=c.value,null!=b&&fe(a,!!c.multiple,b,!1)}};
function ai(a){var b=1073741822-25*(((1073741822-Rf()+500)/25|0)+1);b>=bh&&(b=bh-1);this._expirationTime=bh=b;this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}ai.prototype.render=function(a){this._defer?void 0:t("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new bi;Xh(a,b,null,c,d._onCommit);return d};
ai.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
ai.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:t("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?t("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;Nh(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
null,this._defer=!1};ai.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function bi(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}bi.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
bi.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?t("191",c):void 0;c()}}};
function ci(a,b,c){b=N(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,pingCache:null,earliestPendingTime:0,latestPendingTime:0,earliestSuspendedTime:0,latestSuspendedTime:0,latestPingedTime:0,didError:!1,pendingCommitExpirationTime:0,finishedWork:null,timeoutHandle:-1,context:null,pendingContext:null,hydrate:c,nextExpirationTimeToWorkOn:0,expirationTime:0,firstBatch:null,nextScheduledRoot:null};this._internalRoot=b.stateNode=a}
ci.prototype.render=function(a,b){var c=this._internalRoot,d=new bi;b=void 0===b?null:b;null!==b&&d.then(b);Yh(a,c,null,d._onCommit);return d};ci.prototype.unmount=function(a){var b=this._internalRoot,c=new bi;a=void 0===a?null:a;null!==a&&c.then(a);Yh(null,b,null,c._onCommit);return c};ci.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new bi;c=void 0===c?null:c;null!==c&&e.then(c);Yh(b,d,a,e._onCommit);return e};
ci.prototype.createBatch=function(){var a=new ai(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime>=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function di(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Kb=Th;Lb=Wh;Mb=function(){X||0===rh||(Qh(rh,!1),rh=0)};
function ei(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new ci(a,!1,b)}
function fi(a,b,c,d,e){di(c)?void 0:t("200");var f=c._reactRootContainer;if(f){if("function"===typeof e){var g=e;e=function(){var a=Zh(f._internalRoot);g.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=ei(c,d);if("function"===typeof e){var h=e;e=function(){var a=Zh(f._internalRoot);h.call(a)}}Uh(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return Zh(f._internalRoot)}
function gi(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;di(b)?void 0:t("200");return $h(a,b,null,c)}
var ki={createPortal:gi,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?t("188"):t("268",Object.keys(a)));a=nd(b);a=null===a?null:a.stateNode;return a},hydrate:function(a,b,c){return fi(null,a,b,!0,c)},render:function(a,b,c){return fi(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?t("38"):void 0;return fi(a,b,c,!1,d)},unmountComponentAtNode:function(a){di(a)?
void 0:t("40");return a._reactRootContainer?(Uh(function(){fi(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return gi.apply(void 0,arguments)},unstable_batchedUpdates:Th,unstable_interactiveUpdates:Wh,flushSync:function(a,b){X?t("187"):void 0;var c=Z;Z=!0;try{return wh(a,b)}finally{Z=c,Qh(1073741823,!1)}},unstable_createRoot:hi,unstable_flushControlled:function(a){var b=Z;Z=!0;try{wh(a)}finally{(Z=b)||X||Qh(1073741823,!1)}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{Events:[Ja,
Ka,La,Ca.injectEventPluginsByName,qa,Ra,function(a){za(a,Qa)},Ib,Jb,Jd,Ea]}};function hi(a,b){di(a)?void 0:t("299","unstable_createRoot");return new ci(a,!0,null!=b&&!0===b.hydrate)}(function(a){var b=a.findFiberByHostInstance;return We(n({},a,{overrideProps:null,findHostInstanceByFiber:function(a){a=nd(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))})({findFiberByHostInstance:Ia,bundleType:0,version:"16.7.0",rendererPackageName:"react-dom"});
var li={default:ki},mi=li&&ki||li;module.exports=mi.default||mi;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(56);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** @license React v0.12.0
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});var c=null,f=!1,h=3,k=-1,l=-1,m=!1,n=!1;function p(){if(!m){var a=c.expirationTime;n?q():n=!0;r(t,a)}}
function u(){var a=c,b=c.next;if(c===b)c=null;else{var d=c.previous;c=d.next=b;b.previous=d}a.next=a.previous=null;d=a.callback;b=a.expirationTime;a=a.priorityLevel;var e=h,Q=l;h=a;l=b;try{var g=d()}finally{h=e,l=Q}if("function"===typeof g)if(g={callback:g,priorityLevel:a,expirationTime:b,next:null,previous:null},null===c)c=g.next=g.previous=g;else{d=null;a=c;do{if(a.expirationTime>=b){d=a;break}a=a.next}while(a!==c);null===d?d=c:d===c&&(c=g,p());b=d.previous;b.next=d.previous=g;g.next=d;g.previous=
b}}function v(){if(-1===k&&null!==c&&1===c.priorityLevel){m=!0;try{do u();while(null!==c&&1===c.priorityLevel)}finally{m=!1,null!==c?p():n=!1}}}function t(a){m=!0;var b=f;f=a;try{if(a)for(;null!==c;){var d=exports.unstable_now();if(c.expirationTime<=d){do u();while(null!==c&&c.expirationTime<=d)}else break}else if(null!==c){do u();while(null!==c&&!w())}}finally{m=!1,f=b,null!==c?p():n=!1,v()}}
var x=Date,y="function"===typeof setTimeout?setTimeout:void 0,z="function"===typeof clearTimeout?clearTimeout:void 0,A="function"===typeof requestAnimationFrame?requestAnimationFrame:void 0,B="function"===typeof cancelAnimationFrame?cancelAnimationFrame:void 0,C,D;function E(a){C=A(function(b){z(D);a(b)});D=y(function(){B(C);a(exports.unstable_now())},100)}
if("object"===typeof performance&&"function"===typeof performance.now){var F=performance;exports.unstable_now=function(){return F.now()}}else exports.unstable_now=function(){return x.now()};var r,q,w,G=null;"undefined"!==typeof window?G=window:"undefined"!==typeof global&&(G=global);
if(G&&G._schedMock){var H=G._schedMock;r=H[0];q=H[1];w=H[2];exports.unstable_now=H[3]}else if("undefined"===typeof window||"function"!==typeof MessageChannel){var I=null,J=function(a){if(null!==I)try{I(a)}finally{I=null}};r=function(a){null!==I?setTimeout(r,0,a):(I=a,setTimeout(J,0,!1))};q=function(){I=null};w=function(){return!1}}else{"undefined"!==typeof console&&("function"!==typeof A&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"),
"function"!==typeof B&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"));var K=null,L=!1,M=-1,N=!1,O=!1,P=0,R=33,S=33;w=function(){return P<=exports.unstable_now()};var T=new MessageChannel,U=T.port2;T.port1.onmessage=function(){L=!1;var a=K,b=M;K=null;M=-1;var d=exports.unstable_now(),e=!1;if(0>=P-d)if(-1!==b&&b<=d)e=!0;else{N||(N=!0,E(V));K=a;M=b;return}if(null!==a){O=!0;try{a(e)}finally{O=!1}}};
var V=function(a){if(null!==K){E(V);var b=a-P+S;b<S&&R<S?(8>b&&(b=8),S=b<R?R:b):R=b;P=a+S;L||(L=!0,U.postMessage(void 0))}else N=!1};r=function(a,b){K=a;M=b;O||0>b?U.postMessage(void 0):N||(N=!0,E(V))};q=function(){K=null;L=!1;M=-1}}exports.unstable_ImmediatePriority=1;exports.unstable_UserBlockingPriority=2;exports.unstable_NormalPriority=3;exports.unstable_IdlePriority=5;exports.unstable_LowPriority=4;
exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var d=h,e=k;h=a;k=exports.unstable_now();try{return b()}finally{h=d,k=e,v()}};
exports.unstable_scheduleCallback=function(a,b){var d=-1!==k?k:exports.unstable_now();if("object"===typeof b&&null!==b&&"number"===typeof b.timeout)b=d+b.timeout;else switch(h){case 1:b=d+-1;break;case 2:b=d+250;break;case 5:b=d+1073741823;break;case 4:b=d+1E4;break;default:b=d+5E3}a={callback:a,priorityLevel:h,expirationTime:b,next:null,previous:null};if(null===c)c=a.next=a.previous=a,p();else{d=null;var e=c;do{if(e.expirationTime>b){d=e;break}e=e.next}while(e!==c);null===d?d=c:d===c&&(c=a,p());
b=d.previous;b.next=d.previous=a;a.next=d;a.previous=b}return a};exports.unstable_cancelCallback=function(a){var b=a.next;if(null!==b){if(b===a)c=null;else{a===c&&(c=b);var d=a.previous;d.next=b;b.previous=d}a.next=a.previous=null}};exports.unstable_wrapCallback=function(a){var b=h;return function(){var d=h,e=k;h=b;k=exports.unstable_now();try{return a.apply(this,arguments)}finally{h=d,k=e,v()}}};exports.unstable_getCurrentPriorityLevel=function(){return h};
exports.unstable_shouldYield=function(){return!f&&(null!==c&&c.expirationTime<l||w())};exports.unstable_continueExecution=function(){null!==c&&p()};exports.unstable_pauseExecution=function(){};exports.unstable_getFirstCallbackNode=function(){return c};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)))

/***/ }),
/* 57 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 58 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_css__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__component_Header_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainScreen_js__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AppChoice_js__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LoginPage_js__ = __webpack_require__(158);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//component for the header
// import Content from './Content.js'
//component container for all other components, handles navigation
//component that displays the buttons for asm user types to choose which app they would like to use
//component that displays the login page
var App=function(_Component){_inherits(App,_Component);function App(props){_classCallCheck(this,App);var _this=_possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).call(this,props));_this.state={app:'lov',login:false,userInfo:{}};_this.handleLogin=_this.handleLogin.bind(_this);_this.handleLogout=_this.handleLogout.bind(_this);_this.saveUserCart=_this.saveUserCart.bind(_this);_this.changeRedeemable=_this.changeRedeemable.bind(_this);_this.handleStateUpdate=_this.handleStateUpdate.bind(_this);return _this;}_createClass(App,[{key:'handleLogin',value:function handleLogin(success,userInfo){//method that passes up user info from login page
if(success===true){var app=userInfo.userType.substring(0,3)==="asm"||userInfo.name==="Heidi DeFazio"||userInfo.userType==="sys_admin"?'':"lov";//Heidi is a special case. She is checked here and on line ~65
this.setState({login:success,userInfo:userInfo,app:app});}}},{key:'changeRedeemable',value:function changeRedeemable(operation,points){var lov=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;//method that keeps track of user's redeemable points during their current session
var userInfo=this.state.userInfo;if(lov){if(operation==="subtract"){userInfo.redeemable=Number(userInfo.redeemable)-Number(points);}else{userInfo.redeemable=Number(userInfo.redeemable)+Number(points);}}else{if(operation==="subtract"){userInfo.budget=Number(userInfo.budget)-Number(points);}else{userInfo.budget=Number(userInfo.budget)+Number(points);}}this.setState({userInfo:userInfo});}},{key:'handleLogout',value:function handleLogout(){//method that triggers a page refresh which refreshes the state and logs the user out
window.location.reload(true);}},{key:'saveUserCart',value:function saveUserCart(cart){//method that keeps track of the user shopping cart until logout
this.setState({userCart:cart});}},{key:'handleStateUpdate',value:function handleStateUpdate(state,newValue){//standard method passed down to input/select components to update state
var newState={};newState[state]=newValue;this.setState(newState);}},{key:'render',value:function render(){var pageStyle={backgroundPosition:'center',overflow:'auto'};var user=this.state.userInfo.userType;var content=void 0;var contentStyles=void 0;if(this.state.login===true){contentStyles="fl w-100 bg-near-white br4 br--bottom bn";if((user==='asm'||user==='asm_regional'||user==='asm_admin'||this.state.userInfo.name==="Heidi DeFazio"||user==='sys_admin')&&this.state.app===''){//if the user is an asm, they choose which app they wish to use. Heidi is a special case and needs access to asm budgeting.
content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__AppChoice_js__["a" /* default */],{handleStateUpdate:this.handleStateUpdate});}else{//container of all containers, contains every view
content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__MainScreen_js__["a" /* default */],{app:this.state.app,redeemable:this.changeRedeemable,userInfo:this.state.userInfo,handleStateUpdate:this.handleStateUpdate,logout:this.handleLogout});}}else{//display login page
contentStyles="fl w-100 bg-white br4 br--bottom bn";content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__LoginPage_js__["a" /* default */],{onLogin:this.handleLogin});}var title=void 0;if(this.state.app==='asm'){title="Promotional Orders";}else{title="Living Our Values";}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'br4 bg-near-white mainDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 mt0 br4 bn br--top',style:{backgroundColor:'#357edd',backgroundImage:'linear-gradient(to right,#00449E,#357edd)'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__component_Header_js__["a" /* default */],{title:title,login:this.state.login})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:contentStyles,style:pageStyle},content));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 60 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__asset_img_gf_logo_png__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__asset_img_gf_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__asset_img_gf_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Header=function(_Component){_inherits(Header,_Component);function Header(){_classCallCheck(this,Header);return _possibleConstructorReturn(this,(Header.__proto__||Object.getPrototypeOf(Header)).apply(this,arguments));}_createClass(Header,[{key:'render',value:function render(){var headStyle=void 0;if(this.props.login){headStyle="mt0 mb0 br4 br--top fl w-100 pb3";}else{headStyle="mb0 mt0 br4 bb b--gray br--top fl w-100 pb5";}var imgStyle={minWidth:'75px',minHeight:'27px',maxWidth:'75px',maxHeight:'27px',marginLeft:'27px',marginTop:'27px'};var hStyle={backgroundColor:'#357edd',backgroundImage:'linear-gradient(to right,#00449E,#357edd)',color:'white',height:'100%'};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:headStyle,style:hStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__asset_img_gf_logo_png___default.a,alt:'logo',style:imgStyle,className:'mr2'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 tc pl2 pr2 mt0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'bn tc titleFont light-gray b br2 br--top mt0 mb0 ml3'},this.props.title)));}}]);return Header;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Header);Header.propTypes={login:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,title:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired};

/***/ }),
/* 62 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(64);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Nav_js__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routes_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CreateThankyou_js__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ViewThankyous_js__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PrizeShop_js__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__BulkThankyou_js__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__UserHomeScreen_js__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ApproveThankyous_js__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ViewOrders_js__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__BulkUser_js__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ViewUsers_js__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__AdminCenter_js__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ASMGiftShop_js__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ViewASMOrders_js__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ASMRegionalCenter_js__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ASMAdminCenter_js__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Participation_js__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__MassEmail_js__ = __webpack_require__(156);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//all pages below are the main containers for the entire app, they encompass every other container/component
var MainScreen=function(_Component){_inherits(MainScreen,_Component);function MainScreen(props){_classCallCheck(this,MainScreen);// this.state = {};
var _this=_possibleConstructorReturn(this,(MainScreen.__proto__||Object.getPrototypeOf(MainScreen)).call(this,props));_this.state={page:{Home:false,Sent:false,Received:false,Create:false,Shop:false,Orders:false,Pending:false,Add:false,View:false,Email:false,Mass:false,Prize_Requests:false,Admin_Center:false,Gift_Orders:false,//Gift_Shop:false,
Order_History:false,Budgeting:false},messages:[],userCart:[],cartTotal:0,submitted:false,leaveShop:false// interval:''
};_this.updateCart=_this.updateCart.bind(_this);_this.updateCartTotal=_this.updateCartTotal.bind(_this);_this.logSubmitted=_this.logSubmitted.bind(_this);_this.navigation=_this.navigation.bind(_this);_this.getMessages=_this.getMessages.bind(_this);_this.handleInput=_this.handleInput.bind(_this);_this.leaveShop=_this.leaveShop.bind(_this);return _this;}_createClass(MainScreen,[{key:'handleInput',value:function handleInput(identity,value){//standard method for handling user input
var theState={};theState[identity]=value;this.setState(theState);}},{key:'updateCart',value:function updateCart(cart){var callback=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;//method for updating the user shopping cart. shopping cart stored in this container in order to preserve its state if user navigates to another page
if(callback===null){this.setState({userCart:cart});}else{this.setState({userCart:cart},callback);}}},{key:'updateCartTotal',value:function updateCartTotal(){var item=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;//method for updating the cart total which is also stored in this layer to preserve its value
var total=this.state.cartTotal;var items=this.state.userCart;var newTotal=void 0;if(action==="add"&&item!==null){newTotal=Number(item.total)+Number(total);}else if(action==="remove"&&item!==null){newTotal=Number(total)-Number(item.total);items.splice(items.indexOf(item),1);}else if(item===null&&action===null){newTotal=0;}var newCartTotal=this.props.app==='lov'?Number(newTotal):Number(newTotal.toFixed(2));this.setState({cartTotal:newCartTotal,userCart:items});}//remove because the refresh will be controlled by the state
},{key:'logSubmitted',value:function logSubmitted(){if(this.state.submitted===false){this.setState({submitted:true});}else{this.setState({submitted:false});}}},{key:'getMessages',value:function getMessages(){var _this2=this;//method that retrieves admin messages based on the app that is logged into
var action=this.props.app==="lov"?"admin":"asm_admin";__WEBPACK_IMPORTED_MODULE_2_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_3__routes_js__["c" /* path */],data:{endpoint:'info',table:'messages',action:action}}).then(function(response){var welcomeMessage="Welcome "+_this2.props.userInfo.name+" to ";//default message that is always displayed
if(_this2.props.app==="lov"){welcomeMessage+="Living Our Values!";}else{welcomeMessage+="GF Promotional Orders!";}var messages=[welcomeMessage];var data=response.data.data;data.forEach(function(message){messages.push(message.message);});_this2.setState({messages:messages},function(){//loop through and display admin messages
var index=0;var inter=setInterval(function(){if(index===messages.length){index=0;}document.getElementById("textloop").innerHTML=messages[index];index++;},7000);// this.setState({interval:inter});
});});}},{key:'componentDidMount',value:function componentDidMount(){//when component mounts, display user homepage based on app and usertype
var pages=this.state.page;if(this.props.app==="asm"){if(this.props.userInfo.userType!=="asm_admin"&&this.props.userInfo.userType!=="sys_admin"){if(this.props.userInfo.name==="Heidi DeFazio"){pages['Budgeting']=true;}else{pages['Shop']=true;}}else{pages['Gift_Orders']=true;}}else{pages['Home']=true;}this.setState({page:pages},this.getMessages());}},{key:'navigation',value:function navigation(navState,navAway,navTo){//method to handle navigation between all pages
var newState={};var updatedNavState=navState;updatedNavState[navAway]=false;updatedNavState[navTo]=true;newState['page']=updatedNavState;this.setState(newState);}},{key:'leaveShop',value:function leaveShop(){this.navigation(this.state.page,"Shop","Gift_Orders");this.setState({leaveShop:true},function(){this.setState({leaveShop:false});});}},{key:'render',value:function render(){var content=void 0;var userType=this.props.userInfo.userType;if(this.props.app==="lov"){//navigation for lov app
if(userType!=="admin"&&userType!=="sys_admin"){//lov user and manager navigation
content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__UserHomeScreen_js__["a" /* default */],{userInfo:this.props.userInfo,active:this.state.page.Home,submitted:this.state.submitted})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__CreateThankyou_js__["a" /* default */],{userInfo:this.props.userInfo,active:this.state.page.Create,logChange:this.logSubmitted})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ViewThankyous_js__["a" /* default */],{userInfo:this.props.userInfo,view:'Sent',active:this.state.page.Sent,submitted:this.state.submitted})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ViewThankyous_js__["a" /* default */],{userInfo:this.props.userInfo,view:'Received',active:this.state.page.Received})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__PrizeShop_js__["a" /* default */],{updateCart:this.updateCart,cart:this.state.userCart,cartTotal:this.state.cartTotal,updateCartTotal:this.updateCartTotal,userInfo:this.props.userInfo,redeemable:this.props.redeemable,app:this.props.app,active:this.state.page.Shop,logChange:this.logSubmitted,handleInput:this.handleInput})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__ViewOrders_js__["a" /* default */],{userInfo:this.props.userInfo,app:this.props.app,redeemable:this.props.redeemable,active:this.state.page.Orders,logChange:this.logSubmitted,submitted:this.state.submitted})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__ApproveThankyous_js__["a" /* default */],{userInfo:this.props.userInfo,active:this.state.page.Pending})));}else{//lov admin navigation
content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Participation_js__["a" /* default */],{active:this.state.page.Home})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__ApproveThankyous_js__["a" /* default */],{userInfo:this.props.userInfo,active:this.state.page.Pending,submitted:this.state.submitted})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__BulkUser_js__["a" /* default */],{userInfo:this.props.userInfo,active:this.state.page.Add,logChange:this.logSubmitted})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ViewUsers_js__["a" /* default */],{userInfo:this.props.userInfo,active:this.state.page.View,submitted:this.state.submitted})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__MassEmail_js__["a" /* default */],{active:this.state.page.Email,type:'email'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__MassEmail_js__["a" /* default */],{active:this.state.page.Mass,type:'thankyou'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__BulkThankyou_js__["a" /* default */],{userInfo:this.props.userInfo,active:this.state.page.Create,logChange:this.logSubmitted})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__ViewOrders_js__["a" /* default */],{userInfo:this.props.userInfo,app:this.props.app,active:this.state.page.Prize_Requests,logChange:this.logSubmitted})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__AdminCenter_js__["a" /* default */],{userInfo:this.props.userInfo,app:this.props.app,active:this.state.page.Admin_Center})));}//end lov navigation
}else{if(userType!=="asm_admin"&&userType!=="sys_admin"){//asm and asm_regional navigation
content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__ASMGiftShop_js__["a" /* default */],{userInfo:this.props.userInfo,app:this.props.app,submitted:this.state.submitted,updateCart:this.updateCart,logChange:this.logSubmitted,cart:this.state.userCart,cartTotal:this.state.cartTotal,updateCartTotal:this.updateCartTotal,active:this.state.page.Shop,handleInput:this.handleInput,budgetUpdate:this.props.redeemable})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__ViewASMOrders_js__["a" /* default */],{userInfo:this.props.userInfo,logChange:this.logSubmitted,submitted:this.state.submitted,app:this.props.app,view:'user',active:this.state.page.Order_History,budgetUpdate:this.props.redeemable})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__ASMRegionalCenter_js__["a" /* default */],{userInfo:this.props.userInfo,app:this.props.app,active:this.state.page.Budgeting,logChange:this.logSubmitted})));}else{//asm admin navigation
content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__ViewASMOrders_js__["a" /* default */],{userInfo:this.props.userInfo,app:this.props.app,logChange:this.logSubmitted,submitted:this.state.submitted,view:'admin',active:this.state.page.Gift_Orders,budgetUpdate:this.props.redeemable})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__ViewASMOrders_js__["a" /* default */],{userInfo:this.props.userInfo,app:this.props.app,view:'history',active:this.state.page.Order_History})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__ASMAdminCenter_js__["a" /* default */],{userInfo:this.props.userInfo,app:this.props.app,logChange:this.logSubmitted,submitted:this.state.submitted,active:this.state.page.Admin_Center})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__ASMGiftShop_js__["a" /* default */],{userInfo:this.props.userInfo,app:this.props.app,submitted:this.state.submitted,updateCart:this.updateCart,logChange:this.logSubmitted,cart:this.state.userCart,cartTotal:this.state.cartTotal,updateCartTotal:this.updateCartTotal,active:this.state.page.Shop,handleInput:this.handleInput,leaveShop:this.leaveShop})));}}var userInfo=this.props.userInfo;var mainStyleClass="fl w-100 pa4-ns pa3-m pa2 br4 br--bottom bt b--white bw1 overflow-y-auto bg-near-white";var mainStyle={maxHeight:'650px',minHeight:'650px'};if((userInfo.userType==='admin'||userInfo.userType==='sys_admin')&&this.state.page.Home){mainStyleClass="fl w-100 pa4-ns pa3-m pa2 br4 br--bottom bt b--white overflow-x-hidden overflow-y-hidden bw1 bg-near-white";}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 tc pb3 mt0 b--white',style:{backgroundColor:'#357edd',backgroundImage:'linear-gradient(to right,#00449E,#357edd)'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'adminMessages mt0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'f5 b tc lightest-blue',id:'textloop'},'\xA0'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 pl0 mt0 pt0 bg-navy overflow-x-hidden'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Nav_js__["a" /* default */],{onChange:this.navigation,leaveShop:this.state.leaveShop,navState:this.state.page,user:userInfo.userType,app:this.props.app,logout:this.props.logout})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:mainStyleClass,style:mainStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,content)));}}]);return MainScreen;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (MainScreen);MainScreen.propTypes={app:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,redeemable:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,userInfo:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,logout:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,handleStateUpdate:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired};

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LovUserNav_js__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LovAdminNav_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ASMUserNav_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ASMAdminNav_js__ = __webpack_require__(70);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Nav=function(_Component){_inherits(Nav,_Component);function Nav(props){_classCallCheck(this,Nav);var _this=_possibleConstructorReturn(this,(Nav.__proto__||Object.getPrototypeOf(Nav)).call(this,props));_this.buttonClick=_this.buttonClick.bind(_this);return _this;}_createClass(Nav,[{key:'buttonClick',value:function buttonClick(navAway,navTo){//pass down method for handling navigation
this.props.onChange(this.props.navState,navAway,navTo);}},{key:'render',value:function render(){var type=this.props.user;var app=this.props.app;var navbar=void 0;if(app==="lov"){//determine which navbar to display depending on which app was chosen and user type
if(type==="admin"||type==="sys_admin"){navbar=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__LovAdminNav_js__["a" /* default */],{user:type,navClick:this.buttonClick,logout:this.props.logout});}else{navbar=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__LovUserNav_js__["a" /* default */],{user:type,navClick:this.buttonClick,logout:this.props.logout});}}else{if(type==="asm_admin"||type==="sys_admin"){navbar=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ASMAdminNav_js__["a" /* default */],{user:type,navClick:this.buttonClick,logout:this.props.logout,leaveShop:this.props.leaveShop});}else{navbar=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ASMUserNav_js__["a" /* default */],{user:type,navClick:this.buttonClick,logout:this.props.logout});}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,navbar);}}]);return Nav;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Nav);

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component_NavButton_js__ = __webpack_require__(14);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LovUserNav=function(_Component){_inherits(LovUserNav,_Component);function LovUserNav(props){_classCallCheck(this,LovUserNav);var _this=_possibleConstructorReturn(this,(LovUserNav.__proto__||Object.getPrototypeOf(LovUserNav)).call(this,props));_this.handleThankHover=_this.handleThankHover.bind(_this);_this.handlePrizeHover=_this.handlePrizeHover.bind(_this);_this.handleClick=_this.handleClick.bind(_this);_this.state={thankhover:false,prizehover:false,current:'Home'};return _this;}_createClass(LovUserNav,[{key:'handleThankHover',value:function handleThankHover(){//handles mouse hover over "Thankyous" button, display dropdown buttons
this.setState({thankhover:!this.state.thankhover});}},{key:'handlePrizeHover',value:function handlePrizeHover(){//handles mouse hover over "Prizes" button, display dropdown buttons
this.setState({prizehover:!this.state.prizehover});}},{key:'handleClick',value:function handleClick(navTo){//method that handles user click on a nav button,passes info up to main in order to handle navigation
this.props.navClick(this.state.current,navTo);this.setState({current:navTo});}},{key:'render',value:function render(){var manager=void 0;var divStyle="fl w-25 ma0 bl pl1 pr1 white h-100 userNavDiv";var buttonstyle="dim b w-100 pt2 pb2 bn white bg-navy ml1 mr1 pointer";var disbuttonstyle="b w-100 pt2 pb2 bn white bg-navy ml1 mr1";var dropstyle="b fl w-100 dark-blue bg-white pa1 grow b--dark-blue pt2 pb2 bb bl br bt0 pointer dib";var dropend="b fl w-100 dark-blue bg-white pa1 grow b--dark-blue pt2 pb2 bb bl br bt0 pointer dib br--bottom br3";var endstyle=dropend;if(this.props.user==="manager"||this.props.user==="asm_regional"){manager=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_NavButton_js__["a" /* default */],{name:'Pending',onClick:this.handleClick,styles:dropend});endstyle=dropstyle;}var options=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'z-1 absolute shadow-3 br--bottom br3 userDropDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_NavButton_js__["a" /* default */],{name:'Shop',onClick:this.handleClick,styles:dropstyle}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_NavButton_js__["a" /* default */],{name:'Orders',onClick:this.handleClick,styles:dropend}));var thankyous=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'z-1 absolute shadow-3 br--bottom br3 userDropDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_NavButton_js__["a" /* default */],{name:'Create',onClick:this.handleClick,styles:dropstyle})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_NavButton_js__["a" /* default */],{name:'Sent',onClick:this.handleClick,styles:dropstyle}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_NavButton_js__["a" /* default */],{name:'Received',onClick:this.handleClick,styles:endstyle}),manager);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-25 ma0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_NavButton_js__["a" /* default */],{name:'Home',onClick:this.handleClick,styles:buttonstyle})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:divStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onMouseEnter:this.handleThankHover,onMouseLeave:this.handleThankHover},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_NavButton_js__["a" /* default */],{name:'Thank yous',styles:disbuttonstyle}),this.state.thankhover&&thankyous)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:divStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onMouseEnter:this.handlePrizeHover,onMouseLeave:this.handlePrizeHover},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_NavButton_js__["a" /* default */],{name:'Prizes',styles:disbuttonstyle}),this.state.prizehover&&options)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:divStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:this.props.logout,className:buttonstyle},'Logout')));}}]);return LovUserNav;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (LovUserNav);

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component_NavButton_js__ = __webpack_require__(14);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LovAdminNav=function(_Component){_inherits(LovAdminNav,_Component);function LovAdminNav(props){_classCallCheck(this,LovAdminNav);var _this=_possibleConstructorReturn(this,(LovAdminNav.__proto__||Object.getPrototypeOf(LovAdminNav)).call(this,props));_this.handleEmployeeHover=_this.handleEmployeeHover.bind(_this);_this.handleClick=_this.handleClick.bind(_this);_this.handleThankyouHover=_this.handleThankyouHover.bind(_this);_this.state={employeeHover:false,thankyouHover:false,employeeClicked:false,thankyouClicked:false,current:'Home'};return _this;}_createClass(LovAdminNav,[{key:'handleEmployeeHover',value:function handleEmployeeHover(){//method for handling mouse hover over "Employee" button, display dropdown buttons
if(this.state.employeeClicked!==true){this.setState({employeeHover:!this.state.employeeHover});}}},{key:'handleThankyouHover',value:function handleThankyouHover(){//method for handling mouse hover over "Thankyous" button, display dropdown buttons
if(this.state.thankyouClicked!==true){this.setState({thankyouHover:!this.state.thankyouHover});}}},{key:'handleClick',value:function handleClick(name,type){//method that handles user click on a nav button,passes info up to main in order to handle navigation
this.props.navClick(this.state.current,name);this.setState({current:name});}},{key:'render',value:function render(){var divStyle="fl w-33 ma0 bl b--white adminNavDiv pl1 pr1";var buttonstyle="dim b w-100 center pt2 pb2 bn white bg-navy navOverflow pointer";var hoverButtonstyle="b w-100 center pt2 pb2 bn white bg-navy navOverflow";var dropstyle="b fl w-100 dark-blue bg-white pa1 grow b--dark-blue pt2 pb2 bb bl br bt0 pointer dib";var dropend="b fl w-100 dark-blue bg-white pa1 grow b--dark-blue pt2 pb2 bb bl br bt0 pointer dib br--bottom br3";var thankyous=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'z-1 absolute shadow-3 br--bottom br3 adminDropDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bb b--blue mb3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_NavButton_js__["a" /* default */],{name:'Create',onClick:this.handleClick,type:'thankyoudrop',styles:dropstyle})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bb b--blue mb3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_NavButton_js__["a" /* default */],{name:'Mass',onClick:this.handleClick,type:'thankyoudrop',styles:dropstyle})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_NavButton_js__["a" /* default */],{name:'Pending',onClick:this.handleClick,type:'thankyoudrop',styles:dropend}));var employees=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'z-1 absolute shadow-3 br--bottom br3 adminDropDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_NavButton_js__["a" /* default */],{name:'Add',onClick:this.handleClick,type:'employeedrop',styles:dropstyle}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_NavButton_js__["a" /* default */],{name:'View',onClick:this.handleClick,type:'employeedrop',styles:dropstyle}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_NavButton_js__["a" /* default */],{name:'Email',onClick:this.handleClick,type:'employeedrop',styles:dropend}));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mt0 mb0 fl w-100 bg-navy'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-33 ma0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_NavButton_js__["a" /* default */],{name:'Home',onClick:this.handleClick,styles:buttonstyle,type:'button'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:divStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_NavButton_js__["a" /* default */],{name:'Admin Center',onClick:this.handleClick,styles:buttonstyle,type:'button'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:divStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_NavButton_js__["a" /* default */],{name:'Prize Requests',onClick:this.handleClick,styles:buttonstyle,type:'button'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:divStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onMouseEnter:this.handleEmployeeHover,onMouseLeave:this.handleEmployeeHover,className:'overflow-hidden'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_NavButton_js__["a" /* default */],{name:'Employees',styles:hoverButtonstyle,type:'button'}),this.state.employeeHover&&employees)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:divStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onMouseEnter:this.handleThankyouHover,onMouseLeave:this.handleThankyouHover,className:'overflow-hidden'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_NavButton_js__["a" /* default */],{name:'Thank yous',styles:hoverButtonstyle,type:'button'}),this.state.thankyouHover&&thankyous)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:divStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:this.props.logout,className:buttonstyle},'Logout'))));}}]);return LovAdminNav;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (LovAdminNav);

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component_NavButton_js__ = __webpack_require__(14);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ASMUserNav=function(_Component){_inherits(ASMUserNav,_Component);function ASMUserNav(props){_classCallCheck(this,ASMUserNav);var _this=_possibleConstructorReturn(this,(ASMUserNav.__proto__||Object.getPrototypeOf(ASMUserNav)).call(this,props));_this.handleClick=_this.handleClick.bind(_this);_this.state={current:'Shop'};return _this;}_createClass(ASMUserNav,[{key:'handleClick',value:function handleClick(navTo){//method that passes up the page selected based on the nav button that has been clicked
this.props.navClick(this.state.current,navTo);this.setState({current:navTo});}},{key:'render',value:function render(){var manager=void 0;var buttonstyle="dim b w-100 pt2 pb2 white bg-navy bn ml1 mr1 pointer";var divStyle="fl w-33 bl pl1 pr1 b--white asmUserNav";var firstDivStyle="fl w-33";if(this.props.user!=="asm"){if(this.props.user!=="asm_regional"){divStyle="fl w-50 pl1 pr1 asmUserNav";}else{divStyle="fl w-25 bl b--white asmUserNav";}manager=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:divStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_NavButton_js__["a" /* default */],{name:'Budgeting',onClick:this.handleClick,styles:buttonstyle}));firstDivStyle="fl w-25";}var buttons=void 0;if(this.props.user!=="asm"&&this.props.user!=="asm_regional"){divStyle="fl w-50 bl pl1 pr1 b--white asmUserNav";buttons=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 bg-navy'},manager,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:divStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:this.props.logout,className:buttonstyle},'Logout')));}else{buttons=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 bg-navy'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:firstDivStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_NavButton_js__["a" /* default */],{name:'Shop',styles:buttonstyle,onClick:this.handleClick})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:divStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_NavButton_js__["a" /* default */],{name:'Order History',styles:buttonstyle,onClick:this.handleClick})),manager,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:divStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:this.props.logout,className:buttonstyle},'Logout')));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,buttons);}}]);return ASMUserNav;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ASMUserNav);

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component_NavButton_js__ = __webpack_require__(14);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ASMAdminNav=function(_Component){_inherits(ASMAdminNav,_Component);function ASMAdminNav(props){_classCallCheck(this,ASMAdminNav);var _this=_possibleConstructorReturn(this,(ASMAdminNav.__proto__||Object.getPrototypeOf(ASMAdminNav)).call(this,props));_this.handleClick=_this.handleClick.bind(_this);_this.state={current:'Gift_Orders'};return _this;}_createClass(ASMAdminNav,[{key:'handleClick',value:function handleClick(navTo){//method that passes up the page selected based on the nav button that has been clicked
this.props.navClick(this.state.current,navTo);this.setState({current:navTo});}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){if(prevProps.leaveShop!==this.props.leaveShop&&this.props.leaveShop&&this.state.current!=='Gift_Orders'){this.setState({current:'Gift_Orders'});}}},{key:'render',value:function render(){var divStyle="fl w-20 bl pl1 pr1 b--white asmNavDiv";var buttonstyle="dim b w-100 pt2 pb2 bn white bg-navy ml1 mr1 pointer";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-20'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_NavButton_js__["a" /* default */],{name:'Gift Orders',onClick:this.handleClick,styles:buttonstyle})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:divStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_NavButton_js__["a" /* default */],{name:'Order History',onClick:this.handleClick,styles:buttonstyle})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:divStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_NavButton_js__["a" /* default */],{name:'Admin Center',onClick:this.handleClick,styles:buttonstyle})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:divStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_NavButton_js__["a" /* default */],{name:'Shop',onClick:this.handleClick,styles:buttonstyle})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:divStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:this.props.logout,className:buttonstyle},'Logout')));}}]);return ASMAdminNav;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ASMAdminNav);

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(9);
var bind = __webpack_require__(25);
var Axios = __webpack_require__(72);
var mergeConfig = __webpack_require__(32);
var defaults = __webpack_require__(18);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(33);
axios.CancelToken = __webpack_require__(86);
axios.isCancel = __webpack_require__(31);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(87);

// Expose isAxiosError
axios.isAxiosError = __webpack_require__(88);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(9);
var buildURL = __webpack_require__(26);
var InterceptorManager = __webpack_require__(73);
var dispatchRequest = __webpack_require__(74);
var mergeConfig = __webpack_require__(32);
var validator = __webpack_require__(84);

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      forcedJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      clarifyTimeoutError: validators.transitional(validators.boolean, '1.0.0')
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(9);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(9);
var transformData = __webpack_require__(75);
var isCancel = __webpack_require__(31);
var defaults = __webpack_require__(18);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(9);
var defaults = __webpack_require__(18);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(9);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(30);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(9);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(80);
var combineURLs = __webpack_require__(81);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(9);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(9);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var pkg = __webpack_require__(85);

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};
var currentVerArr = pkg.version.split('.');

/**
 * Compare package versions
 * @param {string} version
 * @param {string?} thanVersion
 * @returns {boolean}
 */
function isOlderVersion(version, thanVersion) {
  var pkgVersionArr = thanVersion ? thanVersion.split('.') : currentVerArr;
  var destVer = version.split('.');
  for (var i = 0; i < 3; i++) {
    if (pkgVersionArr[i] > destVer[i]) {
      return true;
    } else if (pkgVersionArr[i] < destVer[i]) {
      return false;
    }
  }
  return false;
}

/**
 * Transitional option validator
 * @param {function|boolean?} validator
 * @param {string?} version
 * @param {string} message
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  var isDeprecated = version && isOlderVersion(version);

  function formatMessage(opt, desc) {
    return '[Axios v' + pkg.version + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new Error(formatMessage(opt, ' has been removed in ' + version));
    }

    if (isDeprecated && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new TypeError('options must be an object');
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new TypeError('option ' + opt + ' must be ' + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error('Unknown option ' + opt);
    }
  }
}

module.exports = {
  isOlderVersion: isOlderVersion,
  assertOptions: assertOptions,
  validators: validators
};


/***/ }),
/* 85 */
/***/ (function(module, exports) {

module.exports = {"name":"axios","version":"0.21.4","description":"Promise based HTTP client for the browser and node.js","main":"index.js","scripts":{"test":"grunt test","start":"node ./sandbox/server.js","build":"NODE_ENV=production grunt build","preversion":"npm test","version":"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json","postversion":"git push && git push --tags","examples":"node ./examples/server.js","coveralls":"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js","fix":"eslint --fix lib/**/*.js"},"repository":{"type":"git","url":"https://github.com/axios/axios.git"},"keywords":["xhr","http","ajax","promise","node"],"author":"Matt Zabriskie","license":"MIT","bugs":{"url":"https://github.com/axios/axios/issues"},"homepage":"https://axios-http.com","devDependencies":{"coveralls":"^3.0.0","es6-promise":"^4.2.4","grunt":"^1.3.0","grunt-banner":"^0.6.0","grunt-cli":"^1.2.0","grunt-contrib-clean":"^1.1.0","grunt-contrib-watch":"^1.0.0","grunt-eslint":"^23.0.0","grunt-karma":"^4.0.0","grunt-mocha-test":"^0.13.3","grunt-ts":"^6.0.0-beta.19","grunt-webpack":"^4.0.2","istanbul-instrumenter-loader":"^1.0.0","jasmine-core":"^2.4.1","karma":"^6.3.2","karma-chrome-launcher":"^3.1.0","karma-firefox-launcher":"^2.1.0","karma-jasmine":"^1.1.1","karma-jasmine-ajax":"^0.1.13","karma-safari-launcher":"^1.0.0","karma-sauce-launcher":"^4.3.6","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.8","karma-webpack":"^4.0.2","load-grunt-tasks":"^3.5.2","minimist":"^1.2.0","mocha":"^8.2.1","sinon":"^4.5.0","terser-webpack-plugin":"^4.2.3","typescript":"^4.0.5","url-search-params":"^0.10.0","webpack":"^4.44.2","webpack-dev-server":"^3.11.0"},"browser":{"./lib/adapters/http.js":"./lib/adapters/xhr.js"},"jsdelivr":"dist/axios.min.js","unpkg":"dist/axios.min.js","typings":"./index.d.ts","dependencies":{"follow-redirects":"^1.14.0"},"bundlesize":[{"path":"./dist/axios.min.js","threshold":"5kB"}]}

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(33);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return (typeof payload === 'object') && (payload.isAxiosError === true);
};


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CheckboxContainer_js__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__component_Input_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__component_Submit_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__routes_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_select__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__asset_img_loader_gif__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__asset_img_loader_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__asset_img_loader_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_modal__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__asset_img_sparkles2_png__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__asset_img_sparkles2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__asset_img_sparkles2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Validation_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__component_Select_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__component_Searchable_js__ = __webpack_require__(21);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//component that contains the radio inputs with the lov values
var CreateThankyou=function(_Component){_inherits(CreateThankyou,_Component);function CreateThankyou(props){_classCallCheck(this,CreateThankyou);var _this=_possibleConstructorReturn(this,(CreateThankyou.__proto__||Object.getPrototypeOf(CreateThankyou)).call(this,props));_this.state={To:'Select',For:'',value:'',From:_this.props.userInfo.userID,virtues:[],employees:[],required:[],success:'',loading:false,valid:true,searchVal:''};_this.handleInput=_this.handleInput.bind(_this);_this.handleSubmit=_this.handleSubmit.bind(_this);_this.handleSelect=_this.handleSelect.bind(_this);_this.openModal=_this.openModal.bind(_this);_this.closeModal=_this.closeModal.bind(_this);_this.loadingFunc=_this.loadingFunc.bind(_this);_this.handleSearch=_this.handleSearch.bind(_this);return _this;}_createClass(CreateThankyou,[{key:'loadingFunc',value:function loadingFunc(loading){//method for displaying loading gif
if(loading){this.setState({loading:true},function(){this.openModal();});}else{this.setState({loading:false});}}},{key:'componentDidMount',value:function componentDidMount(){var _this2=this;//when component mounts, retrieve all active lov values and all active employees
__WEBPACK_IMPORTED_MODULE_1_axios___default()({//get lov values
method:'post',url:__WEBPACK_IMPORTED_MODULE_5__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'info',table:'virtues'}}).then(function(response){var values=[];var data=response.data.data;data.forEach(function(virtues){values.push(virtues);});_this2.setState({virtues:values});}).then(function(){__WEBPACK_IMPORTED_MODULE_1_axios___default()({//get employees
method:'post',url:__WEBPACK_IMPORTED_MODULE_5__routes_js__["c" /* path */],data:{endpoint:'info',table:'users',action:'employees'}}).then(function(response){var employees=[];var res=response.data.data;res.forEach(function(employee){if(employee.name!==_this2.props.userInfo.name){employees.push({value:employee.name,label:employee.name});}});_this2.setState({employees:employees});});});}},{key:'openModal',value:function openModal(){//method to open the modal
this.setState({modalIsOpen:true});}},{key:'closeModal',value:function closeModal(){//method to close the modal
this.setState({modalIsOpen:false});this.setState({success:''});}},{key:'handleSelect',value:function handleSelect(value){//method to handle change of employee dropdown
this.setState({To:value,searchVal:value});}},{key:'handleSearch',value:function handleSearch(value){this.setState({searchVal:value});}},{key:'handleInput',value:function handleInput(identity,value){//standard method to handle user input
var theState={};theState[identity]=value;this.setState(theState);}},{key:'handleSubmit',value:function handleSubmit(){var _this3=this;//method that is called when submit button is clicked
var checked_button=document.querySelector('input[name="virtues"]:checked');if(checked_button!==null){checked_button.checked=false;//clear the radio buttons
}var submittable={To:this.state.To,For:this.state.For,value:this.state.value};var emptykeys=[];var valid=true;for(var field in submittable){//make sure all fields contain input
if(submittable[field]===''||submittable[field]==='Select'){emptykeys.push(field);}}var reason=this.state.For.trim();if(this.state.For.trim()!==''&&!Object(__WEBPACK_IMPORTED_MODULE_10__Validation_js__["a" /* default */])("reason",this.state.For)){//validate the thank you reason
this.setState({valid:false});valid=false;}else{this.setState({valid:true});}if(emptykeys.length===0&&valid){//if all fields are filled and contain valid input, create thankyou
this.loadingFunc(true);__WEBPACK_IMPORTED_MODULE_1_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_5__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{"endpoint":'create',"table":'thank',"misc":'create',"firstID":this.state.From,"answer":this.state.value,"name":this.state.To,"date":'required',"desc":reason}}).then(function(response){var data=response.data.data;if(data.Message==="Thank you created!"){_this3.setState({To:'Select',For:'',value:''});_this3.props.logChange();_this3.setState({success:data.Message,valid:true,searchVal:''});_this3.loadingFunc(false);}});}else{//log which fields are empty in the state
this.setState({required:emptykeys});}}},{key:'render',value:function render(){var customStyles={content:{top:'50%',left:'50%',right:'auto',bottom:'auto',width:'400px',minWidth:'300px',height:'200px',minHeight:'200px',borderStyle:'solid',borderWidth:'2px',borderColor:'gray',transform:'translate(-50%, -50%)',backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_9__asset_img_sparkles2_png___default.a+')',backgroundRepeat:'no-repeat',backgroundSize:'300px 200px',backgroundPosition:'right',boxShadow:'0.5px 0.5px 1px 0.5px'},overlay:{backgroundColor:'rgba(105,105,105,0.8)'}};var searchableStyles={input:{borderWidth:'.125rem',borderRadius:'3px 3px 3px 3px',borderColor:'gray',height:'32px',width:'100%',paddingLeft:'10px'},list:{listStyleType:'none',backgroundColor:'white',width:'100%',maxHeight:'200px',overflowY:'auto',margin:'0',paddingLeft:'0'}};var selectStyles="hh2 w-100 br2 bw1 truncate shadow-3";var content=void 0;var styles="mb3";var toRequired=void 0;var forRequired=void 0;var valRequired=void 0;var employeeOptions=this.state.employees.map(function(employee,i){//get all employees for dropdown menu options
return employee.value;});this.state.required.forEach(function(emptyField){//validation messages that appear above/next to their respective fields
if(emptyField==="To"){toRequired="Required";}else if(emptyField==="For"){forRequired="Required Field";}else if(emptyField==="value"){valRequired="Required Field";}});if(!this.state.valid){//input not valid message
forRequired="Input not valid.";}var modalContent=void 0;if(this.state.loading){//display loading gif
modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tc',style:{width:'150px',margin:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_7__asset_img_loader_gif___default.a,alt:'Loading'}));}else{//display success message
modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 tr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'bg-white gray b br3',onClick:this.closeModal},'X')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 tc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'b navy f3'},this.state.success)));}if(this.props.active){content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mw6-ns center mb3 mt4 pa4 br3 bt bl b--lightest-blue bg-white',style:{boxShadow:'0px 0px 5px 5px #aaaaaa'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mw5-ns center b'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:styles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pb1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'mb2'},'I Would like to thank:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'red'},'*',toRequired))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'br2 pb3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__component_Searchable_js__["a" /* default */],{containerId:'combo_box_container',inputId:'combo_box',placeholder:'Search or Select',style:searchableStyles,listItemClass:'search_list_item',caseSensitive:false,value:this.state.searchVal,options:employeeOptions,handleSelect:this.handleSelect,handleChange:this.handleSearch}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:styles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pb1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'tl'},'For:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'red'},'*',forRequired))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__component_Input_js__["a" /* default */],{identity:'For',type:'area',onInput:this.handleInput,styles:'pa2 br2 bw1 w-100-ns w-100 shadow-3',val:this.state.For}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:styles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Embodied Value:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'red'},'*',valRequired))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mv3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__CheckboxContainer_js__["a" /* default */],{identity:'value',virtues:this.state.virtues,onCheck:this.handleInput}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mv3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__component_Submit_js__["a" /* default */],{name:'Send',onClick:this.handleSubmit,styles:'br3 grow white bn b w-50 h2 bg-blue btshadow'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_modal___default.a,{isOpen:this.state.modalIsOpen,style:customStyles,contentLabel:'loading',shouldCloseOnOverlayClick:false,shouldCloseOnEsc:false},modalContent)));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,content);}}]);return CreateThankyou;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);//<SelectBox identity="To" onSelect={this.handleInput} options={employeeOptions} styles={selectStyles} val={this.state.To}/>
/* harmony default export */ __webpack_exports__["a"] = (CreateThankyou);

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CheckboxContainer=function(_Component){_inherits(CheckboxContainer,_Component);function CheckboxContainer(props){_classCallCheck(this,CheckboxContainer);var _this=_possibleConstructorReturn(this,(CheckboxContainer.__proto__||Object.getPrototypeOf(CheckboxContainer)).call(this,props));_this.handleCheck=_this.handleCheck.bind(_this);return _this;}_createClass(CheckboxContainer,[{key:"handleCheck",value:function handleCheck(identity,checked){//method that passes up which radio button has been clicked
this.props.onCheck("value",checked);}},{key:"render",value:function render(){var _this2=this;var virtues=this.props.virtues;var theValues=virtues.map(function(virtues){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:virtues.ID,className:"mv3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"radio",name:"virtues",value:virtues.virtue,onClick:function onClick(e){return _this2.handleCheck(e.target.id,e.target.value);},id:virtues.ID}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:virtues.ID},virtues.virtue));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,theValues);}}]);return CheckboxContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CheckboxContainer);

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(92)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)))

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_cache__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emotion_serialize__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_utils__ = __webpack_require__(102);




function insertWithoutScoping(cache, serialized) {
  if (cache.inserted[serialized.name] === undefined) {
    return cache.insert('', serialized, cache.sheet, true);
  }
}

function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = Object(__WEBPACK_IMPORTED_MODULE_2__emotion_utils__["a" /* getRegisteredStyles */])(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var createEmotion = function createEmotion(options) {
  var cache = Object(__WEBPACK_IMPORTED_MODULE_0__emotion_cache__["a" /* default */])(options); // $FlowFixMe

  cache.sheet.speedy = function (value) {
    if (false) {
      throw new Error('speedy must be changed before any rules are inserted');
    }

    this.isSpeedy = value;
  };

  cache.compat = true;

  var css = function css() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var serialized = Object(__WEBPACK_IMPORTED_MODULE_1__emotion_serialize__["a" /* serializeStyles */])(args, cache.registered, this !== undefined ? this.mergedProps : undefined);
    Object(__WEBPACK_IMPORTED_MODULE_2__emotion_utils__["b" /* insertStyles */])(cache, serialized, false);
    return cache.key + "-" + serialized.name;
  };

  var keyframes = function keyframes() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var serialized = Object(__WEBPACK_IMPORTED_MODULE_1__emotion_serialize__["a" /* serializeStyles */])(args, cache.registered);
    var animation = "animation-" + serialized.name;
    insertWithoutScoping(cache, {
      name: serialized.name,
      styles: "@keyframes " + animation + "{" + serialized.styles + "}"
    });
    return animation;
  };

  var injectGlobal = function injectGlobal() {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    var serialized = Object(__WEBPACK_IMPORTED_MODULE_1__emotion_serialize__["a" /* serializeStyles */])(args, cache.registered);
    insertWithoutScoping(cache, serialized);
  };

  var cx = function cx() {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return merge(cache.registered, css, classnames(args));
  };

  return {
    css: css,
    cx: cx,
    injectGlobal: injectGlobal,
    keyframes: keyframes,
    hydrate: function hydrate(ids) {
      ids.forEach(function (key) {
        cache.inserted[key] = true;
      });
    },
    flush: function flush() {
      cache.registered = {};
      cache.inserted = {};
      cache.sheet.flush();
    },
    // $FlowFixMe
    sheet: cache.sheet,
    cache: cache,
    getRegisteredStyles: __WEBPACK_IMPORTED_MODULE_2__emotion_utils__["a" /* getRegisteredStyles */].bind(null, cache.registered),
    merge: merge.bind(null, cache.registered, css)
  };
};

var classnames = function classnames(args) {
  var cls = '';

  for (var i = 0; i < args.length; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

/* harmony default export */ __webpack_exports__["a"] = (createEmotion);


/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_sheet__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emotion_stylis__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_weak_memoize__ = __webpack_require__(97);




// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
// inlined to avoid umd wrapper and peerDep warnings/installing stylis
// since we use stylis after closure compiler
var delimiter = '/*|*/';
var needle = delimiter + '}';

function toSheet(block) {
  if (block) {
    Sheet.current.insert(block + '}');
  }
}

var Sheet = {
  current: null
};
var ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
  switch (context) {
    // property
    case 1:
      {
        switch (content.charCodeAt(0)) {
          case 64:
            {
              // @import
              Sheet.current.insert(content + ';');
              return '';
            }
          // charcode for l

          case 108:
            {
              // charcode for b
              // this ignores label
              if (content.charCodeAt(2) === 98) {
                return '';
              }
            }
        }

        break;
      }
    // selector

    case 2:
      {
        if (ns === 0) return content + delimiter;
        break;
      }
    // at-rule

    case 3:
      {
        switch (ns) {
          // @font-face, @page
          case 102:
          case 112:
            {
              Sheet.current.insert(selectors[0] + content);
              return '';
            }

          default:
            {
              return content + (at === 0 ? delimiter : '');
            }
        }
      }

    case -2:
      {
        content.split(needle).forEach(toSheet);
      }
  }
};

var createCache = function createCache(options) {
  if (options === undefined) options = {};
  var key = options.key || 'css';
  var stylisOptions;

  if (options.prefix !== undefined) {
    stylisOptions = {
      prefix: options.prefix
    };
  }

  var stylis = new __WEBPACK_IMPORTED_MODULE_1__emotion_stylis__["a" /* default */](stylisOptions);

  if (false) {
    // $FlowFixMe
    if (/[^a-z-]/.test(key)) {
      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
    }
  }

  var inserted = {}; // $FlowFixMe

  var container;

  {
    container = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
    Array.prototype.forEach.call(nodes, function (node) {
      var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe

      attrib.split(' ').forEach(function (id) {
        inserted[id] = true;
      });

      if (node.parentNode !== container) {
        container.appendChild(node);
      }
    });
  }

  var _insert;

  {
    stylis.use(options.stylisPlugins)(ruleSheet);

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      Sheet.current = sheet;

      if (false) {
        var map = serialized.map;
        Sheet.current = {
          insert: function insert(rule) {
            sheet.insert(rule + map);
          }
        };
      }

      stylis(selector, serialized.styles);

      if (shouldCache) {
        cache.inserted[name] = true;
      }
    };
  }

  if (false) {
    // https://esbench.com/bench/5bf7371a4cd7e6009ef61d0a
    var commentStart = /\/\*/g;
    var commentEnd = /\*\//g;
    stylis.use(function (context, content) {
      switch (context) {
        case -1:
          {
            while (commentStart.test(content)) {
              commentEnd.lastIndex = commentStart.lastIndex;

              if (commentEnd.test(content)) {
                commentStart.lastIndex = commentEnd.lastIndex;
                continue;
              }

              throw new Error('Your styles have an unterminated comment ("/*" without corresponding "*/").');
            }

            commentStart.lastIndex = 0;
            break;
          }
      }
    });
    stylis.use(function (context, content, selectors) {
      switch (context) {
        case 2:
          {
            for (var i = 0, len = selectors.length; len > i; i++) {
              // :last-child isn't included here since it's safe
              // because a style element will never be the last element
              var match = selectors[i].match(/:(first|nth|nth-last)-child/);

              if (match !== null) {
                console.error("The pseudo class \"" + match[0] + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + match[1] + "-of-type\"");
              }
            }

            break;
          }
      }
    });
  }

  var cache = {
    key: key,
    sheet: new __WEBPACK_IMPORTED_MODULE_0__emotion_sheet__["a" /* StyleSheet */]({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  return cache;
};

/* harmony default export */ __webpack_exports__["a"] = (createCache);


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyleSheet; });
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  return tag;
}

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(options) {
    this.isSpeedy = options.speedy === undefined ? "production" === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      var _tag = createStyleElement(this);

      var before;

      if (this.tags.length === 0) {
        before = this.before;
      } else {
        before = this.tags[this.tags.length - 1].nextSibling;
      }

      this.container.insertBefore(_tag, before);
      this.tags.push(_tag);
    }

    var tag = this.tags[this.tags.length - 1];

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is a really hot path
        // we check the second character first because having "i"
        // as the second character will happen less often than
        // having "@" as the first character
        var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools

        sheet.insertRule(rule, // we need to insert @import rules before anything else
        // otherwise there will be an error
        // technically this means that the @import rules will
        // _usually_(not always since there could be multiple style tags)
        // be the first ones in prod and generally later in dev
        // this shouldn't really matter in the real world though
        // @import is generally only used for font faces from google fonts and etc.
        // so while this could be technically correct then it would be slower and larger
        // for a tiny bit of correctness that won't matter in the real world
        isImportRule ? 0 : sheet.cssRules.length);
      } catch (e) {
        if (false) {
          console.warn("There was a problem inserting the following rule: \"" + rule + "\"", e);
        }
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };

  return StyleSheet;
}();




/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e, m).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e, m).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

/* harmony default export */ __webpack_exports__["a"] = (stylis_min);


/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var weakMemoize = function weakMemoize(func) {
  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // $FlowFixMe
      return cache.get(arg);
    }

    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};

/* unused harmony default export */ var _unused_webpack_default_export = (weakMemoize);


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return serializeStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_hash__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emotion_unitless__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_memoize__ = __webpack_require__(101);




var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var processStyleName = Object(__WEBPACK_IMPORTED_MODULE_2__emotion_memoize__["a" /* default */])(function (styleName) {
  return styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  if (value == null || typeof value === 'boolean') {
    return '';
  }

  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          value = value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (__WEBPACK_IMPORTED_MODULE_1__emotion_unitless__["a" /* default */][key] !== 1 && key.charCodeAt(1) !== 45 && // custom properties
  typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (false) {
  var contentValuePattern = /(attr|calc|counters?|url)\(/;
  var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;
  var msPattern = /^-ms-/;
  var hyphenPattern = /-(.)/g;
  var hyphenatedCache = {};

  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }

    if (key.charCodeAt(1) !== 45 && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
      hyphenatedCache[key] = true;
      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, char) {
        return char.toUpperCase();
      }) + "?");
    }

    return oldProcessStyleValue(key, value);
  };
}

var shouldWarnAboutInterpolatingClassNameFromCss = true;

function handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (false) {
      throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
    }

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles;

          if (false) {
            styles += interpolation.map;
          }

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
        } else if (false) {
          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }
      }
    // eslint-disable-next-line no-fallthrough

    default:
      {
        if (registered == null) {
          return interpolation;
        }

        var cached = registered[interpolation];

        if (false) {
          console.error('Interpolating a className from css`` is not recommended and will cause problems with composition.\n' + 'Interpolating a className from css`` will be completely unsupported in a future major version of Emotion');
          shouldWarnAboutInterpolatingClassNameFromCss = false;
        }

        return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
      }
  }
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i], false);
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {
          throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
        }

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
          }
        } else {
          string += _key + "{" + handleInterpolation(mergedProps, registered, value, false) + "}";
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var sourceMapPattern;

if (false) {
  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//;
} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings, false);
  } else {
    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);

    if (stringMode) {
      styles += strings[i];
    }
  }

  var sourceMap;

  if (false) {
    styles = styles.replace(sourceMapPattern, function (match) {
      sourceMap = match;
      return '';
    });
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = Object(__WEBPACK_IMPORTED_MODULE_0__emotion_hash__["a" /* default */])(styles) + identifierName;

  if (false) {
    return {
      name: name,
      styles: styles,
      map: sourceMap,
      next: cursor
    };
  }

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};




/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable */
// murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function murmurhash2_32_gc(str) {
  var l = str.length,
      h = l ^ l,
      i = 0,
      k;

  while (l >= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    k ^= k >>> 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
    l -= 4;
    ++i;
  }

  switch (l) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  }

  h ^= h >>> 13;
  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  h ^= h >>> 15;
  return (h >>> 0).toString(36);
}

/* harmony default export */ __webpack_exports__["a"] = (murmurhash2_32_gc);


/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ __webpack_exports__["a"] = (unitlessKeys);


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (memoize);


/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getRegisteredStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return insertStyles; });
var isBrowser = "object" !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className]);
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }

  if (cache.inserted[serialized.name] === undefined) {
    var current = serialized;

    do {
      var maybeStyles = cache.insert("." + className, current, cache.sheet, true);

      current = current.next;
    } while (current !== undefined);
  }
};




/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sizerStyle = {
	position: 'absolute',
	top: 0,
	left: 0,
	visibility: 'hidden',
	height: 0,
	overflow: 'scroll',
	whiteSpace: 'pre'
};

var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];

var cleanInputProps = function cleanInputProps(inputProps) {
	INPUT_PROPS_BLACKLIST.forEach(function (field) {
		return delete inputProps[field];
	});
	return inputProps;
};

var copyStyles = function copyStyles(styles, node) {
	node.style.fontSize = styles.fontSize;
	node.style.fontFamily = styles.fontFamily;
	node.style.fontWeight = styles.fontWeight;
	node.style.fontStyle = styles.fontStyle;
	node.style.letterSpacing = styles.letterSpacing;
	node.style.textTransform = styles.textTransform;
};

var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;

var generateId = function generateId() {
	// we only need an auto-generated ID for stylesheet injection, which is only
	// used for IE. so if the browser is not IE, this should return undefined.
	return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
};

var AutosizeInput = function (_Component) {
	_inherits(AutosizeInput, _Component);

	function AutosizeInput(props) {
		_classCallCheck(this, AutosizeInput);

		var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));

		_this.inputRef = function (el) {
			_this.input = el;
			if (typeof _this.props.inputRef === 'function') {
				_this.props.inputRef(el);
			}
		};

		_this.placeHolderSizerRef = function (el) {
			_this.placeHolderSizer = el;
		};

		_this.sizerRef = function (el) {
			_this.sizer = el;
		};

		_this.state = {
			inputWidth: props.minWidth,
			inputId: props.id || generateId()
		};
		return _this;
	}

	_createClass(AutosizeInput, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.mounted = true;
			this.copyInputStyles();
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			var id = nextProps.id;

			if (id !== this.props.id) {
				this.setState({ inputId: id || generateId() });
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			if (prevState.inputWidth !== this.state.inputWidth) {
				if (typeof this.props.onAutosize === 'function') {
					this.props.onAutosize(this.state.inputWidth);
				}
			}
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.mounted = false;
		}
	}, {
		key: 'copyInputStyles',
		value: function copyInputStyles() {
			if (!this.mounted || !window.getComputedStyle) {
				return;
			}
			var inputStyles = this.input && window.getComputedStyle(this.input);
			if (!inputStyles) {
				return;
			}
			copyStyles(inputStyles, this.sizer);
			if (this.placeHolderSizer) {
				copyStyles(inputStyles, this.placeHolderSizer);
			}
		}
	}, {
		key: 'updateInputWidth',
		value: function updateInputWidth() {
			if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
				return;
			}
			var newInputWidth = void 0;
			if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
				newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
			} else {
				newInputWidth = this.sizer.scrollWidth + 2;
			}
			// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
			var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
			newInputWidth += extraWidth;
			if (newInputWidth < this.props.minWidth) {
				newInputWidth = this.props.minWidth;
			}
			if (newInputWidth !== this.state.inputWidth) {
				this.setState({
					inputWidth: newInputWidth
				});
			}
		}
	}, {
		key: 'getInput',
		value: function getInput() {
			return this.input;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.input.focus();
		}
	}, {
		key: 'blur',
		value: function blur() {
			this.input.blur();
		}
	}, {
		key: 'select',
		value: function select() {
			this.input.select();
		}
	}, {
		key: 'renderStyles',
		value: function renderStyles() {
			// this method injects styles to hide IE's clear indicator, which messes
			// with input size detection. the stylesheet is only injected when the
			// browser is IE, and can also be disabled by the `injectStyles` prop.
			var injectStyles = this.props.injectStyles;

			return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
					__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
				} }) : null;
		}
	}, {
		key: 'render',
		value: function render() {
			var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
				if (previousValue !== null && previousValue !== undefined) {
					return previousValue;
				}
				return currentValue;
			});

			var wrapperStyle = _extends({}, this.props.style);
			if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';

			var inputStyle = _extends({
				boxSizing: 'content-box',
				width: this.state.inputWidth + 'px'
			}, this.props.inputStyle);

			var inputProps = _objectWithoutProperties(this.props, []);

			cleanInputProps(inputProps);
			inputProps.className = this.props.inputClassName;
			inputProps.id = this.state.inputId;
			inputProps.style = inputStyle;

			return _react2.default.createElement(
				'div',
				{ className: this.props.className, style: wrapperStyle },
				this.renderStyles(),
				_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
				_react2.default.createElement(
					'div',
					{ ref: this.sizerRef, style: sizerStyle },
					sizerValue
				),
				this.props.placeholder ? _react2.default.createElement(
					'div',
					{ ref: this.placeHolderSizerRef, style: sizerStyle },
					this.props.placeholder
				) : null
			);
		}
	}]);

	return AutosizeInput;
}(_react.Component);

AutosizeInput.propTypes = {
	className: _propTypes2.default.string, // className for the outer element
	defaultValue: _propTypes2.default.any, // default field value
	extraWidth: _propTypes2.default.oneOfType([// additional width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
	injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
	inputClassName: _propTypes2.default.string, // className for the input element
	inputRef: _propTypes2.default.func, // ref callback for the input element
	inputStyle: _propTypes2.default.object, // css styles for the input element
	minWidth: _propTypes2.default.oneOfType([// minimum width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
	onChange: _propTypes2.default.func, // onChange handler: function(event) {}
	placeholder: _propTypes2.default.string, // placeholder text
	placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
	style: _propTypes2.default.object, // css styles for the outer element
	value: _propTypes2.default.any // field value
};
AutosizeInput.defaultProps = {
	minWidth: 1,
	injectStyles: true
};

exports.default = AutosizeInput;

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var simpleIsEqual = function simpleIsEqual(a, b) {
  return a === b;
};

function index (resultFn, isEqual) {
  if (isEqual === void 0) {
    isEqual = simpleIsEqual;
  }

  var lastThis;
  var lastArgs = [];
  var lastResult;
  var calledOnce = false;

  var isNewArgEqualToLast = function isNewArgEqualToLast(newArg, index) {
    return isEqual(newArg, lastArgs[index], index);
  };

  var result = function result() {
    for (var _len = arguments.length, newArgs = new Array(_len), _key = 0; _key < _len; _key++) {
      newArgs[_key] = arguments[_key];
    }

    if (calledOnce && lastThis === this && newArgs.length === lastArgs.length && newArgs.every(isNewArgEqualToLast)) {
      return lastResult;
    }

    lastResult = resultFn.apply(this, newArgs);
    calledOnce = true;
    lastThis = this;
    lastArgs = newArgs;
    return lastResult;
  };

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (index);


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _CSSTransition = _interopRequireDefault(__webpack_require__(106));

var _ReplaceTransition = _interopRequireDefault(__webpack_require__(111));

var _TransitionGroup = _interopRequireDefault(__webpack_require__(37));

var _Transition = _interopRequireDefault(__webpack_require__(35));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  Transition: _Transition.default,
  TransitionGroup: _TransitionGroup.default,
  ReplaceTransition: _ReplaceTransition.default,
  CSSTransition: _CSSTransition.default
};

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(7));

var _addClass = _interopRequireDefault(__webpack_require__(107));

var _removeClass = _interopRequireDefault(__webpack_require__(110));

var _react = _interopRequireDefault(__webpack_require__(0));

var _Transition = _interopRequireDefault(__webpack_require__(35));

var _PropTypes = __webpack_require__(36);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _addClass.default)(node, c);
  });
};

var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _removeClass.default)(node, c);
  });
};
/**
 * A `Transition` component using CSS transitions and animations.
 * It's inspired by the excellent [ng-animate](http://www.nganimate.org/) library.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` stages of the transition. The first class is applied and then a
 * second "active" class in order to activate the css animation. After the animation,
 * matching `done` class names are applied to persist the animation state.
 *
 * When the `in` prop is toggled to `true` the Component will get
 * the `example-enter` CSS class and the `example-enter-active` CSS class
 * added in the next tick. This is a convention based on the `classNames` prop.
 */


var CSSTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.onEnter = function (node, appearing) {
      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
          className = _this$getClassNames.className;

      _this.removeClasses(node, 'exit');

      addClass(node, className);

      if (_this.props.onEnter) {
        _this.props.onEnter(node, appearing);
      }
    };

    _this.onEntering = function (node, appearing) {
      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
          activeClassName = _this$getClassNames2.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onEntering) {
        _this.props.onEntering(node, appearing);
      }
    };

    _this.onEntered = function (node, appearing) {
      var _this$getClassNames3 = _this.getClassNames('enter'),
          doneClassName = _this$getClassNames3.doneClassName;

      _this.removeClasses(node, appearing ? 'appear' : 'enter');

      addClass(node, doneClassName);

      if (_this.props.onEntered) {
        _this.props.onEntered(node, appearing);
      }
    };

    _this.onExit = function (node) {
      var _this$getClassNames4 = _this.getClassNames('exit'),
          className = _this$getClassNames4.className;

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      addClass(node, className);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    _this.onExiting = function (node) {
      var _this$getClassNames5 = _this.getClassNames('exit'),
          activeClassName = _this$getClassNames5.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    };

    _this.onExited = function (node) {
      var _this$getClassNames6 = _this.getClassNames('exit'),
          doneClassName = _this$getClassNames6.doneClassName;

      _this.removeClasses(node, 'exit');

      addClass(node, doneClassName);

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var className = typeof classNames !== 'string' ? classNames[type] : classNames + '-' + type;
      var activeClassName = typeof classNames !== 'string' ? classNames[type + 'Active'] : className + '-active';
      var doneClassName = typeof classNames !== 'string' ? classNames[type + 'Done'] : className + '-done';
      return {
        className: className,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$getClassNames7 = this.getClassNames(type),
        className = _this$getClassNames7.className,
        activeClassName = _this$getClassNames7.activeClassName,
        doneClassName = _this$getClassNames7.doneClassName;

    className && removeClass(node, className);
    activeClassName && removeClass(node, activeClassName);
    doneClassName && removeClass(node, doneClassName);
  };

  _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
    // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.
    if (className) {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
      /* eslint-enable no-unused-expressions */

      addClass(node, className);
    }
  };

  _proto.render = function render() {
    var props = _extends({}, this.props);

    delete props.classNames;
    return _react.default.createElement(_Transition.default, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(_react.default.Component);

CSSTransition.propTypes =  false ? _extends({}, _Transition.default.propTypes, {
  /**
   * The animation classNames applied to the component as it enters, exits or has finished the transition.
   * A single name can be provided and it will be suffixed for each stage: e.g.
   *
   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`, `fade-enter-done`,
   * `fade-exit`, `fade-exit-active`, `fade-exit-done`, `fade-appear`, and `fade-appear-active`.
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply spread
   * them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: _PropTypes.classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
}) : {};
var _default = CSSTransition;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(108);

exports.__esModule = true;
exports.default = addClass;

var _hasClass = _interopRequireDefault(__webpack_require__(109));

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}

module.exports = exports["default"];

/***/ }),
/* 108 */
/***/ (function(module, exports) {

function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hasClass;

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

module.exports = exports["default"];

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = __webpack_require__(13);

var _TransitionGroup = _interopRequireDefault(__webpack_require__(37));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */
var ReplaceTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ReplaceTransition, _React$Component);

  function ReplaceTransition() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;

    _this.handleEnter = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _this.handleLifecycle('onEnter', 0, args);
    };

    _this.handleEntering = function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return _this.handleLifecycle('onEntering', 0, args);
    };

    _this.handleEntered = function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return _this.handleLifecycle('onEntered', 0, args);
    };

    _this.handleExit = function () {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return _this.handleLifecycle('onExit', 1, args);
    };

    _this.handleExiting = function () {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      return _this.handleLifecycle('onExiting', 1, args);
    };

    _this.handleExited = function () {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      return _this.handleLifecycle('onExited', 1, args);
    };

    return _this;
  }

  var _proto = ReplaceTransition.prototype;

  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;

    var children = this.props.children;

    var child = _react.default.Children.toArray(children)[idx];

    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
    if (this.props[handler]) this.props[handler]((0, _reactDom.findDOMNode)(this));
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        inProp = _this$props.in,
        props = _objectWithoutPropertiesLoose(_this$props, ["children", "in"]);

    var _React$Children$toArr = _react.default.Children.toArray(children),
        first = _React$Children$toArr[0],
        second = _React$Children$toArr[1];

    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;
    return _react.default.createElement(_TransitionGroup.default, props, inProp ? _react.default.cloneElement(first, {
      key: 'first',
      onEnter: this.handleEnter,
      onEntering: this.handleEntering,
      onEntered: this.handleEntered
    }) : _react.default.cloneElement(second, {
      key: 'second',
      onEnter: this.handleExit,
      onEntering: this.handleExiting,
      onEntered: this.handleExited
    }));
  };

  return ReplaceTransition;
}(_react.default.Component);

ReplaceTransition.propTypes =  false ? {
  in: _propTypes.default.bool.isRequired,
  children: function children(props, propName) {
    if (_react.default.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
    return null;
  }
} : {};
var _default = ReplaceTransition;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;
exports.getInitialChildMapping = getInitialChildMapping;
exports.getNextChildMapping = getNextChildMapping;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) _react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */


function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return (0, _react.cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}

function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!(0, _react.isValidElement)(child)) return;
    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;
    var prevChild = prevChildMapping[key];
    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = (0, _react.cloneElement)(child, {
        in: false
      });
    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bodyOpenClassName = exports.portalClassName = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(13);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ModalPortal = __webpack_require__(114);

var _ModalPortal2 = _interopRequireDefault(_ModalPortal);

var _ariaAppHider = __webpack_require__(39);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _safeHTMLElement = __webpack_require__(20);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _reactLifecyclesCompat = __webpack_require__(19);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var portalClassName = exports.portalClassName = "ReactModalPortal";
var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";

var isReact16 = _reactDom2.default.createPortal !== undefined;

var getCreatePortal = function getCreatePortal() {
  return isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
};

function getParentElement(parentSelector) {
  return parentSelector();
}

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
      var parent = getParentElement(_this.props.parentSelector);
      parent.removeChild(_this.node);
    }, _this.portalRef = function (ref) {
      _this.portal = ref;
    }, _this.renderPortal = function (props) {
      var createPortal = getCreatePortal();
      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
      _this.portalRef(portal);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_safeHTMLElement.canUseDOM) return;

      if (!isReact16) {
        this.node = document.createElement("div");
      }
      this.node.className = this.props.portalClassName;

      var parent = getParentElement(this.props.parentSelector);
      parent.appendChild(this.node);

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      var prevParent = getParentElement(prevProps.parentSelector);
      var nextParent = getParentElement(this.props.parentSelector);
      return { prevParent: prevParent, nextParent: nextParent };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, _, snapshot) {
      if (!_safeHTMLElement.canUseDOM) return;
      var _props = this.props,
          isOpen = _props.isOpen,
          portalClassName = _props.portalClassName;


      if (prevProps.portalClassName !== portalClassName) {
        this.node.className = portalClassName;
      }

      var prevParent = snapshot.prevParent,
          nextParent = snapshot.nextParent;

      if (nextParent !== prevParent) {
        prevParent.removeChild(this.node);
        nextParent.appendChild(this.node);
      }

      // Stop unnecessary renders if modal is remaining closed
      if (!prevProps.isOpen && !isOpen) return;

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;

      var state = this.portal.state;
      var now = Date.now();
      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);

      if (closesAt) {
        if (!state.beforeClose) {
          this.portal.closeWithTimeout();
        }

        setTimeout(this.removePortal, closesAt - now);
      } else {
        this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!_safeHTMLElement.canUseDOM || !isReact16) {
        return null;
      }

      if (!this.node && isReact16) {
        this.node = document.createElement("div");
      }

      var createPortal = getCreatePortal();
      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
        ref: this.portalRef,
        defaultStyles: Modal.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function setAppElement(element) {
      ariaAppHider.setElement(element);
    }

    /* eslint-disable react/no-unused-prop-types */

    /* eslint-enable react/no-unused-prop-types */

  }]);

  return Modal;
}(_react.Component);

Modal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  portalClassName: _propTypes2.default.string,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  ariaHideApp: _propTypes2.default.bool,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  parentSelector: _propTypes2.default.func,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func
};
Modal.defaultProps = {
  isOpen: false,
  portalClassName: portalClassName,
  bodyOpenClassName: bodyOpenClassName,
  role: "dialog",
  ariaHideApp: true,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: true,
  shouldCloseOnEsc: true,
  shouldCloseOnOverlayClick: true,
  shouldReturnFocusAfterClose: true,
  parentSelector: function parentSelector() {
    return document.body;
  }
};
Modal.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};


(0, _reactLifecyclesCompat.polyfill)(Modal);

exports.default = Modal;

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _focusManager = __webpack_require__(115);

var focusManager = _interopRequireWildcard(_focusManager);

var _scopeTab = __webpack_require__(116);

var _scopeTab2 = _interopRequireDefault(_scopeTab);

var _ariaAppHider = __webpack_require__(39);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _classList = __webpack_require__(119);

var classList = _interopRequireWildcard(_classList);

var _safeHTMLElement = __webpack_require__(20);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// so that our CSS is statically analyzable
var CLASS_NAMES = {
  overlay: "ReactModal__Overlay",
  content: "ReactModal__Content"
};

var TAB_KEY = 9;
var ESC_KEY = 27;

var ariaHiddenInstances = 0;

var ModalPortal = function (_Component) {
  _inherits(ModalPortal, _Component);

  function ModalPortal(props) {
    _classCallCheck(this, ModalPortal);

    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));

    _this.setOverlayRef = function (overlay) {
      _this.overlay = overlay;
      _this.props.overlayRef && _this.props.overlayRef(overlay);
    };

    _this.setContentRef = function (content) {
      _this.content = content;
      _this.props.contentRef && _this.props.contentRef(content);
    };

    _this.afterClose = function () {
      var _this$props = _this.props,
          appElement = _this$props.appElement,
          ariaHideApp = _this$props.ariaHideApp,
          htmlOpenClassName = _this$props.htmlOpenClassName,
          bodyOpenClassName = _this$props.bodyOpenClassName;

      // Remove classes.

      bodyOpenClassName && classList.remove(document.body, bodyOpenClassName);

      htmlOpenClassName && classList.remove(document.getElementsByTagName("html")[0], htmlOpenClassName);

      // Reset aria-hidden attribute if all modals have been removed
      if (ariaHideApp && ariaHiddenInstances > 0) {
        ariaHiddenInstances -= 1;

        if (ariaHiddenInstances === 0) {
          ariaAppHider.show(appElement);
        }
      }

      if (_this.props.shouldFocusAfterRender) {
        if (_this.props.shouldReturnFocusAfterClose) {
          focusManager.returnFocus();
          focusManager.teardownScopedFocus();
        } else {
          focusManager.popWithoutFocus();
        }
      }

      if (_this.props.onAfterClose) {
        _this.props.onAfterClose();
      }
    };

    _this.open = function () {
      _this.beforeOpen();
      if (_this.state.afterOpen && _this.state.beforeClose) {
        clearTimeout(_this.closeTimer);
        _this.setState({ beforeClose: false });
      } else {
        if (_this.props.shouldFocusAfterRender) {
          focusManager.setupScopedFocus(_this.node);
          focusManager.markForFocusLater();
        }

        _this.setState({ isOpen: true }, function () {
          _this.setState({ afterOpen: true });

          if (_this.props.isOpen && _this.props.onAfterOpen) {
            _this.props.onAfterOpen();
          }
        });
      }
    };

    _this.close = function () {
      if (_this.props.closeTimeoutMS > 0) {
        _this.closeWithTimeout();
      } else {
        _this.closeWithoutTimeout();
      }
    };

    _this.focusContent = function () {
      return _this.content && !_this.contentHasFocus() && _this.content.focus();
    };

    _this.closeWithTimeout = function () {
      var closesAt = Date.now() + _this.props.closeTimeoutMS;
      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
      });
    };

    _this.closeWithoutTimeout = function () {
      _this.setState({
        beforeClose: false,
        isOpen: false,
        afterOpen: false,
        closesAt: null
      }, _this.afterClose);
    };

    _this.handleKeyDown = function (event) {
      if (event.keyCode === TAB_KEY) {
        (0, _scopeTab2.default)(_this.content, event);
      }

      if (_this.props.shouldCloseOnEsc && event.keyCode === ESC_KEY) {
        event.stopPropagation();
        _this.requestClose(event);
      }
    };

    _this.handleOverlayOnClick = function (event) {
      if (_this.shouldClose === null) {
        _this.shouldClose = true;
      }

      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
        if (_this.ownerHandlesClose()) {
          _this.requestClose(event);
        } else {
          _this.focusContent();
        }
      }
      _this.shouldClose = null;
    };

    _this.handleContentOnMouseUp = function () {
      _this.shouldClose = false;
    };

    _this.handleOverlayOnMouseDown = function (event) {
      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
        event.preventDefault();
      }
    };

    _this.handleContentOnClick = function () {
      _this.shouldClose = false;
    };

    _this.handleContentOnMouseDown = function () {
      _this.shouldClose = false;
    };

    _this.requestClose = function (event) {
      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
    };

    _this.ownerHandlesClose = function () {
      return _this.props.onRequestClose;
    };

    _this.shouldBeClosed = function () {
      return !_this.state.isOpen && !_this.state.beforeClose;
    };

    _this.contentHasFocus = function () {
      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
    };

    _this.buildClassName = function (which, additional) {
      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
        base: CLASS_NAMES[which],
        afterOpen: CLASS_NAMES[which] + "--after-open",
        beforeClose: CLASS_NAMES[which] + "--before-close"
      };
      var className = classNames.base;
      if (_this.state.afterOpen) {
        className = className + " " + classNames.afterOpen;
      }
      if (_this.state.beforeClose) {
        className = className + " " + classNames.beforeClose;
      }
      return typeof additional === "string" && additional ? className + " " + additional : className;
    };

    _this.attributesFromObject = function (prefix, items) {
      return Object.keys(items).reduce(function (acc, name) {
        acc[prefix + "-" + name] = items[name];
        return acc;
      }, {});
    };

    _this.state = {
      afterOpen: false,
      beforeClose: false
    };

    _this.shouldClose = null;
    _this.moveFromContentToOverlay = null;
    return _this;
  }

  _createClass(ModalPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isOpen) {
        this.open();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (false) {
        if (prevProps.bodyOpenClassName !== this.props.bodyOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "bodyOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
        if (prevProps.htmlOpenClassName !== this.props.htmlOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "htmlOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
      }

      if (this.props.isOpen && !prevProps.isOpen) {
        this.open();
      } else if (!this.props.isOpen && prevProps.isOpen) {
        this.close();
      }

      // Focus only needs to be set once when the modal is being opened
      if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
        this.focusContent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.afterClose();
      clearTimeout(this.closeTimer);
    }
  }, {
    key: "beforeOpen",
    value: function beforeOpen() {
      var _props = this.props,
          appElement = _props.appElement,
          ariaHideApp = _props.ariaHideApp,
          htmlOpenClassName = _props.htmlOpenClassName,
          bodyOpenClassName = _props.bodyOpenClassName;

      // Add classes.

      bodyOpenClassName && classList.add(document.body, bodyOpenClassName);

      htmlOpenClassName && classList.add(document.getElementsByTagName("html")[0], htmlOpenClassName);

      if (ariaHideApp) {
        ariaHiddenInstances += 1;
        ariaAppHider.hide(appElement);
      }
    }

    // Don't steal focus from inner elements

  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          className = _props2.className,
          overlayClassName = _props2.overlayClassName,
          defaultStyles = _props2.defaultStyles;

      var contentStyles = className ? {} : defaultStyles.content;
      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;

      return this.shouldBeClosed() ? null : _react2.default.createElement(
        "div",
        {
          ref: this.setOverlayRef,
          className: this.buildClassName("overlay", overlayClassName),
          style: _extends({}, overlayStyles, this.props.style.overlay),
          onClick: this.handleOverlayOnClick,
          onMouseDown: this.handleOverlayOnMouseDown
        },
        _react2.default.createElement(
          "div",
          _extends({
            ref: this.setContentRef,
            style: _extends({}, contentStyles, this.props.style.content),
            className: this.buildClassName("content", className),
            tabIndex: "-1",
            onKeyDown: this.handleKeyDown,
            onMouseDown: this.handleContentOnMouseDown,
            onMouseUp: this.handleContentOnMouseUp,
            onClick: this.handleContentOnClick,
            role: this.props.role,
            "aria-label": this.props.contentLabel
          }, this.attributesFromObject("aria", this.props.aria || {}), this.attributesFromObject("data", this.props.data || {}), {
            "data-testid": this.props.testId
          }),
          this.props.children
        )
      );
    }
  }]);

  return ModalPortal;
}(_react.Component);

ModalPortal.defaultProps = {
  style: {
    overlay: {},
    content: {}
  },
  defaultStyles: {}
};
ModalPortal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  defaultStyles: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  ariaHideApp: _propTypes2.default.bool,
  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes2.default.func,
  onAfterClose: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  children: _propTypes2.default.node,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  testId: _propTypes2.default.string
};
exports.default = ModalPortal;
module.exports = exports["default"];

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleBlur = handleBlur;
exports.handleFocus = handleFocus;
exports.markForFocusLater = markForFocusLater;
exports.returnFocus = returnFocus;
exports.popWithoutFocus = popWithoutFocus;
exports.setupScopedFocus = setupScopedFocus;
exports.teardownScopedFocus = teardownScopedFocus;

var _tabbable = __webpack_require__(38);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;

function handleBlur() {
  needToFocus = true;
}

function handleFocus() {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation
    // is that the document.body gets focus, and then we focus our element right
    // after, seems fine.
    setTimeout(function () {
      if (modalElement.contains(document.activeElement)) {
        return;
      }
      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
      el.focus();
    }, 0);
  }
}

function markForFocusLater() {
  focusLaterElements.push(document.activeElement);
}

/* eslint-disable no-console */
function returnFocus() {
  var toFocus = null;
  try {
    if (focusLaterElements.length !== 0) {
      toFocus = focusLaterElements.pop();
      toFocus.focus();
    }
    return;
  } catch (e) {
    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
  }
}
/* eslint-enable no-console */

function popWithoutFocus() {
  focusLaterElements.length > 0 && focusLaterElements.pop();
}

function setupScopedFocus(element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener("blur", handleBlur, false);
    document.addEventListener("focus", handleFocus, true);
  } else {
    window.attachEvent("onBlur", handleBlur);
    document.attachEvent("onFocus", handleFocus);
  }
}

function teardownScopedFocus() {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener("blur", handleBlur);
    document.removeEventListener("focus", handleFocus);
  } else {
    window.detachEvent("onBlur", handleBlur);
    document.detachEvent("onFocus", handleFocus);
  }
}

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scopeTab;

var _tabbable = __webpack_require__(38);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scopeTab(node, event) {
  var tabbable = (0, _tabbable2.default)(node);

  if (!tabbable.length) {
    // Do nothing, since there are no elements that can receive focus.
    event.preventDefault();
    return;
  }

  var shiftKey = event.shiftKey;
  var head = tabbable[0];
  var tail = tabbable[tabbable.length - 1];

  // proceed with default browser behavior on tab.
  // Focus on last element on shift + tab.
  if (node === document.activeElement) {
    if (!shiftKey) return;
    target = tail;
  }

  var target;
  if (tail === document.activeElement && !shiftKey) {
    target = head;
  }

  if (head === document.activeElement && shiftKey) {
    target = tail;
  }

  if (target) {
    event.preventDefault();
    target.focus();
    return;
  }

  // Safari radio issue.
  //
  // Safari does not move the focus to the radio button,
  // so we need to force it to really walk through all elements.
  //
  // This is very error prone, since we are trying to guess
  // if it is a safari browser from the first occurence between
  // chrome or safari.
  //
  // The chrome user agent contains the first ocurrence
  // as the 'chrome/version' and later the 'safari/version'.
  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;

  // If we are not in safari desktop, let the browser control
  // the focus
  if (!isSafariDesktop) return;

  var x = tabbable.indexOf(document.activeElement);

  if (x > -1) {
    x += shiftKey ? -1 : 1;
  }

  // If the tabbable element does not exist,
  // focus head/tail based on shiftKey
  if (typeof tabbable[x] === "undefined") {
    event.preventDefault();
    target = shiftKey ? tail : head;
    target.focus();
    return;
  }

  event.preventDefault();

  tabbable[x].focus();
}
module.exports = exports["default"];

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return ExecutionEnvironment;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dumpClassLists = dumpClassLists;
var htmlClassList = {};
var docBodyClassList = {};

function dumpClassLists() {
  if (false) {
    var classes = document.getElementsByTagName("html")[0].className;
    var buffer = "Show tracked classes:\n\n";

    buffer += "<html /> (" + classes + "):\n";
    for (var x in htmlClassList) {
      buffer += "  " + x + " " + htmlClassList[x] + "\n";
    }

    classes = document.body.className;

    // eslint-disable-next-line max-len
    buffer += "\n\ndoc.body (" + classes + "):\n";
    for (var _x in docBodyClassList) {
      buffer += "  " + _x + " " + docBodyClassList[_x] + "\n";
    }

    buffer += "\n";

    // eslint-disable-next-line no-console
    console.log(buffer);
  }
}

/**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var incrementReference = function incrementReference(poll, className) {
  if (!poll[className]) {
    poll[className] = 0;
  }
  poll[className] += 1;
  return className;
};

/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var decrementReference = function decrementReference(poll, className) {
  if (poll[className]) {
    poll[className] -= 1;
  }
  return className;
};

/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */
var trackClass = function trackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    incrementReference(poll, className);
    classListRef.add(className);
  });
};

/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */
var untrackClass = function untrackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    decrementReference(poll, className);
    poll[className] === 0 && classListRef.remove(className);
  });
};

/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var add = exports.add = function add(element, classString) {
  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var remove = exports.remove = function remove(element, classString) {
  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component_TableData_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__component_TableHead_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__routes_js__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ViewThankyous=function(_Component){_inherits(ViewThankyous,_Component);function ViewThankyous(props){_classCallCheck(this,ViewThankyous);var _this=_possibleConstructorReturn(this,(ViewThankyous.__proto__||Object.getPrototypeOf(ViewThankyous)).call(this,props));_this.state={info:[]};_this.getThankyous=_this.getThankyous.bind(_this);return _this;}_createClass(ViewThankyous,[{key:'getThankyous',value:function getThankyous(){var _this2=this;//method for retrieving thank yous from DB
var action=void 0;var name=void 0;var userID=void 0;if(this.props.view==="Sent"){//parameters if user wants to view sent thank yous
action="sent";name=null;userID=this.props.userInfo.userID;}else if(this.props.view==="Received"){//parameters if user wants to view received thank yous
action="received";name=this.props.userInfo.name;userID=null;}__WEBPACK_IMPORTED_MODULE_3_axios___default()({//retrieve thank yous
method:'post',url:__WEBPACK_IMPORTED_MODULE_4__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{"endpoint":"info","table":"thankyous","action":action,"userID":userID,"name":name}}).then(function(response){var data=response.data.data;_this2.setState({info:data});});}},{key:'componentDidMount',value:function componentDidMount(){this.getThankyous();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){//if the view changes or the user creates a thank you, retrieve updated information
if(prevProps.view!==this.props.view){this.getThankyous();}if(prevProps.submitted!==this.props.submitted){this.getThankyous();}}},{key:'render',value:function render(){var content=void 0;var objkeys=["From","Reason","Value","Date"];if(this.props.view==="Sent"){objkeys[0]="To";objkeys.push("Status");}var info=this.state.info;var colData=info.map(function(info,i){//each thankyou is mapped out as a table row
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_TableData_js__["a" /* default */],{key:i,columns:info,cellstyle:'ba b--light-silver tc pa2',rowstyle:'stripe-blue'});});if(this.props.active){if(this.state.info.length>0){content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{margin:'auto',boxShadow:'3px 3px 5px 3px #888888',maxHeight:'560px',overflowY:'auto',overflowX:'auto'},className:'br3 fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'fl w-100 collapse br3 bg-white overflow-x-hidden',style:{margin:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',{className:'collapse'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__component_TableHead_js__["a" /* default */],{columns:objkeys,headstyle:'pa2'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',{className:'br--bottom br3'},colData)));}else{if(this.props.view==="Sent"){content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 f3 tc',style:{margin:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'You have currently sent 0 thank yous this year.'));}else{content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 f3 tc',style:{margin:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'You have currently received 0 thank yous this year.'));}}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,content);}}]);return ViewThankyous;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ViewThankyous);

/***/ }),
/* 121 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Prize_js__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ShoppingCart_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_modal__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__asset_img_shoppingCart_png__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__asset_img_shoppingCart_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__asset_img_shoppingCart_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__component_Select_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__routes_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__asset_img_loader_gif__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__asset_img_loader_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__asset_img_loader_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//component that contains all information for each prize
//component that contains the shopping cart
//shopping cart image for shopping cart button
__WEBPACK_IMPORTED_MODULE_3_react_modal___default.a.setAppElement('#root');var PrizeShop=function(_Component){_inherits(PrizeShop,_Component);function PrizeShop(props){_classCallCheck(this,PrizeShop);var _this=_possibleConstructorReturn(this,(PrizeShop.__proto__||Object.getPrototypeOf(PrizeShop)).call(this,props));_this.state={info:[],modalIsOpen:false,enoughPoints:true,tier:'all',tiers:[],success:false,loading:false,modalPrompt:''};_this.addToCart=_this.addToCart.bind(_this);// this.cartTotal = this.cartTotal.bind(this);
_this.removeItem=_this.removeItem.bind(_this);_this.openModal=_this.openModal.bind(_this);_this.closeModal=_this.closeModal.bind(_this);_this.quantityChange=_this.quantityChange.bind(_this);_this.handleSelection=_this.handleSelection.bind(_this);_this.submitOrder=_this.submitOrder.bind(_this);return _this;}_createClass(PrizeShop,[{key:'handleSelection',value:function handleSelection(identity,value){//standard method for handing user input
var theState=this.state;theState[identity]=value;this.setState(theState);}},{key:'addToCart',value:function addToCart(item){//method for adding an item to the shopping cart
var theCart=[];var exists=false;for(var i=0;i<this.props.cart.length;i++){theCart[i]=this.props.cart[i];if(item.prize===this.props.cart[i].prize&&item.size===this.props.cart[i].size&&item.color===this.props.cart[i].color){//if line item already exists within the cart, update the quantity instead of adding a duplicate line
exists=true;theCart[i].quantity=Number(item.quantity)+Number(this.props.cart[i].quantity);theCart[i].total=Number(item.total)+Number(this.props.cart[i].total);// this.setState({cart:theCart},function(){
// 	this.cartTotal(item,"add");
// 	this.updateCart(this.state.cart);
// });
}}if(!exists){//add item to cart if it doesnt already exist
theCart.push(item);}this.props.updateCart(theCart,this.props.updateCartTotal(item,'add'));//update shopping cart with item to be added
// if(!exists){
// 	this.setState(oldState => ({cart:[...oldState.cart,item]}), function(){
// 		this.cartTotal(item,"add");
// 		this.updateCart(this.state.cart);
// 	});
// }
}// cartTotal(item,action){
// 	let total = this.state.total;
// 	if(action === "add"){
// 		total = Number(item.total) + Number(total);
// 	}else if(action ==="remove"){
// 		total = Number(total) - Number(item.total);
// 	}
// 	this.setState({total:total});
// }
},{key:'removeItem',value:function removeItem(index){//method for removing item from cart
var items=this.props.cart;// items.splice(index,1);
this.props.updateCart(items,this.props.updateCartTotal(items[index],"remove"));// this.setState({cart:items},function(){
// 	this.updateCart(items);
// });
}},{key:'quantityChange',value:function quantityChange(id,newQuant){//method for handling a change in the quantity of a line item in the shopping cart
if(Number(newQuant)>0){// const items = this.props.cart;
// let unitPrice = Number((items[id].total)/(items[id].quantity));
// items[id].quantity = Number(newQuant);
// items[id].total = Number(newQuant*unitPrice);
// let newTotal = 0;
// items.forEach((item)=>{
// 	newTotal = Number(item.total) + Number(newTotal);
// });
var items=this.props.cart;var newTotal=0;var newCart=[];items.forEach(function(item,i){//calculate the new total for each lineitem and the order as a whole when the quantity of a line item is changed
var itemTotal=Number(item.total);var itemQuant=Number(item.quantity);if(id==i){itemTotal=Number(newQuant)*Number(item.total/item.quantity);itemQuant=newQuant;}newCart.push(item);newCart[i].quantity=Number(itemQuant);newCart[i].total=Number(itemTotal);newTotal=Number(itemTotal)+Number(newTotal);});//this.props.updateCart(newCart,this.props.updateCartTotal(newCart[id],'add')); //update cart information
this.props.updateCart(newCart,this.props.handleInput('cartTotal',newTotal));// this.setState({cart:items,total:newTotal},function(){
// 	this.updateCart(items);
// });
}else{//remove item from cart if quantity is set to 0
this.removeItem(id);}}},{key:'componentDidMount',value:function componentDidMount(){var _this2=this;//when component mounts, retrieve all prize and prize variant information, as well as tier information from DB
var prizes=[];__WEBPACK_IMPORTED_MODULE_6_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_7__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'info',table:'prizes',kind:this.props.app,action:this.props.userInfo.userType}}).then(function(response){if(response.data.data.length>0){//make sure there is actual prize info before continuing
var j=0;var prizeInfo=response.data.data;prizes.push({prizeID:prizeInfo[0].prizeID,prize:prizeInfo[0].prize,tier:prizeInfo[0].tier,price:prizeInfo[0].price,picture:__WEBPACK_IMPORTED_MODULE_7__routes_js__["e" /* storeImagePath */]+prizeInfo[0].picture,description:prizeInfo[0].description,variants:[{variantID:prizeInfo[0].variantID,size:prizeInfo[0].size,color:prizeInfo[0].color,photo:prizeInfo[0].photo}]});for(var i=1;i<prizeInfo.length;i++){//consolidate prizes and their respective variants 
if(prizeInfo[i].prizeID===prizes[j].prizeID){prizes[j].variants.push({variantID:prizeInfo[i].variantID,size:prizeInfo[i].size,color:prizeInfo[i].color,photo:prizeInfo[i].photo});}else{prizes.push({prizeID:prizeInfo[i].prizeID,prize:prizeInfo[i].prize,tier:prizeInfo[i].tier,price:prizeInfo[i].price,picture:__WEBPACK_IMPORTED_MODULE_7__routes_js__["e" /* storeImagePath */]+prizeInfo[i].picture,description:prizeInfo[i].description,variants:[{variantID:prizeInfo[i].variantID,size:prizeInfo[i].size,color:prizeInfo[i].color,photo:prizeInfo[i].photo}]});j++;}}_this2.setState({info:prizes});}});var year=new Date().getFullYear();//get current year
__WEBPACK_IMPORTED_MODULE_6_axios___default()({//retrieve tier information for the current year
method:'post',url:__WEBPACK_IMPORTED_MODULE_7__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'info',table:'tiers',kind:this.props.app,year:year,action:'shop'}}).then(function(response){var data=response.data.data;var theTiers=data.map(function(tiers){return tiers.tier;});_this2.setState({tiers:theTiers});});// let sessiontotal = 0;
// this.props.cart.forEach((item)=>{
// 	sessiontotal += Number(item.total);
// });
// this.setState({cart:this.props.cart,total:sessiontotal});
}},{key:'openModal',value:function openModal(){//open the modal
this.setState({modalIsOpen:true});}},{key:'closeModal',value:function closeModal(){//close the modal
this.setState({modalIsOpen:false,success:false});}},{key:'submitOrder',value:function submitOrder(){var _this3=this;//method for submitting order of items currently in shopping cart
var order=this.props.cart;var info=this.state.info;var total=this.props.cartTotal;var userID=this.props.userInfo.userID;var lineitems=[];if(!(total>this.props.userInfo.redeemable)){//if the user has enough points, continue with order
this.setState({loading:true});__WEBPACK_IMPORTED_MODULE_6_axios___default()({//create an entry in the orders table that contains userID, total points, and date ordered
method:'post',url:__WEBPACK_IMPORTED_MODULE_7__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'create',table:'orders',misc:'create',firstID:userID,quantity:total,date:'required'}}).then(function(response){var data=response.data.data;var capMet=[];if(data.ID!==0){//if an entry was created in the orders table, data.ID will be the orderID
order.forEach(function(orderItem){var prizeID=void 0;var variantID=void 0;if(orderItem.size===""||orderItem.size==="N/A"){//prepare data 
orderItem.size=null;}if(orderItem.color==="N/A"){orderItem.color=null;}for(var i=0;i<info.length;i++){if(orderItem.prize===info[i].prize){prizeID=info[i].prizeID;info[i].variants.forEach(function(vari){//get the right variantID for each prize variant that is being ordered
if(orderItem.size===vari.size){//begin
if(orderItem.color!==null){console.log(orderItem.color.replace(" ","_"),vari.color);if(orderItem.color.replace(/ /g,"_")===vari.color||orderItem.color===vari.color){variantID=vari.variantID;}}else{if(orderItem.color===vari.color){variantID=vari.variantID;}}}//end
});}}lineitems.push(__WEBPACK_IMPORTED_MODULE_6_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_7__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'create',table:'items',firstID:data.ID,secondID:prizeID,thirdID:variantID,quantity:orderItem.quantity}}));});var prompt='';var ordertotal=_this3.props.cartTotal;__WEBPACK_IMPORTED_MODULE_6_axios___default.a.all(lineitems).then(function(response){//create line items in line items table
response.forEach(function(res){console.log(res);if(res.data.data.Message!=='success'){capMet.push(res.data.data.Message);}});if(capMet.length<1){_this3.props.redeemable("subtract",ordertotal);//update redeemable points for user
prompt='Your Order has been placed!';}else{//if the user has surpassed the cap on how many of a certain item can be ordered (i.e. only one $75 gift card per year), alert the user
prompt+='Your Order has been placed! however, ';capMet.forEach(function(prize){for(var j=0;j<order.length;j++){if(order[j].prize===prize){prompt+='the item '+prize+' was removed because you have exceeded the limit that can be ordered in a year. ';ordertotal=Number(ordertotal)-order[j].total;}}});_this3.props.redeemable("subtract",ordertotal);//update redeemable points for user
}// this.setState({cart:[],total:0,loading:false,success:true,modalPrompt:prompt},function(){
// 	this.updateCart(this.props.cart);
// 	
// });
_this3.setState({loading:false,success:true,modalPrompt:prompt});_this3.props.updateCart([],function(){_this3.props.updateCartTotal();_this3.props.logChange();});}).catch(function(err){return console.log(err);});}});}//deleted else
}},{key:'render',value:function render(){var _this4=this;var selectStyle="w-80-ns w-100 ml2 h2 shadow-3 pa1 br2 b--gray bw1";var content=void 0;var tierOptions=["all"].concat(_toConsumableArray(this.state.tiers));var customStyles={content:{top:'50%',left:'50%',right:'auto',bottom:'auto',width:'100%',maxWidth:'1080px',transform:'translate(-50%, -50%)',borderWidth:'1px',borderColor:'gray',boxShadow:'0.5px 0.5px 1px 0.5px',paddingTop:'0'},overlay:{backgroundColor:'rgba(105,105,105,0.8)'}};var wallet=void 0;console.log(this.props.userInfo);if(this.props.app==="lov"){//display the user's redeemable points as their "Wallet"
wallet=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginLeft:'1%'},className:'b gray'},'Wallet: ',this.props.userInfo.redeemable,' points');}else{wallet=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginLeft:'1%'}});}var itemTotal=this.props.cart.length;var cartButton={backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_4__asset_img_shoppingCart_png___default.a+')',backgroundSize:'60px 40px',backgroundRepeat:'no-repeat',backgroundPosition:'center',minWidth:'65px',minHeight:'45px'};var information=this.state.info;var prizes=information.map(function(information,i){//display prizes, which can be filtered by tier or all be displayed at once
if(information.tier==_this4.state.tier||_this4.state.tier==="all"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-33-ns w-50-m w-100 pa1 prizeDiv',key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Prize_js__["a" /* default */],{prize:information.prize,path:information.picture,price:information.price,variants:information.variants,onChoice:_this4.addToCart,child:i}));}});if(this.props.active){var modalContent=void 0;if(this.state.loading){//display loading gif
modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tc',style:{width:'150px',margin:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_8__asset_img_loader_gif___default.a,alt:'Loading'}));}else if(this.state.success){//display message
modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 tr mt0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'bg-white gray b br3',onClick:this.closeModal},'X')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'f3 tc'},this.state.modalPrompt));}else{//display shopping cart
modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 tr mt0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'bg-white gray b br3',onClick:this.closeModal},'X')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ShoppingCart_js__["a" /* default */],{items:this.props.cart,total:this.props.cartTotal,remove:this.removeItem,quantChange:this.quantityChange,order:this.submitOrder,limit:this.props.userInfo.redeemable,app:this.props.app}));}content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 b--light-silver bb',style:{maxWidth:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-40-ns w-30-m w-100 tl mb1'},wallet),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-20-ns w-40-m w-50 tc mt2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-30 tr-ns tl mt2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'b gray'},'Tier: ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-70 tl'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__component_Select_js__["a" /* default */],{name:'tier',identity:'tier',onSelect:this.handleSelection,options:tierOptions,styles:selectStyle,val:this.state.tier}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-40-ns w-30-m w-50 tr mb1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'br3 bw1 b red bg-white bn shadow-1',onClick:this.openModal,style:cartButton},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{display:'inline-block',marginRight:'11px',marginBottom:'11px'}},itemTotal)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 overflow-y-auto pt2',style:{maxHeight:'500px'}},prizes),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_modal___default.a,{isOpen:this.state.modalIsOpen,style:customStyles,contentLabel:'shopping cart Modal',shouldCloseOnOverlayClick:false,shouldCloseOnEsc:false},modalContent)));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,content);}}]);return PrizeShop;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (PrizeShop);PrizeShop.propTypes={updateCart:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func.isRequired,cart:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.array.isRequired,cartTotal:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number.isRequired,updateCartTotal:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func.isRequired,userInfo:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object.isRequired,redeemable:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func.isRequired,app:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string.isRequired,active:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool.isRequired,logChange:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func.isRequired};

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component_Submit_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__component_Select_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__component_Input_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Validation_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//used for validating input
var Prize=function(_Component){_inherits(Prize,_Component);function Prize(props){_classCallCheck(this,Prize);var _this=_possibleConstructorReturn(this,(Prize.__proto__||Object.getPrototypeOf(Prize)).call(this,props));_this.state={prize:_this.props.prize,size:'N/A',color:'N/A',photo:'',quantity:1,total:'',variations:[],button:true};_this.handleSubmit=_this.handleSubmit.bind(_this);_this.handleSelection=_this.handleSelection.bind(_this);_this.handleSize=_this.handleSize.bind(_this);_this.handleQuantity=_this.handleQuantity.bind(_this);return _this;}_createClass(Prize,[{key:'handleSize',value:function handleSize(identity,value){//method that handles changing the size of a prize, and setting the correct first color and its respective picture
var variants=this.state.variations;var theState={};theState[identity]=value;for(var i=0;i<variants.length;i++){if(variants[i].size===value){// Convert color to use spaces to match SelectBox options
var firstColor=variants[i].colors[0];if(firstColor!=="N/A"&&firstColor!==null&&firstColor!==undefined){firstColor=firstColor.replace(/_/g," ");}theState['color']=firstColor;//set first color of prize
theState['photo']=variants[i].photos[0];//set picture for first color
}}this.setState(theState);}},{key:'handleSelection',value:function handleSelection(identity,value){//method for handling user input for colors, displays corresponding image of the color selected
var variants=this.state.variations;var theState={};theState[identity]=value;for(var i=0;i<variants.length;i++){if(variants[i].size===this.state.size){for(var j=0;j<variants[i].colors.length;j++){if(variants[i].colors[j]===value){theState['photo']=variants[i].photos[j];}}}}this.setState(theState);}},{key:'handleQuantity',value:function handleQuantity(identity,value){//handles user input for quantity of prize they would like to add to shopping cart
if(/^(\s*|[1-9][0-9]*)$/.test(value)){//only allow positive integers
var theState={};theState[identity]=value;this.setState(theState);}}},{key:'handleSubmit',value:function handleSubmit(){//method for passing up prize information to be added to the shopping cart
if(this.state.quantity!==''){var price=this.props.price;var quant=this.state.quantity===undefined||this.state.quantity===null||Number(this.state.quantity)<1?1:this.state.quantity;var getTotal=function getTotal(x,y){return Number(x)*Number(y);};var total=getTotal(price,quant);//get total cost based on quantity and unit price
this.setState({total:total,button:false},function(){var _this2=this;//on click, add button displays "Added!" for half a second
setTimeout(function(){_this2.setState({button:true});},500);var s=this.state;var size=s.size==='Select'?'N/A':s.size;var color=s.color==='Select'?'N/A':s.color;var lineItem={prize:s.prize,size:size,color:color,quantity:Number(quant),total:s.total};this.setState;this.props.onChoice(lineItem);//pass up gift information
this.setState({quantity:1});});}}},{key:'componentDidMount',value:function componentDidMount(){//when component mounts, loop through prize/variant information and match colors and photos to each size
var allsizes=[];var variations=[];this.props.variants.forEach(function(variant){allsizes.push(variant.size);});var sizes=allsizes.filter(function(v,i,a){return a.indexOf(v)===i;});var firstcolor=void 0;var firstphoto=void 0;var firstsize=void 0;for(var i=0;i<sizes.length;i++){//outer for loop loops through each size in the array sizes
variations.push({size:sizes[i],colors:[],photos:[]});//push objects to variations, colors array is for colors that correspond with each single size
for(var j=0;j<this.props.variants.length;j++){//loop through each variant to compare each size to variant
if(sizes[i]===this.props.variants[j].size){//if the size matches the size in the variations array of objects, add the color to the colors array
variations[i].colors.push(this.props.variants[j].color);variations[i].photos.push(this.props.variants[j].photo);}}if(sizes[i]===null||sizes[i]===undefined||sizes[i]===''){variations[i].size="N/A";}if(variations[i].colors.length===0||variations[i].colors[0]===undefined||variations[i].colors[0]==null||variations[i].colors[0]===''){firstcolor="N/A";firstphoto=variations[i].photos[0];firstsize=variations[i].size;}else{firstcolor=variations[0].colors[0];firstphoto=variations[0].photos[0];}}var theFirst=variations[0];// Convert firstcolor to use spaces to match SelectBox options
var displayColor=firstcolor;if(firstcolor!=="N/A"&&firstcolor!==null&&firstcolor!==undefined){displayColor=firstcolor.replace(/_/g," ");}this.setState({variations:variations,color:displayColor,photo:firstphoto,price:this.props.price,size:theFirst.size});}},{key:'render',value:function render(){var _this3=this;var picstyles={width:'auto',height:'auto',margin:'auto',display:'inline-block',maxHeight:'122px'};var containerDivStyle={minWidth:'260px',minHeight:'375px',boxShadow:'1px 1px 4px 4px #aaaaaa',maxWidth:'315px',margin:'auto',textAlign:'center'};var imgDivStyle={maxWidth:'100px',width:'100px',height:'122px',maxHeight:'122px',textAlign:'center',margin:'auto',overflow:'hidden',paddingBottom:'20px'};var labelStyle="ml5";var selectStyle="w-60 mv1 mr3 pa1 shadow-2 br2 b--gray bw1 tc";var labelDivStyle="fl w-50 tl mt2 b gray";var selectDivStyle="fl w-50 tl pl2";var minHeightStyle={minHeight:'38px'};var borderstyle="br3 bg-white";//:"bb br b--light-silver ba br3 mb2 ma2 bg-white bw1";(this.props.child) % 3 === 0 ?
var theButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_Submit_js__["a" /* default */],{name:'Add',onClick:this.handleSubmit,styles:'bg-dark-blue white b br3 grow bn shadow-3 h2 w-20-ns mt2'});if(!this.state.button){//message displayed in place of add button, on click, for half a second
theButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pt4 mt4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'tc mb0 pt4 pb0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'mt4 b navy'},'Added!')));}var size=[];var colors=[];var theColors=[];var vari=this.state.variations;vari.forEach(function(variation){size.push(variation.size);});var selectSize=void 0;var selectColor=void 0;if(size[0]==="N/A"){//if there are no size options, only display color options
selectSize=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'b mt1 mb1 pt1 pb2'},'N/A');colors=this.state.variations[0].colors;colors.forEach(function(color){if(color===null||color===undefined||color===''){color="N/A";}else{color=color.replace(/_/g," ");}theColors.push(color);});if(colors.length===1&&colors[0]==="N/A"){selectColor=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'b mt1 mb1 pt1 pb2'},'N/A');}else{selectColor=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__component_Select_js__["a" /* default */],{name:'color',identity:'color',onSelect:this.handleSelection,options:theColors,styles:selectStyle,val:this.state.color});}}else{//if there are color options, consolidate them based on the selected size
selectSize=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__component_Select_js__["a" /* default */],{name:'size',identity:'size',onSelect:this.handleSize,options:size,styles:selectStyle,val:this.state.size});//let theColors = [];
vari.forEach(function(variant){if(variant.size===_this3.state.size){colors=variant.colors;colors.forEach(function(color){if(color===null||color===undefined||color===''){color="N/A";}else{theColors.push(color.replace(/_/g," "));}});}});if(colors.length===1&&colors[0]==="N/A"){selectColor=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'b mt1 mb1 pt1 pb2'},'N/A');}else{selectColor=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__component_Select_js__["a" /* default */],{name:'color',identity:'color',onSelect:this.handleSelection,options:theColors,styles:selectStyle,val:this.state.color});}}if(this.state.color==="N/A"&&this.state.size==="N/A"){selectColor=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'b mt1 mb1 pt1 pb2'},'N/A');}var imgpath=this.props.path+this.state.photo;imgpath=imgpath.replace(/\s/g,"_");return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:borderstyle,style:containerDivStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tc',style:{minHeight:'204px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'w-100',style:{minHeight:'64px',maxHeight:'64px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt0 pt2 b navy fl tc w-20'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt0 pt2 b underline navy tc fl w-60'},this.props.prize,' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt0 pt2 b navy fl tc w-20'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'dark-red'},this.props.price,' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'navy'},' pts'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'w-100 prize_image_container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:imgDivStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:imgpath,alt:'error',style:picstyles})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mb3 pb'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'w-100 mw6 center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:labelDivStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:labelStyle},'Size:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:selectDivStyle,style:minHeightStyle},selectSize)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:labelDivStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:labelStyle},'Color:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:selectDivStyle},selectColor))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'w-100 mw-100 center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:labelDivStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:labelStyle},'Quantity:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:selectDivStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__component_Input_js__["a" /* default */],{name:'quantity',identity:'quantity',onInput:this.handleQuantity,inputStyle:selectStyle,val:this.state.quantity,type:'number'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mv3 pt3'},theButton));}}]);return Prize;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Prize);Prize.propTypes={prize:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string.isRequired,path:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string.isRequired,price:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number.isRequired,variants:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.array.isRequired,onChoice:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,child:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number.isRequired};

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component_TableHead_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__component_InputSelect_js__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__component_Submit_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__routes_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Validation_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_modal__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__asset_img_loader_gif__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__asset_img_loader_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__asset_img_loader_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__asset_img_sparkles2_png__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__asset_img_sparkles2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__asset_img_sparkles2_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BulkThankyou=function(_Component){_inherits(BulkThankyou,_Component);function BulkThankyou(props){_classCallCheck(this,BulkThankyou);var _this=_possibleConstructorReturn(this,(BulkThankyou.__proto__||Object.getPrototypeOf(BulkThankyou)).call(this,props));_this.state={thankyous:[],submit:false,rows:5,virtues:[],employees:[],failed:[],loading:false,incomplete:false,messagePrompt:''};_this.handleChange=_this.handleChange.bind(_this);_this.handleSubmit=_this.handleSubmit.bind(_this);_this.addRows=_this.addRows.bind(_this);_this.isValidDate=_this.isValidDate.bind(_this);_this.openModal=_this.openModal.bind(_this);_this.closeModal=_this.closeModal.bind(_this);_this.loadingFunc=_this.loadingFunc.bind(_this);_this.logsubmit=_this.logsubmit.bind(_this);return _this;}_createClass(BulkThankyou,[{key:'isValidDate',value:function isValidDate(dateString){//method for checking whether or not a date is in valid date format and is indeed an actual date that exists
var d=new Date();var year=d.getFullYear();var dateparts=void 0;var dateYear=void 0;if(Object(__WEBPACK_IMPORTED_MODULE_6__Validation_js__["a" /* default */])("date",dateString)){if(dateString.indexOf("/")!==-1){dateparts=dateString.split("/");if(dateparts.length===3){dateYear=Number(dateparts[2]);}else{if(dateparts[0].indexOf("-")!==-1){dateYear=dateparts[1];}else{var dateparts2=dateparts[1].split("-");dateYear=dateparts2[1];}}}else{dateparts=dateString.split("-");if(dateparts.length===3){dateYear=Number(dateparts[2]);}else{if(dateparts[0].indexOf("/")!==-1){dateYear=dateparts[1];}else{var _dateparts=dateparts[1].split("/");dateYear=_dateparts[1];}}}if(Number(dateYear)===Number(year)){return true;}}return false;}},{key:'loadingFunc',value:function loadingFunc(loading){//method to trigger the displaying of the loading gif
if(loading){this.setState({loading:true,modalIsOpen:true});}else{this.setState({loading:false});}}},{key:'componentDidMount',value:function componentDidMount(){var _this2=this;//when component mounts, retrieve all lov values and currently active employees from database
__WEBPACK_IMPORTED_MODULE_4_axios___default()({//retrieve lov values 
method:'post',url:__WEBPACK_IMPORTED_MODULE_5__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{"endpoint":'info',table:'virtues'}}).then(function(response){var virtues=[];var data=response.data.data;data.forEach(function(virtue){virtues.push(virtue.virtue);});_this2.setState({virtues:virtues});});__WEBPACK_IMPORTED_MODULE_4_axios___default()({//retrieve all active employees
method:'post',url:__WEBPACK_IMPORTED_MODULE_5__routes_js__["c" /* path */],data:{endpoint:'info',table:'users',action:'employees'}}).then(function(response){var employees=[];var data=response.data.data;data.forEach(function(employee){if(employee.name!==_this2.props.userInfo.name){employees.push({value:employee.name,label:employee.name});}});_this2.setState({employees:employees});});}},{key:'handleChange',value:function handleChange(thankyou){//method grabs all of the thankyous and adds them to the state since each thankyou is contained in the inputSelect component
this.setState(function(oldState){return{thankyous:[].concat(_toConsumableArray(oldState.thankyous),[thankyou])};});}},{key:'logsubmit',value:function logsubmit(failure){//method that keeps track of incomplete thankyous
this.setState({incomplete:failure});}},{key:'handleSubmit',value:function handleSubmit(){//method that sets submit to true, which sets all operations for submitting the thank yous into motion
this.setState({submit:true},function(){this.loadingFunc(true);});}},{key:'addRows',value:function addRows(){//method to increment the number of rows (input select components rendered)
var oldRows=this.state.rows;var newRows=oldRows+3;this.setState({rows:newRows});}},{key:'openModal',value:function openModal(){//method to open the modal
this.setState({modalIsOpen:true});}},{key:'closeModal',value:function closeModal(){//method to close the modal
this.setState({modalIsOpen:false,submit:false,failed:[]});}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){if(prevState.submit===true&&prevState.thankyous!==this.state.thankyous&&this.state.thankyous.length!==0){//if the submit button has been clicked
var bulkThankyou=this.state.thankyous;var thankyous=[];var failed=[];var reason=void 0;bulkThankyou.forEach(function(thankyou){//validate each thankyou before sending
if(thankyou.for!==''&&thankyou.for!==undefined&&thankyou.from!=='Select'&&thankyou.to!=='Select'&&thankyou.value!=='Select'&&thankyou.date!==''&&thankyou.complete){if(Object(__WEBPACK_IMPORTED_MODULE_6__Validation_js__["a" /* default */])("reason",thankyou.for)&&Object(__WEBPACK_IMPORTED_MODULE_6__Validation_js__["a" /* default */])('date',thankyou.date)){//validate the reason and date
reason=thankyou.for.replace(/\n/g,"<br/>").trim();thankyous.push(__WEBPACK_IMPORTED_MODULE_4_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_5__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'create',table:'thank',misc:'bulk',status:thankyou.from,name:thankyou.to,desc:reason,answer:thankyou.value,date:thankyou.date}}).catch(function(error){failed.push(thankyou);}));}else{failed.push(thankyou);}}else{failed.push(thankyou);}});this.setState({submit:false});this.setState({failed:failed},function(){var _this3=this;//send all thankyous
__WEBPACK_IMPORTED_MODULE_4_axios___default.a.all(thankyous).then(function(response){_this3.setState({thankyous:[],messagePrompt:'All thank yous created successfully!'});_this3.props.logChange();_this3.loadingFunc(false);});});}else if(prevState.submit===true&&this.state.submit){this.setState({submit:false,messagePrompt:'Please Input at least one thank you.'});this.loadingFunc(false);}}},{key:'render',value:function render(){var content=void 0;var customStyles={content:{top:'50%',left:'50%',right:'auto',bottom:'auto',width:'100%',minWidth:'300px',maxWidth:'600px',minHeight:'150px',maxHeight:'600px',borderStyle:'solid',borderWidth:'2px',borderColor:'gray',transform:'translate(-50%, -50%)',backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_9__asset_img_sparkles2_png___default.a+')',backgroundRepeat:'no-repeat',backgroundSize:'300px 160px',backgroundPosition:'right',boxShadow:'0.5px 0.5px 1px 0.5px'},overlay:{backgroundColor:'rgba(105,105,105,0.8)'}};var modalContent=void 0;var failed=this.state.failed;var tableRows=[];for(var i=0;i<this.state.rows;i++){//generate rows of inputs for thank yous
tableRows.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__component_InputSelect_js__["a" /* default */],{key:i,prefix:i,onChange:this.handleChange,submit:this.state.submit,virtues:this.state.virtues,employees:this.state.employees,failed:this.logsubmit}));}if(this.state.loading){//display loader
modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tc',style:{width:'150px',margin:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_8__asset_img_loader_gif___default.a,alt:'Loading'}));}else if(failed.length>0){//display all thankyous that failed from either connection
modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tc mt0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 tr pb2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'bg-white gray b br3',onClick:this.closeModal},'X')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'tc b f4 navy'},'There was a problem creating the following thank yous: '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{overflowY:'auto',overflowX:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UnOrderedList,{failed:failed})));}else{//display message
modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tc mt0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 tr pb2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'bg-white gray b br3',onClick:this.closeModal},'X')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'tc b f3 navy mt0'},this.state.messagePrompt));}if(this.props.active){content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'br3 pa3',style:{boxShadow:'0px 0px 5px 5px #aaaaaa inset'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{maxWidth:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_TableHead_js__["a" /* default */],{columns:["To","From","For","Value","Date"]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,tableRows))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tr mr3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',onClick:this.addRows,className:'blue no-underline underline-hover'},'+Add Rows'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mt4 mb2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__component_Submit_js__["a" /* default */],{name:'Submit',onClick:this.handleSubmit,styles:'br3 white b w-20-ns w-50 hh3 bg-navy shadow-3'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_modal___default.a,{isOpen:this.state.modalIsOpen,style:customStyles,contentLabel:'Bulk Thankyou Modal',shouldCloseOnOverlayClick:false,shouldCloseOnEsc:false},modalContent)));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,content);}}]);return BulkThankyou;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (BulkThankyou);var UnOrderedList=function UnOrderedList(props){//unordered list functional component to display failed thank yous
var li=props.failed.map(function(failed,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:i,className:'fl w-100 pl2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fl w-50 b f5 navy pa0 mt0 tl'},'To: ',failed.to),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fl w-50 b tl f5 navy pa0 mt0'},'From: ',failed.from),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fl w-100 b f5 bb b--light-silver tl navy pa0 mt0'},'For: ',failed.for));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'fl w-100'},li);};

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Input_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Select_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__container_Validation_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Searchable_js__ = __webpack_require__(21);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var InputSelect=function(_Component){_inherits(InputSelect,_Component);function InputSelect(props){_classCallCheck(this,InputSelect);var _this=_possibleConstructorReturn(this,(InputSelect.__proto__||Object.getPrototypeOf(InputSelect)).call(this,props));_this.state={to:'Select',from:'Select',for:'',value:'Select',date:'',valid:false,notValid:'',searchToVal:'',searchFromVal:''};_this.handleInput=_this.handleInput.bind(_this);_this.handleDate=_this.handleDate.bind(_this);_this.handleToSearch=_this.handleToSearch.bind(_this);_this.handleToSelect=_this.handleToSelect.bind(_this);_this.handleFromSearch=_this.handleFromSearch.bind(_this);_this.handleFromSelect=_this.handleFromSelect.bind(_this);//this.handleSearch = this.handleSearch.bind(this);
return _this;}_createClass(InputSelect,[{key:'handleDate',value:function handleDate(identity,value){//method for handling date input 
var theState={};if(/^(\s*|[0-9/-]*)$/g.test(value)){//only allow blank space or numbers, slashes and dashes
theState[identity]=value;this.setState(theState);}}},{key:'handleInput',value:function handleInput(identity,value){//standard method for handling input
var theState={};theState[identity]=value;this.setState(theState);}},{key:'handleToSearch',value:function handleToSearch(value){this.setState({searchToVal:value});}},{key:'handleToSelect',value:function handleToSelect(value){this.setState({to:value,searchToVal:value});}},{key:'handleFromSelect',value:function handleFromSelect(value){this.setState({from:value,searchFromVal:value});}},{key:'handleFromSearch',value:function handleFromSearch(value){this.setState({searchFromVal:value});}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){var s=this.state;if(this.props.submit!==prevProps.submit&&this.props.submit){//if submit has been clicked, continue
var reason='';if(s.to!=="Select"&&s.from!=="Select"&&s.for.trim()!==""&&s.value!=="Select"&&s.date.trim()!==""){//make sure all fields are filled out 
if(s.for.trim()!==""){reason=s.for.replace(/(<([^>]+)>)/ig,"");//replace special characters
}if(reason.trim()!==""){reason=reason.replace(/\*/g,"");//replace asterisk
}if(reason.trim()!==""){reason=reason.replace(/\=/g,"");//replace assignment operator
}this.props.onChange({complete:true,to:s.to,from:s.from,for:reason.trim(),value:s.value,date:s.date.trim()});//pass up sanitized data
}else if(s.to!=="Select"||s.from!=="Select"||s.for.trim()!==""||s.value!=="Select"||s.date.trim()!==""){this.props.onChange({complete:false,to:s.to,from:s.from,for:s.for.trim(),value:s.value,date:s.date.trim()});//if one or more field is empty but others are filled out, pass values up with complete flag set to false
}this.setState({to:'Select',from:'Select',for:'',value:'Select',date:'',searchToVal:'',searchFromVal:''});//clear inputs and reset dropdown menus
}}},{key:'render',value:function render(){var searchableStyles={input:{borderWidth:'.125rem',borderRadius:'3px 3px 3px 3px',borderColor:'gray',height:'2rem',width:'100%',paddingLeft:'10px',boxShadow:'0 0 8px 2px rgba( 0, 0, 0, .2 )'},list:{listStyleType:'none',backgroundColor:'white',width:'100%',maxHeight:'200px',overflowY:'auto',margin:'0',paddingLeft:'0'}};var dateStyles="h2 pa2 br2 bw1 w-100 shadow-2";var forStyles="h2 pa2 br2 bw1 w-100 shadow-2";var employeeOptions=this.props.employees.map(function(employee,i){//get all employee names
return employee.value;});if(this.state.date!==''&&!Object(__WEBPACK_IMPORTED_MODULE_4__container_Validation_js__["a" /* default */])("date",this.state.date)){//highlight date input field if not empty and not a valid date format
dateStyles="h2 pa2 br2 bw1 w-100 b--red shadow-2";}var selectStyles="h2 pa1 w-100 br2 bw1 truncate shadow-2";var tdStyle="pa2 w-20 relative";var options=this.props.virtues;var to_container_id="to_combo_box_container_"+this.props.prefix;var to_input_id="to_combo_box_"+this.props.prefix;var from_container_id="from_combo_box_container_"+this.props.prefix;;var from_input_id="from_combo_box_"+this.props.prefix;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:tdStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Searchable_js__["a" /* default */],{containerId:to_container_id,inputId:to_input_id,placeholder:'Search or Select',style:searchableStyles,listItemClass:'search_list_item',caseSensitive:false,value:this.state.searchToVal,options:employeeOptions,handleSelect:this.handleToSelect,handleChange:this.handleToSearch})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:tdStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Searchable_js__["a" /* default */],{containerId:from_container_id,inputId:from_input_id,placeholder:'Search or Select',style:searchableStyles,listItemClass:'search_list_item',caseSensitive:false,value:this.state.searchFromVal,options:employeeOptions,handleSelect:this.handleFromSelect,handleChange:this.handleFromSearch})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:tdStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Input_js__["a" /* default */],{identity:'for',onInput:this.handleInput,inputStyle:forStyles,val:this.state.for})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:tdStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Select_js__["a" /* default */],{identity:'value',options:options,onSelect:this.handleInput,styles:selectStyles,val:this.state.value})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:tdStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Input_js__["a" /* default */],{identity:'date',placeholder:'mm/dd/yyyy',onInput:this.handleDate,inputStyle:dateStyles,val:this.state.date})));}}]);return InputSelect;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (InputSelect);InputSelect.propTypes={employees:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.array.isRequired,virtues:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.array.isRequired,submit:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool.isRequired};//<SelectBox identity="to" onSelect={this.handleInput} options={employeeOptions} styles={selectStyles} val={this.state.to}/>

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes_js__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UserHomeScreen=function(_Component){_inherits(UserHomeScreen,_Component);function UserHomeScreen(props){_classCallCheck(this,UserHomeScreen);var _this=_possibleConstructorReturn(this,(UserHomeScreen.__proto__||Object.getPrototypeOf(UserHomeScreen)).call(this,props));_this.state={earned:'0',redeemable:'0',redeemed:'0',sent:'0',received:'0',cap:'240'};return _this;}_createClass(UserHomeScreen,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;//when component mounts, retrieve user stats from db (earned points, redeemed points, pending points, redeemable points, sent thankyous, received thankyous)
__WEBPACK_IMPORTED_MODULE_1_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_2__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'info',table:'points',userID:this.props.userInfo.userID,name:this.props.userInfo.name}}).then(function(response){var data=response.data.data;_this2.setState(data[0]);});}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var _this3=this;//get new user stats after they have performed an action that would alter any of their current stats
if(prevProps.submitted!==this.props.submitted){__WEBPACK_IMPORTED_MODULE_1_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_2__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'info',table:'points',userID:this.props.userInfo.userID,name:this.props.userInfo.name}}).then(function(response){var data=response.data.data;_this3.setState(data[0]);});}}},{key:'render',value:function render(){var content=void 0;var pStyle="f3 bb b--light-silver navy";if(this.props.active){content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pa2 br4 bg-white mt5 mb5 center userHomeDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{maxWidth:'70%',margin:'auto',minWidth:'70%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'Welcome, ',this.props.userInfo.name,'!')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:pStyle},'Points Earned: ',this.state.earned,'/',this.state.cap)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:pStyle},'Points Redeemable: ',this.state.redeemable,'/',this.state.cap)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:pStyle},'Points Redeemed: ',this.state.redeemed,'/',this.state.cap)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:pStyle},'Sent Thank-yous: ',this.state.sent)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:pStyle},'Received Thank-yous: ',this.state.received))));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,content);}}]);return UserHomeScreen;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (UserHomeScreen);

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component_ApproveContent_js__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__component_TableHead_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__routes_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_modal__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__component_Input_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__component_Submit_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__asset_img_sparkles2_png__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__asset_img_sparkles2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__asset_img_sparkles2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Validation_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__asset_img_loader_gif__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__asset_img_loader_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__asset_img_loader_gif__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//component that contains each table row for each thankyou to be approved
//component that contains the title of each column in the table
//used for validation
var ApproveThankyous=function(_Component){_inherits(ApproveThankyous,_Component);function ApproveThankyous(props){_classCallCheck(this,ApproveThankyous);var _this=_possibleConstructorReturn(this,(ApproveThankyous.__proto__||Object.getPrototypeOf(ApproveThankyous)).call(this,props));_this.handleClick=_this.handleClick.bind(_this);_this.state={modalIsOpen:false,thankyous:[{ID:'',userID:'',info:{"To":"","From":"","Reason":"","Value":"","Date":""}}],denialReason:'',parameters:{},modalType:'',data:'',manager:'',requiredPrompt:'Required',loading:false,loadingMessage:''};_this.openModal=_this.openModal.bind(_this);_this.closeModal=_this.closeModal.bind(_this);_this.sendInfo=_this.sendInfo.bind(_this);_this.sendDenialReason=_this.sendDenialReason.bind(_this);_this.handleInput=_this.handleInput.bind(_this);_this.handleDenial=_this.handleDenial.bind(_this);_this.handleReview=_this.handleReview.bind(_this);_this.editThankyou=_this.editThankyou.bind(_this);_this.bulkApprove=_this.bulkApprove.bind(_this);return _this;}_createClass(ApproveThankyous,[{key:'bulkApprove',value:function bulkApprove(){var _this2=this;this.setState({loading:true});var emailData=this.state.thankyous.map(function(thank){return{'action':'received','name':thank.info.To,'from':thank.info.From,'reason':thank.info.Reason,'date':thank.info.Date,'virtue':thank.info.Value};});__WEBPACK_IMPORTED_MODULE_3_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_4__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'create',table:'thank',misc:'bulk_approve',emailData:emailData}}).then(function(response){_this2.setState({loadingMessage:'Success!'},function(){setTimeout(function(){return _this2.setState({thankyous:[],loading:false,loadingMessage:''});},2000);});}).catch(function(err){_this2.setState({loadingMessage:'A problem has occured while attempting the bulk approval of thank yous.'},function(){setTimeout(function(){return _this2.setState({loading:false,loadingMessage:''});},4000);});});}},{key:'sendInfo',value:function sendInfo(params){var _this3=this;//this method is for emailing either a thank you recipient or a manager
__WEBPACK_IMPORTED_MODULE_3_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_4__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:params}).then(function(response){var data=void 0;var email=response.data.data[0].email;var username=response.data.data[0].name;if(params.action==="thankyouDenied"){var reason=_this3.state.denialReason.replace(/(?:\r\n|\r|\n)/g,'<br>');data={'action':params.action,'email':email,'name':username,'reason':reason};}else{data={'action':params.action,'email':email,'name':username,'from':params.from,'reason':params.reason,'date':params.date,'virtue':params.virtue};}__WEBPACK_IMPORTED_MODULE_3_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_4__routes_js__["b" /* mail */],headers:{'Content-Type':'application/json'},data:data});});}},{key:'sendDenialReason',value:function sendDenialReason(){//this method is used when a thankyou is denied, sending an email notifying whomever sent the thankyou with info on why it was denied
if(this.state.denialReason.trim()!==''&&Object(__WEBPACK_IMPORTED_MODULE_9__Validation_js__["a" /* default */])("reason",this.state.denialReason.trim())){var data=this.state.data;var thankId=data.firstID;var newState=this.state.thankyous.filter(function(thank){if(Number(thank.ID)!==Number(thankId)){return thank;}});this.setState({modalIsOpen:false,modalType:''},function(){this.sendInfo(this.state.parameters);});this.handleDenial(newState,data);}else{var prompt=void 0;if(this.state.denialReason.trim()!==''){prompt="Contains invalid characters";}else{prompt="Required";}this.setState({requiredPrompt:prompt});}}},{key:'handleDenial',value:function handleDenial(newState,data){var _this4=this;//this method handles updating the status of the thank you in the database and removing it from the current state
__WEBPACK_IMPORTED_MODULE_3_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_4__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:data}).then(function(response){//if status was successfully updated, remove from the state.
var data=response.data.data;if(data.Message==="Success"){_this4.setState({thankyous:newState});}});}},{key:'handleReview',value:function handleReview(){var _this5=this;//method handles updating the status of the thankyou in the database and updates the state
var params=this.state.parameters;var data=this.state.data;var thankId=data.firstID;var newState=this.state.thankyous.filter(function(thank){if(Number(thank.ID)!==Number(thankId)){return thank;}});__WEBPACK_IMPORTED_MODULE_3_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_4__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:data}).then(function(response){var data=response.data.data;if(data.Message==="Success"){//if status was successfully updated, remove from state, send notification
_this5.setState({thankyous:newState});_this5.sendInfo(params);}});this.closeModal();}},{key:'handleClick',value:function handleClick(val,thankId){var _this6=this;//method for handling operations after the approve, review, or deny button is clicked for a thankyou
var userID=void 0;var date=void 0;var name=void 0;var _from=void 0;var reason=void 0;var virtue=void 0;var newState=this.state.thankyous.filter(function(thank){//filter out and get needed information from the thank you that has been either approved, sent for review, or denied
if(thank.ID!==thankId){return thank;}else{userID=thank.userID;date=thank.info.Date;name=thank.info.To;_from=thank.info.From;date=thank.info.Date;reason=thank.info.Reason;virtue=thank.info.Value;}});this.setState({data:{endpoint:'create',table:'thank',misc:'status',firstID:thankId,secondID:userID,status:val,date:date,name:name}});var action=void 0;var params=void 0;if(val!=="denied"){if(val==="review"){//handles updating a thank you and preparing parameters for email if the thank you needs further review
action='manager';name=null;_from=null;date=null;reason=null;virtue=null;params={endpoint:'info',table:'users',action:action,userID:userID,name:name,from:_from,date:date,reason:reason,virtue:virtue};__WEBPACK_IMPORTED_MODULE_3_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_4__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:params}).then(function(response){_this6.setState({parameters:params,modalType:'review',manager:response.data.data[0].name},function(){this.openModal();});});}else if(val==="approved"){//handles updating a thank you and preparing parameters for email if the thank you has been approved
__WEBPACK_IMPORTED_MODULE_3_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_4__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'create',table:'thank',misc:'status',firstID:thankId,secondID:userID,status:val,date:date,name:name}}).then(function(response){var data=response.data.data;if(data.Message==="Success"){_this6.setState({thankyous:newState});action='received';userID=null;params={endpoint:'info',table:'users',action:action,userID:userID,name:name,from:_from,date:date,reason:reason,virtue:virtue};_this6.sendInfo(params);}});}}else if(val==="denied"){//handles updating a thank you and preparing parameters for email if the thank you has been denied
action='thankyouDenied';name=null;params={endpoint:'info',table:'users',action:action,userID:userID,name:name};this.setState({parameters:params,modalType:'denied'},function(){this.setState({modalIsOpen:true});});}}},{key:'componentDidMount',value:function componentDidMount(){var _this7=this;//determines which thank yous to retrieve from database based on user type and then retrieves them
var status=void 0;if(this.props.userInfo.userType==="admin"||this.props.userInfo.userType==="sys_admin"){status="pending";}else{status="review";}__WEBPACK_IMPORTED_MODULE_3_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_4__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'info',table:'thankyous',action:status,name:this.props.userInfo.userID}}).then(function(response){var thanks=[];var res=response.data.data;res.forEach(function(thankyou){thanks.push({ID:thankyou.ID,userID:thankyou.userID,info:{To:thankyou.To,From:thankyou.From,Reason:thankyou.Reason,Value:thankyou.Value,Date:thankyou.Date}});});_this7.setState({thankyous:thanks});});}},{key:'openModal',value:function openModal(){//method for opening modal
this.setState({modalIsOpen:true});}},{key:'closeModal',value:function closeModal(){//method for closing the modal
this.setState({modalIsOpen:false,requiredPrompt:'Required'});}},{key:'handleInput',value:function handleInput(identity,value){//handles input of the reason for denial is a thank you has been denied
this.setState({denialReason:value});}},{key:'editThankyou',value:function editThankyou(e){var id=e.target.id;var text=document.getElementById(id).textContent;var thankyouInfo=id.split("_");var thankyouID=thankyouInfo[0];var thankyouIndex=thankyouInfo[2];var thankyous=this.state.thankyous;thankyous[thankyouIndex].info.Reason=text;this.setState({thankyous:thankyous});if(Object(__WEBPACK_IMPORTED_MODULE_9__Validation_js__["a" /* default */])("reason",text)){document.getElementById(id+"_td").style.borderColor="green";document.getElementById(id+"_td").style.borderWidth="3px";__WEBPACK_IMPORTED_MODULE_3_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_4__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'create',table:'thank',misc:'edit',firstID:thankyouID,desc:text}});}}},{key:'render',value:function render(){var _this8=this;var content=void 0;var modalContent=void 0;var customStyles={content:{top:'50%',left:'50%',right:'auto',bottom:'auto',width:'100%',maxWidth:'500px',transform:'translate(-50%, -50%)',backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_8__asset_img_sparkles2_png___default.a+')',backgroundRepeat:'no-repeat',backgroundSize:'280px 252px',backgroundPosition:'right',boxShadow:'0.5px 0.5px 1px 0.5px'},overlay:{backgroundColor:'rgba(105,105,105,0.8)'}};var objkeys=["To","From","Reason","Value","Date","Action"];var thankyous=this.state.thankyous;var colData=thankyous.map(function(thankyous,i){//each thank you is formatted and displayed as a line in a table, handled by the ApproveContent module
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_ApproveContent_js__["a" /* default */],{key:thankyous.ID,child:i,edit:_this8.editThankyou,identity:thankyous.ID,user:_this8.props.userInfo.userType,columns:thankyous.info,click:_this8.handleClick,kind:'thankyou'});});if(this.state.modalType==='denied'){//if else statement, first if is for thank you denial
modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'center pb3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'b navy'},'Reason for denial: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'red f5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'red f4 b'},'*'),this.state.requiredPrompt)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__component_Input_js__["a" /* default */],{type:'area',styles:'pa2 br2 bw1 w-100-ns w-100 h3',onInput:this.handleInput,identity:'reason'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pt2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__component_Submit_js__["a" /* default */],{name:'Submit',onClick:this.sendDenialReason,styles:'br2 white b w-40 h2 bg-blue'})));}else{//this block is for marking a thank you for review
modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'b navy tc'},'Are you sure you would like to send this thank you to ',this.state.manager,' for review?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50 tc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:this.handleReview,className:'w-50-ns w-100 bg-navy b white br2'},'Yes')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50 tc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:this.closeModal,className:'w-50-ns w-100 bg-navy b white br2'},'No'))));}if(this.props.active){if(this.state.thankyous.length!==0){content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{margin:'auto',boxShadow:'3px 3px 5px 3px #888888'},className:'br3 br--top shadow-3 w-100 tc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'w-100 collapse br3 bg-white tc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',{className:'collapse h2 bg-white br3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__component_TableHead_js__["a" /* default */],{columns:objkeys,headstyle:'pa2 br3 bg-white'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,colData)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{id:'approve-all',className:'shadow-3',onClick:this.bulkApprove},'Approve All'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_modal___default.a,{isOpen:this.state.modalIsOpen,style:customStyles,contentLabel:'Denial Reason',shouldCloseOnOverlayClick:false,shouldCloseOnEsc:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 tr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'bg-white gray b br3',onClick:this.closeModal},'X')),modalContent)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_modal___default.a,{isOpen:this.state.loading,style:customStyles,contentLabel:'loading',shouldCloseOnOverlayClick:false,shouldCloseOnEsc:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tc',style:{width:'150px',margin:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_10__asset_img_loader_gif___default.a,alt:'Loading'})),';')));}else{content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'w-100 f3 tc'},'There is nothing to view at this time.');}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,content);}}]);return ApproveThankyous;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ApproveThankyous);

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__asset_img_denied_png__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__asset_img_denied_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__asset_img_denied_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__asset_img_checkmark_png__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__asset_img_checkmark_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__asset_img_checkmark_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__asset_img_questionmark_png__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__asset_img_questionmark_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__asset_img_questionmark_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__container_Validation_js__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ApproveContent=function(_Component){_inherits(ApproveContent,_Component);function ApproveContent(props){_classCallCheck(this,ApproveContent);var _this=_possibleConstructorReturn(this,(ApproveContent.__proto__||Object.getPrototypeOf(ApproveContent)).call(this,props));_this.onclick=_this.onclick.bind(_this);//this.editThankyou = this.editThankyou.bind(this);
return _this;}_createClass(ApproveContent,[{key:'onclick',value:function onclick(e){//method for handling the click of a button
var val=e.currentTarget.value;this.props.click(val,this.props.identity);}},{key:'render',value:function render(){var _this2=this;var approve={//styling for approve button
backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_2__asset_img_checkmark_png___default.a+')',backgroundRepeat:'no-repeat',backgroundPosition:'center',backgroundColor:'white',backgroundSize:'26px 24px',minWidth:'26px',minHeight:'24px'};var deny={//styling for deny button
backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_1__asset_img_denied_png___default.a+')',backgroundRepeat:'no-repeat',backgroundPosition:'center',backgroundColor:'white',backgroundSize:'26px 24px',minWidth:'26px',minHeight:'24px'};var review={//styling for review button
backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_3__asset_img_questionmark_png___default.a+')',backgroundRepeat:'no-repeat',backgroundPosition:'center',backgroundColor:'white',backgroundSize:'26px 24px',minWidth:'26px',minHeight:'24px'};var cols=this.props.columns;var tdata=Object.keys(cols).map(function(col,i){//map object passed down through columns prop and return column data for each key
var theid=_this2.props.identity+"_"+col+"_"+_this2.props.child;var td_id=theid+"_td";var isEditable=col==="Reason"?true:false;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:i,id:td_id,className:'ba b--gray',style:{maxWidth:'300px',wordWrap:'break-word'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:theid,onBlur:_this2.props.edit,contentEditable:isEditable},cols[col]));});var buttons=void 0;var extra=void 0;if(this.props.user==="admin"&&this.props.kind==="thankyou"){//review button for pending thank yous
extra=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'br2 mt0',value:'review',onClick:this.onclick,style:review});}buttons=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'tc bg-white ba b--gray',style:{minWidth:'85px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'br2 mt1',value:'approved',onClick:this.onclick,style:approve}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'br2 mt1',value:'denied',onClick:this.onclick,style:deny}),extra);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'stripe-blue'},tdata,buttons);}}]);return ApproveContent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ApproveContent);

/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAA6CAIAAACI8BY7AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAJnSURBVGhD7ZoxbsIwFIZNJ7ZSIdGlgqXqFSpG1LEK50g3DpAj5AAVF8jevd0q2KBjRxCqFCQkulTd0pfml4XsQIv97Agpn57EnxDgz4vtPDs0siwTJ8sZXk+T2n11sLX7z0+RpmK1wqbk+lp0u9D8kHsb0jRLkiwMKQWHIo6z+RwfYcTc/WKRe1JcHg46SfoUI4bu399VZ/+PyQRfYo9hr9Xb9//p98V0Cm0Jz5gTRWIyyXvt78VE0CbtDEMcswudwHIJbQWuwZE8P6MZUJfdbrFzH/Lg3aA+YI+he3JMnv70LaEBR3FPYT8KGbo3gK6S4n48xlvG+KvS6HbWakFLLH/cX6Vwfp53boX1GsIMr3XOYAAh+f6GMKPiKu3jA8IMr+6pYlP4+oIww6t7PdP6+RyFV/eWmdbx6n42g5DYlv7FsO8HeZ8qIoqw3xh/uX95gZDc30OYg7NwDE1KdrNOEQR4ywYfuadqvteDloxGEFbgLLih+S7lm+rQ0ikvTSlZYHZPHVExqod9Z5Vwui8t4pV4esLBLHC2+80GopTxWCwWIgiwyQJnfU9j4t0ddEGSiE5HXF2Jmxvs4cWte77vLoez5bTbEN7gdH9xAeENf5WCCxy6j2MId9S5r47Tds+8GkXl5OtrLuj2dHub36qc4m8tzQV1u68O/pZTPFZoNp03eoIz929vYjjMJ4EUl5fi4cF2kfVvKPdc6JNA+xX6w3Dm/vERQsLzcGo/nO2+0YDYxemA7HbM0R838MLpXn+46fAfCgVF82dBWVMIgnxVxymuxnvCeeLrOqdKavfVUbuvjlN2L8QP+YsUn2RVZxEAAAAASUVORK5CYII="

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component_TableData_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__component_TableHead_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__routes_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__asset_img_checkmark_png__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__asset_img_checkmark_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__asset_img_checkmark_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__asset_img_denied_png__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__asset_img_denied_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__asset_img_denied_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_modal__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__component_Select_js__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ViewOrders=function(_Component){_inherits(ViewOrders,_Component);function ViewOrders(props){_classCallCheck(this,ViewOrders);var _this=_possibleConstructorReturn(this,(ViewOrders.__proto__||Object.getPrototypeOf(ViewOrders)).call(this,props));_this.state={orders:[],modalIsOpen:false,cancelID:0,modalPrompt:'',view:'Pending'};_this.getOrders=_this.getOrders.bind(_this);_this.handleCancel=_this.handleCancel.bind(_this);_this.cancelOrder=_this.cancelOrder.bind(_this);_this.changeStatus=_this.changeStatus.bind(_this);_this.openModal=_this.openModal.bind(_this);_this.closeModal=_this.closeModal.bind(_this);_this.onclick=_this.onclick.bind(_this);_this.handleSelect=_this.handleSelect.bind(_this);_this.downloadReport=_this.downloadReport.bind(_this);return _this;}_createClass(ViewOrders,[{key:'getOrders',value:function getOrders(){var _this2=this;//method that retrieves all order information, different information depending on user_type
var parameters=void 0;if(this.props.userInfo.userType!=="admin"){//if not admin, grab all orders that the user has submitted
parameters={endpoint:'info',table:'orders',action:'history',kind:this.props.app,userID:this.props.userInfo.userID};}else{//if the user is an admin, there will be two different sets of data depending on if the admin would like to see pending orders or order history
if(this.state.view==="Pending"){//this is for viewing all pending orders
parameters={endpoint:'info',table:'orders',action:'admin',kind:this.props.app};}else if(this.state.view==="Fulfilled"){//this is for viewing all fulfilled orders
parameters={endpoint:'info',table:'orders',action:'admin_history',kind:this.props.app};}else if(this.state.view==="Ordered"){parameters={endpoint:'info',table:'orders',action:'ordered'};}}__WEBPACK_IMPORTED_MODULE_3_axios___default()({//retrieve order info
method:'post',url:__WEBPACK_IMPORTED_MODULE_4__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:parameters}).then(function(response){var orderitem={};var orderInfo=[];var data=response.data.data;data.forEach(function(item){orderInfo.push({ID:item.ID,userID:item.userID,name:item.name,points:item.points,Date:item.Date,status:item.order_status,items:[]});});var orders=orderInfo.filter(function(obj){return!orderitem[obj.ID]&&(orderitem[obj.ID]=true);});orders.forEach(function(order){//consolidate orders and their line items
data.forEach(function(orderItem){if(orderItem.ID===order.ID){var orderSize=orderItem.size===null?"N/A":orderItem.size;var orderColor=orderItem.color===null?"N/A":orderItem.color;order.items.push({prize:orderItem.prize,cost:orderItem.item_points,quantity:orderItem.quantity,size:orderSize,color:orderColor.replace(/_/g," ")});}});});_this2.setState({orders:orders});});}},{key:'componentDidMount',value:function componentDidMount(){//when component mounts, call getOrders()
this.getOrders();}},{key:'handleCancel',value:function handleCancel(e){//method that begins the process of canceling an order
var orderID=e.currentTarget.name;this.setState({cancelID:orderID},function(){this.openModal();});}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){//get new order information 
if(prevProps.submitted!==this.props.submitted){this.getOrders();}}},{key:'changeStatus',value:function changeStatus(status,id,date,quantity,userID){var _this3=this;//method for changing the status of an order (fulfilled,canceled, or denied)
__WEBPACK_IMPORTED_MODULE_3_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_4__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'create',table:'orders',misc:'status',status:status,firstID:id,secondID:userID,date:date,quantity:quantity}}).then(function(response){if(status==="cancel"||"denied"){_this3.setState({modalPrompt:"Order Canceled!"});if(_this3.props.userInfo.userType!=="admin"){//if a user cancels an order, refund their points
_this3.props.redeemable("add",quantity);}}else{_this3.setState({modalPrompt:"Order Fulfilled!"});}_this3.props.logChange();});}},{key:'onclick',value:function onclick(e){var _this4=this;//method that handles click of cancel, fulfill, or deny buttons
var val=e.currentTarget.value;var orderID=e.currentTarget.name;var date=void 0;var quantity=void 0;var userID=void 0;if(val==="cancel"){//if user is choosing to cancel their order
this.setState({cancelID:orderID},function(){this.openModal();});}else{//admin chose to fulfill or deny order
var newOrders=[];this.state.orders.forEach(function(order){if(Number(order.ID)!==Number(orderID)){newOrders.push(order);}else{date=order.Date;quantity=order.points;userID=_this4.props.userInfo.userType!=="admin"?_this4.props.userInfo.userID:order.userID;}});this.changeStatus(val,orderID,date,quantity,userID);this.setState({orders:newOrders});}}},{key:'handleSelect',value:function handleSelect(identity,value){//method for handling admin view selection (view pending or view history)
this.setState({view:value},function(){this.getOrders();});}},{key:'openModal',value:function openModal(){//open the modal
this.setState({modalIsOpen:true});}},{key:'closeModal',value:function closeModal(){//close the modal
this.setState({modalIsOpen:false,modalPrompt:''});}},{key:'cancelOrder',value:function cancelOrder(){var _this5=this;//method that performs necessary operations for canceling an order
var date=void 0;var _state=this.state,orders=_state.orders,cancelID=_state.cancelID;var newOrders=[];var quantity=void 0;var userID=void 0;orders.forEach(function(order){//filter out order to be cancelled
if(Number(order.ID)!==Number(cancelID)){newOrders.push(order);}else{date=order.Date;quantity=order.points;userID=_this5.props.userInfo.userType!=="admin"?_this5.props.userInfo.userID:order.userID;}});this.setState({orders:newOrders});this.changeStatus("cancel",cancelID,date,quantity,userID);}},{key:'downloadReport',value:function downloadReport(){window.location.href=__WEBPACK_IMPORTED_MODULE_4__routes_js__["d" /* report */]+"/?endpoint=order_report";}},{key:'render',value:function render(){var _this6=this;var content=void 0;var columnthree=void 0;var customStyles={content:{top:'50%',left:'50%',right:'auto',bottom:'auto',width:'400px',minWidth:'300px',borderStyle:'solid',borderWidth:'2px',borderColor:'gray',// backgroundColor:'#F4F4F4',
transform:'translate(-50%, -50%)',boxShadow:'0.5px 0.5px 1px 0.5px'},overlay:{backgroundColor:'rgba(105,105,105,0.8)'}};var approve={backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_5__asset_img_checkmark_png___default.a+')',backgroundRepeat:'no-repeat',backgroundPosition:'center',backgroundColor:'white',backgroundSize:'35px 25px',minWidth:'40px',minHeight:'30px'};var deny={backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_6__asset_img_denied_png___default.a+')',backgroundRepeat:'no-repeat',backgroundPosition:'center',backgroundColor:'white',backgroundSize:'35px 25px',minWidth:'40px',minHeight:'30px'};var orders=this.state.orders;var viewDrop=void 0;var pStyle=void 0;var selectStyles="w-100 br2 bw1 truncate shadow-3 viewOrders tc center";var columnHeads=["Prize","Unit Cost","Quantity","Size","Color"];var orderhistory=orders.map(function(orders,i){//map out all order information
var items=orders.items;var orderitems=items.map(function(items,i){//map out each line item for each order
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_TableData_js__["a" /* default */],{key:i,columns:items,cellstyle:'ba tc pa1',rowstyle:'stripe-blue',viewOrders:true});});if(_this6.props.userInfo.userType!=="admin"){//add cancel button for user if order is pending
if(orders.status==="pending"){pStyle="fl w-25 b";columnthree=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fl w-50 b'},'Status: ',orders.status),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50 tr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'w-100 bg-dark-blue br3 white b h2 mt2 mr2',style:{maxWidth:'110px'},name:orders.ID,onClick:_this6.handleCancel},'Cancel')));}else{pStyle="fl w-33 b";columnthree=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:pStyle},'Status: ',orders.status);}}else{if(_this6.state.view==="Pending"||_this6.state.view==="Ordered"){//add buttons for admin to either deny or mark as ordered if pending, mark as fulfilled if ordered.
if(_this6.state.view==="Pending"){pStyle="fl w-25 b";columnthree=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50 b'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fl w-50 b'},'Name: ',orders.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50 pr2 mt2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'fr br3',name:orders.ID,value:'ordered',onClick:_this6.onclick,style:approve}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'fr br3',name:orders.ID,value:'denied',onClick:_this6.onclick,style:deny})));}else{pStyle="fl w-25 b";columnthree=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50 b'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fl w-50 b'},'Name: ',orders.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50 pr2 mt2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'fr br3',name:orders.ID,value:'fulfilled',onClick:_this6.onclick,style:approve})));}}else{pStyle="fl w-25 b";columnthree=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fl w-50 b'},'Name: ',orders.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fl w-50 b'},'Status: ',orders.status));}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 mv3 br3 shadow-3 bg-white',key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 ba br--top br3 br bl pl2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:pStyle},'Date: ',orders.Date),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:pStyle},'Points: ',orders.points),columnthree),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'fl w-100 collapse'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',{className:'collapse'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__component_TableHead_js__["a" /* default */],{columns:columnHeads,headstyle:'ba pa2'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,orderitems)));});var order_report_button=void 0;var item_report_button=void 0;var order_report_href=void 0;var item_report_href=void 0;var item_report_button_name=void 0;var order_report_button_name=void 0;if(this.props.userInfo.userType==="admin"){//dropdown menu to view pending orders or order history for admin
if(this.state.view!=="Pending"){if(this.state.view==="Ordered"){item_report_href=__WEBPACK_IMPORTED_MODULE_4__routes_js__["d" /* report */]+"/?endpoint=item_report";order_report_href=__WEBPACK_IMPORTED_MODULE_4__routes_js__["d" /* report */]+"/?endpoint=order_report";item_report_button_name="Item Report";order_report_button_name="Order Report";}else{item_report_href=__WEBPACK_IMPORTED_MODULE_4__routes_js__["d" /* report */]+"/?endpoint=YTD_item_report";order_report_href=__WEBPACK_IMPORTED_MODULE_4__routes_js__["d" /* report */]+"/?endpoint=YTD_order_report";item_report_button_name="YTD Item Report";order_report_button_name="YTD Order Report";}var buttonClasses="br3 shadow-3 bg-dark-blue white ba pa2 no-underline b b--dark-blue reportButtons";var buttonStyle={display:'inline-block',minWidth:'100%',textAlign:'center'};//report_download_button = <input type="button" value="Download Report" onClick={this.downloadReport} className="pa1 h2 pl2 pr2 bg-blue white b br2 shadow-3"/>;
item_report_button=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:item_report_href,target:'_self',download:true,className:buttonClasses,style:buttonStyle},item_report_button_name);order_report_button=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:order_report_href,target:'_self',download:true,className:buttonClasses,style:buttonStyle},order_report_button_name);}viewDrop=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fc w-100 mb4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fc w-100 tc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fc w-100 tc',style:{maxWidth:'335px',margin:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__component_Select_js__["a" /* default */],{options:["Pending","Ordered","Fulfilled"],id:'viewOrders',styles:selectStyles,val:this.state.view,onSelect:this.handleSelect})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fc w-100 tc pt3',style:{maxWidth:'335px',margin:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50 pr1'},item_report_button),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50 pl1'},order_report_button))));}if(this.props.active){if(orders.length!==0){content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,viewDrop,orderhistory);}else{content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,viewDrop,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fl w-100 f3 tc mt3'},'There is nothing to view at this time.'));}}var modalContent=void 0;if(this.state.modalPrompt!==''){//display message
modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'b navy tc f4'},this.state.modalPrompt);}else{//display prompt for canceling an order
modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Are you sure you would like to cancel this order?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50 tc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:this.cancelOrder,className:'w-50-ns w-100 bg-navy b white br2'},'Yes')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50 tc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:this.closeModal,className:'w-50-ns w-100 bg-navy b white br2'},'No'))));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,content,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_modal___default.a,{isOpen:this.state.modalIsOpen,style:customStyles,contentLabel:'order cancel',shouldCloseOnOverlayClick:false,shouldCloseOnEsc:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 tr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'bg-white gray b br3',onClick:this.closeModal},'X')),modalContent));}}]);return ViewOrders;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ViewOrders);

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component_TableHead_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__component_Submit_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__routes_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CreateUser_js__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_modal__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__asset_img_sparkles2_png__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__asset_img_sparkles2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__asset_img_sparkles2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Validation_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__asset_img_loader_gif__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__asset_img_loader_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__asset_img_loader_gif__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//each row of inputs and selects for new user information is contained in this component
//used for validation
var BulkUser=function(_Component){_inherits(BulkUser,_Component);function BulkUser(props){_classCallCheck(this,BulkUser);var _this=_possibleConstructorReturn(this,(BulkUser.__proto__||Object.getPrototypeOf(BulkUser)).call(this,props));_this.state={newUsers:[],departments:[],userTypes:[],failedUsers:[],rows:8,submit:false,modalIsOpen:false,incomplete:false,messagePrompt:''};_this.handleChange=_this.handleChange.bind(_this);_this.handleSubmit=_this.handleSubmit.bind(_this);_this.openModal=_this.openModal.bind(_this);_this.closeModal=_this.closeModal.bind(_this);_this.addRows=_this.addRows.bind(_this);_this.getUserInfo=_this.getUserInfo.bind(_this);_this.logsubmit=_this.logsubmit.bind(_this);_this.loadingFunc=_this.loadingFunc.bind(_this);return _this;}_createClass(BulkUser,[{key:'loadingFunc',value:function loadingFunc(loading){//method for loading gif
if(loading){this.setState({loading:true},function(){this.openModal();});}else{this.setState({loading:false});}}},{key:'getUserInfo',value:function getUserInfo(){var _this2=this;//method that retrieves all departments and user types
__WEBPACK_IMPORTED_MODULE_3_axios___default()({//retrieve departments
method:'post',url:__WEBPACK_IMPORTED_MODULE_4__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'info',table:'department'}}).then(function(response){var departments=[];var data=response.data.data;data.forEach(function(d){departments.push(d.department);});_this2.setState({departments:departments});});__WEBPACK_IMPORTED_MODULE_3_axios___default()({//retrieve user types
method:'post',url:__WEBPACK_IMPORTED_MODULE_4__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'info',table:'user_type'}}).then(function(response){var types=[];var data=response.data.data;data.forEach(function(type){types.push(type.type);});_this2.setState({userTypes:types});});}},{key:'componentDidMount',value:function componentDidMount(){//when component mounts, retrieve necessary information
this.getUserInfo();}},{key:'handleChange',value:function handleChange(newUser){//method grabs all of the new users and adds them to the state since each new user is contained in the CreateUser component
this.setState(function(oldState){return{newUsers:[].concat(_toConsumableArray(oldState.newUsers),[newUser])};});}},{key:'handleSubmit',value:function handleSubmit(){//method that sets submit to true, which sets all operations for submitting the new users into motion
this.setState({submit:true},function(){this.loadingFunc(true);});}},{key:'logsubmit',value:function logsubmit(failure){//method that keeps track of incomplete user data
this.setState({incomplete:failure});}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){if(prevState.submit===true&&prevState.newUsers!==this.state.newUsers&&this.state.newUsers.length!==0){//if all new user information has been passed up from create user components
var newUsers=this.state.newUsers;var failures=[];var userCreate=[];newUsers.forEach(function(user){//validate each field and the either push to be sent or into failed
if(Object(__WEBPACK_IMPORTED_MODULE_8__Validation_js__["a" /* default */])("name",user.name)&&Object(__WEBPACK_IMPORTED_MODULE_8__Validation_js__["a" /* default */])("email",user.email)&&Object(__WEBPACK_IMPORTED_MODULE_8__Validation_js__["a" /* default */])("pword",user.password)&&user.complete){userCreate.push(__WEBPACK_IMPORTED_MODULE_3_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_4__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'create',table:'users',name:user.name,email:user.email,misc:user.password,picture:user.department,status:user.userType}}).catch(function(){failures.push(user);}));}else{if(user.name.trim()===''){user.name="BLANK";}if(user.email.trim()===''){user.email="BLANK";}failures.push(user);}});this.setState({submit:false});this.setState({failedUsers:failures},function(){var _this3=this;__WEBPACK_IMPORTED_MODULE_3_axios___default.a.all(userCreate).then(function(){//send all valid new users
_this3.setState({newUsers:[],messagePrompt:'All users created successfully!'});_this3.props.logChange();_this3.loadingFunc(false);if(_this3.state.incomplete){_this3.closeModal();}});});}else if(prevState.submit===true&&this.state.submit===true){//if no information has been entered but submit has been clicked
this.setState({submit:false,messagePrompt:'Please Input at least one user.'});this.loadingFunc(false);if(this.state.incomplete){this.closeModal();}}}},{key:'openModal',value:function openModal(){//method to open the modal
this.setState({modalIsOpen:true});}},{key:'closeModal',value:function closeModal(){//method to close the modal
this.setState({modalIsOpen:false,submit:false,failedUsers:[]});}},{key:'addRows',value:function addRows(){//method to add rows (CreateUser components)
var oldRows=this.state.rows;var newRows=oldRows+5;this.setState({rows:newRows});}},{key:'render',value:function render(){var content=void 0;var customStyles={content:{top:'50%',left:'50%',right:'auto',bottom:'auto',width:'100%',minWidth:'300px',maxWidth:'600px',minHeight:'200px',maxHeight:'600px',borderStyle:'solid',borderWidth:'2px',borderColor:'gray',transform:'translate(-50%, -50%)',backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_7__asset_img_sparkles2_png___default.a+')',backgroundRepeat:'no-repeat',backgroundSize:'300px 160px',backgroundPosition:'right',boxShadow:'0.5px 0.5px 1px 0.5px'},overlay:{backgroundColor:'rgba(105,105,105,0.8)'}};var tableRows=[];for(var i=0;i<this.state.rows;i++){//generate rows of inputs and selects for new user information
tableRows.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__CreateUser_js__["a" /* default */],{key:i,id:i,onChange:this.handleChange,submit:this.state.submit,departments:this.state.departments,userTypes:this.state.userTypes,employees:this.state.employees,failed:this.logsubmit}));}var modalContent=void 0;var failed=this.state.failedUsers;var incomplete=void 0;if(this.state.loading){//display loader gif
modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tc',style:{width:'150px',margin:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_9__asset_img_loader_gif___default.a,alt:'Loading'}));}else if(failed.length>0){//display all failed users to be created
modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 tr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'bg-white gray b br3',onClick:this.closeModal},'X')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'tc b f4 navy'},'There was a problem creating the following users: '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{overflowY:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UnOrderedList,{failed:failed})));}else{//display message
modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 tr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'bg-white gray b br3',onClick:this.closeModal},'X')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'tc b f3 navy mt0'},this.state.messagePrompt));}if(this.props.active){content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'br3 pa3 ba b--light-silver',style:{boxShadow:'0px 0px 5px 5px #aaaaaa inset',overflowY:'auto',maxHeight:'475px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{maxWidth:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_TableHead_js__["a" /* default */],{columns:["Name","Email","Password","Department","User Type"]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,tableRows))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tr mr3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',onClick:this.addRows,className:'blue no-underline underline-hover'},'+Add Rows'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mt4 mb2'},incomplete,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__component_Submit_js__["a" /* default */],{name:'Submit',onClick:this.handleSubmit,styles:'br3 white b w-20-ns w-50 hh3 bg-navy shadow-3'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_modal___default.a,{isOpen:this.state.modalIsOpen,style:customStyles,contentLabel:'Account Creation Modal',shouldCloseOnOverlayClick:false,shouldCloseOnEsc:false},modalContent)));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,content);}}]);return BulkUser;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (BulkUser);var UnOrderedList=function UnOrderedList(props){//unordered list functional component to display failed new users
var li=props.failed.map(function(failed,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:i,className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fl w-50 b f5 navy tl pa0 bb b--light-silver mt0'},failed.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fl w-50 b f5 tl navy pa0 mt0 bb b--light-silver'},failed.email));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'fl w-100'},li);};

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component_Input_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__component_Select_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Validation_js__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CreateUser=function(_Component){_inherits(CreateUser,_Component);function CreateUser(props){_classCallCheck(this,CreateUser);var _this=_possibleConstructorReturn(this,(CreateUser.__proto__||Object.getPrototypeOf(CreateUser)).call(this,props));_this.state={name:'',email:'',password:'',department:'Select',userType:'Select',localID:_this.props.id};_this.handleInput=_this.handleInput.bind(_this);return _this;}_createClass(CreateUser,[{key:'handleInput',value:function handleInput(identity,value){//standard method for handling user input
var theState={};theState[identity]=value;this.setState(theState);}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var s=this.state;if(this.props.submit!==prevProps.submit&&this.props.submit){//if the user has chosen to submit new user information
if(s.name.trim()!==""&&s.email.trim()!==""&&s.password.trim()!==""&&s.department!=="Select"&&s.userType!=="Select"&&prevProps.submit===false){//make sure user chose to submit information and that all information has been filled out
this.props.onChange({complete:true,name:s.name.trim(),email:s.email.trim(),password:s.password.trim(),department:s.department,userType:s.userType,localID:this.props.id});//pass state up to parent (BulkUser)
this.setState({name:'',email:'',password:'',department:'Select',userType:'Select'});//clear input fields
this.props.failed(false);}else if(s.name.trim()!==""||s.email.trim()!==""||s.password.trim()!==""||s.department!=="Select"||s.userType!=="Select"){//if a field is empty, pass up new user information with the complete flag set to false to allow for error messages
this.props.failed(false);this.props.onChange({complete:false,name:s.name.trim(),email:s.email.trim(),password:s.password.trim(),department:s.department,userType:s.userType,localID:this.props.id});this.setState({name:'',email:'',password:'',department:'Select',userType:'Select'});}}}},{key:'render',value:function render(){var inputStyles="h2 pa2 br2 bw1 w-100 shadow-3";var departments=this.props.departments;var types=this.props.userTypes;var selectStyles="h2 pa1 w-100 br2 bw1 truncate shadow-3";var tdStyle="pa2";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:tdStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_Input_js__["a" /* default */],{identity:'name',onInput:this.handleInput,inputStyle:inputStyles,val:this.state.name})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:tdStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_Input_js__["a" /* default */],{identity:'email',onInput:this.handleInput,inputStyle:inputStyles,val:this.state.email})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:tdStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_Input_js__["a" /* default */],{identity:'password',onInput:this.handleInput,inputStyle:inputStyles,val:this.state.password})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:tdStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__component_Select_js__["a" /* default */],{identity:'department',options:departments,onSelect:this.handleInput,styles:selectStyles,val:this.state.department})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:tdStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__component_Select_js__["a" /* default */],{identity:'userType',options:types,onSelect:this.handleInput,styles:selectStyles,val:this.state.userType})));}}]);return CreateUser;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CreateUser);

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__component_Select_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__asset_img_loader_gif__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__asset_img_loader_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__asset_img_loader_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_modal__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_modal__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}__WEBPACK_IMPORTED_MODULE_5_react_modal___default.a.setAppElement('#root');var ViewUsers=function(_Component){_inherits(ViewUsers,_Component);function ViewUsers(props){_classCallCheck(this,ViewUsers);var _this=_possibleConstructorReturn(this,(ViewUsers.__proto__||Object.getPrototypeOf(ViewUsers)).call(this,props));_this.state={users:[],selected:{},userTypes:[],modalIsOpen:false,loading:false,confirmationMessage:''};_this.handleClick=_this.handleClick.bind(_this);_this.getData=_this.getData.bind(_this);_this.handleSelect=_this.handleSelect.bind(_this);_this.getUsers=_this.getUsers.bind(_this);_this.resetPassword=_this.resetPassword.bind(_this);_this.closeModal=_this.closeModal.bind(_this);return _this;}_createClass(ViewUsers,[{key:'getUsers',value:function getUsers(){var _this2=this;//method for retrieving users and user_types from DB
__WEBPACK_IMPORTED_MODULE_1_axios___default()({//retrieve all users
method:'post',url:__WEBPACK_IMPORTED_MODULE_2__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'info',table:'users',action:"view"}}).then(function(response){var users=[];var data=response.data.data;data.forEach(function(user){users.push(user);});_this2.setState({users:users},function(){this.getData(users[0],0);});});__WEBPACK_IMPORTED_MODULE_1_axios___default()({//retrieve user types
method:'post',url:__WEBPACK_IMPORTED_MODULE_2__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'info',table:'user_type'}}).then(function(response){var types=[];var data=response.data.data;data.forEach(function(type){types.push(type.type);});_this2.setState({userTypes:types});});}},{key:'componentDidMount',value:function componentDidMount(){this.getUsers();}},{key:'getData',value:function getData(user,index){var _this3=this;//method to retrieve user stats for the selected user
__WEBPACK_IMPORTED_MODULE_1_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_2__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'info',table:'points',userID:user.userID}}).then(function(response){var data=response.data.data;var merge=Object.assign({},data[0],user,{index:index});_this3.setState({selected:merge});});}},{key:'handleSelect',value:function handleSelect(identity,value){//method for handling user input
var selected=this.state.selected;selected[identity]=value;this.setState({selected:selected});var misc=void 0;if(identity==='user_status'){//update user status (active or inactive) on change
var index=selected.index;var users=this.state.users;users[index].user_status=value;this.setState({users:users});misc="status";}else{//update usertype on change
misc="type";}__WEBPACK_IMPORTED_MODULE_1_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_2__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'create',table:'users',misc:misc,firstID:selected.userID,status:value}});}},{key:'handleClick',value:function handleClick(e){var _this4=this;//handles retrieving user data based on which user name was clicked
this.state.users.filter(function(user){if(user.userID===Number(e.target.id)){_this4.getData(user,e.target.name);}});}},{key:'closeModal',value:function closeModal(){this.setState({modalIsOpen:false,confirmationMessage:''});}},{key:'resetPassword',value:function resetPassword(){var _this5=this;this.setState({loading:true});__WEBPACK_IMPORTED_MODULE_1_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_2__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'create',table:'users',misc:'security_reset',firstID:this.state.selected.userID}}).then(function(response){_this5.setState({confirmationMessage:response.data.data.Message},function(){this.setState({loading:false});});}).catch(function(error){_this5.setState({confirmationMessage:"There has been a problem. Please try again later."},function(){this.setState({loading:false});});});}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){//if new users are created, retrieve the updated user list
if(prevProps.submitted!==this.props.submitted){this.getUsers();}}},{key:'render',value:function render(){var _this6=this;var modalContent=void 0;var customStyles={content:{top:'50%',left:'50%',right:'auto',bottom:'auto',width:'100%',minHeight:'195px',maxWidth:'500px',transform:'translate(-50%, -50%)',backgroundRepeat:'no-repeat',backgroundSize:'280px 252px',backgroundPosition:'right',boxShadow:'0.5px 0.5px 1px 0.5px'},overlay:{backgroundColor:'rgba(105,105,105,0.8)'}};var labelStyle="fl w-50 f3 navy";var spanStyle="dark-blue";var selectStyles="h2 pa1 w-90 br2 bw1 truncate shadow-3 bg-near-white";var content=void 0;var status=["active","inactive"];var pStyle="f3 navy bb b--light-silver";var promptContent=void 0;if(!this.state.loading){if(this.state.confirmationMessage===''){promptContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'navy b f4'},'Are you sure you want to reset ',this.state.selected.name,'\'s security information?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'200px',margin:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{onClick:this.resetPassword,className:'mr2 yes_button white'},'Yes'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{onClick:this.closeModal,className:'no_button white'},'No')));}else{promptContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'navy b f4'},this.state.confirmationMessage));}modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'w-100 tr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'bg-white gray b br3',onClick:this.closeModal},'X')),promptContent);}else{modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tc',style:{width:'150px',margin:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4__asset_img_loader_gif___default.a,alt:'Loading...'}));}if(this.props.active){content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-25 mb2',style:{maxHeight:'500px',height:'500px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UnorderedList,{users:this.state.users,onClick:this.handleClick})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-75 br3 pb3 pl2 bg-white mt2',style:{boxShadow:'0px 0px 3px 3px #aaaaaa inset',height:'540px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{maxWidth:'400px',margin:'auto'},className:'mt3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'f2 tc underline mt_3 navy'},this.state.selected.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:pStyle},'Points Earned: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:spanStyle},this.state.selected.earned),'/',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:spanStyle},this.state.selected.cap)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:pStyle},'Points Redeemed: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:spanStyle},this.state.selected.redeemed),'/',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:spanStyle},this.state.selected.cap)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:pStyle},'Points Redeemable: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:spanStyle},this.state.selected.redeemable),'/',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:spanStyle},this.state.selected.cap)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:pStyle},'Sent Thank Yous: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:spanStyle},this.state.selected.sent)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:pStyle},'Received Thank Yous: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:spanStyle},this.state.selected.received)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 mb3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:labelStyle},'User Type: '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:' tl fl w-50'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__component_Select_js__["a" /* default */],{identity:'user_type',options:this.state.userTypes,val:this.state.selected.user_type,onSelect:this.handleSelect,styles:selectStyles}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 mb4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:labelStyle},'User Status: '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:' tl fl w-50'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__component_Select_js__["a" /* default */],{identity:'user_status',options:status,val:this.state.selected.user_status,onSelect:this.handleSelect,styles:selectStyles}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 pb3 pt1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'169px',margin:'auto',paddingBottom:'5px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'shadow-3',id:'reset_password',onClick:function onClick(){return _this6.setState({modalIsOpen:true});}},'Reset Security Info'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_modal___default.a,{isOpen:this.state.modalIsOpen,style:customStyles,contentLabel:'Admin Security Reset',shouldCloseOnOverlayClick:false,shouldCloseOnEsc:false},modalContent));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,content);}}]);return ViewUsers;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ViewUsers);var UnorderedList=function UnorderedList(props){//unordered list function component for displaying the list of all users, separated by their status (active or inactive)
var p="tc b underline";var activeUserList=[];var inactiveUserList=[];props.users.forEach(function(user,i){if(user.user_status!=="inactive"){activeUserList.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:i,className:'mb1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',className:'dark-blue no-underline underline-hover',name:i,id:user.userID,onClick:props.onClick},user.name)));}else{inactiveUserList.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:i,className:'mb1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',className:'mid-gray no-underline underline-hover',name:i,id:user.userID,onClick:props.onClick},user.name)));}});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:p},'Active Users'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'list pl2 overflow-y-auto bb b--light-silver',style:{maxHeight:'200px'}},activeUserList),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:p},'Inactive Users'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'list pl2 overflow-y-auto',style:{maxHeight:'200px'}},inactiveUserList));};

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__component_Select_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ManageTiers_js__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ManageVirtues_js__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ManageYears_js__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ManagePrizes_js__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ManageAdminMessages_js__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ManageDepartments_js__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__component_Submit_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_modal__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__asset_img_loader_gif__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__asset_img_loader_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__asset_img_loader_gif__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//container for viewing, creating, or editing Tiers
//container for viewing, creating, or editing lov values
//container for viewing or creating years
//container for viewing, creating, or editing prizes
//container for viewing or creating admin messages
//container for viewing or creating departments 
var AdminCenter=function(_Component){_inherits(AdminCenter,_Component);function AdminCenter(props){_classCallCheck(this,AdminCenter);var _this=_possibleConstructorReturn(this,(AdminCenter.__proto__||Object.getPrototypeOf(AdminCenter)).call(this,props));_this.state={Tiers:[],Prizes:[],Virtues:[],Years:[],Messages:[],Departments:[],departmentInfo:[],employees:[],category:'Prizes',year:'',create:false,edit:false,save:false};_this.handleSelect=_this.handleSelect.bind(_this);_this.goBack=_this.goBack.bind(_this);_this.onClose=_this.onClose.bind(_this);_this.getTiers=_this.getTiers.bind(_this);_this.getVirtues=_this.getVirtues.bind(_this);_this.getPrizes=_this.getPrizes.bind(_this);_this.getMessages=_this.getMessages.bind(_this);_this.handleChoice=_this.handleChoice.bind(_this);_this.handleSave=_this.handleSave.bind(_this);_this.handleReset=_this.handleReset.bind(_this);_this.revertSave=_this.revertSave.bind(_this);_this.loadingFunc=_this.loadingFunc.bind(_this);_this.openModal=_this.openModal.bind(_this);_this.closeModal=_this.closeModal.bind(_this);_this.getDepartments=_this.getDepartments.bind(_this);return _this;}_createClass(AdminCenter,[{key:'getDepartments',value:function getDepartments(){var _this2=this;//method that retrieves and formats all department data from the database
__WEBPACK_IMPORTED_MODULE_1_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_2__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'info',table:'department',action:'manage'}}).then(function(response){var data=response.data.data;var departmentNames=[];//list of departments
var departmentInfo=[];//list of information about departments
var index=void 0;for(var i=0;i<data.length;i++){index=departmentNames.indexOf(data[i].department);if(index!==-1){//if list of departments already contains department
if(data[i].name!==data[i].manager){departmentInfo[index].employees.push({userID:data[i].userID,name:data[i].name});}else{departmentInfo[index].manager.userID=data[i].userID;}}else{departmentNames.push(data[i].department);if(data[i].name!==data[i].manager){departmentInfo.push({department:data[i].department,manager:{name:data[i].manager,userID:''},employees:[{userID:data[i].userID,name:data[i].name}]});}else{departmentInfo.push({department:data[i].department,manager:data[i].manager,employees:[]});}}}_this2.setState({Departments:departmentNames,departmentInfo:departmentInfo,employees:data});});}},{key:'loadingFunc',value:function loadingFunc(loading){//method for displaying and closing loading gif
if(loading){this.setState({loading:true},function(){this.openModal();});}else{this.setState({loading:false},function(){this.closeModal();});}}},{key:'componentDidMount',value:function componentDidMount(){var _this3=this;//when component mounts, all information regarding prizes/gifts, tiers, admin messages, years, departments, and values are retrieved.
__WEBPACK_IMPORTED_MODULE_1_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_2__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'info',table:'years'}}).then(function(response){var data=response.data.data;_this3.setState({Years:data,year:data[0].year});_this3.getTiers(data[0].year);_this3.getPrizes(data[0].year);_this3.getMessages(data[0].year);});this.getDepartments();this.getVirtues();}},{key:'getTiers',value:function getTiers(year){var _this4=this;//method that handles retrieving tier information for the selected year from the database.
__WEBPACK_IMPORTED_MODULE_1_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_2__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'info',table:'tiers',kind:this.props.app,year:year}}).then(function(response){var data=response.data.data;_this4.setState({Tiers:data});});}},{key:'getVirtues',value:function getVirtues(){var _this5=this;//method that handles retrieving lov values information from the database.
__WEBPACK_IMPORTED_MODULE_1_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_2__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'info',table:'virtues',action:'admin'}}).then(function(response){var data=response.data.data;_this5.setState({Virtues:data});});}},{key:'getPrizes',value:function getPrizes(year){var _this6=this;//method that handles retrieving prize/gift information for the selected year from the database.
this.loadingFunc(true);var prizes=[];var variants=[];__WEBPACK_IMPORTED_MODULE_1_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_2__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'info',table:'prizes',kind:'lov',action:this.props.userInfo.userType,year:year}}).then(function(response){//outer promise
var data=response.data.data;data.forEach(function(prize){prizes.push(Object.assign(prize,{variants:[]}));});__WEBPACK_IMPORTED_MODULE_1_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_2__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'info',table:'variants',action:'admin',year:year}}).then(function(response){var data=response.data.data;data.forEach(function(variant){variants.push(variant);});}).then(function(){for(var i=0;i<prizes.length;i++){prizes[i].picture=__WEBPACK_IMPORTED_MODULE_2__routes_js__["e" /* storeImagePath */]+prizes[i].picture;for(var j=0;j<variants.length;j++){if(variants[j].prizeID===prizes[i].prizeID){prizes[i].variants.push(variants[j]);}}}_this6.setState({Prizes:prizes},function(){this.loadingFunc(false);});});//end outer romise
});}},{key:'getMessages',value:function getMessages(year){var _this7=this;//method that handles retrieving admin message information for the selected year from the database.
__WEBPACK_IMPORTED_MODULE_1_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_2__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'info',table:'messages',action:'admin_center',kind:'admin',year:year}}).then(function(response){var data=response.data.data;_this7.setState({Messages:data});});}},{key:'handleChoice',value:function handleChoice(identity){//this method controls the state of the admin center, whether it is in view mode, edit mode, or create mode.
if(identity==="create"){this.setState({create:true});this.setState({edit:false});}else{this.setState({edit:true});this.setState({create:false});}}},{key:'handleSelect',value:function handleSelect(identity,value){//handleChange method for the category and year dropdown menus
var theState={};theState[identity]=value;this.setState(theState);if(identity==="year"){this.setState({edit:false});this.getTiers(value);this.getPrizes(value);this.getMessages(value);}else{this.goBack();}}},{key:'handleReset',value:function handleReset(type){var _this8=this;//method that grabs the current version of information that was just updated from the database
if(type==="tiers"){this.getTiers(this.state.year);}else if(type==="prizes"){this.getPrizes(this.state.year);}else if(type==="virtues"){this.getVirtues();}else if(type==="years"){__WEBPACK_IMPORTED_MODULE_1_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_2__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'info',table:'years'}}).then(function(response){var data=response.data.data;_this8.setState({Years:data,year:data[0].year});});}else if(type==="messages"){this.getMessages(this.state.year);}this.setState({create:false,edit:false,save:false});}},{key:'goBack',value:function goBack(){//method sets the create, edit, and save parts of the state to their defaults
this.setState({create:false,edit:false,save:false});}},{key:'handleSave',value:function handleSave(){//method to trigger state change for saving information that has been created or updated
this.setState({save:true});}},{key:'revertSave',value:function revertSave(){//method to reset the save parameter of the state to its default
this.setState({save:false});}},{key:'onClose',value:function onClose(){//method that resets create or edit back to default when user exits in the middle of an operation
this.setState({create:false,edit:false});}},{key:'openModal',value:function openModal(){//method for opening the modal
this.setState({modalIsOpen:true});}},{key:'closeModal',value:function closeModal(){//method for closing the modal
this.setState({modalIsOpen:false,submit:false,failed:[]});}},{key:'render',value:function render(){var customStyles={content:{top:'50%',left:'50%',right:'auto',bottom:'auto',width:'100%',minWidth:'300px',maxWidth:'400px',minHeight:'250px',maxHeight:'250px',borderStyle:'solid',borderWidth:'2px',borderColor:'gray',transform:'translate(-50%, -50%)',boxShadow:'0.5px 0.5px 1px 0.5px'},overlay:{backgroundColor:'rgba(105,105,105,0.8)'}};var dis=false;var inlineContent={boxShadow:'0px 0px 5px 5px #aaaaaa inset',backgroundColor:'#e6e6e6',maxHeight:'450px',overflowY:'auto'};var contentStyles="br3 ba b--gray fl pb4 w-100 pt3 mb3";var greaterContent=void 0;var _state=this.state,Tiers=_state.Tiers,create=_state.create,edit=_state.edit,save=_state.save,year=_state.year,Virtues=_state.Virtues,Years=_state.Years,Prizes=_state.Prizes,Messages=_state.Messages;var content=void 0;var categories=["Tiers","Prizes","Values","Messages","Years","Departments"];//options for category dropdown
var years=this.state.Years.map(function(Years){return Years.year;});//returns an array of the current year options for year dropdown
var selectStyles="h2 pa1 w-70-ns w-100 br2 bw1 truncate shadow-2";var labelStyle="fl w-30";var selectDivStyle="fl w-70";var buttonStyles="br3 white b w-100 h2 bg-navy shadow-2";var prizeTiers=[];Tiers.forEach(function(tiers){//returns all active tiers for prize/gift creation
if(tiers.tier_status!=='inactive'){prizeTiers.push(tiers.tier);}});var yearSelect=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50-ns w-100-m w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:labelStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'b mt2'},'Year: ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:selectDivStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__component_Select_js__["a" /* default */],{identity:'year',options:years,onSelect:this.handleSelect,styles:selectStyles,val:this.state.year})));var saveButton=void 0;var createButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__component_Submit_js__["a" /* default */],{name:'Create',identity:'create',onClick:this.handleChoice,styles:buttonStyles});//default create button
var editButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__component_Submit_js__["a" /* default */],{name:'Edit',identity:'edit',onClick:this.handleChoice,styles:buttonStyles,disable:dis});//default edit button
if(this.state.create||this.state.edit){saveButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__component_Submit_js__["a" /* default */],{name:'Save',identity:'save',onClick:this.handleSave,styles:buttonStyles});if(this.state.create){//if the admin center is in create mode, these are the button values
editButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__component_Submit_js__["a" /* default */],{name:'Back',identity:'back',onClick:this.goBack,styles:buttonStyles});createButton=saveButton;}else{//if the admin center is in edit mode, these are the button values
if(this.state.category==="Prizes"){editButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__component_Submit_js__["a" /* default */],{name:'Back',identity:'back',onClick:this.goBack,styles:buttonStyles});}else{editButton=saveButton;createButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__component_Submit_js__["a" /* default */],{name:'Back',identity:'back',onClick:this.goBack,styles:buttonStyles});}}}//button original div that the buttons remain in, can change based on category chosen
var ButtonGroup=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mb2 mt3',style:{maxWidth:'300px',margin:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50 tr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tr'},createButton)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50'},editButton));switch(this.state.category){//switch statement for rendering content based on category selection
case"Tiers":content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ManageTiers_js__["a" /* default */],{tiers:Tiers,revertSave:this.revertSave,create:create,edit:edit,save:save,year:year,app:this.props.app,reset:this.handleReset});break;case"Prizes":content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ManagePrizes_js__["a" /* default */],{prizes:Prizes,revertSave:this.revertSave,create:create,edit:edit,save:save,year:year,app:this.props.app,reset:this.getPrizes,onClose:this.onClose,tiers:prizeTiers});break;case"Values":yearSelect='';content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ManageVirtues_js__["a" /* default */],{virtues:Virtues,revertSave:this.revertSave,create:create,edit:edit,save:save,reset:this.handleReset});break;case"Messages":content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ManageAdminMessages_js__["a" /* default */],{messages:Messages,years:years,year:year,revertSave:this.revertSave,create:create,edit:edit,save:save,reset:this.getMessages,userInfo:this.props.userInfo});dis=true;if(!this.state.create){//admin messages dont have an edit option
ButtonGroup=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mb2 mt3',style:{maxWidth:'300px',margin:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tc w-50 center'},createButton)));}else{ButtonGroup=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mb2 mt3',style:{maxWidth:'300px',margin:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50 tr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tr'},createButton)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__component_Submit_js__["a" /* default */],{name:'Back',identity:'back',onClick:this.goBack,styles:buttonStyles})));}break;case"Years":content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ManageYears_js__["a" /* default */],{years:Years,year:year,revertSave:this.revertSave,create:create,edit:edit,save:save,reset:this.handleReset});dis=true;yearSelect='';if(!this.state.create){//years dont have an edit option
ButtonGroup=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mb2 mt3',style:{maxWidth:'300px',margin:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tc w-50 center'},createButton)));}else{ButtonGroup=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mb2 mt3',style:{maxWidth:'300px',margin:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50 tr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tr'},createButton)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__component_Submit_js__["a" /* default */],{name:'Back',identity:'back',onClick:this.goBack,styles:buttonStyles})));}break;case"Departments":content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ManageDepartments_js__["a" /* default */],{Add:this.createDepartment,getDepartments:this.getDepartments,create:create,departments:this.state.Departments,employeeList:this.state.employees,departmentInfo:this.state.departmentInfo});yearSelect='';if(!this.state.create){//departments dont have an edit option
ButtonGroup=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mb2 mt3',style:{maxWidth:'300px',margin:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tc w-50 center'},createButton)));}else{ButtonGroup=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mb2 mt3',style:{maxWidth:'300px',margin:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'w-50 tc center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__component_Submit_js__["a" /* default */],{name:'Back',identity:'back',onClick:this.goBack,styles:buttonStyles}))));}break;default:content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ManagePrizes_js__["a" /* default */],{prizes:Prizes,create:create,revertSave:this.revertSave,edit:edit,save:save,year:year,app:this.props.app,reset:this.getPrizes,onClose:this.onClose});}if(this.props.active){greaterContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 mv2 pb3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50-ns w-100-m w-100 mb1',style:{display:'inline-block'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:labelStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'b mt2'},'Category: ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:selectDivStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__component_Select_js__["a" /* default */],{identity:'category',options:categories,onSelect:this.handleSelect,styles:selectStyles,val:this.state.category}))),yearSelect),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:contentStyles,style:inlineContent},content),ButtonGroup,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_modal___default.a,{isOpen:this.state.modalIsOpen,style:customStyles,contentLabel:'loading',shouldCloseOnOverlayClick:false,shouldCloseOnEsc:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 tr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'bg-white gray b br3',onClick:this.closeModal},'X')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tc',style:{width:'150px',margin:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_12__asset_img_loader_gif___default.a,alt:'Loading'})))));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,greaterContent);}}]);return AdminCenter;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AdminCenter);

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component_Input_js__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CreateTiers=function(_Component){_inherits(CreateTiers,_Component);function CreateTiers(props){_classCallCheck(this,CreateTiers);var _this=_possibleConstructorReturn(this,(CreateTiers.__proto__||Object.getPrototypeOf(CreateTiers)).call(this,props));_this.state={tier:'',points:'',index:_this.props.id};_this.handleInput=_this.handleInput.bind(_this);return _this;}_createClass(CreateTiers,[{key:'handleInput',value:function handleInput(identity,value){//standard method for handling user input, with added regex to only allow numbers
if(/^(\s*|[1-9][0-9]*)$/.test(value)){var theState={};theState[identity]=value;this.setState(theState);}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(this.props.save){//if the user has clicked the save button
var tID=this.props.id.toString()+'_tier';//tier id
var pID=this.props.id.toString()+'_points';//points/price id
if(prevProps.save===false&&this.props.save===true&&this.state.tier!==''&&this.state.points!==''){//conditional to prevent infinite loop and to check whether or not values have been entered for the tier and points/price field
this.props.onSave(this.state);//pass up tier info to parent (ManageTiers)
}else if(prevProps.save===false&&this.props.save===true&&this.state.tier===''&&this.state.points!==''||this.state.tier!==''&&this.state.points===''){//if one or both of the fields is blank
if(this.state.points!==''&&this.state.tier===''){//highlight tier input
document.getElementById(tID).style.borderColor="red";}else{document.getElementById(tID).style.borderColor="inherit";}if(this.state.points===''&&this.state.tier!==''){//highlight points/price input
document.getElementById(pID).style.borderColor="red";}else{document.getElementById(pID).style.borderColor="inherit";}this.props.onSave(this.state);//pass up incomplete information so that parent can display proper error message
}else if(prevProps.save===false&&this.props.save===true&&this.state.tier===''&&this.state.points===''){//once state has been passed up, remove error highlighting
document.getElementById(tID).style.borderColor="inherit";document.getElementById(pID).style.borderColor="inherit";}}if(this.props.success){//if success, clear inputs
if(prevProps.success!==this.props.success&&this.props.success){this.setState({tier:'',points:''});}}}},{key:'render',value:function render(){var inputStyles="h2 br2 bw1 w-100 shadow-3 pl2 pr2";var label=void 0;if(this.props.app==="lov"){//tiers have point values for lov, have price values for asm
label="Points: ";}else{label="Price: ($)";}var tierId=this.props.id.toString()+'_tier';var pointsId=this.props.id.toString()+'_points';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'w-90-ns w-100-m w-100 center',style:{maxWidth:'500px',margin:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50 mb3 pr3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 mt2 navy'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'b navy'},'Tier Number: ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_Input_js__["a" /* default */],{identity:'tier',id:tierId,onInput:this.handleInput,type:'number',val:this.state.tier,inputStyle:inputStyles}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50 mb3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 mt2 navy'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'b navy'},label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_Input_js__["a" /* default */],{identity:'points',id:pointsId,onInput:this.handleInput,type:'number',val:this.state.points,inputStyle:inputStyles}))));}}]);return CreateTiers;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CreateTiers);

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component_Input_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__component_Select_js__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EditTiers=function(_Component){_inherits(EditTiers,_Component);function EditTiers(props){_classCallCheck(this,EditTiers);var _this=_possibleConstructorReturn(this,(EditTiers.__proto__||Object.getPrototypeOf(EditTiers)).call(this,props));_this.state={points:'',status:'',original:{}};_this.handleInput=_this.handleInput.bind(_this);return _this;}_createClass(EditTiers,[{key:'componentDidMount',value:function componentDidMount(){//when component mounts, fill in current tier values in input fields
this.setState({points:this.props.tiers.points,status:this.props.tiers.tier_status,original:this.props.tiers});}},{key:'handleInput',value:function handleInput(identity,value){//standard method for processing user input
var theState={};theState[identity]=value;this.setState(theState);}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(prevProps.save===false&&this.props.save===true){//if the user has chosen to save the edited values
this.props.onSave({quantity:this.state.points,status:this.state.status,firstID:this.props.tiers.ID,misc:'edit'});//pass up values to ManageTiers component
var pID=this.props.id.toString()+"_points";if(this.state.points===''){//empty point values are not allowed, highlight empty point input fields
document.getElementById(pID).style.borderColor="red";}else{document.getElementById(pID).style.borderColor="inherit";}}else if(prevProps.save===true&&this.props.save===false&&this.props.success){//clear/reset input fields
this.setState({points:'',status:'',original:{}});}}},{key:'render',value:function render(){var selectStyles="h2 pa1 w-90 br2 bw1 ml2-ns truncate shadow-2";var inputStyles="h2 br2 bw1 w-100 ml2-ns shadow-3 pl2 pr2";var priceType=this.props.app==="lov"?"Points: ":"Max Price: $";var pointsID=this.props.id.toString()+"_points";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 mt3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt2 b navy'},'Tier: ',this.props.tiers.tier)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50 tr mt2 b navy'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,priceType,' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50 tl'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_Input_js__["a" /* default */],{identity:'points',id:pointsID,onInput:this.handleInput,type:'number',val:this.state.points,inputStyle:inputStyles}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-40'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50 tr mt2 b navy'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Status: ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50 tl'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__component_Select_js__["a" /* default */],{identity:'status',onSelect:this.handleInput,val:this.state.status,options:["active","inactive"],styles:selectStyles}))));}}]);return EditTiers;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (EditTiers);

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__component_Select_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__component_Input_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Validation_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_modal__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__asset_img_sparkles2_png__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__asset_img_sparkles2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__asset_img_sparkles2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__asset_img_loader_gif__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__asset_img_loader_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__asset_img_loader_gif__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ManageVirtues=function(_Component){_inherits(ManageVirtues,_Component);function ManageVirtues(props){_classCallCheck(this,ManageVirtues);var _this=_possibleConstructorReturn(this,(ManageVirtues.__proto__||Object.getPrototypeOf(ManageVirtues)).call(this,props));_this.state={rows:1,newVirtues:[],editVirtues:[],failedVirtues:[],modalIsOpen:false,loading:false,modalPrompt:''};_this.addRows=_this.addRows.bind(_this);_this.handleEdit=_this.handleEdit.bind(_this);_this.handleInput=_this.handleInput.bind(_this);_this.closeModal=_this.closeModal.bind(_this);return _this;}_createClass(ManageVirtues,[{key:'addRows',value:function addRows(){//add rows of input field for creating new lov values
var rows=this.state.rows+1;this.setState({rows:rows});}},{key:'handleEdit',value:function handleEdit(identity,value){//method for handling status update of lov values
var virtueState=this.state.editVirtues;virtueState[identity].lov_status=value;this.setState({editVirtues:virtueState});}},{key:'handleInput',value:function handleInput(identity,value){//method for handling user input for new value creation
var virtueState=this.state.newVirtues;virtueState[identity]=value;this.setState({newVirtues:virtueState});}},{key:'closeModal',value:function closeModal(){//close the modal
this.setState({modalIsOpen:false,failedVirtues:[]});}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var _this2=this;if(prevProps.save!==this.props.save&&this.props.save){this.setState({loading:true},function(){this.setState({modalIsOpen:true});});if(this.props.create){//if user has chosen to save new values that they have created
var newVirtues=this.state.newVirtues;var failures=[];if(newVirtues.length>0){//make sure that they are not trying to save empty input field(s)
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.all(newVirtues.map(function(virtues){if(Object(__WEBPACK_IMPORTED_MODULE_5__Validation_js__["a" /* default */])("name",virtues)){//validate user input
return __WEBPACK_IMPORTED_MODULE_1_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_2__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'create',table:'virtues',misc:'create',desc:virtues}}).catch(function(error){failures.push(virtues);});}else{failures.push(virtues);}})).then(function(){if(failures.length<1){//success message
_this2.setState({modalPrompt:'Value(s) successfully created!'});}_this2.setState({failedVirtues:failures,newVirtues:[],rows:1},function(){this.props.reset("virtues");this.setState({loading:false});});});}else{//display message if user attempted to save with no new values
this.setState({newVirtues:[],modalPrompt:'Please enter at least one value.'},function(){this.setState({loading:false});this.props.revertSave();});}}else if(this.props.edit){//if user is saving edited lov values
var editVirtues=this.state.editVirtues;var _failures=[];__WEBPACK_IMPORTED_MODULE_1_axios___default.a.all(editVirtues.map(function(virtues){return __WEBPACK_IMPORTED_MODULE_1_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_2__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'create',table:'virtues',misc:'status',firstID:virtues.ID,status:virtues.lov_status}}).catch(function(error){_failures.push(virtues);});})).then(function(){if(_failures.length<1){//success message
_this2.setState({modalPrompt:'Value(s) successfully updated!'});}_this2.setState({failedVirtues:_failures,editVirtues:[]},function(){this.props.reset("virtues");this.setState({loading:false});});});}}else if(prevProps.edit!==this.props.edit&&this.props.edit){this.setState({editVirtues:this.props.virtues});}}},{key:'render',value:function render(){var _this3=this;var customStyles={content:{top:'50%',left:'50%',right:'auto',bottom:'auto',width:'100%',minWidth:'300px',maxWidth:'600px',minHeight:'200px',maxHeight:'600px',borderStyle:'solid',borderWidth:'2px',borderColor:'gray',transform:'translate(-50%, -50%)',backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_7__asset_img_sparkles2_png___default.a+')',backgroundRepeat:'no-repeat',backgroundSize:'300px 160px',backgroundPosition:'right',boxShadow:'0.5px 0.5px 1px 0.5px'},overlay:{backgroundColor:'rgba(105,105,105,0.8)'}};var selectStyles="h2 pa1 w-90-ns w-100 br2 bw1 truncate shadow-2";var label=void 0;var virtues=void 0;var input=[];var add=void 0;var labelStyle={marginBlockStart:'1em',marginBlockEnd:'1em'};var inputStyles="pa2 shadow-2 br2 bw1 w-100-ns w-100 mw6";if(!this.props.edit){//display current lov values
virtues=this.props.virtues.map(function(virtues){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:virtues.ID,className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fl w-75 navy b'},virtues.virtue),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fl w-25'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'b navy'},'Status:'),' ',virtues.lov_status));});if(this.props.create){//display input field for new value creation
label=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'tl fl navy b'},'Value: ');for(var i=0;i<this.state.rows;i++){input.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:i,className:'pb2'},label,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__component_Input_js__["a" /* default */],{type:'text',identity:i,onInput:this.handleInput,inputStyle:inputStyles})));}add=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',onClick:this.addRows},'+Add');}}else if(this.props.edit){//display dropdown menu with active and inactive options for each value
virtues=this.state.editVirtues.map(function(virtues,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:virtues.ID,className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-60 b navy mt1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,virtues.virtue)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-40',style:labelStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-35 pr2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'fl w-35 b navy mt1'},'Status: ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-65'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__component_Select_js__["a" /* default */],{identity:i,onSelect:_this3.handleEdit,options:["active","inactive"],val:virtues.lov_status,styles:selectStyles}))));});}var modalContent=void 0;if(this.state.loading){//display loading gif
modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tc',style:{width:'150px',margin:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_8__asset_img_loader_gif___default.a,alt:'Loading'}));}else if(this.state.failedVirtues.length>0){//display values that failed due to connection or validation
modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 tr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'bg-white gray b br3',onClick:this.closeModal},'X')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'tc b f4 navy'},'There was a problem creating the following virtues: '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{overflowY:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UnOrderedList,{failed:this.state.failedVirtues}))));}else{//display message
modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 tr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'bg-white gray b br3',onClick:this.closeModal},'X')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'tc b navy f4'},this.state.modalPrompt),';');}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{maxWidth:'550px',margin:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'list'},virtues),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'list'},input,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tr'},add))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_modal___default.a,{isOpen:this.state.modalIsOpen,style:customStyles,contentLabel:'Values Modal',shouldCloseOnOverlayClick:false,shouldCloseOnEsc:false},modalContent)));}}]);return ManageVirtues;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ManageVirtues);var UnOrderedList=function UnOrderedList(props){//unordered list for displaying values that were not created due to failure
var li=props.failed.map(function(failed,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:i,className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fl w-100 b f5 navy tc pa0 bb b--light-silver mt0'},failed));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'fl w-100'},li);};

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__component_Input_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_modal__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__asset_img_loader_gif__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__asset_img_loader_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__asset_img_loader_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__asset_img_sparkles2_png__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__asset_img_sparkles2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__asset_img_sparkles2_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ManageYears=function(_Component){_inherits(ManageYears,_Component);function ManageYears(props){_classCallCheck(this,ManageYears);var _this=_possibleConstructorReturn(this,(ManageYears.__proto__||Object.getPrototypeOf(ManageYears)).call(this,props));_this.state={newYear:{year:'',cap:'',sent:'',received:''},failed:false,modalPrompt:'',loading:false};_this.handleCreate=_this.handleCreate.bind(_this);_this.closeModal=_this.closeModal.bind(_this);return _this;}_createClass(ManageYears,[{key:'handleCreate',value:function handleCreate(identity,value){//method for handling user input for each input field during year creation
var pass=false;if(identity==="year"&&value.toString().length<=4){//makes sure that year length is 4
pass=true;}else if(identity==="cap"&&value.toString().length<=3){//makes sure that point cap length for user points is 3
pass=true;}else if(identity==="sent"&&value.toString().length<=2){//makes sure that sent points length is 2
pass=true;}else if(identity==="received"&&value.toString().length<=2){//makes sure that received points length is 2
pass=true;}if(pass&&/^(\s*|[1-9][0-9]*)$/.test(value)){//only allow blank input fields or positive integers
var theState=this.state.newYear;theState[identity]=value;this.setState({newYear:theState});}}},{key:'closeModal',value:function closeModal(){//close the modal
this.setState({modalIsOpen:false,modalPrompt:''});this.props.revertSave();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var _this2=this;if(prevProps.save!==this.props.save&&this.props.save){//if user has chosen to save new year information
var newYear=this.state.newYear;var d=new Date();var year=d.getFullYear();var failed=false;if(this.props.create&&newYear.year!==''&&newYear.year!==0&&newYear.year>=year&&newYear.cap!==''&&newYear.cap!==0&&newYear.sent!==''&&newYear.sent!==0&&newYear.received!==''&&newYear.received!==0){//make sure all fields are filled out and that none of them equal 0
this.setState({loading:true,modalIsOpen:true});__WEBPACK_IMPORTED_MODULE_1_axios___default()({//create new year information
method:'post',url:__WEBPACK_IMPORTED_MODULE_2__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'create',table:'year',misc:'create',firstID:newYear.year,secondID:newYear.cap,thirdID:newYear.sent,quantity:newYear.received}}).then(function(response){if(response.data.data.Message==="Year exists."){//if year already exists, alert user
_this2.setState({modalPrompt:'Year already exists.'},function(){this.setState({loading:false});document.getElementById("year").classList.add("invalid");});}else{//clear inputs and alert user that year was successfully created
_this2.props.reset("years");_this2.setState({newYear:{year:'',cap:'',sent:'',received:''},modalPrompt:'Year successfully created!'},function(){this.setState({loading:false});});}}).catch(function(error){_this2.setState({modalPrompt:'There was a problem during creation. Please try again.'},function(){this.setState({loading:false});});});}else{var prompt='';if(newYear.year===''||newYear.cap===''||newYear.sent===''||newYear.received===''){//validate fields and highlight the ones that are not filled out
prompt+='All Fields are required. ';if(newYear.year===''||newYear.year<=year){document.getElementById("year").classList.add("invalid");}else{document.getElementById("year").classList.remove("invalid");}if(newYear.cap===''){document.getElementById("pointCap").classList.add("invalid");}else{document.getElementById("pointCap").classList.remove("invalid");}if(newYear.sent===''){document.getElementById("sent").classList.add("invalid");}else{document.getElementById("sent").classList.remove("invalid");}if(newYear.received===''){document.getElementById("received").classList.add("invalid");}else{document.getElementById("received").classList.remove("invalid");}}if(newYear.year<=year){//validate year value
prompt+='Year is invalid. Please try again. ';document.getElementById("year").classList.add("invalid");}else{document.getElementById("year").classList.remove("invalid");}this.setState({modalPrompt:prompt},function(){this.setState({modalIsOpen:true});});}}}},{key:'render',value:function render(){var customStyles={content:{top:'50%',left:'50%',right:'auto',bottom:'auto',width:'100%',minWidth:'300px',maxWidth:'400px',minHeight:'200px',maxHeight:'200px',borderStyle:'solid',borderWidth:'2px',borderColor:'gray',transform:'translate(-50%, -50%)',boxShadow:'0.5px 0.5px 1px 0.5px',backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_6__asset_img_sparkles2_png___default.a+')',backgroundSize:'300px 200px',backgroundRepeat:'no-repeat'},overlay:{backgroundColor:'rgba(105,105,105,0.8)'}};var newYear=this.state.newYear;var years=void 0;var pstyle="fl w-25 f4";var create=void 0;var labelStyle="mt2 b tr-ns mr3 pt1 navy";var divstyle="fl w-100 mb4";var inputStyles="pl1 h2 br2 bw1 w-70-ns w-100 shadow-2 ml1-ns";var modalContent=void 0;if(this.state.loading){//display loading gif
modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tc',style:{width:'150px',margin:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5__asset_img_loader_gif___default.a,alt:'Loading'}));}else{//display message
modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 tr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'bg-white gray b br3',onClick:this.closeModal},'X')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pt3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'tc b f4 navy mt3'},this.state.modalPrompt)));}if(!(this.props.edit||this.props.create)){//display all years and their information
years=this.props.years.map(function(years,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'fl w-100 bb b--light-silver',key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fl w-20 f4'},'Year: ',years.year),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:pstyle},'Point Cap: ',years.point_cap),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:pstyle},'Sent Points: ',years.sent_points),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fl w-30 f4'},'Received Points: ',years.received_points));});}else if(this.props.create){//display input fields for creating new year information
years=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'fl w-100',key:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:divstyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-40-ns w-100 tr-ns pt1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:labelStyle},'Year:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-60-ns w-100 tl'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__component_Input_js__["a" /* default */],{identity:'year',id:'year',val:newYear.year,onInput:this.handleCreate,inputStyle:inputStyles,type:'number'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:divstyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-40-ns w-100 tr-ns pt1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:labelStyle},'Point Cap:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-60-ns w-100 tl'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__component_Input_js__["a" /* default */],{identity:'cap',id:'pointCap',val:newYear.cap,onInput:this.handleCreate,inputStyle:inputStyles,type:'number'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'fl w-100',key:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:divstyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-40-ns w-100 tr-ns pt1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:labelStyle},'Sent Points:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-60-ns w-100 tl'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__component_Input_js__["a" /* default */],{identity:'sent',id:'sent',val:newYear.sent,onInput:this.handleCreate,inputStyle:inputStyles,type:'number'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:divstyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-40-ns w-100 tr-ns pt1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:labelStyle},'Received Points:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-60-ns w-100 tl'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__component_Input_js__["a" /* default */],{identity:'received',id:'received',val:newYear.received,onInput:this.handleCreate,inputStyle:inputStyles,type:'number'}))))];}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{maxWidth:'700px',margin:'auto'},className:'w-90 center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'list'},years),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pt2',style:{maxWidth:'500px',margin:'auto'}},create),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_modal___default.a,{isOpen:this.state.modalIsOpen,style:customStyles,contentLabel:'loading',shouldCloseOnOverlayClick:false,shouldCloseOnEsc:false},modalContent)));}}]);return ManageYears;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ManageYears);

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CreatePrize_js__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EditPrize_js__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_modal__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__asset_img_sparkles2_png__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__asset_img_sparkles2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__asset_img_sparkles2_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ManagePrizes=function(_Component){_inherits(ManagePrizes,_Component);function ManagePrizes(props){_classCallCheck(this,ManagePrizes);var _this=_possibleConstructorReturn(this,(ManagePrizes.__proto__||Object.getPrototypeOf(ManagePrizes)).call(this,props));_this.state={newPrize:'',editedPrize:[],currentVariants:[],failed:false};_this.viewVariants=_this.viewVariants.bind(_this);_this.openModal=_this.openModal.bind(_this);_this.closeModal=_this.closeModal.bind(_this);return _this;}_createClass(ManagePrizes,[{key:'viewVariants',value:function viewVariants(e){//method that retrieves all prize variants for user to see for the prize that they have selected
var ID=e.target.id;var variants=[];this.props.prizes.forEach(function(prizes){if(Number(prizes.prizeID)===Number(ID)){variants=prizes.variants;}});this.setState({currentVariants:variants},function(){this.openModal();});}},{key:'openModal',value:function openModal(){//open the modal
this.setState({modalIsOpen:true});}},{key:'closeModal',value:function closeModal(){//close the modal
this.setState({modalIsOpen:false});}},{key:'render',value:function render(){var _this2=this;var customStyles={content:{top:'50%',left:'50%',right:'auto',bottom:'auto',width:'80%',transform:'translate(-50%, -50%)',borderWidth:'1px',borderColor:'gray',minHeight:'350px',maxWidth:'630px',boxShadow:'0.5px 0.5px 1px 0.5px'},overlay:{backgroundColor:'rgba(105,105,105,0.8)'}};var picstyles={display:'block',maxWidth:'100px',maxHeight:'122px',width:'auto',height:'auto',margin:'auto'};var prizes=void 0;var variants=void 0;var pStyles="mt0 pt3 fl w-100 b navy mb3 bb b--light-silver";if(!(this.props.create||this.props.edit)&&this.props.prizes.length>0){//display all prizes for the selected year
prizes=this.props.prizes.map(function(prizes,i){var cap=prizes.cap===null?"none":prizes.cap;var photo=prizes.picture+prizes.variants[0].photo;photo=photo.replace(/\s/g,"_");return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50-ns mb2 w-100-m w-100 pa1',key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{maxWidth:'460px',margin:'auto',height:'250px'},className:'ba overflow-y-hidden ma2 pa2 bw1 b--light-silver br3 shadow-3 bg-white'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-60',style:{minHeight:'200px',maxHeight:'200px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt0 pt2 tc b mr2'},prizes.prize),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:photo,alt:'error',style:picstyles,className:'mr2'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'tc mr2'},prizes.description)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-40'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:pStyles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'b'},'Tier: '),prizes.tier),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:pStyles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'b'},'Cap: '),cap),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:pStyles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'b'},'Status: '),prizes.status),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'br2 bg-navy white pa1 mt2 b',id:prizes.prizeID,onClick:_this2.viewVariants},'View Variants')))));});if(this.state.currentVariants!==''){//return a list of all prize variants for selected prize if user clicks "View Variants" button
variants=this.state.currentVariants.map(function(variants,i){var size=variants.size===null||variants.size===undefined||variants.size===''?"N/A":variants.size;var color=variants.color===null||variants.color===undefined||variants.color===''?"N/A":variants.color;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fl w-33 tc bb b--light-silver'},size),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fl w-33 tc bb b--light-silver'},color),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fl w-33 tc bb b--light-silver'},variants.status));});}}else if(this.props.create){//if user clicks create, display CreatePrize component
prizes=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__CreatePrize_js__["a" /* default */],{save:this.props.save,year:this.props.year,reset:this.props.reset,tiers:this.props.tiers,revertSave:this.props.revertSave});}else if(this.props.edit){//if user clicks edit, display EditPrize component
if(this.props.prizes.length>0){//check to make sure there have been prizes created for the current selected year
prizes=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__EditPrize_js__["a" /* default */],{save:this.props.save,year:this.props.year,prizes:this.props.prizes,reset:this.props.reset,onClose:this.props.onClose,revertSave:this.props.revertSave,tiers:this.props.tiers});}else{prizes=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'w-100 f3 tc'},'There is nothing to view at this time.');}}else{prizes=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'w-100 f3 tc'},'There is nothing to view at this time.');}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pa3'},prizes),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_modal___default.a,{isOpen:this.state.modalIsOpen,onRequestClose:this.closeModal,shouldCloseOnOverlayClick:false,shouldCloseOnEsc:false,style:customStyles,contentLabel:'Registration Modal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 tr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'bg-white gray b br3',onClick:this.closeModal},'X')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 mt2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'list pl3 mt0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'b bb b--dark-gray bw1 tc fl w-33'},'Size'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'b bb b--gray tc bw1 fl w-33'},'Color'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'b bb b--gray tc bw1 fl w-33'},'Status'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'overflow-y-auto fl w-100',style:{maxHeight:'200px',minHeight:'250px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'list pl3 mt0'},variants)))));}}]);return ManagePrizes;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ManagePrizes);

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__component_Input_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__asset_img_loader_gif__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__asset_img_loader_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__asset_img_loader_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_modal__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__component_Select_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Validation_js__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CreatePrize=function(_Component){_inherits(CreatePrize,_Component);function CreatePrize(props){_classCallCheck(this,CreatePrize);var _this=_possibleConstructorReturn(this,(CreatePrize.__proto__||Object.getPrototypeOf(CreatePrize)).call(this,props));_this.handleInput=_this.handleInput.bind(_this);_this.handleFile=_this.handleFile.bind(_this);_this.handlePic=_this.handlePic.bind(_this);_this.addRows=_this.addRows.bind(_this);_this.logColor=_this.logColor.bind(_this);_this.logSizes=_this.logSizes.bind(_this);_this.setVariants=_this.setVariants.bind(_this);_this.onCreate=_this.onCreate.bind(_this);_this.reconcileVariants=_this.reconcileVariants.bind(_this);_this.putVariants=_this.putVariants.bind(_this);_this.fileInput=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.openModal=_this.openModal.bind(_this);_this.closeModal=_this.closeModal.bind(_this);_this.isImage=_this.isImage.bind(_this);_this.loadingFunc=_this.loadingFunc.bind(_this);_this.state={prize:'',tier:1,cap:'',picture:'',description:'',noPic:'',variants:[],files:[],rows:1,modalIsOpen:false,modalPrompt:'',loading:false};return _this;}_createClass(CreatePrize,[{key:'loadingFunc',value:function loadingFunc(loading){//method for displaying the loading gif
if(loading){this.setState({loading:true},function(){this.openModal();});}else{this.setState({loading:false});}}},{key:'isImage',value:function isImage(file){//method to determine whether or not an uploaded file is an image (validate file uploads to prevent malicious code/programs from being uploaded)
return file['type'].split('/')[0]=='image';}},{key:'handleInput',value:function handleInput(identity,value){//standard method for updating the state based on user input
var theState=this.state;theState[identity]=value;this.setState(theState);}},{key:'openModal',value:function openModal(){//method for opening the modal
this.setState({modalIsOpen:true});}},{key:'closeModal',value:function closeModal(){//method for closing the modal
this.setState({modalIsOpen:false,modalPrompt:''});}},{key:'addRows',value:function addRows(){var rows=this.state.rows+1;this.setState({rows:rows});}},{key:'setVariants',value:function setVariants(variants){this.setState(function(oldState){return{variants:[].concat(_toConsumableArray(oldState.variants),[variants])};});}},{key:'handleFile',value:function handleFile(){//method that stores correct file name for each picture that is uploaded
var fileNames=[];var variants=[];var files=[];for(var i=0;i<this.fileInput.current.files.length;i++){if(this.isImage(this.fileInput.current.files[i])){fileNames.push("lov_"+this.fileInput.current.files[i].name.replace(/\s/g,"_"));files.push(this.fileInput.current.files[i]);variants.push({color:'',sizes:''});}}this.setState({picture:fileNames,variants:variants,files:files});}},{key:'handlePic',value:function handlePic(identity,value){//handles changing the name of each picture uploaded based on the color it is associated with
var theState=this.state.picture;var endIndex=theState[identity].lastIndexOf(".");var ext=theState[identity].substr(endIndex);value=value.trim().toLowerCase()+ext;theState[identity]=value.replace(/\s/g,"_");this.setState({picture:theState});}},{key:'logColor',value:function logColor(identity,value){//method for logging each color value in the state
var variants=this.state.variants;variants[identity].color=value;this.setState({variants:variants});this.handlePic(identity,value);}},{key:'logSizes',value:function logSizes(identity,value){//method for logging each size value in the state
var variants=this.state.variants;variants[identity].sizes=value;this.setState({variants:variants});}},{key:'reconcileVariants',value:function reconcileVariants(){//method for organizing and compiling all variant values together to get ready to send to database
var pictures=this.state.picture;var noPic=this.state.noPic;var fixedVariants=[];var variants=this.state.variants;var _loop=function _loop(i){//create a variant for each size and color combo with its corresponding picture
var sizes=variants[i].sizes.split(",");sizes.forEach(function(size){fixedVariants.push({size:size.trim(),color:variants[i].color.trim(),photo:pictures[i]});});};for(var i=0;i<variants.length;i++){_loop(i);}if(noPic!==''){//format all variants without pictures
var otherVariants=noPic.split("\n");otherVariants=otherVariants.map(function(variant){return variant.split(";").map(function(next){return next.split(":");});});otherVariants.forEach(function(varArray){var sizes=varArray[0][1].split(",");var colors=varArray[1][1].split(",");for(var i=0;i<sizes.length;i++){for(var j=0;j<colors.length;j++){fixedVariants.push({size:sizes[i],color:colors[j],photo:pictures[0]});}}});}this.setState({variants:fixedVariants});}},{key:'putVariants',value:function putVariants(id){var _this2=this;//method for storing all variants in the database
var variants=this.state.variants;var merge=[].concat.apply([],variants);if(merge.length===0){merge.push({size:null,color:null});}var variantCalls=[];merge.forEach(function(variant){//format all variant data
var size=variant.size===''||variant.size===undefined?null:variant.size.replace(/\s/g,"_");var color=variant.color===''||variant.color===undefined?null:variant.color.replace(/\s/g,"_");variantCalls.push(__WEBPACK_IMPORTED_MODULE_1_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_2__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'create',table:'variants',misc:'create',firstID:id,secondID:_this2.props.year,status:size,name:color,picture:"_"+variant.photo}}));});__WEBPACK_IMPORTED_MODULE_1_axios___default.a.all(variantCalls).then(function(){//send all variants
_this2.props.revertSave();_this2.setState({prize:'',tier:'',cap:'',picture:'',description:'',noPic:'',variants:[],rows:1,modalPrompt:'Prize successfully created!'},function(){this.loadingFunc(false);});_this2.props.reset(_this2.props.year);setTimeout(function(){_this2.closeModal();},1500);});}},{key:'onCreate',value:function onCreate(newPrize){var _this3=this;//method to create main prize information (tier, year, type, picture path, name of prize, description)
var cap=newPrize.cap===''||newPrize.cap===0?null:newPrize.cap;var picture="lov_"+newPrize.prize.replace(/\s/g,"_").replace(/'/g,"_").toLowerCase();__WEBPACK_IMPORTED_MODULE_1_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_2__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'create',table:'prizes',misc:'create',firstID:newPrize.tier,secondID:this.props.year,quantity:cap,status:'lov',name:newPrize.prize,picture:picture,desc:newPrize.description}}).then(function(response){var data=response.data.data;if(data.ID!==0){_this3.reconcileVariants();_this3.putVariants(data.ID);}else{_this3.setState({modalPrompt:"Prize already exists!"},function(){this.loadingFunc(false);});_this3.props.revertSave();}});}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){var _this4=this;if(prevProps.save!==this.props.save&&this.props.save){//if user has chosen to save/create prize
document.getElementById("desc").classList.remove("invalid");document.getElementById("prize").classList.remove("invalid");document.getElementById("noPic").classList.remove("invalid");var _state=this.state,tier=_state.tier,picture=_state.picture,files=_state.files;var noPic=this.state.noPic;var prize=this.state.prize;var description=this.state.description;var validColors=true;var noColorCount=0;if(picture.length>=1){//make sure that each picture has its color listed if there is more than one picture
for(var i=0;i<this.state.variants.length;i++){if(this.state.variants[i].color===''){noColorCount++;}}}if(picture.length===1&&noColorCount>1){validColors=false;}else if(picture.length>1&&noColorCount>0){validColors=false;}if(prevProps.save!==this.props.save&&this.props.save&&picture.length>0&&Object(__WEBPACK_IMPORTED_MODULE_7__Validation_js__["a" /* default */])("prize",prize.trim())&&Object(__WEBPACK_IMPORTED_MODULE_7__Validation_js__["a" /* default */])("prize",description.trim())&&validColors){//if user has chosen to create prize and input is valid
var validNoPic=true;if(noPic!==''){//make sure all no picture variants are valid
if(/\n/.test(noPic)){noPic=noPic.split("\n");noPic.forEach(function(line){if(!Object(__WEBPACK_IMPORTED_MODULE_7__Validation_js__["a" /* default */])("noPic",line)){validNoPic=false;}});}else{if(!Object(__WEBPACK_IMPORTED_MODULE_7__Validation_js__["a" /* default */])("noPic",noPic)){validNoPic=false;}}}var validVariants=true;if(this.state.variants.length>0){//make sure all variants are valid
this.state.variants.forEach(function(variant){if(variant.sizes!==''&&!Object(__WEBPACK_IMPORTED_MODULE_7__Validation_js__["a" /* default */])("size",variant.sizes)){validVariants=false;}if(variant.color!==''&&!Object(__WEBPACK_IMPORTED_MODULE_7__Validation_js__["a" /* default */])("color",variant.color)){validVariants=false;}});}if(picture!==''&&prize.trim()!==''&&description.trim()!==''){if(validNoPic&&validVariants){(function(){var success=[];var calls=[];_this4.loadingFunc(true);for(var _i=0;_i<files.length;_i++){//send variant picture files to server
var name=prize.trim().toLowerCase().replace(/\s/g,"_");if(picture.length>1){name=name+"_"+picture[_i];}else{name=name+"_"+picture[0];}var data=new FormData();data.append('file[]',files[_i],"lov_"+name);calls.push(__WEBPACK_IMPORTED_MODULE_1_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_2__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:data}).then(function(response){var data=response.data.data;if(data!=="error"){success.push(data);}}));}__WEBPACK_IMPORTED_MODULE_1_axios___default.a.all(calls).then(function(){//once all pictures have been stored, create the prize
_this4.onCreate(_this4.state);});})();}else{if(validVariants){//noPic variants contains invalid input
document.getElementById("noPic").classList.add("invalid");this.setState({modalPrompt:'Please follow the correct format for "Variants without pictures".'},function(){this.openModal();this.props.revertSave();});}else{if(validNoPic){document.getElementById("noPic").classList.remove("invalid");}var j=void 0;var sizeElements=document.getElementsByClassName("sizeInput");var colorElements=document.getElementsByClassName("colorInput");for(j=0;j<sizeElements.length;j++){//highlight whichever size inputs are invalid
if(sizeElements[j].value!==''&&!Object(__WEBPACK_IMPORTED_MODULE_7__Validation_js__["a" /* default */])("size",sizeElements[j].value)){sizeElements[j].classList.add("invalid");}else{sizeElements[j].classList.remove("invalid");}}for(j=0;j<colorElements.length;j++){//highlight whichever color inputs are invalid
if(colorElements[j].value!==''&&!Object(__WEBPACK_IMPORTED_MODULE_7__Validation_js__["a" /* default */])("color",colorElements[j].value)){colorElements[j].classList.add("invalid");}else{colorElements[j].classList.remove("invalid");}}this.setState({modalPrompt:'Please enter variants in the correct format.'},function(){this.openModal();this.props.revertSave();});}}}else{if(picture===''){//highlight picture label
document.getElementById("pic").classList.add("invalidLabel");}else{document.getElementById("pic").classList.remove("invalidLabel");}if(prize.trim()===''){//highlight prize input
document.getElementById("prize").classList.add("invalid");}else{document.getElementById("prize").classList.remove("invalid");}if(description.trim()===''){//highlight description input
document.getElementById("desc").classList.add("invalid");}else{document.getElementById("desc").classList.remove("invalid");}this.setState({modalPrompt:'All fields except for "variants without pictures" are required.'},function(){this.openModal();this.props.revertSave();});}}else if(prevProps.save!==this.props.save&&this.props.save&&picture.length<1||!Object(__WEBPACK_IMPORTED_MODULE_7__Validation_js__["a" /* default */])("prize",prize.trim())||!Object(__WEBPACK_IMPORTED_MODULE_7__Validation_js__["a" /* default */])("prize",description.trim())||!validColors){var modalPrompt='';if(picture.length<1){//if no pictures have been chosen
modalPrompt+='At least one picture is required for each prize.\n';document.getElementById("pic").classList.add("invalidLabel");}else{document.getElementById("pic").classList.remove("invalidLabel");}if(!validColors){//if multiple pictures chosen but colors not specified
modalPrompt+='Colors need to be specified if there is more than one photo.\n';var elements=document.getElementsByClassName("colorInput");for(var _i2=0;_i2<elements.length;_i2++){if(elements[_i2].value.trim()===''){elements[_i2].classList.add("invalid");}else{elements[_i2].classList.remove("invalid");}}}if(!Object(__WEBPACK_IMPORTED_MODULE_7__Validation_js__["a" /* default */])("prize",prize.trim())||!Object(__WEBPACK_IMPORTED_MODULE_7__Validation_js__["a" /* default */])("prize",description.trim())){//if prize or description are not valid
modalPrompt+='Prize name and/or description does not contain valid input.\n';if(!Object(__WEBPACK_IMPORTED_MODULE_7__Validation_js__["a" /* default */])("prize",prize.trim())){//if prize is not valid
document.getElementById("prize").classList.add("invalid");}else{document.getElementById("prize").classList.remove("invalid");}if(!Object(__WEBPACK_IMPORTED_MODULE_7__Validation_js__["a" /* default */])("prize",description.trim())){//if description is not valid
document.getElementById("desc").classList.add("invalid");}else{document.getElementById("desc").classList.remove("invalid");}}this.setState({modalPrompt:modalPrompt},function(){this.openModal();this.props.revertSave();});}}}},{key:'render',value:function render(){var customStyles={content:{top:'50%',left:'50%',right:'auto',bottom:'auto',width:'400px',minWidth:'300px',borderStyle:'solid',borderWidth:'2px',borderColor:'gray',transform:'translate(-50%, -50%)',boxShadow:'0.5px 0.5px 1px 0.5px'},overlay:{backgroundColor:'rgba(105,105,105,0.8)'}};var picstyles={display:'block',maxWidth:'100px',maxHeight:'100px',width:'auto',height:'auto',margin:'auto'};var picPreviews=[];var inputStyles="h2 br2 bw1 w-100 shadow-3 pl2 pr2";var areaStyles="br2 bw1 h3 w-100 shadow-3 pa2";var modalContent=void 0;if(this.state.loading){//display loading gif
modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tc',style:{width:'150px',margin:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4__asset_img_loader_gif___default.a,alt:'Loading'}));}else{//display error/success message
modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 tr pb2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'bg-white gray b br3',onClick:this.closeModal},'X')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'b navy f4 tc'},this.state.modalPrompt));}if(this.state.picture!==''){//display image previews with color and size input fields for each image
for(var i=0;i<this.state.files.length;i++){var prevURL=URL.createObjectURL(this.state.files[i]);picPreviews.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-33-ns w-50 mv3',style:{height:'200px'},key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mt0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'100px',height:'100px',margin:'auto'},className:'tc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:prevURL,alt:'error',style:picstyles})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{maxWidth:'100px',margin:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pb1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'color: '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__component_Input_js__["a" /* default */],{identity:i,onInput:this.logColor,placeholder:'color',inputStyle:'h2 br2 bw1 w-100 shadow-3 pl2 pr2 colorInput'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'sizes: '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__component_Input_js__["a" /* default */],{identity:i,onInput:this.logSizes,placeholder:'xl,med,...',inputStyle:'h2 br2 bw1 w-100 shadow-3 pl2 pr2 sizeInput'}))))));}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'w-60-ns w-80-m w-90 center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 mt3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50-ns w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'b'},'Prize name: ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 pr2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__component_Input_js__["a" /* default */],{identity:'prize',onInput:this.handleInput,id:'prize',val:this.state.prize,inputStyle:inputStyles}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-25-ns w-50 mt0-ns mt2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'b'},'Tier: ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 pr2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__component_Select_js__["a" /* default */],{name:'tier',identity:'tier',onSelect:this.handleInput,options:this.props.tiers,styles:inputStyles,val:this.state.tier}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-25-ns w-50 mt0-ns mt2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'b'},'Cap: ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 pr2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__component_Input_js__["a" /* default */],{identity:'cap',onInput:this.handleInput,val:this.state.cap,inputStyle:inputStyles,type:'number'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 mt3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'b'},'Description: ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 pr2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__component_Input_js__["a" /* default */],{type:'text',identity:'description',id:'desc',inputStyle:inputStyles,onInput:this.handleInput,val:this.state.description}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 mt3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-20'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'b',id:'pic'},'Picture(s): ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-80 pl2 overflow-x-hidden'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ml2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'file',name:'file',onChange:this.handleFile,ref:this.fileInput,accept:'image/*',multiple:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pics ml2-ns',style:{maxWidth:'525px',margin:'auto'}},picPreviews),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 mt3 pb3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 tl pr2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'b'},'Variants without pictures: '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__component_Input_js__["a" /* default */],{type:'area',identity:'noPic',id:'noPic',styles:areaStyles,onInput:this.handleInput,val:this.state.noPic,placeholder:'i.e. sizes:xl;colors:red,green,blue'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_modal___default.a,{isOpen:this.state.modalIsOpen,style:customStyles,contentLabel:'loading/message',shouldCloseOnOverlayClick:false,shouldCloseOnEsc:false},modalContent)));}}]);return CreatePrize;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CreatePrize);

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_modal__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CurrentEdit_js__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__asset_img_loader_gif__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__asset_img_loader_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__asset_img_loader_gif__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//component that contains the information of prize that is currently being edited
var EditPrizes=function(_Component){_inherits(EditPrizes,_Component);function EditPrizes(props){_classCallCheck(this,EditPrizes);var _this=_possibleConstructorReturn(this,(EditPrizes.__proto__||Object.getPrototypeOf(EditPrizes)).call(this,props));_this.editPrize=_this.editPrize.bind(_this);_this.openModal=_this.openModal.bind(_this);_this.closeModal=_this.closeModal.bind(_this);_this.commitEdit=_this.commitEdit.bind(_this);_this.putVariants=_this.putVariants.bind(_this);_this.updateVariants=_this.updateVariants.bind(_this);_this.updatePrize=_this.updatePrize.bind(_this);_this.loadingFunc=_this.loadingFunc.bind(_this);_this.state={currentEdit:'',editedPrizes:[],failed:false,modalIsOpen:false,loading:false,done:false};return _this;}_createClass(EditPrizes,[{key:'loadingFunc',value:function loadingFunc(loading){//function to open modal and display loading gif
if(loading){this.setState({loading:true},function(){this.openModal();});}else{this.setState({loading:false},function(){this.props.reset(this.props.year);});}}},{key:'editPrize',value:function editPrize(e){//method for selecting which prize/gift to be edited. passes down information to CurrentEdit component
var ID=e.target.id;var prize=void 0;this.props.prizes.forEach(function(prizes){if(Number(prizes.prizeID)===Number(ID)){prize=prizes;}});this.setState({currentEdit:prize},function(){this.openModal();});}},{key:'updatePrize',value:function updatePrize(p){//method that handles api calls for updating all prize information
__WEBPACK_IMPORTED_MODULE_1_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_2__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'create',table:'prizes',misc:'update',name:p.prize,secondID:p.tier,desc:p.description,quantity:p.cap,firstID:p.ID,status:p.status}});}},{key:'putVariants',value:function putVariants(id,variants){var _this2=this;variants.forEach(function(variant){__WEBPACK_IMPORTED_MODULE_1_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_2__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'create',table:'variants',misc:'create',firstID:id,secondID:_this2.props.year,status:variant.size,name:variant.color}});});}},{key:'updateVariants',value:function updateVariants(variants){var _this3=this;//method for updating the status of pize variants (active or inactive)
var updated=[];variants.forEach(function(variant){updated.push(__WEBPACK_IMPORTED_MODULE_1_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_2__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'create',table:'variants',misc:'status',firstID:variant.variantID,status:variant.status}}));});__WEBPACK_IMPORTED_MODULE_1_axios___default.a.all(updated).then(function(){_this3.setState({modalPrompt:"Prize Updated!",done:true},function(){this.loadingFunc(false);});});}},{key:'commitEdit',value:function commitEdit(edited){//begin process of saving edited information
if(edited.ID!==0){this.loadingFunc(true);this.updatePrize(edited);this.updateVariants(edited.variants);}else{this.setState({modalPrompt:"Sorry, there was a problem with your input. Please try again.",done:true},function(){this.openModal();});}}},{key:'openModal',value:function openModal(){//open the modal
this.setState({modalIsOpen:true});}},{key:'closeModal',value:function closeModal(){//close the modal
this.setState({modalIsOpen:false,done:false});}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){var _this4=this;//dont believe this code is used anymore
if(prevProps.save!==this.props.save&&this.props.save){var edited=this.state.editedPrizes;edited.forEach(function(prize){_this4.updatePrize(prize);_this4.updateVariants(prize.variants);if(prize.newVariants.length>0){_this4.putVariants(prize.ID,prize.newVariants);}});}}},{key:'render',value:function render(){var _this5=this;var customStyles={content:{top:'50%',left:'50%',right:'auto',bottom:'auto',width:'100%',maxWidth:'900px',transform:'translate(-50%, -50%)',borderStyle:'solid',borderWidth:'2px',borderColor:'gray',backgroundColor:'#F4F4F4',boxShadow:'0.5px 0.5px 1px 0.5px'},overlay:{backgroundColor:'rgba(105,105,105,0.8)'}};var modalContent=void 0;var picstyles={display:'block',maxWidth:'100px',maxHeight:'122px',width:'auto',height:'auto',margin:'auto'};var prizes=void 0;var pStyles="mt0 pt3 fl w-100 b navy mb3 bb b--light-silver";prizes=this.props.prizes.map(function(prizes,i){//loop through and display all prizes/gifts
var cap=prizes.cap===null?"none":prizes.cap;var photo=prizes.picture+prizes.variants[0].photo;photo=photo.replace(/\s/g,"_");return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50-ns mb2 w-100-m w-100 pa1',key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{maxWidth:'460px',margin:'auto',height:'250px'},className:'ba overflow-y-auto ma2 pa2 bw1 b--light-silver br3 shadow-3 bg-white'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-60',style:{minHeight:'200px',maxHeight:'200px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt0 pt2 tc b mr2'},prizes.prize),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:photo,alt:'error',style:picstyles,className:'mr2'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'tc mr2'},prizes.description)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-40'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:pStyles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'b'},'Tier: '),prizes.tier),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:pStyles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'b'},'Cap: '),cap),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:pStyles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'b'},'Status: '),prizes.status),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{id:prizes.prizeID,onClick:_this5.editPrize,className:'bg-navy b br2 mt2 pa1 white'},'Edit Prize')))));});if(this.state.loading){//display loading gif
modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tc',style:{width:'150px',margin:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5__asset_img_loader_gif___default.a,alt:'Loading'}));}else if(this.state.done){//display message prompt
modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'tc b navy f3'},this.state.modalPrompt);}else{//modal displays the CurrentEdit component
modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__CurrentEdit_js__["a" /* default */],{prize:this.state.currentEdit,onFinish:this.commitEdit,tiers:this.props.tiers});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,prizes),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_modal___default.a,{isOpen:this.state.modalIsOpen,style:customStyles,contentLabel:'shopping cart Modal',shouldCloseOnOverlayClick:false,shouldCloseOnEsc:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 tr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'bg-white gray b br3',onClick:this.closeModal},'X')),modalContent)));}}]);return EditPrizes;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (EditPrizes);

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component_Select_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__component_Input_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Validation_js__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CurrentEdit=function(_Component){_inherits(CurrentEdit,_Component);function CurrentEdit(props){_classCallCheck(this,CurrentEdit);var _this=_possibleConstructorReturn(this,(CurrentEdit.__proto__||Object.getPrototypeOf(CurrentEdit)).call(this,props));_this.handleInput=_this.handleInput.bind(_this);_this.removeVar=_this.removeVar.bind(_this);//this.setVariants = this.setVariants.bind(this);
_this.commitChanges=_this.commitChanges.bind(_this);//this.setNew = this.setNew.bind(this);
//this.setCreate = this.setCreate.bind(this);
_this.state={prize:'',tier:'',cap:'',picture:'',description:'',variants:[],prizeStatus:'',create:false,finish:false,new:false,invalid:false,invalidFields:''};return _this;}_createClass(CurrentEdit,[{key:'componentDidMount',value:function componentDidMount(){//set state with current prize values so that inputs contain current values by default
var p=this.props.prize;var cap=p.cap===null?'':p.cap;this.setState({prize:p.prize,tier:p.tier,cap:cap,picture:p.picture,description:p.description,variants:p.variants,prizeStatus:p.status});}},{key:'handleInput',value:function handleInput(identity,value){//standard method for handling user input
var theState=this.state;theState[identity]=value;this.setState(theState);}// setNew(){ 
// 	this.setState({new:true,create:false});
// }
// setVariants(variants){
// 	this.setState(oldState => ({newVariants:[...oldState.newVariants,variants]}));
// }
// setCreate(){
// 	this.setState({create:true});
// }
},{key:'commitChanges',value:function commitChanges(){//method to begin process of updating prize info. eventually, all code in componentDidUpdate should be moved here
this.setState({finish:true});}},{key:'removeVar',value:function removeVar(identity,value){//method for changing the status of a variant (active or inactive)
var variants=this.state.variants;variants[identity].status=value;this.setState({variants:variants});}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){if(this.state.finish!==prevState.finish&&this.state.finish){//user has chosen to save all edited information
var _state=this.state,tier=_state.tier,cap=_state.cap,picture=_state.picture,variants=_state.variants,newVariants=_state.newVariants,prizeStatus=_state.prizeStatus;var prize=this.state.prize;var description=this.state.description;if(prize.trim()!==''&&description.trim()!==''&&Object(__WEBPACK_IMPORTED_MODULE_3__Validation_js__["a" /* default */])("prize",prize.trim())&&Object(__WEBPACK_IMPORTED_MODULE_3__Validation_js__["a" /* default */])("prize",description.trim())){//if all fields are filled out and contain valid input, continue
var merge=[].concat.apply([],newVariants);this.props.onFinish({ID:this.props.prize.prizeID,prize:prize.trim(),tier:tier,cap:cap,picture:picture,description:description.trim(),variants:variants,newVariants:merge,status:prizeStatus});//pass up state to EditPrize
}else{//log blank or invalid input fields
var invalidField=void 0;if((!Object(__WEBPACK_IMPORTED_MODULE_3__Validation_js__["a" /* default */])("prize",prize.trim())||prize.trim()==='')&&(!Object(__WEBPACK_IMPORTED_MODULE_3__Validation_js__["a" /* default */])("prize",description.trim())||description.trim()==='')){invalidField='both';}else if(!Object(__WEBPACK_IMPORTED_MODULE_3__Validation_js__["a" /* default */])("prize",prize.trim())||prize.trim()===''){invalidField='prize';}else if(!Object(__WEBPACK_IMPORTED_MODULE_3__Validation_js__["a" /* default */])("prize",description.trim())||description.trim()===''){invalidField='description';}this.setState({finish:false,invalid:true,invalidFields:invalidField});}}}},{key:'render',value:function render(){var _this2=this;var buttonStyles="br3 white b w-30-ns w-60-m w-100 h2 bg-navy shadow-2";var inputStyles="pt0 pb0 pr0 pl2 h2 br2 bw1 w-100 shadow-3";var selectStyles="pa1 shadow-2 br2 b--gray bw1 mt2 w-70-ns";var areaStyles=inputStyles;var prizeStyles=inputStyles;var invalidMessage=void 0;var dis=false;if(this.state.invalid){//error message and highlighting for invalid or empty input fields
invalidMessage=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'b red'},'*All fields must be valid');if(this.state.invalidFields==='both'){areaStyles="pa0 h2 b--red br2 bw1 w-100 shadow-2 pl2";prizeStyles="pa0 h2 b--red br2 bw1 w-100 shadow-2 pl2";}else if(this.state.invalidFields==='prize'){prizeStyles="pa0 h2 b--red br2 bw1 w-100 shadow-2 pl2";}else if(this.state.invalidFields==='description'){areaStyles="pa0 h2 b--red br2 bw1 w-100 shadow-2 pl2";}}if(this.state.variants.length===1){//if only one variant exists, dont allow it to be set to inactive. whole prize should be set to inactive.
dis=true;}var variants=this.state.variants.map(function(variants,i){//map out variants with dropdown menu to change status (active or inactive)
var size=variants.size===null||variants.size===undefined||variants.size===''?"N/A":variants.size;var color=variants.color===null||variants.color===undefined||variants.color===''?"N/A":variants.color;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'fl w-100 bb b--light-silver',key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fl w-33 tc'},size),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fl w-33 tc'},color),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-33 tc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_Select_js__["a" /* default */],{val:variants.status,identity:i,options:["active","inactive"],onSelect:_this2.removeVar,styles:selectStyles,disable:dis})));});var photo=void 0;if(this.state.variants.length>0){photo=this.state.picture+this.state.variants[0].photo;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100',style:{margin:'auto'}},invalidMessage,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 mt2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50-ns w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 pb1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'b'},'Prize name: ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 pr3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__component_Input_js__["a" /* default */],{identity:'prize',onInput:this.handleInput,val:this.state.prize,inputStyle:prizeStyles}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-25-ns w-50 mt0-ns mt2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 pb1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'b'},'Tier: ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 pr3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_Select_js__["a" /* default */],{name:'tier',identity:'tier',onSelect:this.handleInput,options:this.props.tiers,styles:inputStyles,val:this.state.tier}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-25-ns w-50 mt0-ns mt2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 pb1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'b'},'Cap: ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 pr3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__component_Input_js__["a" /* default */],{identity:'cap',onInput:this.handleInput,val:this.state.cap,inputStyle:inputStyles,type:'number'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 mt4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-75-ns w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 pb1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'b'},'Description: ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 pr3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__component_Input_js__["a" /* default */],{identity:'description',inputStyle:areaStyles,onInput:this.handleInput,val:this.state.description}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-25-ns w-100 mt0-ns mt2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 pb1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'b'},'Status: ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 pr3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_Select_js__["a" /* default */],{name:'status',identity:'prizeStatus',onSelect:this.handleInput,options:["active","inactive"],styles:inputStyles,val:this.state.prizeStatus})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{maxHeight:'300px'},className:'fl w-100 mt3 overflow-y-scroll'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'list fl w-100'},variants)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 tc pt4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:this.commitChanges,className:buttonStyles},'Save Changes')));}}]);return CurrentEdit;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CurrentEdit);

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__component_Input_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_modal__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__asset_img_sparkles2_png__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__asset_img_sparkles2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__asset_img_sparkles2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Validation_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__component_Select_js__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//used for validation
var CreateAdminMessages=function(_Component){_inherits(CreateAdminMessages,_Component);function CreateAdminMessages(props){_classCallCheck(this,CreateAdminMessages);var _this=_possibleConstructorReturn(this,(CreateAdminMessages.__proto__||Object.getPrototypeOf(CreateAdminMessages)).call(this,props));_this.handleInput=_this.handleInput.bind(_this);_this.openModal=_this.openModal.bind(_this);_this.closeModal=_this.closeModal.bind(_this);_this.handleStart=_this.handleStart.bind(_this);_this.handleEnd=_this.handleEnd.bind(_this);_this.getDays=_this.getDays.bind(_this);_this.createDateObject=_this.createDateObject.bind(_this);_this.isLeapYear=_this.isLeapYear.bind(_this);_this.state={message:'',startDate:{month:'',day:'',year:'',monthDays:[]},endDate:{month:'',day:'',year:'',monthDays:[]},modalIsOpen:false,modalPrompt:'',today:''};return _this;}_createClass(CreateAdminMessages,[{key:'isLeapYear',value:function isLeapYear(year){//method for determining whether or not a year is a leap year
return year%100===0?year%400===0:year%4===0;}},{key:'componentDidMount',value:function componentDidMount(){var _this2=this;//when component mounts get today's date from the server
__WEBPACK_IMPORTED_MODULE_1_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_2__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{"endpoint":"getDate"}}).then(function(response){var today=response.data.data;var defaultStart=today.split("/");var monthDays=_this2.getDays(defaultStart[0]);var endDay=(Number(defaultStart[1])+1).toString();_this2.setState({today:today,startDate:{month:defaultStart[0],day:defaultStart[1],year:defaultStart[2],monthDays:monthDays},endDate:{month:defaultStart[0],day:endDay,year:defaultStart[2],monthDays:monthDays}});});}},{key:'getDays',value:function getDays(value,year){//method for determing how many days in each month
var days=void 0;if(value==='02'){days=['01','02','03','04','05','06','07','08','09','10','11','12','13','14','15','16','17','18','19','20','21','22','23','24','25','26','27','28'];if(this.isLeapYear(year)){days.push('29');}}else if(value==='01'||value==='03'||value==='05'||value==='07'||value==='08'||value==='10'||value==='12'){days=['01','02','03','04','05','06','07','08','09','10','11','12','13','14','15','16','17','18','19','20','21','22','23','24','25','26','27','28','29','30','31'];}else{days=['01','02','03','04','05','06','07','08','09','10','11','12','13','14','15','16','17','18','19','20','21','22','23','24','25','26','27','28','29','30'];}return days;}},{key:'createDateObject',value:function createDateObject(dateString){//method to create date objects out of the selected dates in order to perform further validation using date comparisons
var year=dateString.substr(6);var day=dateString.substr(3,2);var month=Number(dateString.substr(0,2));month=(month-1).toString();var d=new Date(year,month,day);return d;}},{key:'openModal',value:function openModal(){//method to open the modal
this.setState({modalIsOpen:true});}},{key:'closeModal',value:function closeModal(){//method to close the modal
this.setState({modalIsOpen:false,modalPrompt:''});this.props.revertSave();}},{key:'handleStart',value:function handleStart(identity,value){//method for handling the change of the start date dropdown menus
var theState=this.state.startDate;theState[identity]=value;if(identity==="month"){var year=theState['year'];theState['monthDays']=this.getDays(value,year);theState['day']='01';}else if(identity==="year"){theState['monthDays']=this.getDays(theState['month'],value);theState['day']='01';}this.setState({startDate:theState});}},{key:'handleEnd',value:function handleEnd(identity,value){//method for handling the change of the end date dropdown menus
var theState=this.state.endDate;theState[identity]=value;if(identity==="month"){var year=theState['year'];theState['monthDays']=this.getDays(value,year);theState['day']='01';}else if(identity==="year"){theState['monthDays']=this.getDays(theState['month'],value);theState['day']='01';}this.setState({endDate:theState});}},{key:'handleInput',value:function handleInput(identity,value){//standard method for updating the state based on user input from select menus
if(value.length<186){var theState={};theState[identity]=value;this.setState(theState);document.getElementById("messageSpan").style.color="#001B44";document.getElementById("messageSpan").innerHTML="("+value.length+")";}else{document.getElementById("messageSpan").style.color="red";document.getElementById("messageSpan").innerHTML="(185) Limit Reached!";}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var _this3=this;var _state=this.state,message=_state.message,startDate=_state.startDate,endDate=_state.endDate;if(prevProps.save!==this.props.save&&this.props.save){//if the user has chosen to save the new admin message
document.getElementById("message").classList.remove("invalid");var theStart=startDate.month+"/"+startDate.day+"/"+startDate.year;var theEnd=endDate.month+"/"+endDate.day+"/"+endDate.year;var start=this.createDateObject(theStart);var end=this.createDateObject(theEnd);var today=this.createDateObject(this.state.today);if(message.trim()!==''&&Object(__WEBPACK_IMPORTED_MODULE_6__Validation_js__["a" /* default */])("reason",message)&&start>=today&&end>start){//validate the message, start date and end date of message
__WEBPACK_IMPORTED_MODULE_1_axios___default()({//send info to create new admin message in database
method:'post',url:__WEBPACK_IMPORTED_MODULE_2__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{"endpoint":"create","table":"messages","misc":"new","firstID":this.props.userInfo.userID,"status":this.props.userInfo.userType,"desc":message.trim(),"date":theStart,"secondDate":theEnd}}).then(function(response){var data=response.data.data;if(data.Message==="Success!"){_this3.setState({message:'',modalPrompt:'Message successfully created!'},function(){this.openModal();this.props.reset(this.props.year);});}}).catch(function(error){_this3.setState({modalPrompt:"Sorry, there has been a problem."},function(){this.openModal();});});}else{//if validation was not passed for any of the fields
var prompt='';if(message.trim()===''||!Object(__WEBPACK_IMPORTED_MODULE_6__Validation_js__["a" /* default */])("reason",message)){//invalid input field for message
document.getElementById("message").classList.add("invalid");if(message.trim()===''){prompt+="Message cannot be blank. ";}else{prompt+="Message input contains invalid characters. ";}}if(start<today){//invalid start date
prompt+='Your start date must be today or a later date. ';}if(end<=start){//invalid end date
prompt+='Your end date must be after your start date. ';}prompt+='Please try again.';this.setState({modalPrompt:prompt},function(){this.openModal();});}}}},{key:'render',value:function render(){var startDate=this.state.startDate;var endDate=this.state.endDate;var startMonth=startDate.month;var endMonth=this.state.endDate.month;var selectStyles="h2 pa1 w-100 br2 bw1 truncate shadow-2";var months=['01','02','03','04','05','06','07','08','09','10','11','12'];var startdays=startDate.monthDays;var endDays=endDate.monthDays;var customStyles={content:{top:'50%',left:'50%',right:'auto',bottom:'auto',width:'400px',minWidth:'300px',minHeight:'160px',borderStyle:'solid',borderWidth:'2px',borderColor:'gray',transform:'translate(-50%, -50%)',backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_5__asset_img_sparkles2_png___default.a+')',backgroundRepeat:'no-repeat',backgroundSize:'300px 160px',backgroundPosition:'right',boxShadow:'0.5px 0.5px 1px 0.5px'},overlay:{backgroundColor:'rgba(105,105,105,0.8)'}};var inputStyles="h2 pa2 br2 bw1 w-100-ns w-100 shadow-2";var areaStyles="pa2 br2 bw1 w-100-ns w-100 shadow-2";if(this.state.modalPrompt==='Your input is invalid. Please try again.'){areaStyles="pa2 br2 b--red bw1 w-100-ns w-100 shadow-2";}else if(this.state.modalPrompt==='Your dates are invalid. Please try again.'){inputStyles="h2 pa2 br2 b--red bw1 w-100-ns w-100 shadow-2";}var modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'f4 b navy tc'},this.state.modalPrompt);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{maxWidth:'500px',margin:'auto'},className:'w-80'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 mt3 pb4 bb b--light-silver'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 pb3 tc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'b navy f4'},'Start Date')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-33'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 pb1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'b navy'},'Month:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 pr2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__component_Select_js__["a" /* default */],{identity:'month',options:months,onSelect:this.handleStart,styles:selectStyles,val:startDate.month}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-33'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 pb1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'b navy'},'Day:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 pr2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__component_Select_js__["a" /* default */],{identity:'day',options:startdays,onSelect:this.handleStart,styles:selectStyles,val:startDate.day}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-33'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 pb1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'b navy'},'Year:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 pr2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__component_Select_js__["a" /* default */],{identity:'year',options:this.props.years,onSelect:this.handleStart,styles:selectStyles,val:startDate.year}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 mt3 pb3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 pb3 tc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'b navy f4'},'End Date ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-33'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 pb1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'b navy'},'Month:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 pr2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__component_Select_js__["a" /* default */],{identity:'month',options:months,onSelect:this.handleEnd,styles:selectStyles,val:this.state.endDate.month}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-33'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 pb1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'b navy'},'Day:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 pr2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__component_Select_js__["a" /* default */],{identity:'day',options:endDays,onSelect:this.handleEnd,styles:selectStyles,val:this.state.endDate.day}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-33'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 pb1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'b navy'},'Year:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 pr2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__component_Select_js__["a" /* default */],{identity:'year',options:this.props.years,onSelect:this.handleEnd,styles:selectStyles,val:this.state.endDate.year})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 mt3 pr3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 pb1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'b navy'},'Message: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:'messageSpan'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__component_Input_js__["a" /* default */],{type:'text',identity:'message',id:'message',onInput:this.handleInput,val:this.state.message,inputStyle:inputStyles}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_modal___default.a,{isOpen:this.state.modalIsOpen,style:customStyles,contentLabel:'prompt',shouldCloseOnOverlayClick:false,shouldCloseOnEsc:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 tr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'bg-white gray b br3',onClick:this.closeModal},'X')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pt2'},modalContent))));}}]);return CreateAdminMessages;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CreateAdminMessages);

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component_Select_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__component_Input_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__routes_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_modal__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__asset_img_loader_gif__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__asset_img_loader_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__asset_img_loader_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Validation_js__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ManageDepartments=function(_Component){_inherits(ManageDepartments,_Component);function ManageDepartments(props){_classCallCheck(this,ManageDepartments);var _this=_possibleConstructorReturn(this,(ManageDepartments.__proto__||Object.getPrototypeOf(ManageDepartments)).call(this,props));_this.state={createDepartment:'',newDepartment:'Select',managerChoice:'Select',department:'',manager:'',employees:[],departmentMembers:[],modalIsOpen:false,loading:false,newManager:false,onlyDepartment:false,employeeToMove:{},modalPrompt:''};_this.handleInput=_this.handleInput.bind(_this);_this.createDepartment=_this.createDepartment.bind(_this);_this.moveEmployee=_this.moveEmployee.bind(_this);_this.handleButtonClick=_this.handleButtonClick.bind(_this);_this.closeModal=_this.closeModal.bind(_this);_this.newManager=_this.newManager.bind(_this);return _this;}_createClass(ManageDepartments,[{key:'moveEmployee',value:function moveEmployee(){var _this2=this;//method for moving employee from one department to another department
if(this.state.newDepartment!=='Select'){//make sure a new department is selected
document.getElementById("newDeptSpan").innerHTML="*";this.setState({loading:true});var employeeToMove=this.state.employeeToMove;__WEBPACK_IMPORTED_MODULE_3_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_4__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'create',table:'department',misc:'switch',firstID:employeeToMove.userID,name:this.state.newDepartment,status:this.state.department}}).then(function(response){_this2.setState({modalPrompt:'Employee department successfully changed!',employeeToMove:'',newDepartment:'Select',loading:false});_this2.props.getDepartments();});}else{document.getElementById("newDeptSpan").innerHTML="*Required";}}},{key:'newManager',value:function newManager(){var _this3=this;//method for promoting someone to manager of a department
if(!this.state.onlyDepartment||this.state.newDepartment&&this.state.newDepartment!=="Select"){//if they are manager of another department, or they are not a manager of another department but a second department has been selected for them, begin
var newManagerID=void 0;this.setState({loading:true});for(var i=0;i<this.props.employeeList.length;i++){//get userID for the new manager
if(this.state.manager===this.props.employeeList[i].name){newManagerID=this.props.employeeList[i].userID;break;}}var department=this.state.department.toLowerCase();var status=department.indexOf("asm")===-1?"manager":"asm_regional";//promote them to either manager or asm_regional depending on whether or not the department is an asm department 
__WEBPACK_IMPORTED_MODULE_3_axios___default()({//update usertype
method:'post',url:__WEBPACK_IMPORTED_MODULE_4__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'create',table:'users',misc:'type',firstID:newManagerID,status:status,name:this.state.department}}).then(function(response){if(_this3.state.newDepartment){//if the department is brand new, create the department
__WEBPACK_IMPORTED_MODULE_3_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_4__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'create',table:'department',misc:'switch',firstID:newManagerID,name:_this3.state.newDepartment,status:"add_dept"}}).then(function(response){_this3.setState({newDepartment:'Select',onlyDepartment:false,loading:false,newManager:false,modalPrompt:'Manager successfully changed!'});_this3.props.getDepartments();});}else{_this3.setState({loading:false,newManager:false,modalPrompt:'Manager successfully changed!'});_this3.props.getDepartments();}});}}},{key:'closeModal',value:function closeModal(){//method to close the modal
this.setState({modalIsOpen:false,modalPrompt:''});}},{key:'handleButtonClick',value:function handleButtonClick(e){//handles button click for choosing to move an employee to another department
this.setState({modalIsOpen:true,employeeToMove:{userID:e.target.id,name:e.target.name}});}},{key:'handleInput',value:function handleInput(identity,value){var _this4=this;//method for handling user input
var theState={};if(identity==="department"){//handle department selection from department dropdown menu
for(var i=0;i<this.props.departmentInfo.length;i++){if(this.props.departmentInfo[i].department===value){theState['manager']=this.props.departmentInfo[i].manager.name;theState['departmentMembers']=this.props.departmentInfo[i].employees;break;}}}if(identity==="manager"){(function(){//handle new manager selection from manager dropdown menu
var departments=0;var currentMember=false;theState['newManager']=true;theState['modalIsOpen']=true;for(var j=0;j<_this4.state.departmentMembers.length;j++){//check to see if new manager is part of current department
if(_this4.state.departmentMembers[j].name===value){currentMember=true;_this4.props.employeeList.forEach(function(employee){//check if this is the only department they are a part of
if(employee.name===value){departments++;}});break;}}if(currentMember&&departments===1){//this is if they are only part of current department
theState['onlyDepartment']=true;theState['newDepartment']="Miscellaneous";//arbitrary default department value
}})();}theState[identity]=value;this.setState(theState);}},{key:'componentDidMount',value:function componentDidMount(){var _this5=this;//when component mounts, retrieve list of all employees
var employeeList=[];__WEBPACK_IMPORTED_MODULE_3_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_4__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'info',table:'users',action:'employees'}}).then(function(response){var employeeList=response.data.data.map(function(employee){return employee.name;});_this5.setState({employees:employeeList,department:_this5.props.departmentInfo[0].department,manager:_this5.props.departmentInfo[0].manager.name,departmentMembers:_this5.props.departmentInfo[0].employees});});}},{key:'createDepartment',value:function createDepartment(){var _this6=this;//method that handles the creation of a new department
if(this.state.createDepartment.trim()!==''&&this.state.managerChoice!=='Select'&&this.props.departments.indexOf(this.state.createDepartment.trim())===-1&&Object(__WEBPACK_IMPORTED_MODULE_7__Validation_js__["a" /* default */])("department",this.state.createDepartment.trim())){//check to make sure all fields are filled out and contain valid input
document.getElementById("createDepartment").style.borderColor="inherit";document.getElementById("manageLabel").style.color="inherit";var managerID=void 0;this.setState({loading:true,modalIsOpen:true});for(var i=0;i<this.props.employeeList.length;i++){//get user ID for the manager of the new department
if(this.state.managerChoice===this.props.employeeList[i].name){managerID=this.props.employeeList[i].userID;break;}}__WEBPACK_IMPORTED_MODULE_3_axios___default()({//create new department
method:'post',url:__WEBPACK_IMPORTED_MODULE_4__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'create',table:'department',misc:'create',name:this.state.createDepartment.trim(),firstID:managerID}}).then(function(response){_this6.setState({createDepartment:'',managerChoice:'Select',loading:false,modalPrompt:'Department Created!'});});}else{if(this.state.createDepartment.trim()===''||!Object(__WEBPACK_IMPORTED_MODULE_7__Validation_js__["a" /* default */])("department",this.state.createDepartment.trim())||this.props.departments.indexOf(this.state.createDepartment.trim())!==-1){//highlight new deparmtnet input field if it is empty, contains invalid characters, or already exists
document.getElementById("createDepartment").style.borderColor="red";var message='';if(this.props.departments.indexOf(this.state.createDepartment.trim())!==-1){//display error message
message+="*department already exists.";}else if(!Object(__WEBPACK_IMPORTED_MODULE_7__Validation_js__["a" /* default */])("department",this.state.createDepartment.trim())){//display error message
message+="*must contain valid input.";}document.getElementById("createDeptSpan").innerHTML=message;}if(this.state.managerChoice==='Select'){//if no manager is selected for new department, highlight it in red
document.getElementById("manageLabel").style.color="red";}}}},{key:'render',value:function render(){var _this7=this;var customStyles={content:{top:'50%',left:'50%',right:'auto',bottom:'auto',width:'100%',minWidth:'300px',maxWidth:'500px',borderStyle:'solid',borderWidth:'2px',borderColor:'gray',paddingTop:'10px',transform:'translate(-50%, -50%)',boxShadow:'0.5px 0.5px 1px 0.5px'},overlay:{backgroundColor:'rgba(105,105,105,0.8)'}};var buttonStyles="br3 white b w-25-ns w-50-m w-100 h2 bg-navy shadow-2";var inputStyle="pa2 br2 bw1 w-100-ns w-100 shadow-3";var selectStyles="h2 pa1 w-100 br2 bw1 truncate shadow-3";var departmentInfo=this.props.departmentInfo;var employees=[];var currentManager=void 0;var otherDepartments=this.props.departments.filter(function(department){//get department options for dropdown menu
return department!==_this7.state.department;});for(var i=0;i<this.props.departmentInfo.length;i++){//get relevant information for the current department that has been selected
if(this.props.departmentInfo[i].department===this.state.department){employees=this.props.departmentInfo[i].employees;currentManager=this.props.departmentInfo[i].manager.name;}}var modalContent=void 0;if(!this.state.loading){if(this.state.modalPrompt===''){if(!this.state.newManager){//modal content for moving employee to different department
modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 tr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'bg-white gray b br3',onClick:this.closeModal},'X')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'navy b f5'},'Employee: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'black'},this.state.employeeToMove.name))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pb1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'navy b',id:'newDeptLabel'},'New Department: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:'newDeptSpan',className:'red b'},'*'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pb3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_Select_js__["a" /* default */],{identity:'newDepartment',options:otherDepartments,styles:selectStyles,val:this.state.newDepartment,onSelect:this.handleInput})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'w-100 center tc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'br2 bg-navy b pa2 white',onClick:this.moveEmployee},'Move Employee')));}else{//modal content (confirmation) for selecting a new manager
var departmentSelect=void 0;if(this.state.onlyDepartment){//if new manager is only part of current department
departmentSelect=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pb1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'b navy',id:'otherDept'},'Add To: ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pb3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_Select_js__["a" /* default */],{identity:'newDepartment',options:otherDepartments,styles:selectStyles,val:this.state.newDepartment,onSelect:this.handleInput}))));}modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 tr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'bg-white gray b br3',onClick:function onClick(){_this7.setState({modalIsOpen:false,newManager:false,onlyDepartment:false,manager:currentManager});}},'X')),departmentSelect,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'tc f4'},'Are you sure you would like to replace ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'b navy'},currentManager),' with ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'b navy'},this.state.manager),'?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'w-50-ns w-70-m w-100 center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:this.newManager,className:'tc br2 pa1 bg-dark-blue white b w-100'},'Yes')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'tc br2 pa1 bg-dark-blue white b w-100',onClick:function onClick(){_this7.setState({modalIsOpen:false,newManager:false,onlyDepartment:false,manager:currentManager});}},'No'))));}}else{//modal prompt
modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 tr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'bg-white gray b br3',onClick:this.closeModal},'X')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'navy b tc f4'},this.state.modalPrompt)));}}else{//loader gif
modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tc',style:{width:'150px',margin:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_6__asset_img_loader_gif___default.a,alt:'Loading'}));}var content=void 0;if(!this.props.create){//this is the content for managing departments
content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'w-60-ns w-75-m w-90 center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pb1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'navy b'},'Department: ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pb3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_Select_js__["a" /* default */],{identity:'department',options:this.props.departments,styles:selectStyles,val:this.state.department,onSelect:this.handleInput})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pb1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'navy b'},'Manager: ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pb3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_Select_js__["a" /* default */],{identity:'manager',options:this.state.employees,styles:selectStyles,val:this.state.manager,onSelect:this.handleInput})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tc pb1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'navy b tc underline f4'},'Employees')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tc bg-white ba bw1 b--gray br2 pa1 shadow-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UnorderedList,{employees:employees,buttonClick:this.handleButtonClick}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_modal___default.a,{isOpen:this.state.modalIsOpen,style:customStyles,contentLabel:'move department',shouldCloseOnOverlayClick:false,shouldCloseOnEsc:false},modalContent)));}else{// this is the content for creating a new department
content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'w-40-ns w-60-m w-80 center pt2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pb1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{id:'deptLabel',className:'b navy'},'Department name: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:'createDeptSpan',className:'red b'},'*Required'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pb3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__component_Input_js__["a" /* default */],{id:'createDepartment',identity:'createDepartment',type:'text',onInput:this.handleInput,inputStyle:inputStyle,val:this.state.createDepartment})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pb1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{id:'manageLabel',className:'b navy'},'Manager: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:'createManagerSpan',className:'red b'},'*Required'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pb3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_Select_js__["a" /* default */],{identity:'managerChoice',options:this.state.employees,styles:selectStyles,val:this.state.managerChoice,onSelect:this.handleInput})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'w-100 center tc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:buttonStyles,onClick:this.createDepartment},'Create')));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,content);}}]);return ManageDepartments;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ManageDepartments);var UnorderedList=function UnorderedList(props){//functional unordered list component for listing the current members of each department
var employees=props.employees.map(function(employee,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:i,className:'tl fl w-100 pa1 bb b--light-silver'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pa1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-70 pa1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'ma0'},employee.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-30 pa1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{id:employee.userID,name:employee.name,onClick:props.buttonClick,className:'br2 bg-dark-blue white b'},'Switch Dept.'))));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'list overflow-y-auto mt0 mb0 pl1 pr1',style:{maxHeight:'200px'}},employees));};

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_modal__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__asset_img_shoppingCart_png__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__asset_img_shoppingCart_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__asset_img_shoppingCart_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ShoppingCart_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__routes_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Gift_js__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__component_Select_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Validation_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__asset_img_loader_gif__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__asset_img_loader_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__asset_img_loader_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//component that contains the shopping cart
//component that contains each gift and its information
//used for validation
var ASMGiftShop=function(_Component){_inherits(ASMGiftShop,_Component);function ASMGiftShop(props){_classCallCheck(this,ASMGiftShop);var _this=_possibleConstructorReturn(this,(ASMGiftShop.__proto__||Object.getPrototypeOf(ASMGiftShop)).call(this,props));_this.state={info:[],modalIsOpen:false,lowInventory:[],adminEmail:'',adminName:'',approval:'',notes:'',tier:'All',tierInfo:[],tierOptions:[],success:false,validNotes:true,validShipping:true,loading:false,modalPrompt:'',asmList:[],chosenAsm:'',cartChangeGift:{prize:'',sizeIndex:0,colorIndex:0},didCartChange:false,chosenAsmIndex:-1,states:[],currentBudget:0,shippingInfo:{street_address:'',city:'',state:'',zipcode:'',shipping_instructions:''}};_this.addToCart=_this.addToCart.bind(_this);// this.cartTotal = this.cartTotal.bind(this);
_this.getGifts=_this.getGifts.bind(_this);_this.removeItem=_this.removeItem.bind(_this);_this.openModal=_this.openModal.bind(_this);_this.closeModal=_this.closeModal.bind(_this);_this.handleSelection=_this.handleSelection.bind(_this);_this.quantityChange=_this.quantityChange.bind(_this);_this.submitOrder=_this.submitOrder.bind(_this);_this.handleInput=_this.handleInput.bind(_this);_this.updateInfo=_this.updateInfo.bind(_this);_this.selectAsm=_this.selectAsm.bind(_this);_this.leaveShop=_this.leaveShop.bind(_this);_this.getASMinfo=_this.getASMinfo.bind(_this);return _this;}_createClass(ASMGiftShop,[{key:'selectAsm',value:function selectAsm(){var _state=this.state,chosenAsm=_state.chosenAsm,asmList=_state.asmList;for(var i=0;i<asmList.length;i++){if(asmList[i].name===chosenAsm){this.setState({chosenAsmIndex:i,modalIsOpen:false,currentBudget:asmList[i].budget});break;}}}},{key:'handleSelection',value:function handleSelection(identity,value){//standard method for updating the state based on user input from select fields
var theState=this.state;if(value!=="All"&&value!=="New"&&value!=="Discontinued"){value=value.replace(/\$/g,'');value=value.replace(/\s/g,'');var range=value.split("-");for(var i=0;i<this.state.tierInfo.length;i++){if(Number(range[1])===Number(this.state.tierInfo[i].points)){theState[identity]=this.state.tierInfo[i].tier;break;}}}else{theState[identity]=value;}this.setState(theState);}},{key:'addToCart',value:function addToCart(item){//method for handling an item being added to the shopping cart
var theCart=[];var exists=false;for(var i=0;i<this.props.cart.length;i++){//check to see if the shopping cart already contains an item
theCart[i]=this.props.cart[i];if(item.prize===theCart[i].prize&&item.size===theCart[i].size&&item.color===theCart[i].color){exists=true;theCart[i].quantity=Number(item.quantity)+Number(this.props.cart[i].quantity);theCart[i].total=(Number(item.total)+Number(this.props.cart[i].total)).toFixed(2);}}if(!exists){theCart.push(item);}this.updateInfo(item,'add');this.props.updateCart(theCart,this.props.updateCartTotal(item,'add'));var currentBudget=Number(this.state.currentBudget)-Number(item.total);this.setState({currentBudget:currentBudget.toFixed(2)});}},{key:'handleInput',value:function handleInput(identity,value){//standard method for updating the state based on user input from input fields
var theState=void 0;if(identity==="chosenAsm"||identity==="notes"){theState={};}else{theState=this.state.shippingInfo;}theState[identity]=value;this.setState(theState);}},{key:'updateInfo',value:function updateInfo(item,action){//method that updates the state to reflect current quantity available of an item based on the user adding to or removing from shopping cart
var cartChangeGift=Object.assign({},this.state.cartChangeGift);var didCartChange=this.state.didCartChange;var newInfo=[];var item_size=void 0,item_color=void 0;for(var j=0;j<this.state.info.length;j++){newInfo.push(this.state.info[j]);if(item.prize===newInfo[j].prize){for(var i=0;i<newInfo[j].variants.length;i++){item_size=item.size==='N/A'?null:item.size;item_color=item.color==='N/A'?null:item.color.replace(' ','_');if(item_size===newInfo[j].variants[i].size&&item_color===newInfo[j].variants[i].color){//if( item.size === newInfo[j].variants[i].size && item.color === newInfo[j].variants[i].color ){
cartChangeGift.prize=item.prize;cartChangeGift.sizeIndex=item.variationsIndex.sizeIndex;cartChangeGift.colorIndex=item.variationsIndex.colorIndex;didCartChange=!this.state.didCartChange;if(action==='add'){newInfo[j].variants[i].currentQuantity=Number(newInfo[j].variants[i].currentQuantity)-Number(item.quantity);}else if(action==='remove'){newInfo[j].variants[i].currentQuantity=Number(newInfo[j].variants[i].quantity);}}}}}this.setState({info:newInfo,cartChangeGift:cartChangeGift,didCartChange:didCartChange});}},{key:'removeItem',value:function removeItem(index){//method for handling the removal of a line item from the shopping cart
var items=this.props.cart;var newTotal=Number(this.state.currentBudget)+Number(items[index].total);this.updateInfo(this.props.cart[index],'remove');this.props.updateCart(items,this.props.updateCartTotal(items[index],'remove'));this.setState({currentBudget:newTotal.toFixed(2)});}},{key:'quantityChange',value:function quantityChange(id,newQuant){var _this2=this;//method for handling the quantity of a line item from the shopping cart
var info=this.state.info;var items=this.props.cart;var GiftIndex=-1,variantIndex=-1;var item_size=void 0,item_color=void 0;var budget=this.props.userInfo.userType==="asm_admin"||this.props.userInfo.userType==="sys_admin"?this.state.asmList[this.state.chosenAsmIndex].budget:this.props.userInfo.budget;if(Number(newQuant)>0){(function(){//if the quantity is not 0, perform operations for changing line item quantity 
for(var i=0;i<info.length;i++){if(info[i].prize===items[id].prize){GiftIndex=i;for(var j=0;j<info[i].variants.length;j++){item_size=items[id].size==='N/A'?null:items[id].size;item_color=items[id].color==='N/A'?null:items[id].color.replace(' ','_');if(info[i].variants[j].size==item_size&&info[i].variants[j].color==item_color){variantIndex=j;if(Number(info[i].variants[j].quantity)-Number(newQuant)<0){//change made here
newQuant=Number(info[i].variants[j].quantity);}else if(info[i].variants[j].limit&&Number.isFinite(info[i].variants[j].limit)&&Number(info[i].variants[j].limit)-Number(newQuant)<0){newQuant=Number(info[i].variants[j].limit);}else{newQuant=Number(newQuant);}}}}}var unitPrice=Number(items[id].total/items[id].quantity);unitPrice=unitPrice.toFixed(2);var notaffordable=true;var newTotal=void 0;while(notaffordable){var newItemTotal=Number(newQuant*unitPrice).toFixed(2);items[id].quantity=Number(newQuant);items[id].total=Number(newItemTotal);newTotal=0;items.forEach(function(item){newTotal=Number(item.total)+Number(newTotal);});if(newTotal<=budget){notaffordable=false;}else{newQuant--;}}info[GiftIndex].variants[variantIndex].currentQuantity=Number(info[GiftIndex].variants[variantIndex].quantity)-newQuant;var currentBudget=budget-newTotal;_this2.setState({info:info,currentBudget:Number(currentBudget).toFixed(2),cartChangeGift:{prize:items[id].prize,sizeIndex:items[id].variationsIndex.sizeIndex,colorIndex:items[id].variationsIndex.colorIndex},didCartChange:!_this2.state.didCartChange});_this2.props.handleInput('cartTotal',newTotal);})();}else{//if quantity is 0, remove item from shopping cart
this.removeItem(id);}}},{key:'getGifts',value:function getGifts(){var _this3=this;//method to retrieve all gift information for current year from database
var gifts=[];__WEBPACK_IMPORTED_MODULE_4_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_5__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'info',table:'prizes',kind:'test',action:'_asm_shop'}}).then(function(response){var giftInfo=response.data.data;var j=0;if(giftInfo.length>0){gifts.push({prizeID:giftInfo[0].prizeID,prize:giftInfo[0].prize,tier:giftInfo[0].tier,picture:__WEBPACK_IMPORTED_MODULE_5__routes_js__["e" /* storeImagePath */]+giftInfo[0].picture,description:giftInfo[0].description,status:giftInfo[0].status,variants:[{variantID:giftInfo[0].variantID,size:giftInfo[0].size,color:giftInfo[0].color,photo:giftInfo[0].photo,threshold:giftInfo[0].threshold,currentQuantity:giftInfo[0].quantity,quantity:giftInfo[0].quantity,price:giftInfo[0].price,limit:giftInfo[0].orderLimit}]});for(var i=1;i<giftInfo.length;i++){if(giftInfo[i].prizeID===gifts[j].prizeID){gifts[j].variants.push({variantID:giftInfo[i].variantID,size:giftInfo[i].size,color:giftInfo[i].color,photo:giftInfo[i].photo,threshold:giftInfo[i].threshold,currentQuantity:giftInfo[i].quantity,quantity:giftInfo[i].quantity,price:giftInfo[i].price,limit:giftInfo[i].orderLimit});}else{gifts.push({prizeID:giftInfo[i].prizeID,prize:giftInfo[i].prize,tier:giftInfo[i].tier,picture:__WEBPACK_IMPORTED_MODULE_5__routes_js__["e" /* storeImagePath */]+giftInfo[i].picture,description:giftInfo[i].description,status:giftInfo[0].status,variants:[{variantID:giftInfo[i].variantID,size:giftInfo[i].size,color:giftInfo[i].color,photo:giftInfo[i].photo,threshold:giftInfo[i].threshold,currentQuantity:giftInfo[i].quantity,quantity:giftInfo[i].quantity,price:giftInfo[i].price,limit:giftInfo[i].orderLimit}]});j++;}}}_this3.setState({info:gifts});});}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){//method that retrieves updated gift information from database once an order has been submitted
if(prevProps.submitted!==this.props.submitted){this.getGifts();if(this.props.userInfo.userType==='asm_admin'||this.props.userInfo.userType==="sys_admin"){this.getASMinfo(false);}}if(prevProps.active!==this.props.active&&(this.props.userInfo.userType==='asm_admin'||this.props.userInfo.userType==="sys_admin")&&this.props.active){this.setState({modalIsOpen:true,chosenAsm:this.state.asmList[0].name,chosenAsmIndex:-1});}}},{key:'componentDidMount',value:function componentDidMount(){var _this4=this;//when component mounts, retrieve gift information,regional threshold information,admin email, and tiers for current year
this.getGifts();var year=new Date().getFullYear();__WEBPACK_IMPORTED_MODULE_4_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_5__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'info',table:'tiers',kind:this.props.app,year:year,action:'shop'}}).then(function(response){var data=response.data.data;var tierOptions=[];tierOptions.push("$00.01 - $"+data[0].points.toFixed(2));for(var i=1;i<data.length;i++){var min=Number(data[i-1].points)+0.01;tierOptions.push("$"+min+" - $"+data[i].points.toFixed(2));}_this4.setState({tierInfo:data,tierOptions:tierOptions});});__WEBPACK_IMPORTED_MODULE_4_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_5__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'info',table:'state'}}).then(function(response){var states=[];var data=response.data.data;var shipping=_this4.state.shippingInfo;if(data){for(var j=0;j<data.length;j++){states.push(data[j].Abbrev);}shipping['state']=data[0].Abbrev;}_this4.setState({states:states,shippingInfo:shipping});});if(this.props.userInfo.userType==='asm_admin'||this.props.userInfo.userType==="sys_admin"){this.getASMinfo();}else{this.setState({currentBudget:this.props.userInfo.budget});}// axios({
// 	method:'post',
// 	url:path,headers:{'Content-Type':'application/json'},
// 	data:{endpoint:'info',table:'department',action:'threshold',userID:this.props.userInfo.userID,name:this.props.userInfo.department}
// }).then((response)=>{
// 	let data = response.data.data;
// 	if(data !== undefined && data[0] !== undefined){
// 		this.setState({regionalThreshold:data[0].threshold,approval:data[0].approval,adminEmail:data[0].email,adminName:data[0].name});
// 	}
// });
var sessiontotal=0;this.props.cart.forEach(function(item){sessiontotal=Number(item.total)+Number(sessiontotal);});this.setState({cart:this.props.cart,total:sessiontotal});}},{key:'openModal',value:function openModal(){//method for opening the modal
this.setState({modalIsOpen:true});}},{key:'closeModal',value:function closeModal(){//method for closing the modal
this.setState({modalIsOpen:false,success:false});}},{key:'leaveShop',value:function leaveShop(){this.setState({chosenAsm:this.state.asmList[0].name,chosenAsmIndex:-1,modalIsOpen:false,success:false},function(){this.props.leaveShop();});}},{key:'getASMinfo',value:function getASMinfo(firstMount){var _this5=this;__WEBPACK_IMPORTED_MODULE_4_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_5__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'info',table:'users',action:'asm_shop'}}).then(function(response){var data=response.data.data;if(firstMount){_this5.setState({asmList:data,chosenAsm:data[0].name});}else{_this5.setState({asmList:data});}});}},{key:'submitOrder',value:function submitOrder(){var _this6=this;//method that handles all operations required for submitting an order
var userType=this.props.userInfo.userType;var total=this.props.cartTotal;var budget=userType==="asm_admin"||this.props.userInfo.userType==="sys_admin"?this.state.asmList[this.state.chosenAsmIndex].budget:this.props.userInfo.budget;if(total<=budget){var cart=this.props.cart;var _state2=this.state,info=_state2.info,notes=_state2.notes,approval=_state2.approval,shippingInfo=_state2.shippingInfo;var validshipping=true;var validnotes=true;//validate additional notes field
if(!Object(__WEBPACK_IMPORTED_MODULE_8__Validation_js__["a" /* default */])("reason",notes)||notes.trim()===''){validnotes=false;document.getElementById("notes").style.borderColor="red";if(notes.trim()===''){document.getElementById("notes_span").textContent="Required";}else{document.getElementById("notes_span").textContent="Invalid characters";}}else{document.getElementById("notes").style.borderColor="inherit";document.getElementById("notes_span").textContent="";}var notValidFields=[];for(var thekey in this.state.shippingInfo){if(thekey!=="shipping_instructions"&&thekey!=="state"){if(document.getElementById("city").value.trim()===''){document.getElementById("city").style.borderColor="red";document.getElementById("city_span").textContent="Required";}else{document.getElementById("city").style.borderColor="inherit";document.getElementById("city_span").textContent="";}if(!Object(__WEBPACK_IMPORTED_MODULE_8__Validation_js__["a" /* default */])(thekey,this.state.shippingInfo[thekey]||this.state.shippingInfo[thekey].trim()==='')){validshipping=false;document.getElementById(thekey).style.borderColor="red";var text=void 0;if(this.state.shippingInfo[thekey].trim()===''){text="Required";}else{text="Invalid characters";}document.getElementById(thekey+"_span").textContent=text;//notValidFields.push(thekey);
}else{document.getElementById(thekey).style.borderColor="inherit";document.getElementById(thekey+"_span").textContent="";}}else if(thekey==="shipping_instructions"&&this.state.shippingInfo.shipping_instructions.trim()!==''){if(!Object(__WEBPACK_IMPORTED_MODULE_8__Validation_js__["a" /* default */])("reason",this.state.shippingInfo[thekey])){validshipping=false;document.getElementById(thekey).style.borderColor="red";document.getElementById(thekey+"_span").textContent="*Invalid characters";//notValidFields.push(thekey);
}else{document.getElementById(thekey).style.borderColor="inherit";document.getElementById(thekey+"_span").textContent="";}}}if(validnotes&&validshipping){//if additional notes and order instructions contain valid input, begin submitting order
var userID=userType==="asm_admin"||userType==="sys_admin"?this.state.asmList[this.state.chosenAsmIndex].userID:this.props.userInfo.userID;//const status = this.props.userInfo.userType === 'asm_admin'?"admin_order":"pending"; //determine if order goes straight to admin approval or not
var misc=this.props.userInfo.userType==="asm_admin"||this.props.userInfo.userType==="sys_admin"?'admin_create':'create';var orderNotes=notes.trim()===''?null:notes;var instructions=shippingInfo.shipping_instructions.trim()===''?null:shippingInfo.shipping_instructions;var orderData={//all order data 
endpoint:'create',table:'asm_order',misc:misc,firstID:userID,cost:total,date:'required',name:shippingInfo.street_address,email:shippingInfo.city,answer:shippingInfo.state,picture:shippingInfo.zipcode,status:instructions,desc:orderNotes};this.setState({loading:true});__WEBPACK_IMPORTED_MODULE_4_axios___default()({//create order in orders table
method:'post',url:__WEBPACK_IMPORTED_MODULE_5__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:orderData}).then(function(response){//create line items for order in line items table
var res=response.data.data;if(res.ID!==0){var thresholdReached=void 0;var overThreshold=[];var orderItemsForEmail=[];var lineitems=[];cart.forEach(function(orderItem){var prizeID=void 0,variantID=void 0;if(orderItem.size===""||orderItem.size==="N/A"){//prepare data 
orderItem.size=null;}if(orderItem.color==="N/A"){orderItem.color=null;}for(var i=0;i<info.length;i++){if(orderItem.prize===info[i].prize){prizeID=info[i].prizeID;info[i].variants.forEach(function(vari){//get the right variantID for each prize variant that is being ordered
if(orderItem.size===vari.size){//begin
if(orderItem.color!==null){if(orderItem.color===vari.color||orderItem.color.replace(" ","_")===vari.color||orderItem.color.replace("_"," ")===vari.color){variantID=vari.variantID;thresholdReached=vari.quantity-orderItem.quantity<=vari.threshold?true:false;}}else{if(orderItem.color===vari.color){variantID=vari.variantID;thresholdReached=vari.quantity-orderItem.quantity<=vari.threshold?true:false;}}}});}}if(thresholdReached){overThreshold.push(orderItem.prize);}lineitems.push(__WEBPACK_IMPORTED_MODULE_4_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_5__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'create',table:'asm_item',misc:'create_order_item',firstID:res.ID,secondID:prizeID,thirdID:variantID,quantity:orderItem.quantity}}));orderItemsForEmail.push({item:orderItem.prize,quantity:orderItem.quantity,ID:prizeID,variantID:variantID,size:orderItem.size===null?'N/A':orderItem.size,color:orderItem.color===null?'N/A':orderItem.color});});__WEBPACK_IMPORTED_MODULE_4_axios___default.a.all(lineitems).then(function(resp){var admin_email=resp[0].data.data.email;var admin_name=resp[0].data.data.name;if(overThreshold.length>0){overThreshold.forEach(function(over){//if threshold was reached, email the asm admin --this.state.adminEmail--'name':this.state.adminName
__WEBPACK_IMPORTED_MODULE_4_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_5__routes_js__["b" /* mail */],headers:{'Content-Type':'application/json'},data:{'action':'item_threshold','type':'asm','email':admin_email,'prize':over,'name':admin_name}});});}var orderName=_this6.props.userInfo.userType==='asm_admin'||_this6.props.userInfo.userType==='sys_admin'?_this6.state.chosenAsm:_this6.props.userInfo.name;__WEBPACK_IMPORTED_MODULE_4_axios___default()({//email letting the asm admin know that an order has been placed
method:'post',url:__WEBPACK_IMPORTED_MODULE_5__routes_js__["b" /* mail */],headers:{'Content-Type':'application/json'},data:{'action':'newOrder','type':'asm','email':admin_email,'name':admin_name,'orderName':orderName,'orderItems':orderItemsForEmail,'shippingInfo':_this6.state.shippingInfo,'notes':orderNotes,'orderID':res.ID}});if(_this6.props.userInfo.userType!=='asm_admin'&&_this6.props.userInfo.userType!=='user'&&_this6.props.userInfo.userType!=='sys_admin'){_this6.props.budgetUpdate("subtract",total,false);//update budget, lov=false
}_this6.props.updateCart([],_this6.props.updateCartTotal());_this6.setState({success:true,notes:'',loading:false,shippingInfo:{street_address:'',city:'',state:'',zipcode:'',shipping_instructions:''}},function(){_this6.getGifts();_this6.props.logChange();});});}});}else{//let user know that their input is invalid
// let modalPrompt = '';
// let shippingState = this.state.shippingInfo;
// 	if(!validnotes){
// 		modalPrompt += 'Additional notes contains invalid input. ';
// 	}
// 	for(let v=0;v<notValidFields.length;v++){
// 		if(shippingState[notValidFields[v]].trim() === ''){
// 			modalPrompt += notValidFields[v]+' must be filled out. ';
// 		}else{
// 			modalPrompt += notValidFields[v]+' contains invalid characters. ';
// 		}
// 	}
// 	// if(!validcenter){
// 	// 	if(callcenter.trim() === ''){
// 	// 		modalPrompt += 'Call center must be filled out. ';
// 	// 	}else if(!Validation("callcenter",callcenter)){
// 	// 		modalPrompt += 'Call center contains invalid characters. ';
// 	// 	}
// 	// }
// this.setState({validNotes:false,notes:'',modalPrompt:modalPrompt},function(){
// 	setTimeout(()=>{
// 		this.setState({validNotes:true,modalPrompt:''});
// 	},2000);
// });
}}}},{key:'render',value:function render(){var _this7=this;var tierOptions=["All","New","Discontinued"].concat(_toConsumableArray(this.state.tierOptions));var selectStyle="w-80-ns w-100 ml2 h2 shadow-3 pa1 br2 b--gray bw1";var asmSelectStyle="w-100 h2 shadow-3 pa1 br2 b--gray bw1";var selectButtonStyle="bg-dark-blue white grow b br3 bn shadow-3 h2 w-100 mt2";var content=void 0;var customStyles={content:{top:'50%',left:'50%',right:'auto',bottom:'auto',width:'100%',maxWidth:'1080px',transform:'translate(-50%, -50%)',boxShadow:'0.5px 0.5px 1px 0.5px',paddingTop:'10px'},overlay:{backgroundColor:'rgba(105,105,105,0.8)'}};var itemTotal=this.props.cart.length;var cartButton={backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_2__asset_img_shoppingCart_png___default.a+')',backgroundSize:'60px 40px',backgroundRepeat:'no-repeat',backgroundPosition:'center',minWidth:'65px',minHeight:'45px'};var asmNames=[];for(var i=0;i<this.state.asmList.length;i++){asmNames.push(this.state.asmList[i].name);}var information=this.state.info;var limitBudget=(this.props.userInfo.userType==="asm_admin"||this.props.userInfo.userType==='sys_admin')&&this.state.chosenAsmIndex!==-1?this.state.asmList[this.state.chosenAsmIndex].budget:this.props.userInfo.budget;var currentBudget=(limitBudget-this.props.cartTotal).toFixed(2);var gifts=information.map(function(information,i){var item_name=information.status==='active'?information.prize:information.prize+" ("+information.status+")";if(information.tier==_this7.state.tier||_this7.state.tier==="All"){//return all gifts to display based on the tier chosen
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-33-ns w-50-m w-100 pa1 prizeDiv',key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Gift_js__["a" /* default */],{prize:item_name,path:information.picture,variants:information.variants,onChoice:_this7.addToCart,description:information.description,child:i,currentBudget:currentBudget,cartChangeGift:_this7.state.cartChangeGift,didCartChange:_this7.state.didCartChange,cart:_this7.props.cart}));}else if(information.status===_this7.state.tier){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-33-ns w-50-m w-100 pa1 prizeDiv',key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Gift_js__["a" /* default */],{prize:item_name,path:information.picture,variants:information.variants,onChoice:_this7.addToCart,description:information.description,child:i,currentBudget:currentBudget}));}});if(this.props.active){var modalContent=void 0;if(this.state.loading){//display loader 
modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tc',style:{width:'150px',margin:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_9__asset_img_loader_gif___default.a,alt:'Loading'}));}else if(this.state.success){//display success message if order placed successfully
if(this.props.userInfo.userType!=='asm_admin'||this.props.userInfo.userType!=='sys_admin'){modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 tr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'bg-white gray b br3',onClick:this.closeModal},'X')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'f3 navy tc'},'Your order has been placed! You will receive an email once it has been shipped.'));}else{modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'f3 navy tc fl w-100'},'Your order for ',this.state.chosenAsm,' has been placed! Would you like to place another order?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 tc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50 tr pa2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'w-50 bg-dark-blue white br3 pa2',style:{maxWidth:'100px'},onClick:function onClick(){_this7.setState({chosenAsm:_this7.state.asmList[0].name,chosenAsmIndex:-1,success:false});}},'Yes')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50 tl pa2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'w-50 bg-dark-blue white br3 pa2',style:{maxWidth:'100px'},onClick:this.leaveShop},'No'))));}}else if(!this.state.validNotes||!this.state.validShipping){//display message that user input was invalid
modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 tr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'bg-white gray b br3',onClick:this.closeModal},'X')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'f3 navy tc'},this.state.modalPrompt));}else if((this.props.userInfo.userType==='asm_admin'||this.props.userInfo.userType==='sys_admin')&&this.state.chosenAsmIndex===-1){customStyles.content.maxWidth="500px";modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pa0 mb2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 tr pa0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'bg-white gray b br3',onClick:this.leaveShop},'X')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 pb2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'navy b'},'Select an ASM: ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__component_Select_js__["a" /* default */],{name:'chosenAsm',identity:'chosenAsm',onSelect:this.handleInput,options:asmNames,styles:asmSelectStyle,val:this.state.chosenAsm})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100',style:{width:'100px',maxWidth:'100px',margin:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:selectButtonStyle,onClick:this.selectAsm},'Select'))));}else{//display shopping cart
modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pa0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 tr pa0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'bg-white gray b br3',onClick:this.closeModal},'X')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ShoppingCart_js__["a" /* default */],{items:this.props.cart,total:this.props.cartTotal,remove:this.removeItem,quantChange:this.quantityChange,order:this.submitOrder,limit:limitBudget,app:'asm',notes:this.handleInput,states:this.state.states}));}var asmName=void 0;if((this.props.userInfo.userType==='asm_admin'||this.props.userInfo.userType==='sys_admin')&&this.state.chosenAsm!==''){asmName=this.state.chosenAsm+"'s";}content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 b--light-silver bb',style:{maxWidth:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-30 tl mt2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mt2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'b gray'},asmName,' Budget: $',currentBudget))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-40 tc mt2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50 tr mt2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'b gray'},'Price Range: ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50 tl'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__component_Select_js__["a" /* default */],{name:'tier',identity:'tier',onSelect:this.handleSelection,options:tierOptions,styles:selectStyle}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-30 tr mb1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'br3 bw1 b red bg-white bn shadow-1',onClick:this.openModal,style:cartButton},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{display:'inline-block',marginRight:'11px',marginBottom:'11px'}},itemTotal)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 overflow-y-auto pt2',style:{maxHeight:'500px'}},gifts),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_modal___default.a,{isOpen:this.state.modalIsOpen,style:customStyles,contentLabel:'shopping cart Modal',shouldCloseOnOverlayClick:false,shouldCloseOnEsc:false},modalContent)));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,content);}}]);return ASMGiftShop;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ASMGiftShop);ASMGiftShop.propTypes={userInfo:__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.object.isRequired,app:__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.string.isRequired,submitted:__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool.isRequired,updateCart:__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func.isRequired,logChange:__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func.isRequired,cart:__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.array.isRequired,active:__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool.isRequired,cartTotal:__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.number.isRequired,updateCartTotal:__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func.isRequired,handleInput:__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func.isRequired};

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component_Submit_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__component_Input_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__component_Select_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_modal__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__asset_img_magnify_png__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__asset_img_magnify_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__asset_img_magnify_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Gift=function(_Component){_inherits(Gift,_Component);function Gift(props){_classCallCheck(this,Gift);var _this=_possibleConstructorReturn(this,(Gift.__proto__||Object.getPrototypeOf(Gift)).call(this,props));_this.state={prize:_this.props.prize,quantity:1,total:0,available:0,totalAvailable:0,price:0.00,variations:[],variationsIndex:{sizeIndex:0,colorIndex:0},size:'N/A',color:'N/A',photo:'',title:'',variantId:null,limit:null,button:true,modalIsOpen:false};_this.handleSubmit=_this.handleSubmit.bind(_this);_this.getTotal=_this.getTotal.bind(_this);_this.handleQuantity=_this.handleQuantity.bind(_this);_this.handleColor=_this.handleColor.bind(_this);_this.handleSize=_this.handleSize.bind(_this);return _this;}_createClass(Gift,[{key:'componentDidMount',value:function componentDidMount(){//when component mounts, fill in appropriate information for each gift
var allsizes=[];var variations=[];this.props.variants.forEach(function(variant){allsizes.push(variant.size);});var sizes=allsizes.filter(function(v,i,a){return a.indexOf(v)===i;});var firstcolor=void 0,firstphoto=void 0,firstsize=void 0,firstAvailableQuant=void 0,firstTotalAvailable=void 0,firstLimit=void 0;for(var i=0;i<sizes.length;i++){//outer for loop loops through each size in the array sizes
variations.push({//push objects to variations, colors array is for colors that correspond with each single size
size:sizes[i],price:'',colors:[],photos:[],availableQuant:[],totalAvailable:[],variantId:[],limit:[],variantIds:[]});for(var j=0;j<this.props.variants.length;j++){//loop through each variant to compare each size to variant
if(sizes[i]===this.props.variants[j].size){//if the size matches the size in the variations array of objects, add the color to the colors array
variations[i].colors.push(this.props.variants[j].color);variations[i].photos.push(this.props.variants[j].photo);variations[i].availableQuant.push(this.props.variants[j].quantity);variations[i].totalAvailable.push(this.props.variants[j].quantity);variations[i].price=this.props.variants[j].price;variations[i].limit.push(this.props.variants[j].limit?this.props.variants[j].limit:Infinity);//add this to new gf_keys
variations[i].variantIds.push(this.props.variants[j].variantID);//add this to new gf_keys
}}if(sizes[i]===null||sizes[i]===undefined||sizes[i]===''){variations[i].size="N/A";}if(variations[i].colors.length===0||variations[i].colors[0]===undefined||variations[i].colors[0]==null||variations[i].colors[0]===''){firstcolor="N/A";firstphoto=variations[i].photos[0];firstsize=variations[i].size;firstAvailableQuant=variations[i].availableQuant[0];firstTotalAvailable=variations[i].totalAvailable[0];firstLimit=variations[i].limit[0];}else{firstcolor=variations[0].colors[0];firstphoto=variations[0].photos[0];firstAvailableQuant=variations[0].availableQuant[0];firstTotalAvailable=variations[i].totalAvailable[0];firstLimit=variations[0].limit[0];}}this.setState({title:this.props.prize,variations:variations,color:firstcolor,photo:firstphoto,price:variations[0].price,size:variations[0].size,available:firstAvailableQuant,totalAvailable:firstTotalAvailable,limit:firstLimit,quantity:Number(firstAvailableQuant)>0?1:0});}},{key:'getTotal',value:function getTotal(x,y){return Number(x)*Number(y);}},{key:'handleQuantity',value:function handleQuantity(identity,value){var _this2=this;//method for handling user input for quantity of gift
if(Number(this.state.available)>0){//only allow if gift inventory level is above 0
var theState={};if(/^(\s*|[1-9][0-9]*)$/.test(value)){//only allow positive integer values
if(value!==''){if(Number(value)>Number(this.state.available)){//dont allow a quantity greater than the quantity available
value=Number(this.state.available);}if(this.state.limit&&Number.isFinite(this.state.limit)){var cartQuant=this.props.cart.find(function(item){return item.variantId===_this2.state.variantId;});cartQuant=cartQuant?cartQuant.quantity:0;var totalQuant=cartQuant+value;var quantCheck=this.state.limit-totalQuant;console.log(cartQuant,quantCheck,this.state.limit);if(quantCheck<0){value=this.state.limit-cartQuant;}}var total=this.getTotal(Number(this.state.price),value);while(this.props.currentBudget-total<0){value--;total=this.getTotal(Number(this.state.price),value);}theState[identity]=Number(value);}else{theState[identity]=value;}this.setState(theState);}}}},{key:'handleSize',value:function handleSize(identity,value){//method that handles changing the size of a prize, and setting the correct first color and its respective picture
var variants=this.state.variations;var theState={};var variationsIndex={};theState[identity]=value;for(var i=0;i<variants.length;i++){if(variants[i].size===value){theState['color']=variants[i].colors[0];//set first color of prize
theState['photo']=variants[i].photos[0];//set picture for first color
theState['available']=variants[i].availableQuant[0];theState['totalAvailable']=variants[i].totalAvailable[0];theState['limit']=variants[i].limit[0];theState['variantId']=variants[i].variantIds[0];theState['price']=variants[i].price;variationsIndex['sizeIndex']=i;variationsIndex['colorIndex']=0;theState['variationsIndex']=variationsIndex;if(Number(theState['available'])>0){theState['quantity']=1;}else{theState['quantity']=0;}}}this.setState(theState);}},{key:'handleColor',value:function handleColor(identity,value){//method for handling user input for colors, displays corresponding image of the color selected
var variants=this.state.variations;var theState={};var variationsIndex={};theState[identity]=value;for(var i=0;i<variants.length;i++){if(variants[i].size===this.state.size){for(var j=0;j<variants[i].colors.length;j++){if(variants[i].colors[j]===value.replace(/\s/g,"_")){theState['photo']=variants[i].photos[j];theState['available']=variants[i].availableQuant[j];theState['totalAvailable']=variants[i].totalAvailable[j];variationsIndex['sizeIndex']=i;variationsIndex['colorIndex']=j;theState['variantId']=variants[i].variantIds[j];theState['limit']=variants[i].limit[j];theState['variationsIndex']=variationsIndex;if(Number(theState['available'])>0){theState['quantity']=1;}else{theState['quantity']=0;}}}}}this.setState(theState);}},{key:'handleSubmit',value:function handleSubmit(){var _this3=this;//method for passing up gift information to be added to the shopping cart
if(this.state.quantity!==''){var price=this.state.price;var quant=this.state.quantity===undefined||this.state.quantity===null||this.state.quantity<1?1:this.state.quantity;var available=Number(this.state.available)-Number(quant);var total=this.getTotal(price,quant).toFixed(2);//get total cost based on quantity and unit price
var cartQuant=this.props.cart.find(function(item){return item.variantId===_this3.state.variantId;});cartQuant=cartQuant?cartQuant.quantity:0;var totalQuant=cartQuant+quant;var canAdd=totalQuant<=this.state.limit&&available>=0&&this.props.currentBudget-total>=0;if(canAdd){var variations=[].concat(_toConsumableArray(this.state.variations));var oldVariantQuantity=variations[this.state.variationsIndex.sizeIndex].availableQuant;var newVariantQuantity=[].concat(_toConsumableArray(oldVariantQuantity));newVariantQuantity[this.state.variationsIndex.colorIndex]=available;variations[this.state.variationsIndex.sizeIndex].availableQuant=newVariantQuantity;this.setState({total:total,available:available,button:false,variations:variations},function(){var _this4=this;//on click, add button displays "Added!" for half a second
setTimeout(function(){_this4.setState({button:true});},500);var lineItem={prize:this.state.prize,quantity:Number(quant),total:this.state.total,size:this.state.size,color:this.state.color,variationsIndex:this.state.variationsIndex,totalAvailable:this.state.totalAvailable,limit:this.state.limit,variantId:this.state.variantId};this.props.onChoice(lineItem);//pass up gift information
if(available>0&&totalQuant<this.state.limit){this.setState({quantity:1});}else{this.setState({quantity:0});}});}}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){//update available quantity of gift, which is passed down from giftshop. can change if quantity in shopping cart is edited
if(prevProps.didCartChange!==this.props.didCartChange&&this.props.cartChangeGift.prize===this.props.prize){var cartChangeGift=this.props.cartChangeGift;var allsizes=[];var variations=[];var currentAvailable=Number(this.state.available);var totalAvailable=Number(this.state.totalAvailable);var quantity=1;this.props.variants.forEach(function(variant){allsizes.push(variant.size);});var sizes=allsizes.filter(function(v,i,a){return a.indexOf(v)===i;});for(var i=0;i<sizes.length;i++){//outer for loop loops through each size in the array sizes
variations.push({//push objects to variations, colors array is for colors that correspond with each single size
size:sizes[i],price:'',colors:[],photos:[],availableQuant:[],totalAvailable:[],limit:[],variantIds:[]});for(var j=0;j<this.props.variants.length;j++){//loop through each variant to compare each size to variant
if(sizes[i]===this.props.variants[j].size){//if the size matches the size in the variations array of objects, add the color to the colors array
variations[i].colors.push(this.props.variants[j].color);variations[i].photos.push(this.props.variants[j].photo);variations[i].availableQuant.push(this.props.variants[j].currentQuantity);variations[i].totalAvailable.push(this.props.variants[j].quantity);variations[i].price=this.props.variants[j].price;variations[i].limit.push(this.props.variants[j].limit?this.props.variants[j].limit:Infinity);variations[i].variantIds.push(this.props.variants[j].variantID);}}if(sizes[i]===null||sizes[i]===undefined||sizes[i]===''){variations[i].size="N/A";}if(variations[i].size===this.state.size&&i==cartChangeGift.sizeIndex){var changedColor=variations[cartChangeGift.sizeIndex].colors[cartChangeGift.colorIndex];var _index=variations[i].colors.indexOf(changedColor);if(_index!==-1){currentAvailable=Number(variations[i].availableQuant[_index]);totalAvailable=Number(variations[i].totalAvailable[_index]);}}}if(currentAvailable<1){quantity=0;currentAvailable=0;}this.setState({available:currentAvailable,totalAvailable:totalAvailable,quantity:quantity,variations:variations});}}},{key:'render',value:function render(){var _this5=this;var customStyles={content:{top:'50%',left:'50%',right:'auto',bottom:'auto',width:'100%',maxWidth:'600px',padding:'5px',transform:'translate(-50%, -50%)',boxShadow:'0.5px 0.5px 1px 0.5px'},overlay:{backgroundColor:'rgba(105,105,105,0.8)'}};var magnifyButton={backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_5__asset_img_magnify_png___default.a+')',backgroundRepeat:'no-repeat',backgroundPosition:'center',backgroundColor:'white',backgroundSize:'25px 25px',minWidth:'30px',minHeight:'30px',maxWidth:'30px',maxHeight:'30px',borderRadius:'8px'};var picstyles={display:'block',maxWidth:'100px',maxHeight:'122px',width:'auto',height:'auto',margin:'auto',cursor:'pointer'};var modalPicStyles={display:'block',width:'auto',height:'auto',margin:'auto',boxShadow:'1px 1px 4px 4px #aaaaaa'};//border:'1px solid black'};
var minHeightStyle={minHeight:'38px'};var selectStyle="w-60 mv1 ml1 mr1 pa1 shadow-2 br2 b--gray bw1";var labelDivStyle="fl w-50 mt2 b gray";var selectDivStyle="fl w-50 tl";var borderstyle="br3 bg-white";var thePrice=this.state.price.toFixed(2);var disable=Number(this.state.available)>0?false:true;var availableStyle=Number(this.state.available)>0?"mt2 ml1 tl b mb2":"mt2 ml1 tl b mb2 red";var descriptionArray=this.props.description.split(",");var bulletPoints=descriptionArray.map(function(details,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'pb3',key:i},details);});var theButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_Submit_js__["a" /* default */],{name:'Add',onClick:this.handleSubmit,styles:'bg-dark-blue white grow b br3 bn shadow-3 h2 w-20-ns',disable:disable});if(!this.state.button){//message displayed in place of add button, on click, for half a second
theButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pt3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'tc mb0 pt4 pb0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'mt4 b navy'},'Added!')));}var size=[];var colors=[];var theColors=[];var vari=this.state.variations;vari.forEach(function(variation){size.push(variation.size);});var selectSize=void 0;var selectColor=void 0;if(size[0]==="N/A"){//if there are no size options, only display color options
selectSize=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'b mt1 mb1 pt1 pb2'},'N/A');colors=this.state.variations[0].colors;colors.forEach(function(color){if(color===null||color===undefined||color===''){color="N/A";}else{color=color.replace(/_/g," ");}theColors.push(color);});if(colors.length===1&&colors[0]==="N/A"){selectColor=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'b mt1 mb1 pt1 pb2'},'N/A');}else{selectColor=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__component_Select_js__["a" /* default */],{name:'color',identity:'color',onSelect:this.handleColor,options:theColors,styles:selectStyle,val:this.state.color});}}else{//if there are color options, consolidate them based on the selected size
selectSize=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__component_Select_js__["a" /* default */],{name:'size',identity:'size',onSelect:this.handleSize,options:size,styles:selectStyle,val:this.state.size});vari.forEach(function(variant){if(variant.size===_this5.state.size){colors=variant.colors;colors.forEach(function(color){if(color===null||color===undefined||color===''){color="N/A";}else{theColors.push(color.replace(/_/g," "));}});}});if(colors.length===1&&colors[0]==="N/A"){selectColor=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'b mt1 mb1 pt1 pb2'},'N/A');}else{selectColor=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__component_Select_js__["a" /* default */],{name:'color',identity:'color',onSelect:this.handleColor,options:theColors,styles:selectStyle,val:this.state.color});}}if(this.state.color==="N/A"&&this.state.size==="N/A"){selectColor=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'b mt1 mb1 pt1 pb2'},'N/A');}var imgpath=this.props.path+this.state.photo;imgpath=imgpath.replace(/\s/g,"_");return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:borderstyle,style:{minWidth:'260px',minHeight:'420px',boxShadow:'1px 1px 4px 4px #aaaaaa',maxWidth:'315px',margin:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tc',style:{height:'176px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt0 pt2 b navy fl tc w-20-ns'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt0 pt2 b navy tc fl w-60-ns'},this.props.prize,' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt0 pt2 b navy fl tc w-20-ns'},'$',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'dark-red'},thePrice,' '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:imgpath,alt:this.props.prize,style:picstyles,onClick:function onClick(){_this5.setState({modalIsOpen:true});}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl cf w-100 mb2 pb mt2 ml4 tl'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:labelDivStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Limit: ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:selectDivStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:availableStyle},this.state.limit&&Number.isFinite(this.state.limit)?this.state.limit:'N/A'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'w-100 center mt2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:labelDivStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Available: ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50 tc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:availableStyle},this.state.available))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'w-100  center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:labelDivStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Size:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:selectDivStyle,style:minHeightStyle},selectSize)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'w-100  center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:labelDivStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Color:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:selectDivStyle},selectColor)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'w-100  center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:labelDivStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Quantity:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:selectDivStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__component_Input_js__["a" /* default */],{name:'quantity',identity:'quantity',onInput:this.handleQuantity,val:this.state.quantity,type:'number',inputStyle:selectStyle})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mv3 pt3'},theButton),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_modal___default.a,{isOpen:this.state.modalIsOpen,style:customStyles,contentLabel:'shopping cart Modal',shouldCloseOnOverlayClick:true,shouldCloseOnEsc:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 tr pt0 pr0 pb1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'b gray',onClick:function onClick(){_this5.setState({modalIsOpen:false});}},'X')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 pb3 pl3 pr3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-40'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{style:{paddingLeft:'10px',paddingRight:'30px'}},bulletPoints)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-60'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:imgpath,alt:this.props.prize,style:modalPicStyles}))))));}}]);return Gift;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Gift);

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/magnify.d50ba4a4.png";

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/settingsGear.5eb92cf6.png";

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__component_Submit_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__component_Select_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ManageTiers_js__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ManageASMPrizes_js__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ASMRegionalCenter_js__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ManageAdminMessages_js__ = __webpack_require__(43);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//container for viewing, creating, or editing Tiers
//container for viewing, creating, or editing prizes/gifts
//container for managing asm budgets
//container for viewing or creating admin messages
var ASMAdminCenter=function(_Component){_inherits(ASMAdminCenter,_Component);function ASMAdminCenter(props){_classCallCheck(this,ASMAdminCenter);var _this=_possibleConstructorReturn(this,(ASMAdminCenter.__proto__||Object.getPrototypeOf(ASMAdminCenter)).call(this,props));_this.handleChoice=_this.handleChoice.bind(_this);_this.handleSelect=_this.handleSelect.bind(_this);_this.getTiers=_this.getTiers.bind(_this);_this.getPrizes=_this.getPrizes.bind(_this);_this.getMessages=_this.getMessages.bind(_this);_this.handleReset=_this.handleReset.bind(_this);_this.handleSave=_this.handleSave.bind(_this);_this.goBack=_this.goBack.bind(_this);_this.revertSave=_this.revertSave.bind(_this);_this.state={Tiers:[],Prizes:[],Years:[],Messages:[],category:'Budgets',year:'',create:false,edit:false,save:false};return _this;}_createClass(ASMAdminCenter,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;//when component mounts, all information regarding prizes/gifts, tiers, and admin messages are retrieved.
__WEBPACK_IMPORTED_MODULE_1_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_2__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'info',table:'years'}}).then(function(response){var data=response.data.data;_this2.setState({Years:data,year:data[0].year});_this2.getPrizes(data[0].year);_this2.getTiers(data[0].year);_this2.getMessages(data[0].year);});}},{key:'getTiers',value:function getTiers(year){var _this3=this;//method that handles retrieving tier information for the selected year from the database.
__WEBPACK_IMPORTED_MODULE_1_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_2__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'info',table:'tiers',kind:'asm',year:year}}).then(function(response){var data=response.data.data;_this3.setState({Tiers:data});});}},{key:'getPrizes',value:function getPrizes(year){var _this4=this;//method that handles retrieving prize/gift information for the selected year from the database.
var gifts=[];__WEBPACK_IMPORTED_MODULE_1_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_2__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'info',table:'prizes',kind:'asm',action:this.props.userInfo.userType,year:year}}).then(function(response){var data=response.data.data;data.forEach(function(prize){prize.picture=__WEBPACK_IMPORTED_MODULE_2__routes_js__["e" /* storeImagePath */]+prize.picture;gifts.push(prize);});_this4.setState({Prizes:gifts});});}},{key:'getMessages',value:function getMessages(year){var _this5=this;//method that handles retrieving admin message information for the selected year from the database.
__WEBPACK_IMPORTED_MODULE_1_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_2__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'info',table:'messages',action:'admin_center',kind:'asm_admin',year:year}}).then(function(response){var data=response.data.data;_this5.setState({Messages:data});});}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){//once a data manipulation action has been taken, this method retrieves the current information from the database.
if(prevProps.submitted!==this.props.submitted){this.getTiers(this.state.year);this.getMessages();this.getPrizes();}}},{key:'handleChoice',value:function handleChoice(identity){//this method controls the state of the admin center, whether it is in view mode, edit mode, or create mode.
if(identity==="create"){this.setState({create:true});this.setState({edit:false});}else{this.setState({edit:true});this.setState({create:false});}}},{key:'handleSelect',value:function handleSelect(identity,value){//handleChange method for the category and year dropdown menus
var theState={};theState[identity]=value;this.setState(theState);this.goBack();if(identity==="year"){//if the year is being changed, get all information from the selected year
this.getTiers(value);this.getPrizes(value);this.getMessages(value);}}},{key:'handleReset',value:function handleReset(type){//method that grabs the current version of information that was just updated from the database
this.setState({create:false,edit:false,save:false});if(type==="tiers"){this.getTiers(this.state.year);}else if(type==="prizes"){this.getPrizes(this.state.year);}else if(type==="messages"){this.getMessages(this.state.year);}}},{key:'goBack',value:function goBack(){//method sets the create, edit, and save parts of the state to their defaults
this.setState({create:false,edit:false,save:false});}},{key:'handleSave',value:function handleSave(){//method to trigger state change for saving information that has been created or updated
this.setState({save:true});}},{key:'revertSave',value:function revertSave(){//method to reset the save parameter of the state to its default
this.setState({save:false});}},{key:'render',value:function render(){var dis=false;var inlineContent={boxShadow:'0px 0px 5px 5px #aaaaaa inset',backgroundColor:'#e6e6e6',maxHeight:'450px'};var contentStyles="b--gray fl pb4 w-100 br3 pt3 mb3 pl3 pr3 overflow-y-auto ba";var greaterContent=void 0;var _state=this.state,Tiers=_state.Tiers,create=_state.create,edit=_state.edit,save=_state.save,year=_state.year,Prizes=_state.Prizes,Messages=_state.Messages;var content=void 0;var years=this.state.Years.map(function(Years){return Years.year;});//returns an array of the current year options for year dropdown
var categories=["Tiers","Gifts","Messages","Budgets"];//options for category dropdown
var selectStyles="h2 pa1 w-70-ns w-100 br2 bw1 truncate shadow-2";var labelStyle="fl w-30 mt1";var selectDivStyle="fl w-70";var buttonStyles="br3 white b w-100 h2 bg-navy shadow-2";var prizeTiers=[];Tiers.forEach(function(tiers){//returns all active tiers for prize/gift creation
if(tiers.tier_status!=='inactive'){prizeTiers.push(tiers.tier);}});var createButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__component_Submit_js__["a" /* default */],{name:'Create',identity:'create',onClick:this.handleChoice,styles:buttonStyles});//default create button
var editButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__component_Submit_js__["a" /* default */],{name:'Edit',identity:'edit',onClick:this.handleChoice,styles:buttonStyles,disable:dis});//default edit button
if(this.state.create||this.state.edit){if(this.state.create){//if the admin center is in create mode, these are the button values
editButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__component_Submit_js__["a" /* default */],{name:'Back',identity:'back',onClick:this.goBack,styles:buttonStyles});createButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__component_Submit_js__["a" /* default */],{name:'Save',identity:'save',onClick:this.handleSave,styles:buttonStyles});}else{//if the admin center is in edit mode, these are the button values
if(this.state.category==="Tiers"){editButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__component_Submit_js__["a" /* default */],{name:'Back',identity:'back',onClick:this.goBack,styles:buttonStyles});createButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__component_Submit_js__["a" /* default */],{name:'Save',identity:'save',onClick:this.handleSave,styles:buttonStyles});}else{editButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__component_Submit_js__["a" /* default */],{name:'Back',identity:'back',onClick:this.goBack,styles:buttonStyles});createButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__component_Submit_js__["a" /* default */],{name:'Create',identity:'create',onClick:this.handleChoice,styles:buttonStyles});}}}//button original div that the buttons remain in, can change based on category chosen
var ButtonGroup=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mb2 mt3',style:{maxWidth:'300px',margin:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50 tr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tr'},createButton)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50'},editButton));var yearSelect=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50-ns w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:labelStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'mt2 b'},'Year: ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:selectDivStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__component_Select_js__["a" /* default */],{identity:'year',options:years,onSelect:this.handleSelect,styles:selectStyles,val:this.state.year})));switch(this.state.category){//switch statement for rendering content based on category selection
case"Tiers":content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ManageTiers_js__["a" /* default */],{tiers:Tiers,create:create,edit:edit,save:save,revertSave:this.revertSave,year:year,app:this.props.app,reset:this.handleReset,logChange:this.props.logChange});break;case"Gifts":content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ManageASMPrizes_js__["a" /* default */],{prizes:Prizes,create:create,edit:edit,revertSave:this.revertSave,save:save,year:year,app:this.props.app,getPrizes:this.getPrizes,logChange:this.props.logChange,reset:this.handleReset,tiers:prizeTiers});break;case"Messages":content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ManageAdminMessages_js__["a" /* default */],{messages:Messages,years:years,year:year,create:create,edit:edit,revertSave:this.revertSave,save:save,reset:this.getMessages,logChange:this.props.logChange,userInfo:this.props.userInfo});if(!this.state.create){//admin messages dont have an edit option
ButtonGroup=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mb2 mt3',style:{maxWidth:'300px',margin:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tc w-50 center'},createButton)));}else{ButtonGroup=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mb2 mt3',style:{maxWidth:'300px',margin:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50 tr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tr'},createButton)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__component_Submit_js__["a" /* default */],{name:'Back',identity:'back',onClick:this.goBack,styles:buttonStyles})));}break;case"Budgets":content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ASMRegionalCenter_js__["a" /* default */],{userInfo:this.props.userInfo,app:this.props.app,active:true,logChange:this.props.logSubmitted}));ButtonGroup='';yearSelect='';break;default:content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ManageTiers_js__["a" /* default */],{tiers:Tiers,create:create,edit:edit,save:save,year:year,app:this.props.app,reset:this.handleReset,logChange:this.props.logChange});}if(this.props.active){greaterContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 mv2 pb3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50-ns w-100 mb1',style:{display:'inline-block'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:labelStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'mt2 b'},'Category: ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:selectDivStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__component_Select_js__["a" /* default */],{identity:'category',options:categories,onSelect:this.handleSelect,styles:selectStyles,val:this.state.category}))),yearSelect),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:contentStyles,style:inlineContent},content),ButtonGroup);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,greaterContent);}}]);return ASMAdminCenter;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ASMAdminCenter);

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CreateASMPrize_js__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EditASMPrize_js__ = __webpack_require__(152);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//component for creating ASM prizes/gifts
//component for editing ASM prizes/gifts
var ManageASMPrizes=function(_Component){_inherits(ManageASMPrizes,_Component);function ManageASMPrizes(props){_classCallCheck(this,ManageASMPrizes);var _this=_possibleConstructorReturn(this,(ManageASMPrizes.__proto__||Object.getPrototypeOf(ManageASMPrizes)).call(this,props));_this.state={newPrize:'',editedPrize:[],failed:false};return _this;}_createClass(ManageASMPrizes,[{key:'render',value:function render(){var divStyles=void 0;var pStyles="mt0 pt2 fl w-100 b navy mb3 bb b--light-silver";var picstyles={display:'block',maxWidth:'100px',maxHeight:'122px',width:'auto',height:'auto',margin:'auto'};var spanStyle=void 0;var prizes=void 0;if(this.props.prizes!==undefined&&this.props.prizes.length>0){//display all ASM prizes/gifts for year selected
if(!(this.props.create||this.props.edit)){//if prize/gift inventory is lower than threshold set in LOV_ASM_Inventory table, highlight prize/gift in red
prizes=this.props.prizes.map(function(prizes,i){if(prizes.quantity<=prizes.threshold){spanStyle="red";divStyles="pa2 ba br3 overflow-y-auto ma3 bg-white shadow-3 b--red";}else{spanStyle="";divStyles="pa2 ba br3 overflow-y-auto ma3 bg-white shadow-3 b--navy";}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50-ns mb2 w-100-m w-100 pa1',key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{maxWidth:'460px',margin:'auto'},className:divStyles,key:prizes.prizeID},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-60 pr2',style:{minHeight:'200px',maxHeight:'200px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt0 pt2 tc b navy underline'},prizes.prize),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:prizes.picture,alt:'error',style:picstyles}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'tc navy'},prizes.description)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-40'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:pStyles},'Tier: ',prizes.tier),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:pStyles},'Price: $',prizes.price.toFixed(2)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:pStyles},'Quantity: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:spanStyle},prizes.quantity)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:pStyles},'Status: ',prizes.status)))));});}}else{//if there have been no prizes/gifts created for the year selected, display this message
prizes=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'w-100 f3 tc'},'There is nothing to view at this time.');}if(this.props.create){//display CreateASMPrize
prizes=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__CreateASMPrize_js__["a" /* default */],{save:this.props.save,revertSave:this.props.revertSave,year:this.props.year,onClose:this.props.getPrizes,logChange:this.props.logChange,tiers:this.props.tiers});}else if(this.props.edit){//display EditASMPrize
prizes=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__EditASMPrize_js__["a" /* default */],{save:this.props.save,revertSave:this.props.revertSave,year:this.props.year,prizes:this.props.prizes,onClose:this.props.getPrizes,reset:this.props.reset,tiers:this.props.tiers});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{maxWidth:'900px',margin:'auto'}},prizes);}}]);return ManageASMPrizes;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ManageASMPrizes);

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__component_Input_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_modal__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__asset_img_sparkles2_png__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__asset_img_sparkles2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__asset_img_sparkles2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__component_Select_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__asset_img_loader_gif__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__asset_img_loader_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__asset_img_loader_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Validation_js__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CreateASMPrize=function(_Component){_inherits(CreateASMPrize,_Component);function CreateASMPrize(props){_classCallCheck(this,CreateASMPrize);var _this=_possibleConstructorReturn(this,(CreateASMPrize.__proto__||Object.getPrototypeOf(CreateASMPrize)).call(this,props));_this.handleInput=_this.handleInput.bind(_this);_this.handleFile=_this.handleFile.bind(_this);_this.onCreate=_this.onCreate.bind(_this);_this.openModal=_this.openModal.bind(_this);_this.closeModal=_this.closeModal.bind(_this);_this.fileInput=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.isImage=_this.isImage.bind(_this);_this.loadingFunc=_this.loadingFunc.bind(_this);_this.state={prize:'',tier:'1',price:'',quantity:'',threshold:'',picture:[],description:'',modalPrompt:'',modalIsOpen:false,loading:false};return _this;}_createClass(CreateASMPrize,[{key:'handleInput',value:function handleInput(identity,value){//standard method for updating the state based on user input
var theState=this.state;theState[identity]=value;this.setState(theState);}},{key:'loadingFunc',value:function loadingFunc(loading){//method for displaying the loading gif
if(loading){this.setState({loading:true},function(){this.openModal();});}else{this.setState({loading:false});}}},{key:'openModal',value:function openModal(){//method for opening the modal
this.setState({modalIsOpen:true});}},{key:'closeModal',value:function closeModal(){//method for closing the modal
this.setState({modalIsOpen:false,modalPrompt:''});this.props.revertSave();}},{key:'isImage',value:function isImage(file){//method to determine whether or not an uploaded file is an image (validate file uploads to prevent malicious code/programs from being uploaded)
return file['type'].split('/')[0]=='image';}},{key:'handleFile',value:function handleFile(){//method that records name of uploaded picture for file storage
var fileName="asm_"+this.fileInput.current.files[0].name;this.setState({picture:fileName});}},{key:'onCreate',value:function onCreate(newPrize){var _this2=this;//method to create main prize information (tier, year, type, picture path, name of prize, description)
__WEBPACK_IMPORTED_MODULE_1_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_2__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'create',table:'prizes',misc:'create',firstID:newPrize.tier,secondID:this.props.year,status:'asm',name:newPrize.prize,picture:newPrize.picture,desc:newPrize.description}}).then(function(response){var data=response.data.data;if(data.ID!==0){//if prize information was created, continue
_this2.putPrice(data.ID);}else{_this2.setState({modalPrompt:"Gift already exists!"},function(){this.openModal();});}});}},{key:'putPrice',value:function putPrice(prizeID){var _this3=this;//method for saving the price of prize/gift being created, the quantity in inventory, and the "low inventory" threshold
__WEBPACK_IMPORTED_MODULE_1_axios___default()({//store price
method:'post',url:__WEBPACK_IMPORTED_MODULE_2__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'create',table:'pricing',firstID:prizeID,cost:this.state.price}}).then(function(response){_this3.setState({prize:'',tier:'',price:'',picture:'',description:''});});__WEBPACK_IMPORTED_MODULE_1_axios___default()({//store quantity and threshold
method:'post',url:__WEBPACK_IMPORTED_MODULE_2__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'create',table:'inventory',misc:'create',firstID:prizeID,quantity:this.state.quantity,secondID:this.state.threshold}}).then(function(response){_this3.props.revertSave();_this3.setState({threshold:'',quantity:'',modalPrompt:'Gift successfully created!'},function(){this.loadingFunc(false);this.props.onClose(this.props.year);});});}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){var _this4=this;var _state=this.state,prize=_state.prize,tier=_state.tier,picture=_state.picture,description=_state.description,price=_state.price,quantity=_state.quantity,threshold=_state.threshold;if(prevProps.save!==this.props.save&&this.props.save){//if user has chosen to save/create prize
if(picture.length>0&&tier!==''&&prize!==''&&description!==''&&price!==''&&price>0&&quantity!==''&&threshold!==''){//make sure all fields have been filled out
if(Object(__WEBPACK_IMPORTED_MODULE_8__Validation_js__["a" /* default */])("prize",prize)&&Object(__WEBPACK_IMPORTED_MODULE_8__Validation_js__["a" /* default */])("prize",description)&&this.isImage(this.fileInput.current.files[0])){//if fields contain valid input, create prize
this.loadingFunc(true);document.getElementById("desc").classList.remove("invalid");document.getElementById("prize").classList.remove("invalid");var data=new FormData();data.append('file[]',this.fileInput.current.files[0],"asm_"+this.fileInput.current.files[0].name);__WEBPACK_IMPORTED_MODULE_1_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_2__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:data}).then(function(response){_this4.onCreate(_this4.state);});}else{//fields dont contain valid input
var modalPrompt='';if(!Object(__WEBPACK_IMPORTED_MODULE_8__Validation_js__["a" /* default */])("prize",prize)||!Object(__WEBPACK_IMPORTED_MODULE_8__Validation_js__["a" /* default */])("prize",description)){//prize name or description do not contain valid input
modalPrompt+='Fields must contain valid input. No special characters.';}if(!this.isImage(this.fileInput.current.files[0])){//file is not an image, only images are allowed for file upload
modalPrompt+='Only images are allowed to be uploaded.';}this.setState({modalPrompt:modalPrompt},function(){this.openModal();});if(!Object(__WEBPACK_IMPORTED_MODULE_8__Validation_js__["a" /* default */])("prize",prize)){//highlight prize name input
document.getElementById("prize").classList.add("invalid");}else{document.getElementById("prize").classList.remove("invalid");}if(!Object(__WEBPACK_IMPORTED_MODULE_8__Validation_js__["a" /* default */])("prize",description)){//highlight description input
document.getElementById("desc").classList.add("invalid");}else{document.getElementById("desc").classList.remove("invalid");}if(!this.isImage(this.fileInput.current.files[0])){//highlight image upload lable
document.getElementById("pic").classList.add("invalidLabel");}else{document.getElementById("pic").classList.remove("invalidLabel");}}}else{if(picture.length===0){//highlight image upload lable
document.getElementById("pic").classList.add("invalidLabel");}else{document.getElementById("pic").classList.remove("invalidLabel");}if(prize===''){//highlight prize name input
document.getElementById("prize").classList.add("invalid");}else{document.getElementById("prize").classList.remove("invalid");}if(description===''){//highlight description input
document.getElementById("desc").classList.add("invalid");}else{document.getElementById("desc").classList.remove("invalid");}if(price===''||price<=0){//highlight price input field
document.getElementById("price").classList.add("invalid");}else{document.getElementById("price").classList.remove("invalid");}if(quantity===''){//highlight quantity input field
document.getElementById("qty").classList.add("invalid");}else{document.getElementById("qty").classList.remove("invalid");}if(threshold===''){//highlight threshold input field
document.getElementById("thresh").classList.add("invalid");}else{document.getElementById("thresh").classList.remove("invalid");}this.setState({modalPrompt:'All fields are required.'},function(){this.openModal();});}}}},{key:'render',value:function render(){var customStyles={content:{top:'50%',left:'50%',right:'auto',bottom:'auto',width:'400px',minWidth:'300px',minHeight:'160px',borderStyle:'solid',borderWidth:'2px',borderColor:'gray',transform:'translate(-50%, -50%)',backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_5__asset_img_sparkles2_png___default.a+')',backgroundRepeat:'no-repeat',backgroundSize:'300px 160px',backgroundPosition:'right',boxShadow:'0.5px 0.5px 1px 0.5px'},overlay:{backgroundColor:'rgba(105,105,105,0.8)'}};var modalContent=void 0;if(this.state.loading){//either display loading gif or message
modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tc',style:{width:'150px',margin:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_7__asset_img_loader_gif___default.a,alt:'Loading'}));}else{modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'b navy tc mt3 f4'},this.state.modalPrompt);}var inputStyles="h2 br2 bw1 w-100 shadow-3 pl2 pr2";var areaStyles="br2 bw1 h3 w-100 shadow-3 pa2";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100',style:{maxWidth:'900px',margin:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 mt4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50-ns w-100 mt0-ns mt3-m'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'b'},'Gift name: ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 pr2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__component_Input_js__["a" /* default */],{identity:'prize',onInput:this.handleInput,id:'prize',val:this.state.prize,inputStyle:inputStyles}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-25-ns w-50 mt0-ns mt3-m mt3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'b'},'Tier: ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 pr2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__component_Select_js__["a" /* default */],{name:'tier',identity:'tier',onSelect:this.handleInput,options:this.props.tiers,styles:inputStyles,val:this.state.tier}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-25-ns w-50 mt0-ns mt3-m mt3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'b'},'Price: ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 pr2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__component_Input_js__["a" /* default */],{identity:'price',id:'price',onInput:this.handleInput,val:this.state.price,inputStyle:inputStyles,type:'number'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 mt3-m mt3-ns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50-ns w-100-m w-100 mv3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-20'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{id:'pic',className:'b'},'Picture: ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-80 pr2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ml2-ns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'file',name:'files',onChange:this.handleFile,ref:this.fileInput,accept:'image/*'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-25-ns w-50-m w-100 mt2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'b'},'Notification Threshold: ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 pr2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__component_Input_js__["a" /* default */],{identity:'threshold',id:'thresh',onInput:this.handleInput,val:this.state.threshold,inputStyle:'h2 br2 bw1 w-100 shadow-3 pl2 pr2 mr2-ns mr2-m',type:'number'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-25-ns w-50-m w-100 mt2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'b'},'Quantity: ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 pr2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__component_Input_js__["a" /* default */],{identity:'quantity',id:'qty',onInput:this.handleInput,val:this.state.quantity,inputStyle:'h2 br2 bw1 w-100 shadow-3 pl2',type:'number'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 mt3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'b'},'Description: ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 tl pr2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__component_Input_js__["a" /* default */],{type:'text',identity:'description',id:'desc',inputStyle:inputStyles,onInput:this.handleInput,val:this.state.description}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_modal___default.a,{isOpen:this.state.modalIsOpen,style:customStyles,contentLabel:'loading',shouldCloseOnOverlayClick:false,shouldCloseOnEsc:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 tr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'bg-white gray b br3',onClick:this.closeModal},'X')),modalContent)));}}]);return CreateASMPrize;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CreateASMPrize);

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_modal__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CurrentASMEdit_js__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__asset_img_loader_gif__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__asset_img_loader_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__asset_img_loader_gif__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//component that contains the information of prize/gift that is currently being edited
var EditASMPrize=function(_Component){_inherits(EditASMPrize,_Component);function EditASMPrize(props){_classCallCheck(this,EditASMPrize);var _this=_possibleConstructorReturn(this,(EditASMPrize.__proto__||Object.getPrototypeOf(EditASMPrize)).call(this,props));_this.editPrize=_this.editPrize.bind(_this);_this.openModal=_this.openModal.bind(_this);_this.closeModal=_this.closeModal.bind(_this);_this.commitEdit=_this.commitEdit.bind(_this);_this.updatePrize=_this.updatePrize.bind(_this);_this.state={currentEdit:'',editedPrizes:[],failed:false,modalIsOpen:false,modalPrompt:'',loading:false};return _this;}_createClass(EditASMPrize,[{key:'editPrize',value:function editPrize(e){//method for selecting which prize/gift to be edited. passes down information to currentASMEdit component
var ID=e.target.id;var prize=void 0;this.props.prizes.forEach(function(prizes){if(Number(prizes.prizeID)===Number(ID)){prize=prizes;}});this.setState({currentEdit:prize},function(){this.openModal();});}},{key:'updatePrize',value:function updatePrize(p){var _this2=this;//method that handles api calls for updating all prize/gift information
var calls=[];calls.push(__WEBPACK_IMPORTED_MODULE_1_axios___default()({//update information in LOV_Prizes table
method:'post',url:__WEBPACK_IMPORTED_MODULE_2__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'create',table:'prizes',misc:'update',name:p.prize,secondID:p.tier,desc:p.description,firstID:p.ID,status:p.status}}));calls.push(__WEBPACK_IMPORTED_MODULE_1_axios___default()({//update information in LOV_ASM_Gift_Pricing table
method:'post',url:__WEBPACK_IMPORTED_MODULE_2__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'create',table:'pricing',firstID:p.ID,cost:p.price,misc:'edit'}}));calls.push(__WEBPACK_IMPORTED_MODULE_1_axios___default()({//update information in LOV_ASM_Inventory  table
method:'post',url:__WEBPACK_IMPORTED_MODULE_2__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'create',table:'inventory',misc:'update',firstID:p.ID,secondID:p.threshold,quantity:p.quantity}}));__WEBPACK_IMPORTED_MODULE_1_axios___default.a.all(calls).then(function(){_this2.props.onClose(_this2.props.year);_this2.setState({modalPrompt:'Gift updated!'},function(){this.setState({loading:false});});}).catch(function(){_this2.setState({loading:false});_this2.setState({modalPrompt:'A problem has occured. Please try again.'});});}},{key:'commitEdit',value:function commitEdit(edited){//begin process of saving edited information
this.setState({currentEdit:'',loading:true});this.updatePrize(edited);}},{key:'openModal',value:function openModal(){//open the modal
this.setState({modalIsOpen:true});}},{key:'closeModal',value:function closeModal(){//close the modal
this.setState({modalIsOpen:false,modalPrompt:''});}},{key:'render',value:function render(){var _this3=this;var customStyles={content:{top:'50%',left:'50%',right:'auto',bottom:'auto',width:'100%',maxWidth:'800px',backgroundColor:'#F4F4F4',borderStyle:'solid',borderWidth:'2px',borderColor:'gray',paddingTop:'0',transform:'translate(-50%, -50%)',boxShadow:'0.5px 0.5px 1px 0.5px'},overlay:{backgroundColor:'rgba(105,105,105,0.8)'}};var pStyles="mt0 pt2 fl w-100 b navy mb3 bb b--light-silver";var picstyles={display:'block',maxWidth:'100px',maxHeight:'122px',width:'auto',height:'auto',margin:'auto'};var buttonStyles="bg-navy white br2 b pa1 tc";var prizes=void 0;var spanStyle=void 0;var divStyles=void 0;var modalContent=void 0;if(this.state.currentEdit!==''){//modal displays the CurrentASMEdit component
modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 tr pt2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'bg-white gray b br3',onClick:this.closeModal},'X')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__CurrentASMEdit_js__["a" /* default */],{prize:this.state.currentEdit,onFinish:this.commitEdit,tiers:this.props.tiers}));}else if(this.state.loading){//display loading gif
modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tc',style:{width:'150px',margin:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5__asset_img_loader_gif___default.a,alt:'Loading'}));}else{//display message prompt
modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 tr pt2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'bg-white gray b br3',onClick:this.closeModal},'X')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'b navy tc f4'},this.state.modalPrompt));}prizes=this.props.prizes.map(function(prizes,i){//loop through and display all prizes/gifts
if(prizes.quantity<=prizes.threshold){//highlight prize if current inventory is lower than the set threshold in the LOV_ASM_Inventory table
spanStyle="red";divStyles="pa2 ba br3 overflow-y-auto ma3 bg-white shadow-3 b--red";}else{spanStyle="";divStyles="pa2 ba br3 overflow-y-auto ma3 bg-white shadow-3 b--navy";}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50-ns w-100-m w-100 mb2 pa1',key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{maxWidth:'460px',margin:'auto'},className:divStyles,key:prizes.prizeID},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-60 pr2',style:{minHeight:'200px',maxHeight:'200px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt0 pt2 tc b navy underline'},prizes.prize),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:prizes.picture,alt:'error',style:picstyles}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'tc navy'},prizes.description)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-40'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:pStyles},'Tier: ',prizes.tier),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:pStyles},'Price: $',prizes.price.toFixed(2)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:pStyles},'Quantity: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:spanStyle},prizes.quantity)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:pStyles},'Status: ',prizes.status),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{id:prizes.prizeID,onClick:_this3.editPrize,className:buttonStyles},'Edit Prize')))));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,prizes),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_modal___default.a,{isOpen:this.state.modalIsOpen,style:customStyles,contentLabel:'shopping cart Modal',shouldCloseOnOverlayClick:false,shouldCloseOnEsc:false},modalContent)));}}]);return EditASMPrize;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (EditASMPrize);

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component_Input_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__component_Select_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Validation_js__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CurrentASMEdit=function(_Component){_inherits(CurrentASMEdit,_Component);function CurrentASMEdit(props){_classCallCheck(this,CurrentASMEdit);var _this=_possibleConstructorReturn(this,(CurrentASMEdit.__proto__||Object.getPrototypeOf(CurrentASMEdit)).call(this,props));_this.handleInput=_this.handleInput.bind(_this);_this.commitChanges=_this.commitChanges.bind(_this);_this.state={prize:'',tier:'',price:'',quantity:0,threshold:'',picture:'',description:'',status:'',finish:false,invalid:false,invalidFields:''};return _this;}_createClass(CurrentASMEdit,[{key:'componentDidMount',value:function componentDidMount(){//set state with current prize values so that inputs contain current values by default
var p=this.props.prize;this.setState({prize:p.prize,tier:p.tier,price:Number(p.price).toFixed(2),threshold:Number(p.threshold),picture:p.picture,description:p.description,status:p.status});}},{key:'handleInput',value:function handleInput(identity,value){//standard method for handling user input
var theState=this.state;theState[identity]=value;this.setState(theState);}},{key:'commitChanges',value:function commitChanges(){//method to begin process of updating prize info. eventually, all code in componentDidUpdate should be moved here
this.setState({finish:true});}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){if(this.state.finish!==prevState.finish&&this.state.finish){//if user has chosen to update prize with the current information
var _state=this.state,prize=_state.prize,tier=_state.tier,price=_state.price,description=_state.description,quantity=_state.quantity,threshold=_state.threshold,status=_state.status;if(Object(__WEBPACK_IMPORTED_MODULE_3__Validation_js__["a" /* default */])("prize",prize.trim())&&Object(__WEBPACK_IMPORTED_MODULE_3__Validation_js__["a" /* default */])("prize",description.trim())&&prize.trim()!==''&&description.trim()!==''&&price.trim()!==''&&price.trim()!=='.'&&threshold!==''){//if all fields are filled out and contain valid input, pass up state to parent (EditASMPrize)
this.setState({invalid:false});var qty=quantity===''?0:quantity;this.props.onFinish({ID:this.props.prize.prizeID,prize:prize.trim(),tier:tier,price:price,description:description.trim(),threshold:threshold,quantity:qty,status:status});}else{//one or more input fields is blank or invalid
var invalidField=void 0;if((!Object(__WEBPACK_IMPORTED_MODULE_3__Validation_js__["a" /* default */])("prize",prize.trim())||prize.trim()==='')&&(!Object(__WEBPACK_IMPORTED_MODULE_3__Validation_js__["a" /* default */])("prize",description.trim())||description.trim()==='')){invalidField='both';}else if(!Object(__WEBPACK_IMPORTED_MODULE_3__Validation_js__["a" /* default */])("prize",prize.trim())||prize.trim()===''){invalidField='prize';}else if(!Object(__WEBPACK_IMPORTED_MODULE_3__Validation_js__["a" /* default */])("prize",description.trim())||description.trim()===''){invalidField='description';}if(threshold===''){document.getElementById("threshold").classList.add("invalid");}else{document.getElementById("threshold").classList.remove("invalid");}if(price.trim()===''||price.trim()==='.'){document.getElementById("price").classList.add("invalid");}else{document.getElementById("price").classList.remove("invalid");}this.setState({finish:false,invalid:true,invalidFields:invalidField});}}}},{key:'render',value:function render(){var invalidMessage=void 0;var inputStyles="pa0 h2 br2 bw1 w-100 shadow-2 pl2";var areaStyles="pa0 br2 bw1 h3 w-100";var prizeStyles=inputStyles;if(this.state.invalid){//error message and highlighting for invalid or empty input fields
invalidMessage=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'b red'},'*All fields must be filled out and valid');if(this.state.invalidFields==='both'){areaStyles="pa0 b--red br2 bw1 h3 w-100";prizeStyles="pa0 h2 b--red br2 bw1 w-100 shadow-2 pl2";}else if(this.state.invalidFields==='prize'){prizeStyles="pa0 h2 b--red br2 bw1 w-100 shadow-2 pl2";}else if(this.state.invalidFields==='description'){areaStyles="pa0 b--red br2 bw1 h3 w-100";}}var buttonStyles="br3 white b w-30-ns w-60-m w-100 h2 bg-navy shadow-2";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100',style:{maxWidth:'800px',margin:'auto'}},invalidMessage,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50-ns w-100 pa2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'b navy mb1'},'Prize name: ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_Input_js__["a" /* default */],{identity:'prize',onInput:this.handleInput,val:this.state.prize,inputStyle:prizeStyles}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-25-ns w-100 pa2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'b navy tr mb1'},'Tier: ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__component_Select_js__["a" /* default */],{name:'tier',identity:'tier',onSelect:this.handleInput,options:this.props.tiers,styles:inputStyles,val:this.state.tier}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-25-ns w-100 pa2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'b navy tr mb1'},'Price: ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_Input_js__["a" /* default */],{identity:'price',id:'price',onInput:this.handleInput,val:this.state.price,inputStyle:inputStyles,type:'number'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 mt3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-75-ns w-100-m w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50-ns w-100 pa2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'b navy tr mb1'},'Notification Threshold: ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_Input_js__["a" /* default */],{identity:'threshold',id:'threshold',onInput:this.handleInput,val:this.state.threshold,inputStyle:inputStyles,type:'number'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-50-ns  w-100 pa2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'b navy tr mb1'},'Quantity To Add: ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_Input_js__["a" /* default */],{identity:'quantity',onInput:this.handleInput,val:this.state.quantity,inputStyle:inputStyles,type:'number'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-25-ns w-100-m w-100 pa2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'b navy tr mb1'},'Status: ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__component_Select_js__["a" /* default */],{identity:'status',onSelect:this.handleInput,val:this.state.status,options:["active","inactive","Discontinued"],styles:inputStyles})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 mt3 pa2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'mb1 b navy mb1'},'Description: ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_Input_js__["a" /* default */],{type:'text',identity:'description',inputStyle:inputStyles,onInput:this.handleInput,val:this.state.description}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 tc mt2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:this.commitChanges,className:buttonStyles},'Save Changes')));}}]);return CurrentASMEdit;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CurrentASMEdit);

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_minimal_pie_chart__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_minimal_pie_chart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_minimal_pie_chart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__asset_img_loader_gif__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__asset_img_loader_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__asset_img_loader_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_modal__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__asset_img_sparkles2_png__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__asset_img_sparkles2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__asset_img_sparkles2_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Participation=function(_Component){_inherits(Participation,_Component);function Participation(props){_classCallCheck(this,Participation);var _this=_possibleConstructorReturn(this,(Participation.__proto__||Object.getPrototypeOf(Participation)).call(this,props));_this.state={data:[],value_data:[],width:0,year:'',totalParticipation:'',totalRecipient:'',totalThankyous:'',loading:false,modalIsOpen:false,participation:true};_this.updateDimensions=_this.updateDimensions.bind(_this);_this.getStats=_this.getStats.bind(_this);_this.getData=_this.getData.bind(_this);_this.getValueCount=_this.getValueCount.bind(_this);_this.loadingFunc=_this.loadingFunc.bind(_this);_this.openModal=_this.openModal.bind(_this);_this.closeModal=_this.closeModal.bind(_this);return _this;}_createClass(Participation,[{key:'updateDimensions',value:function updateDimensions(){var updateWidth=document.getElementById("chart").offsetWidth;this.setState({width:updateWidth});}},{key:'openModal',value:function openModal(){this.setState({modalIsOpen:true});}},{key:'closeModal',value:function closeModal(){this.setState({modalIsOpen:false});}},{key:'loadingFunc',value:function loadingFunc(loading){if(loading){this.setState({loading:true},function(){this.openModal();});}else{this.setState({loading:false},function(){this.closeModal();});}}},{key:'getStats',value:function getStats(){var _this2=this;__WEBPACK_IMPORTED_MODULE_1_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_2__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'info',table:'thankyous',action:'participation'}}).then(function(response){var data=response.data.data;var sender=data[0].sender/data[0].user_count*100;var recipient=data[0].receiver/data[0].user_count*100;_this2.setState({totalParticipation:sender,totalRecipient:recipient,totalThankyous:data[0].total,year:data[0].year});_this2.getData(data[0].total);});}},{key:'getData',value:function getData(total){var _this3=this;__WEBPACK_IMPORTED_MODULE_1_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_2__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'info',table:'thankyous',action:'department'}}).then(function(response){var data=response.data.data;var departments=[];var percentage=void 0;data.forEach(function(dataSeg){percentage=(dataSeg.total/total*100).toFixed(2);departments.push({title:dataSeg.department+" ("+percentage+"%)",value:dataSeg.total,label:dataSeg.department});});_this3.setState({data:departments});_this3.loadingFunc(false);}).catch(function(e){return console.log("getDATA",e);});}},{key:'getValueCount',value:function getValueCount(){var _this4=this;__WEBPACK_IMPORTED_MODULE_1_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_2__routes_js__["c" /* path */],data:{endpoint:'info',table:'thankyous',action:'value_count'}}).then(function(response){var value_data=[];var total=response.data.data[0].total;var percent=void 0;var valueLabel=void 0;var colorOptions=["#FF6262","#B88AE6","#2EB8B8","#66C266","#E9967A","#747400","#B8008A","#6666ff"];response.data.data.forEach(function(values,i){if(values.count!==0){percent=(values.count/total*100).toFixed(2);value_data.push({label:values.virtue,title:values.virtue+" ("+percent+"%)",value:values.count,color:colorOptions[i]});}});_this4.setState({value_data:value_data});});}},{key:'componentDidMount',value:function componentDidMount(){this.loadingFunc(true);this.getStats();this.updateDimensions();this.getValueCount();}},{key:'render',value:function render(){var _this5=this;var customStyles={content:{top:'50%',left:'50%',right:'auto',bottom:'auto',maxWidth:'400px',minWidth:'300px',width:'100%',borderStyle:'solid',backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_6__asset_img_sparkles2_png___default.a+')',borderWidth:'2px',borderColor:'gray',transform:'translate(-50%, -50%)',boxShadow:'0.5px 0.5px 1px 0.5px'},overlay:{backgroundColor:'rgba(105,105,105,0.8)'}};var content=void 0;var participation=Number(this.state.totalParticipation).toFixed(2);var recipient=Number(this.state.totalRecipient).toFixed(2);var divStyle={display:'inline-block'//,width:'100%',height:'100%'};
};if(this.props.active){divStyle={display:'inline-block',width:'100%',height:'100%',minWidth:'700px',maxWidth:'1020px'};var data_Meta={"Accounting":{"color":'#0000CD',"parentDepartment":null},"ASM North":{"color":'#008080',"parentDepartment":"RSD"},"ASM South":{"color":'#F5FFFA',"parentDepartment":"RSD"},"ASM West":{"color":'#8FBC8F',"parentDepartment":"RSD"},"Atlanta DC":{"color":'#FF8C00',"parentDepartment":'Operations'},"B.U. Americas":{"color":'#FF3A3A',"parentDepartment":null},"Business Development":{"color":'#00FF00',"parentDepartment":'Miscellaneous'},"C.o.E":{"color":'#FFF8DC',"parentDepartment":'Miscellaneous'},"Chicago DC":{"color":'#9400D3',"parentDepartment":'Operations'},"CNC":{"color":'#F0E68C',"parentDepartment":'Operations'},"Customer Experience":{"color":'#E9967A',"parentDepartment":'Customer Experience'},"Dallas DC":{"color":'#808080',"parentDepartment":'Operations'},"Engineering":{"color":'#B0C4DE',"parentDepartment":'Engineering'},"EXCOM":{"color":'#8D5D93',"parentDepartment":'EXCOM'},"Fabrication":{"color":'#B22222',"parentDepartment":'Operations'},"Human Resources":{"color":'#48D1CC',"parentDepartment":null},"Inside Sales":{"color":'#CD5C5C',"parentDepartment":'Customer Experience'},"Irvine DC":{"color":'#8B4513',"parentDepartment":'Operations'},"IT":{"color":'#8B0000',"parentDepartment":null},"Machine Department":{"color":'#FFA500',"parentDepartment":'Engineering'},"Miscellaneous":{"color":'#ed00a2',"parentDepartment":'Miscellaneous'},"MSM":{"color":'#87CEEB',"parentDepartment":'RSD'},"Operations":{"color":'#FF69B4',"parentDepartment":'Operations'},"Product Management":{"color":'#DEB887',"parentDepartment":'Product Management'},"Production":{"color":'#f442e2',"parentDepartment":'Operations'},"Production Planning":{"color":'#CD853F',"parentDepartment":'Operations'},"Project Execution":{"color":'#8D5D93',"parentDepartment":'EXCOM'},"Quality Control":{"color":'#FDF5E6',"parentDepartment":'Operations'},"RSD":{"color":'#81EF91',"parentDepartment":'RSD'},"Sales":{"color":'#008000',"parentDepartment":null},"Sales Services":{"color":'#ADD8E6',"parentDepartment":'Product Management'},"SAP":{"color":'#FF0000',"parentDepartment":'Miscellaneous'},"Strategic Marketing":{"color":'#7CFC00',"parentDepartment":'Miscellaneous'},"Supply Chain":{"color":'#F0F8FF',"parentDepartment":'Operations'},"Tech Service":{"color":'#F4A460',"parentDepartment":'Customer Experience'},"Valve Assembly":{"color":'#2F4F4F',"parentDepartment":'Operations'},"Marine":{"color":'#660066',"parentDepartment":null}};var chartData=[];var orderChart=[];this.state.data.forEach(function(e,i){var newData=e;console.log(e);newData['color']=data_Meta[e.label].color;if(data_Meta[newData.label]===undefined){var missingEntryIndex=orderChart.indexOf(newData.label);if(missingEntryIndex!==-1){chartData[missingEntryIndex].value+=newData.value;}else{orderChart.push(newData.label);chartData.push(newData);}}else{if(data_Meta[newData.label].parentDepartment===null){orderChart.push(newData.label);chartData.push(newData);}else{var parentDepartmentIndex=orderChart.indexOf(data_Meta[newData.label].parentDepartment);if(parentDepartmentIndex!==-1){var departmentCount=chartData[parentDepartmentIndex].value;chartData[parentDepartmentIndex].value+=newData.value;}else{var parentDepartment=data_Meta[newData.label].parentDepartment;orderChart.push(parentDepartment);chartData.push({title:parentDepartment,value:newData.value,color:data_Meta[parentDepartment].color,label:parentDepartment});}}}});var config=[];var legend=void 0;chartData=chartData.filter(function(item){return item.value!==0;});chartData.forEach(function(item){var percentage=(item.value/_this5.state.totalThankyous*100).toFixed(2);config.push({color:item.color});if(item.title.indexOf("(")===-1){item.title=item.title+" ("+percentage+"%)";}});var chartContent=void 0;var buttonTabOneStyle="ba b blueButton br3 br--left bg-white dark-blue bw1 b--dark-blue";var buttonTabTwoStyle="ba b blueButton br3 br--right bg-white dark-blue bw1 b--dark-blue";var defaultLabelStyle={fontSize:'4px',fontFamily:'sans-serif',fontWeight:'bold'};if(this.state.participation){buttonTabOneStyle="blueButton ba b br3 br--left bg-dark-blue white bw1 b--dark-blue";chartContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'tc mt0'},'Total Participation for ',this.state.year,': ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'red'},participation),'% (Sender) ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'red'},recipient),'% (Recipient) ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'red'},this.state.totalThankyous),' (Total Thank yous)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 cf'},legend,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 tc cf chart-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PieCanvas,{data:chartData}))));}else{buttonTabTwoStyle="blueButton ba b br3 br--right bg-dark-blue white bw1 b--dark-blue";chartContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 cf'},legend,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 tc cf chart-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PieCanvas,{data:this.state.value_data})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-25 cf absolute',style:{maxWidth:'385px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.state.dataDisplay?this.state.dataDisplay:''))));}content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 cf'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tc pb4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:buttonTabOneStyle,id:'buttonTabOne',onClick:function onClick(){_this5.setState({participation:true});}},'Departments'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:buttonTabTwoStyle,id:'buttonTabTwo',onClick:function onClick(){_this5.setState({participation:false});}},'Values')),chartContent,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_modal___default.a,{isOpen:this.state.modalIsOpen,style:customStyles,contentLabel:'loading',shouldCloseOnOverlayClick:false,shouldCloseOnEsc:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tc',style:{width:'150px',margin:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4__asset_img_loader_gif___default.a,alt:'Loading'})))));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:divStyle,id:'chart'},content);}}]);return Participation;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Participation);var CustomLabel=function CustomLabel(props){//need to figure out padding and actual background color
var textDY=props.dy;if(navigator.userAgent.indexOf('MSIE')>-1||navigator.appVersion.indexOf('Trident/')>-1){textDY+=1;}var theid="text_"+props.dataIndex;var thehref="#"+theid;var circleX=props.x+props.dx;var circleY=props.y+props.dy;circleY=circleY<0?circleY+0.4:circleY-0.4;var textDX=props.dx>0?props.dx+3:props.dx-3;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle',{cx:circleX,cy:circleY,r:'2',fill:props.color}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{id:theid,textAnchor:props.textAnchor,alignmentBaseline:'middle',fill:'black',x:props.x,y:props.y,dx:textDX,dy:textDY,style:props.style},props.data[props.dataIndex].label+" ("+props.data[props.dataIndex].value+")"));};var PieCanvas=function(_Component2){_inherits(PieCanvas,_Component2);function PieCanvas(props){_classCallCheck(this,PieCanvas);var _this6=_possibleConstructorReturn(this,(PieCanvas.__proto__||Object.getPrototypeOf(PieCanvas)).call(this,props));_this6.canvas=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this6.ctx=null;_this6.state={dataLoaded:false};return _this6;}_createClass(PieCanvas,[{key:'componentDidMount',value:function componentDidMount(){this.ctx=this.canvas.current.getContext("2d");if(this.props.data.length!==0){this.setState({dataLoaded:true});this.drawChart();}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(this.state.dataLoaded===false&&this.props.data.length!==0&&this.props.data!==prevProps.data){this.setState({dataLoaded:true});this.drawChart();}}},{key:'drawChart',value:function drawChart(){var _this7=this;var total=0;var newData=[];this.props.data.forEach(function(data){total+=data.value;newData.push(Object.assign({},data,{percent:0.00}));});newData.sort(function(a,b){return b.value-a.value;});for(var i=0,j=newData.length-1;i<j&&j>i;i++,j--){if(i%2!==0){var temp=newData[i];newData[i]=newData[j];newData[j]=temp;}}console.log(newData);var center_x=this.canvas.current.width/2;var center_y=this.canvas.current.height/2;var radius=this.canvas.current.height/2-30;var percent=void 0,endPoint=0,startingPoint=0,medianPoint=void 0,offset_x=void 0,offset_y=void 0,x=void 0,y=void 0,xIsGreaterThan=void 0;newData.forEach(function(data){percent=data.value/total;data.percent=percent*100;startingPoint=endPoint;endPoint=endPoint+percent*Math.PI*2;medianPoint=(startingPoint+endPoint)/2;data['midArcCoords']={_x:center_x+Math.cos(medianPoint)*radius,_y:center_y+Math.sin(medianPoint)*radius};_this7.ctx.beginPath();_this7.ctx.fillStyle=data.color;_this7.ctx.moveTo(center_x,center_y);_this7.ctx.strokeStyle="#555555";_this7.ctx.arc(center_x,center_y,radius,startingPoint,endPoint);_this7.ctx.fill();_this7.ctx.lineTo(center_x,center_y);_this7.ctx.lineWidth=0.5;_this7.ctx.strokeStyle="#f4f4f4";_this7.ctx.stroke();_this7.ctx.beginPath();_this7.ctx.lineWidth=1;_this7.ctx.strokeStyle="#000000";_this7.ctx.moveTo(data.midArcCoords._x,data.midArcCoords._y);offset_y=data.midArcCoords._y+Math.sin(medianPoint)*20;_this7.ctx.lineTo(data.midArcCoords._x+Math.cos(medianPoint)*20,offset_y);_this7.ctx.stroke();xIsGreaterThan=data.midArcCoords._x>center_x;offset_x=xIsGreaterThan?data.midArcCoords._x+40:data.midArcCoords._x-40;_this7.ctx.lineTo(offset_x,offset_y);_this7.ctx.stroke();_this7.ctx.font="bold 16px Arial";_this7.ctx.textAlign=xIsGreaterThan?"left":"end";//this.ctx.fillStyle = "#000000";
_this7.ctx.fillText(data.label+" ("+data.value+")",xIsGreaterThan?offset_x+5:offset_x-5,offset_y);});console.log(newData);}},{key:'render',value:function render(){//console.log(this.props.data);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('canvas',{ref:this.canvas,height:'460',width:'1000'});}}]);return PieCanvas;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(exports, __webpack_require__(0), __webpack_require__(7)) :
  typeof define === 'function' && define.amd ? define(['exports', 'react', 'prop-types'], factory) :
  (global = global || self, factory(global.ReactMinimalPieChart = {}, global.React, global.PropTypes));
}(this, function (exports, React, PropTypes) { 'use strict';

  var React__default = 'default' in React ? React['default'] : React;
  PropTypes = PropTypes && PropTypes.hasOwnProperty('default') ? PropTypes['default'] : PropTypes;

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
  }

  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  var PI = Math.PI;
  function degreesToRadians(degrees) {
    return degrees * PI / 180;
  }
  function evaluateViewBoxSize(ratio, baseSize) {
    // Wide ratio
    if (ratio > 1) {
      return "0 0 " + baseSize + " " + baseSize / ratio;
    } // Narrow/squared ratio


    return "0 0 " + baseSize * ratio + " " + baseSize;
  }
  function evaluateLabelTextAnchor(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        labelPosition = _ref.labelPosition,
        lineWidth = _ref.lineWidth,
        labelHorizontalShift = _ref.labelHorizontalShift;

    // Label in the vertical center
    if (labelHorizontalShift === 0) {
      return 'middle';
    } // Outward label


    if (labelPosition > 100) {
      return labelHorizontalShift > 0 ? 'start' : 'end';
    } // Inward label


    var innerRadius = 100 - lineWidth;

    if (labelPosition < innerRadius) {
      return labelHorizontalShift > 0 ? 'end' : 'start';
    } // Overlying label


    return 'middle';
  }
  function valueBetween(value, min, max) {
    if (value > max) return max;
    if (value < min) return min;
    return value;
  }
  function extractPercentage(value, percentage) {
    return value * percentage / 100;
  }

  var partialCircle = function partialCircle(cx, cy, r, start, end) {
    var length = end - start;
    if (length === 0) return [];
    var fromX = r * Math.cos(start) + cx;
    var fromY = r * Math.sin(start) + cy;
    var toX = r * Math.cos(end) + cx;
    var toY = r * Math.sin(end) + cy;
    var large = Math.abs(length) <= Math.PI ? '0' : '1';
    var sweep = length < 0 ? '0' : '1';
    return [['M', fromX, fromY], ['A', r, r, 0, large, sweep, toX, toY]];
  };

  function makePathCommands(cx, cy, startAngle, lengthAngle, radius) {
    var patchedLengthAngle = valueBetween(lengthAngle, -359.999, 359.999);
    return partialCircle(cx, cy, // center X and Y
    radius, degreesToRadians(startAngle), degreesToRadians(startAngle + patchedLengthAngle)).map(function (command) {
      return command.join(' ');
    }).join(' ');
  }

  function ReactMinimalPieChartPath(_ref) {
    var cx = _ref.cx,
        cy = _ref.cy,
        startAngle = _ref.startAngle,
        lengthAngle = _ref.lengthAngle,
        radius = _ref.radius,
        lineWidth = _ref.lineWidth,
        reveal = _ref.reveal,
        title = _ref.title,
        props = _objectWithoutPropertiesLoose(_ref, ["cx", "cy", "startAngle", "lengthAngle", "radius", "lineWidth", "reveal", "title"]);

    var actualRadio = radius - lineWidth / 2;
    var pathCommands = makePathCommands(cx, cy, startAngle, lengthAngle, actualRadio);
    var strokeDasharray;
    var strokeDashoffset; // Animate/hide paths with "stroke-dasharray" + "stroke-dashoffset"
    // https://css-tricks.com/svg-line-animation-works/

    if (typeof reveal === 'number') {
      strokeDasharray = degreesToRadians(actualRadio) * Math.abs(lengthAngle);
      strokeDashoffset = strokeDasharray + extractPercentage(strokeDasharray, reveal);
    }

    return React__default.createElement("path", _extends({
      d: pathCommands,
      strokeWidth: lineWidth,
      strokeDasharray: strokeDasharray,
      strokeDashoffset: strokeDashoffset
    }, props), title && React__default.createElement("title", null, title));
  }
  ReactMinimalPieChartPath.displayName = 'ReactMinimalPieChartPath';
  ReactMinimalPieChartPath.propTypes = {
    cx: PropTypes.number.isRequired,
    cy: PropTypes.number.isRequired,
    startAngle: PropTypes.number,
    lengthAngle: PropTypes.number,
    radius: PropTypes.number,
    lineWidth: PropTypes.number,
    reveal: PropTypes.number,
    title: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  };
  ReactMinimalPieChartPath.defaultProps = {
    startAngle: 0,
    lengthAngle: 0,
    lineWidth: 100,
    radius: 100
  };

  var dataPropType = PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    value: PropTypes.number.isRequired,
    key: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    color: PropTypes.string
  }));
  var stylePropType = PropTypes.objectOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string]));

  function ReactMinimalPieChartLabel(_ref) {
    var data = _ref.data,
        dataIndex = _ref.dataIndex,
        color = _ref.color,
        props = _objectWithoutPropertiesLoose(_ref, ["data", "dataIndex", "color"]);

    return React__default.createElement("text", _extends({
      textAnchor: "middle",
      alignmentBaseline: "middle",
      fill: color
    }, props));
  }
  ReactMinimalPieChartLabel.displayName = 'ReactMinimalPieChartLabel';
  ReactMinimalPieChartLabel.propTypes = {
    data: dataPropType,
    dataIndex: PropTypes.number,
    color: PropTypes.string
  };

  var VIEWBOX_SIZE = 100;
  var VIEWBOX_HALF_SIZE = VIEWBOX_SIZE / 2;

  function sumValues(data) {
    return data.reduce(function (acc, dataEntry) {
      return acc + dataEntry.value;
    }, 0);
  } // Append "percentage", "degrees" and "startOffset" into each data entry


  if (typeof Math.sign === 'undefined') {
    Math.sign = function (x) {
      return x > 0 ? 1 : x < 0 ? -1 : x;
    };
  }

  function extendData(_ref) {
    var data = _ref.data,
        totalAngle = _ref.lengthAngle,
        totalValue = _ref.totalValue,
        paddingAngle = _ref.paddingAngle;
    var total = totalValue || sumValues(data);
    var normalizedTotalAngle = valueBetween(totalAngle, -360, 360);
    var numberOfPaddings = Math.abs(normalizedTotalAngle) === 360 ? data.length : data.length - 1;
    var degreesTakenByPadding = Math.abs(paddingAngle) * numberOfPaddings * Math.sign(normalizedTotalAngle);
    var singlePaddingDegrees = degreesTakenByPadding / numberOfPaddings;
    var degreesTakenByPaths = normalizedTotalAngle - degreesTakenByPadding;
    var lastSegmentEnd = 0;
    return data.map(function (dataEntry) {
      var valueInPercentage = dataEntry.value / total * 100;
      var degrees = extractPercentage(degreesTakenByPaths, valueInPercentage);
      var startOffset = lastSegmentEnd;
      lastSegmentEnd = lastSegmentEnd + degrees + singlePaddingDegrees;
      return _extends({
        percentage: valueInPercentage,
        degrees: degrees,
        startOffset: startOffset
      }, dataEntry);
    });
  }

  function makeSegmentTransitionStyle(duration, easing, furtherStyles) {
    if (furtherStyles === void 0) {
      furtherStyles = {};
    }

    // Merge CSS transition necessary for chart animation with the ones provided by "segmentsStyle"
    var transition = ["stroke-dashoffset " + duration + "ms " + easing, furtherStyles.transition].filter(Boolean).join(',');
    return {
      transition: transition
    };
  }

  function renderLabelItem(option, props, value) {
    if (React__default.isValidElement(option)) {
      return React__default.cloneElement(option, props);
    }

    var label = value;

    if (typeof option === 'function') {
      label = option(props);

      if (React__default.isValidElement(label)) {
        return label;
      }
    }

    return React__default.createElement(ReactMinimalPieChartLabel, props, label);
  }

  function renderLabels(data, props) {
    var labelPosition = extractPercentage(props.radius, props.labelPosition);
    var labels = data.map(function (dataEntry, index) {
      var startAngle = props.startAngle + dataEntry.startOffset;
      var halfAngle = startAngle + dataEntry.degrees / 2;
      var halfAngleRadians = degreesToRadians(halfAngle);
      var dx = Math.cos(halfAngleRadians) * labelPosition;
      var dy = Math.sin(halfAngleRadians) * labelPosition; // This object is passed as props to the "label" component

      var labelProps = {
        key: "label-" + (dataEntry.key || index),
        x: props.cx,
        y: props.cy,
        dx: dx,
        dy: dy,
        textAnchor: evaluateLabelTextAnchor({
          lineWidth: props.lineWidth,
          labelPosition: props.labelPosition,
          labelHorizontalShift: dx
        }),
        data: data,
        dataIndex: index,
        color: dataEntry.color,
        style: props.labelStyle
      };
      return {
        label: props.label,
        props: labelProps,
        value: dataEntry.value
      };
    });

    for (var i = 0; i < labels.length; i++) {
      var previousIndex = i == 0 ? labels.length - 1 : i - 1;

      while (Math.abs(Math.abs(labels[previousIndex].props.dy) - Math.abs(labels[i].props.dy)) < 4) {
        if (labels[previousIndex].props.dy > labels[i].props.dy) {
          labels[i].props.dy -= 0.15;
        } else {
          labels[i].props.dy += 0.15;
        }
      }
    }

    return labels.map(function (label) {
      return renderLabelItem(label.label, label.props, label.value);
    });
  }

  function renderSegments(data, props, hide) {
    var style = props.segmentsStyle;
    var reveal;

    if (props.animate) {
      var transitionStyle = makeSegmentTransitionStyle(props.animationDuration, props.animationEasing, style);
      style = Object.assign({}, style, transitionStyle);
    } // Hide/reveal the segment?


    if (hide === true) {
      reveal = 0;
    } else if (typeof props.reveal === 'number') {
      reveal = props.reveal;
    } else if (hide === false) {
      reveal = 100;
    }

    return data.map(function (dataEntry, index) {
      var startAngle = props.startAngle + dataEntry.startOffset;
      return React__default.createElement(ReactMinimalPieChartPath, {
        key: dataEntry.key || index,
        cx: props.cx,
        cy: props.cy,
        startAngle: startAngle,
        lengthAngle: dataEntry.degrees,
        radius: props.radius,
        lineWidth: extractPercentage(props.radius, props.lineWidth),
        reveal: reveal,
        title: dataEntry.title,
        style: style,
        stroke: dataEntry.color,
        strokeLinecap: props.rounded ? 'round' : undefined,
        fill: "none",
        onMouseOver: props.onMouseOver && function (e) {
          return props.onMouseOver(e, props.data, index);
        },
        onMouseOut: props.onMouseOut && function (e) {
          return props.onMouseOut(e, props.data, index);
        },
        onClick: props.onClick && function (e) {
          return props.onClick(e, props.data, index);
        }
      });
    });
  }

  var ReactMinimalPieChart =
  /*#__PURE__*/
  function (_Component) {
    _inheritsLoose(ReactMinimalPieChart, _Component);

    function ReactMinimalPieChart(props) {
      var _this;

      _this = _Component.call(this, props) || this;

      if (_this.props.animate === true) {
        _this.hideSegments = true;
      }

      return _this;
    }

    var _proto = ReactMinimalPieChart.prototype;

    _proto.componentDidMount = function componentDidMount() {
      var _this2 = this;

      if (this.props.animate === true && requestAnimationFrame) {
        this.initialAnimationTimerId = setTimeout(function () {
          _this2.initialAnimationTimerId = null;
          _this2.initialAnimationRAFId = requestAnimationFrame(function () {
            _this2.initialAnimationRAFId = null, _this2.startAnimation();
          });
        });
      }
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      if (this.initialAnimationTimerId) {
        clearTimeout(this.initialAnimationTimerId);
      }

      if (this.initialAnimationRAFId) {
        cancelAnimationFrame(this.initialAnimationRAFId);
      }
    };

    _proto.startAnimation = function startAnimation() {
      this.hideSegments = false;
      this.forceUpdate();
    };

    _proto.render = function render() {
      if (this.props.data === undefined) {
        return null;
      }

      var extendedData = extendData(this.props);
      return React__default.createElement("div", {
        className: this.props.className,
        style: this.props.style
      }, React__default.createElement("svg", {
        viewBox: evaluateViewBoxSize(this.props.ratio, VIEWBOX_SIZE),
        width: "100%",
        height: "100%",
        style: {
          display: 'block'
        }
      }, renderSegments(extendedData, this.props, this.hideSegments), this.props.label && renderLabels(extendedData, this.props), this.props.injectSvg && this.props.injectSvg()), this.props.children);
    };

    return ReactMinimalPieChart;
  }(React.Component);
  ReactMinimalPieChart.displayName = 'ReactMinimalPieChart';
  ReactMinimalPieChart.propTypes = {
    data: dataPropType,
    cx: PropTypes.number,
    cy: PropTypes.number,
    ratio: PropTypes.number,
    totalValue: PropTypes.number,
    className: PropTypes.string,
    style: stylePropType,
    segmentsStyle: stylePropType,
    startAngle: PropTypes.number,
    lengthAngle: PropTypes.number,
    paddingAngle: PropTypes.number,
    lineWidth: PropTypes.number,
    radius: PropTypes.number,
    rounded: PropTypes.bool,
    animate: PropTypes.bool,
    animationDuration: PropTypes.number,
    animationEasing: PropTypes.string,
    reveal: PropTypes.number,
    children: PropTypes.node,
    injectSvg: PropTypes.func,
    label: PropTypes.oneOfType([PropTypes.func, PropTypes.element, PropTypes.bool]),
    labelPosition: PropTypes.number,
    labelStyle: stylePropType,
    onMouseOver: PropTypes.func,
    onMouseOut: PropTypes.func,
    onClick: PropTypes.func
  };
  ReactMinimalPieChart.defaultProps = {
    cx: VIEWBOX_HALF_SIZE,
    cy: VIEWBOX_HALF_SIZE,
    ratio: 1,
    startAngle: 0,
    lengthAngle: 360,
    paddingAngle: 0,
    lineWidth: 100,
    radius: VIEWBOX_HALF_SIZE,
    rounded: false,
    animate: false,
    animationDuration: 500,
    animationEasing: 'ease-out',
    label: false,
    labelPosition: 50,
    onMouseOver: undefined,
    onMouseOut: undefined,
    onClick: undefined
  };

  exports.default = ReactMinimalPieChart;

  Object.defineProperty(exports, '__esModule', { value: true });

}));
//# sourceMappingURL=index.js.map


/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__asset_img_loader_gif__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__asset_img_loader_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__asset_img_loader_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_modal__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__asset_img_sparkles2_png__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__asset_img_sparkles2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__asset_img_sparkles2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Validation_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__component_Searchable_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__component_Input_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__component_Select_js__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MassEmail=function(_Component){_inherits(MassEmail,_Component);function MassEmail(props){_classCallCheck(this,MassEmail);var _this=_possibleConstructorReturn(this,(MassEmail.__proto__||Object.getPrototypeOf(MassEmail)).call(this,props));_this.state={from:'Julie Malizia',from_email:'Julie.Malizia@georgfischer.com',searchFromVal:'Julie Malizia',subject:'',message:'',to:["All active employees"],searchToVal:'',employees:[],loading:false,modalIsOpen:false,from_edit:false,to_edit:false,response_message:'',virtues:[],virtue:'Select'};_this.closeModal=_this.closeModal.bind(_this);_this.handleInput=_this.handleInput.bind(_this);_this.validateFields=_this.validateFields.bind(_this);_this.sendEmail=_this.sendEmail.bind(_this);_this.fromEdit=_this.fromEdit.bind(_this);_this.toEdit=_this.toEdit.bind(_this);_this.toFocusOut=_this.toFocusOut.bind(_this);_this.handleFromSearch=_this.handleFromSearch.bind(_this);_this.handleFromSelect=_this.handleFromSelect.bind(_this);_this.handleToSearch=_this.handleToSearch.bind(_this);_this.handleToSelect=_this.handleToSelect.bind(_this);_this.fromFocusOut=_this.fromFocusOut.bind(_this);_this.removeContact=_this.removeContact.bind(_this);return _this;}_createClass(MassEmail,[{key:'closeModal',value:function closeModal(){this.setState({modalIsOpen:false});}},{key:'handleInput',value:function handleInput(identity,value){//standard method to handle user input
var theState={};if(identity==="message"&&this.props.type==="thankyou"&&value.length>450){theState['response_message']="Message length exceeded. Character limit is 450.";theState['modalIsOpen']=true;}else{theState[identity]=value;}this.setState(theState);}},{key:'handleFromSearch',value:function handleFromSearch(value){var from_object=this.state.employees.filter(function(employee){return employee.name.toLowerCase()===value.toLowerCase();})[0];var _from='';var from_email='';if(from_object){_from=from_object.name;from_email=from_object.email;}this.setState({searchFromVal:value,from:_from,from_email:from_email});}},{key:'handleFromSelect',value:function handleFromSelect(value){var from_email=this.state.employees.filter(function(employee){return employee.name.toLowerCase()===value.toLowerCase();})[0].email;this.setState({from:value,from_email:from_email,searchFromVal:value,from_edit:false});}},{key:'fromEdit',value:function fromEdit(){this.setState({from_edit:true});}},{key:'fromFocusOut',value:function fromFocusOut(event,ref){var _this2=this;if(this.state.from_edit&&event.target.id!=="mass_email_from_edit"){ref.setState({has_focus:false},function(){var theState={from_edit:false};if(_this2.state.searchFromVal&&_this2.state.from.toLowerCase()!==_this2.state.searchFromVal.toLowerCase()){theState['searchFromVal']='';}_this2.setState(theState);});}}},{key:'handleToSearch',value:function handleToSearch(value){var to_array=[].concat(_toConsumableArray(this.state.to));this.setState({searchToVal:value});}},{key:'handleToSelect',value:function handleToSelect(value){var theState={searchToVal:''};if(this.state.to.indexOf(value)===-1){var bool=this.state.to.length===1&&this.state.to[0]==="All active employees";theState['to']=bool?[value]:[].concat(_toConsumableArray(this.state.to),[value]);}this.setState(theState);document.getElementById("to_mass_email").focus();}},{key:'toEdit',value:function toEdit(){this.setState({to_edit:true});}},{key:'toFocusOut',value:function toFocusOut(event,ref){var _this3=this;var shouldFocusOut=this.state.to_edit&&event.target.id!=="mass_email_to_edit"&&event.target.className!=="search_list_item"&&event.target.className!=="remove_from_list";if(shouldFocusOut){ref.setState({has_focus:false},function(){_this3.setState({to_edit:false});});}}},{key:'removeContact',value:function removeContact(e){var newArray=[].concat(_toConsumableArray(this.state.to));var index=Number(e.target.getAttribute("name"));newArray.splice(index,1);this.setState({to:newArray});document.getElementById("to_mass_email").focus();}},{key:'validateFields',value:function validateFields(){var _state=this.state,subject=_state.subject,message=_state.message,to=_state.to,virtue=_state.virtue;var _from=this.state.from;var response_message="",valid=true;var subject_input=void 0,virtue_select=void 0;if(this.props.type==="email"){subject_input=document.getElementById("mass_email_subject_container");subject_input.style.borderColor="#777777";}else{virtue_select=document.getElementsByClassName("virtue_select")[0];virtue_select.style.borderColor="#777777";}var to_container=document.getElementById("to_container");var from_container=document.getElementById("from_container");var message_input=document.getElementById("mass_email_textarea");message_input.style.borderColor="#777777";if(_from.trim()!==''&&message.trim()!==''&&to.length>0){if(this.props.type==="email"&&(subject.trim()===''||!Object(__WEBPACK_IMPORTED_MODULE_6__Validation_js__["a" /* default */])('reason',subject))){subject_input.style.borderColor="red";valid=false;response_message=subject.trim()===''?"Subject is a required field. ":"Subject contains invalid characters. ";}else if(this.props.type==="thankyou"&&virtue==='Select'){virtue_select.style.borderColor="red";response_message+="Value is a required field. ";}if(!Object(__WEBPACK_IMPORTED_MODULE_6__Validation_js__["a" /* default */])('reason',message)){message_input.style.borderColor="red";response_message+="Message contains invalid characters.";valid=false;}}else{response_message="All fields are required.";valid=false;if(to.length<1){to_container.style.borderColor="red";}if(_from.trim()===''){from_container.style.borderColor="red";}if(this.props.type==="email"&&subject.trim()===''){subject_input.style.borderColor="red";}else if(this.props.type==="thankyou"&&virtue==='Select'){virtue_select.style.borderColor="red";}if(message.trim()===''){message_input.style.borderColor="red";}this.setState({response_message:response_message});}return valid;}},{key:'sendEmail',value:function sendEmail(){var _this4=this;this.setState({loading:true,modalIsOpen:true});if(this.validateFields()){var data={'message':this.state.message,'from':{name:this.state.from,email:this.state.from_email},'to':this.state.to};if(this.props.type==="email"){data['action']='mass_email';data['subject']=this.state.subject;}else{data['action']='mass_thankyou';data['virtue']=this.state.virtue;}__WEBPACK_IMPORTED_MODULE_1_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_2__routes_js__["b" /* mail */],data:data}).then(function(response){_this4.setState({response_message:response.data.message,loading:false,from:'Julie Malizia',from_email:'Julie.Malizia@georgfischer.com',searchFromVal:'Julie Malizia',subject:'',message:'',searchToVal:'',virtue:'Select',to:["All active employees"]});}).catch(function(error){_this4.setState({loading:false,response_message:"There was a problem sending the email."});});}else{this.setState({loading:false});}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){if(prevState.from_edit!==this.state.from_edit&&this.state.from_edit){document.getElementById("from_mass_email").focus();}if(prevState.to_edit!==this.state.to_edit&&this.state.to_edit){document.getElementById("to_mass_email").focus();}}},{key:'componentDidMount',value:function componentDidMount(){var _this5=this;__WEBPACK_IMPORTED_MODULE_1_axios___default()({//retrieve all users
method:'post',url:__WEBPACK_IMPORTED_MODULE_2__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'info',table:'users',action:"view"}}).then(function(response){var employees=[];var data=response.data.data;data.forEach(function(employee){employees.push(employee);});_this5.setState({employees:employees});});if(this.props.type==="thankyou"){__WEBPACK_IMPORTED_MODULE_1_axios___default()({//retrieve lov values 
method:'post',url:__WEBPACK_IMPORTED_MODULE_2__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{"endpoint":'info',table:'virtues'}}).then(function(response){var virtues=[];var data=response.data.data;data.forEach(function(virtue){virtues.push(virtue.virtue);});_this5.setState({virtues:virtues});});}}},{key:'render',value:function render(){var _this6=this;var customStyles={content:{top:'50%',left:'50%',right:'auto',bottom:'auto',width:'400px',minWidth:'300px',height:'200px',minHeight:'200px',borderStyle:'solid',borderWidth:'2px',borderColor:'gray',transform:'translate(-50%, -50%)',backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_5__asset_img_sparkles2_png___default.a+')',backgroundRepeat:'no-repeat',backgroundSize:'300px 200px',backgroundPosition:'right',boxShadow:'0.5px 0.5px 1px 0.5px'},overlay:{backgroundColor:'rgba(105,105,105,0.8)'}};var searchableStyles={input:{border:'none',height:'32px',width:'200px',paddingLeft:'10px'},list:{listStyleType:'none',backgroundColor:'white',width:'100%',maxHeight:'200px',overflowY:'auto',margin:'0',paddingLeft:'0'}};var selectStyles="hh2 w-100 br2 bw1 truncate";var content=void 0;var modalContent=void 0;if(this.state.loading){//display loading gif
modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tc',style:{width:'150px',margin:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__asset_img_loader_gif___default.a,alt:'Loading'}));}else{//display success message
modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 tr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'bg-white gray b br3',onClick:this.closeModal},'X')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 tc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'b navy f3'},this.state.response_message)));}if(this.props.active){var employeeOptions=this.state.employees.map(function(employee,i){//get all employees for dropdown menu options
return employee.name;});var to_employeeOptions=["All active employees"].concat(_toConsumableArray(employeeOptions));var from_field=void 0,from_edit_button=void 0;if(this.state.from_edit){from_field=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__component_Searchable_js__["a" /* default */],{containerId:'from_mass_email_container',inputId:'from_mass_email',placeholder:'Search or Select',style:searchableStyles,listItemClass:'search_list_item',caseSensitive:false,value:this.state.searchFromVal,options:employeeOptions,handleSelect:this.handleFromSelect,handleChange:this.handleFromSearch,onFocusOut:this.fromFocusOut});}else{from_edit_button=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'mass_email_edit',id:'mass_email_from_edit',onClick:this.fromEdit},'+\xA0Edit');var _from_=this.state.from?this.state.from+';':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\xA0');from_field=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:'from_field'},_from_);}var to_fields=void 0,to_search_field=void 0,to_edit_button=void 0;if(this.state.to_edit){to_search_field=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__component_Searchable_js__["a" /* default */],{containerId:'to_mass_email_container',inputId:'to_mass_email',placeholder:'Search or Select',style:searchableStyles,listItemClass:'search_list_item',caseSensitive:false,value:this.state.searchToVal,options:to_employeeOptions,handleSelect:this.handleToSelect,handleChange:this.handleToSearch,onFocusOut:this.toFocusOut});to_fields=this.state.to.map(function(employee,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:i,className:'to_edit_span_container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'to_edit_span',key:i},employee),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'remove_from_list',name:i,onClick:_this6.removeContact},'X'));});}else{to_edit_button=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'mass_email_edit',id:'mass_email_to_edit',onClick:this.toEdit},'+\xA0Edit');to_fields=this.state.to.map(function(employee,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'to_field',key:i,name:i},employee,';');});if(to_fields.length<1){to_fields=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'to_placeholder'},'\xA0');}}var _dynamic_label=void 0,_dynamic_component=void 0;if(this.props.type==="email"){_dynamic_label="Subject:";_dynamic_component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__component_Input_js__["a" /* default */],{id:'mass_email_subject',identity:'subject',onInput:this.handleInput,inputStyle:'pa2 br2 w-100',val:this.state.subject});}else{var _selectStyles="h2 pa1 w-25-ns w-40-m w-100 br2 truncate ml1 virtue_select";_dynamic_label="Value:";_dynamic_component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__component_Select_js__["a" /* default */],{identity:'virtue',options:this.state.virtues,onSelect:this.handleInput,styles:_selectStyles,val:this.state.virtue});}var _title=this.props.type==="email"?"Mass Email":"Mass Thank You";content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'b navy f3 ma0 pb3'},_title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'br2 pa3 bg-white shadow-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'from_container',className:'pb2 email_input_container w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dib'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'tl b navy pl1'},'From:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'required'},'*'))),from_field,from_edit_button),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'to_container',className:'pb2 pt2 w-100 email_input_container w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dib'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'tl b navy pl1'},'To:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'required'},'*'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'to_flex_container'},to_fields,to_search_field),to_edit_button),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'mass_email_subject_container',className:'pb2 pt2 w-100 email_input_container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dib'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'tl b navy pl1'},_dynamic_label,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'required'},'*'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dib w-100'},_dynamic_component)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__component_Input_js__["a" /* default */],{id:'mass_email_textarea',identity:'message',type:'area',onInput:this.handleInput,styles:'pa2 w-100-ns w-100',val:this.state.message,placeholder:'message'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pt4',style:{width:'128px',margin:'auto',paddingBottom:'5px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'shadow-3',id:'send_mass_email',onClick:this.sendEmail},'Send Email')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_modal___default.a,{isOpen:this.state.modalIsOpen,style:customStyles,contentLabel:'Mass Email Modal',shouldCloseOnOverlayClick:false,shouldCloseOnEsc:false},modalContent));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,content);}}]);return MassEmail;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (MassEmail);

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__asset_img_sparkles2_png__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__asset_img_sparkles2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__asset_img_sparkles2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AppChoice=function(_Component){_inherits(AppChoice,_Component);function AppChoice(props){_classCallCheck(this,AppChoice);var _this=_possibleConstructorReturn(this,(AppChoice.__proto__||Object.getPrototypeOf(AppChoice)).call(this,props));_this.handleClick=_this.handleClick.bind(_this);return _this;}_createClass(AppChoice,[{key:'handleClick',value:function handleClick(e){//method to pass up the app which has been chosen
var identity=e.currentTarget.name;this.props.handleStateUpdate('app',identity);}},{key:'render',value:function render(){var buttonStyles={backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_1__asset_img_sparkles2_png___default.a+')',minHeight:'150px',maxWidth:'700px',margin:'auto',backgroundColor:'white'};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{maxWidth:'700px',margin:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 mv3 pa2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'fl w-100 f2 b dark-blue shadow-3 br3',style:buttonStyles,name:'lov',onClick:this.handleClick},'Living Our Values')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 mv3 pa2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'fl w-100 f2 b dark-blue shadow-3 br3',style:buttonStyles,name:'asm',onClick:this.handleClick},'GF Promotional Orders')));}}]);return AppChoice;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AppChoice);AppChoice.propTypes={handleStateUpdate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component_Input_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__component_Submit_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_modal__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RecoverPassword_js__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ResetPassword_js__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SetUserLogin_js__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__routes_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__asset_img_loader_gif__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__asset_img_loader_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__asset_img_loader_gif__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//page that asks for user email and emails them their current password
//page that allows user to reset their password
//page that promps user for security information on first login
__WEBPACK_IMPORTED_MODULE_4_react_modal___default.a.setAppElement('#root');//provide anchor div for react-modal (required)
var LoginPage=function(_Component){_inherits(LoginPage,_Component);function LoginPage(props){_classCallCheck(this,LoginPage);var _this=_possibleConstructorReturn(this,(LoginPage.__proto__||Object.getPrototypeOf(LoginPage)).call(this,props));_this.state={success:false,modalIsOpen:false,email:'',password:'',recover:false,reset:false,userInfo:'',firstLogin:false,failPrompt:'',loading:false,ack:false};_this.loginAttempt=_this.loginAttempt.bind(_this);_this.handleInput=_this.handleInput.bind(_this);_this.recoverPass=_this.recoverPass.bind(_this);_this.resetPass=_this.resetPass.bind(_this);_this.firstLogin=_this.firstLogin.bind(_this);_this.openModal=_this.openModal.bind(_this);_this.closeModal=_this.closeModal.bind(_this);_this.enterButtonListener=_this.enterButtonListener.bind(_this);_this.welcomeBackAck=_this.welcomeBackAck.bind(_this);return _this;}_createClass(LoginPage,[{key:'resetPass',value:function resetPass(){//method to display ResetPassword page in modal
this.setState({reset:true,recover:false,failPrompt:''},function(){this.openModal();});}},{key:'recoverPass',value:function recoverPass(){//method to display RecoverPassword page in modal
this.setState({recover:true,reset:false,failPrompt:''},function(){this.openModal();});}},{key:'firstLogin',value:function firstLogin(){//method to display SetUserLogin page in modal (only on first user login)
this.setState({firstLogin:true},function(){this.openModal();});}},{key:'handleInput',value:function handleInput(identity,value){//standard method for handling user input
var theState={};theState[identity]=value;this.setState(theState);}},{key:'enterButtonListener',value:function enterButtonListener(e){if(e.keyCode==13){this.loginAttempt();}}},{key:'loginAttempt',value:function loginAttempt(){var _this2=this;//method for handling user login
this.setState({loading:true,modalIsOpen:true});__WEBPACK_IMPORTED_MODULE_3_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_8__routes_js__["a" /* loginPath */],//data:{"endpoint":"info","table":"users","action":"login","kind":this.state.password,"name":this.state.email}
data:{"action":"login","password":this.state.password,"email":this.state.email// headers:{"Content-Type":"application/json"}
}}).then(function(response){console.log(response);var info=response.data.data;if(info.Message==="success"){//login is a success, pass up userinfo 
_this2.setState({success:true,userType:info.user_type,failPrompt:'',loading:false,modalIsOpen:false},function(){this.props.onLogin(this.state.success,{email:this.state.email,name:info.name,userType:info.user_type,department:info.department,userID:info.userID,redeemable:info.redeemable,budget:info.budget});});}else if(info.Message==="first"){//display SetUserLogin page and pass up userinfo
_this2.setState({userInfo:{email:_this2.state.email,name:info.name,userType:info.user_type,department:info.department,userID:info.userID,redeemable:info.redeemable,budget:info.budget},failPrompt:'',loading:false},function(){this.firstLogin();});}else{//login attempt failed
_this2.setState({failPrompt:info.Message,loading:false,modalIsOpen:false});}}).catch(function(err){//login failed due to connection
console.log(err);if(!err.response||err.message==='Network Error'){_this2.setState({failPrompt:'Connection timed out. Please ensure you are on the GF Network.',loading:false,modalIsOpen:false});}else{_this2.setState({failPrompt:'An error has occured. Please try again later or contact an admin.',loading:false,modalIsOpen:false});}});}},{key:'componentDidMount',value:function componentDidMount(){var _this3=this;if(window.location.search){var token=new URLSearchParams(window.location.search).get('token');if(token){window.history.replaceState({},'',window.location.pathname);this.setState({loading:true,modalIsOpen:true});__WEBPACK_IMPORTED_MODULE_3_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_8__routes_js__["a" /* loginPath */],data:{"action":"account","token":token}}).then(function(response){var info=response.data.data;if(info.Message==="first"){_this3.setState({userInfo:{email:info.email,name:info.name,userType:info.user_type,department:info.department,userID:info.userID,redeemable:info.redeemable,budget:info.budget},failPrompt:'',loading:false},function(){this.firstLogin();});}else{//attempt failed
_this3.setState({failPrompt:info.Message,loading:false,modalIsOpen:false});}}).catch(function(err){//attempt failed due to connection
console.log(err);if(!err.response||err.message==='Network Error'){_this3.setState({failPrompt:'Connection timed out. Please ensure you are on the GF Network.',loading:false,modalIsOpen:false});}else{_this3.setState({failPrompt:'An error has occured. Please try again later or contact an admin.',loading:false,modalIsOpen:false});}});}else{// Check disclaimer
var stored=localStorage.getItem('welcome-back');if(!(stored==='acknowledged')){this.setState({ack:true},function(){this.openModal();});}}}else{// Check disclaimer
var _stored=localStorage.getItem('welcome-back');if(!(_stored==='acknowledged')){this.setState({ack:true},function(){this.openModal();});}}}},{key:'welcomeBackAck',value:function welcomeBackAck(){localStorage.setItem('welcome-back','acknowledged');}},{key:'openModal',value:function openModal(){//method to open the modal
this.setState({modalIsOpen:true});}},{key:'closeModal',value:function closeModal(){//method to close the modal
this.setState({modalIsOpen:false,recover:false,reset:false,firstLogin:false});}},{key:'render',value:function render(){var _this4=this;var customStyles={content:{top:'50%',left:'50%',right:'auto',bottom:'auto',width:'100%',minHeight:'225px',maxWidth:'800px',transform:'translate(-50%, -50%)',backgroundColor:'white',backgroundBack:'transparent',opacity:1,background:'transparent',boxShadow:'0.5px 0.5px 1px 0.5px'},overlay:{backgroundColor:'rgba(105,105,105,0.8)'}};var inputStyles="hh3 pl1 pr3 br2 bw1 w-100 shadow-3 tc ";var modalContent=void 0;if(!this.state.loading){if(this.state.recover){//display RecoverPassword component
modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 tr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'bg-white gray b br3',onClick:this.closeModal},'X')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__RecoverPassword_js__["a" /* default */],null));}else if(this.state.reset){//display ResetPassword component
modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 tr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'bg-white gray b br3',onClick:this.closeModal},'X')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ResetPassword_js__["a" /* default */],null));}else if(this.state.firstLogin){//display SetUserLogin component
modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 tr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'bg-white gray b br3',onClick:this.closeModal},'X')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__SetUserLogin_js__["a" /* default */],{success:this.props.onLogin,pass:this.state.password,info:this.state.userInfo,close:this.closeModal}));}else if(this.state.ack){modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 tr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'bg-white gray b br3',onClick:function onClick(){_this4.welcomeBackAck();_this4.closeModal();}},'X')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'mt0 gf dark-blue'},'Welcome Back!'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{lineHeight:'1.8',fontSize:'1.2rem'}},'Welcome back to Living Our Values! If this is your first time back since the application has been back online, please click the ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',className:'blue no-underline underline-hover',onClick:function onClick(){_this4.welcomeBackAck();_this4.recoverPass();}},'Recover Account'),' link below the login button. Once you provide your account email address, you will receive an email with a link that allows for you to reset your security information.')));}}else{//display loading gif
customStyles.content.maxWidth='400px';customStyles.content.minHeight='100px';modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tc',style:{width:'150px',margin:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_9__asset_img_loader_gif___default.a,alt:'Loading'}));}var promptStyle={fontSize:'.8em'};var prompt=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'mt0 mb0 pa0',style:promptStyle},'\xA0');if(this.state.failPrompt!==''){//display error message
prompt=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'red mt0 mb0 pa0',style:promptStyle},'*',this.state.failPrompt);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'center pb3 bg-white mt5 mb5 w-40-ns w-50-m w-80',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'dark-blue tc mb0'},'USER LOGIN')),prompt,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tc mt3 w-100 mb3 mt0',style:{minHeight:'45px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_Input_js__["a" /* default */],{identity:'email',inputStyle:inputStyles,placeholder:'email@georgfischer.com',onInput:this.handleInput})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tc mv3 w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_Input_js__["a" /* default */],{identity:'password',id:'password',onKeyDown:this.enterButtonListener,inputStyle:inputStyles,placeholder:'Password',onInput:this.handleInput,type:'password'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pb3 center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__component_Submit_js__["a" /* default */],{name:'Login',styles:'br3 white b grow hh3 bg-blue w-100',onClick:this.loginAttempt}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 mv2 mb2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',className:'fl f7 blue fl-w30 no-underline underline-hover',onClick:this.resetPass},'Reset password'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',className:'fr f7 blue fl-w70 no-underline underline-hover',onClick:this.recoverPass},'Recover Account'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_modal___default.a,{isOpen:this.state.modalIsOpen,onRequestClose:this.closeModal,shouldCloseOnOverlayClick:false,shouldCloseOnEsc:false,style:customStyles,contentLabel:'Reset/Recover password'},modalContent));}}]);return LoginPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (LoginPage);

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component_Input_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routes_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Validation_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__asset_img_loader_gif__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__asset_img_loader_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__asset_img_loader_gif__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RecoverPassword=function(_Component){_inherits(RecoverPassword,_Component);function RecoverPassword(props){_classCallCheck(this,RecoverPassword);var _this=_possibleConstructorReturn(this,(RecoverPassword.__proto__||Object.getPrototypeOf(RecoverPassword)).call(this,props));_this.onSubmit=_this.onSubmit.bind(_this);_this.handleInput=_this.handleInput.bind(_this);_this.state={email:'',validEmail:true,emailSent:false,loading:false,failPrompt:''};return _this;}_createClass(RecoverPassword,[{key:'handleInput',value:function handleInput(identity,value){//standard method for handling user input
var theState={};theState[identity]=value;this.setState(theState);}},{key:'onSubmit',value:function onSubmit(){var _this2=this;//method that handles sending the user their account recovery link
if(Object(__WEBPACK_IMPORTED_MODULE_4__Validation_js__["a" /* default */])("email",this.state.email)){//validate input field, make sure it is an email address
this.setState({loading:true});__WEBPACK_IMPORTED_MODULE_2_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_3__routes_js__["a" /* loginPath */],headers:{'Content-Type':'application/json'},data:{action:'recover',email:this.state.email.toLowerCase()}}).then(function(response){var data=response.data.data;_this2.setState({emailSent:true,loading:false,failPrompt:''});}).catch(function(err){console.log(err);if(!err.response||err.message==='Network Error'){_this2.setState({failPrompt:'Connection timed out. Please ensure you are on the GF Network.',loading:false});}else{_this2.setState({failPrompt:'An error has occured. Please try again later or contact an admin.',loading:false});}_this2.setState({loading:false});});}else{this.setState({failPrompt:'Not a valid email address.',validEmail:false});}}},{key:'render',value:function render(){var invalid=void 0;var inputStyles="h2 mb2 pl3 br2 bw1 w-100 shadow-3";inputStyles=this.state.validEmail?inputStyles+"  b--light-silver":inputStyles+"  b--red";invalid=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'red'},this.state.failPrompt);var labelStyles="fl w-100 tl b navy f5 mt3";var inputDiv="fl w-100 tl pt2";var content=void 0;if(this.state.loading){content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tc',style:{width:'150px',margin:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5__asset_img_loader_gif___default.a,alt:'Loading'}));}else if(!this.state.emailSent){//display the email input field
content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'b navy f3 tc pa0 ma0'},'Recover Account')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:labelStyles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Account Email:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'red'},'*',invalid))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:inputDiv},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_Input_js__["a" /* default */],{identity:'email',inputStyle:inputStyles,onInput:this.handleInput,placeholder:'email@georgfischer.com'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 tc mt3 mb3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'fc w-50-ns w-100 br3 pv2 f5 shadow-3 bg-navy white',onClick:this.onSubmit},'Submit')));}else{//display message
content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'f3 underline tc navy center'},'Email Sent!'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'b navy f4 tc'},'You should soon receive an email regarding your account.'));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{maxWidth:'100%',margin:'auto'}},content));}}]);return RecoverPassword;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (RecoverPassword);

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component_Input_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routes_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__component_Select_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Validation_js__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//used for validation
var ResetPassword=function(_Component){_inherits(ResetPassword,_Component);function ResetPassword(props){_classCallCheck(this,ResetPassword);var _this=_possibleConstructorReturn(this,(ResetPassword.__proto__||Object.getPrototypeOf(ResetPassword)).call(this,props));_this.getQuestion=_this.getQuestion.bind(_this);//this.getQuestionList = this.getQuestionList.bind(this);
_this.handleInput=_this.handleInput.bind(_this);_this.afterSubmit=_this.afterSubmit.bind(_this);_this.onSubmit=_this.onSubmit.bind(_this);_this.state={email:'',password:'',newPass:'',confirm:'',answer:'',question:'',questions:[],invalid:true,confirmed:false,reset:'',prompt:'',first:false};return _this;}_createClass(ResetPassword,[{key:'handleInput',value:function handleInput(identity,value){//standard method for handling user input
var theState={};theState[identity]=value;this.setState(theState);}},{key:'getQuestionList',value:function getQuestionList(){var _this2=this;//method for retrieving security questions
__WEBPACK_IMPORTED_MODULE_2_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_3__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'info',table:'question'}}).then(function(response){var data=response.data.data;var questions=data.map(function(questions){return questions.Question;});_this2.setState({question:data[0].Question,questions:questions});});}},{key:'getQuestion',value:function getQuestion(){var _this3=this;//method that retrieves the users security question
__WEBPACK_IMPORTED_MODULE_2_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_3__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'info',table:'users',action:'question',name:this.state.email.toLowerCase(),kind:this.state.password}}).then(function(response){var data=response.data.data;if(data[0].Message!=="invalid"){if(data[0].Question===null){_this3.getQuestionList();}else{_this3.setState({question:data[0].Question});}if(_this3.state.invalid){_this3.setState({invalid:false,prompt:''});}}});}// componentDidMount(){
// 	this.getQuestionList();
// }
},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){if(this.state.email.trim()!==''&&this.state.password.trim()!==''&&this.state.invalid&&prevState.email===this.state.email&&prevState.password===this.state.password&&prevState.newPass!==this.state.newPass){//attempt to retrieve the user's security question if they have filled out their email and password
this.getQuestion();}if(this.state.confirm.trim()!==''&&this.state.newPass.trim()===this.state.confirm.trim()&&!this.state.confirmed){//confirm password matches new password
this.setState({confirmed:true});}else if(this.state.confirm.trim()!==''&&this.state.newPass.trim()!==this.state.confirm.trim()&&this.state.confirmed){//confirm password does not match new password
this.setState({confirmed:false});}}},{key:'afterSubmit',value:function afterSubmit(message){var _this4=this;//method that displays error message
if(message==="failed"){setTimeout(function(){_this4.setState({password:'',newPass:'',confirm:'',answer:'',invalid:true,confirmed:false,reset:'',prompt:'The information provided is incorrect.'});},3000);}}},{key:'onSubmit',value:function onSubmit(){var _this5=this;//method for submitting information, including user's new password
var _state=this.state,email=_state.email,password=_state.password,newPass=_state.newPass,answer=_state.answer,confirmed=_state.confirmed,first=_state.first,question=_state.question;var data=void 0;if(email.trim()!==''&&newPass.trim()!==''&&confirmed){//if all fields are filled out and the user has confirmed their new password, continue
//&& answer.trim() !== ''
if(!this.state.first){//if the user has logged in before and is resetting their password
data={endpoint:'create',table:'users',misc:'password',email:email.trim(),answer:answer.trim().toLowerCase(),status:newPass,name:password,desc:question};}else{//if the user has not logged in before and is resetting their password
data={endpoint:'create',table:'users',misc:'password_first',email:email.trim(),answer:answer.trim().toLowerCase(),status:newPass,name:password,desc:question};}__WEBPACK_IMPORTED_MODULE_2_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_3__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:data}).then(function(response){var data=response.data.data;_this5.setState({reset:data.Message});_this5.afterSubmit(data.Message);});}else{//set error message
this.setState({prompt:'All fields are required'});}}},{key:'render',value:function render(){var content=void 0;var questioncontent=void 0;var inputStyles="h2 pl3 br2 bw1 w-100 shadow-3 b--light-silver";var labelStyles="fl w-100 tl pr4-ns b navy f5 mt3";var inputDiv="fl w-100 tl pt2";var outerDiv="mb5 pb3";var confirmStyle=inputStyles;var confirmSpan=void 0;if(this.state.confirm.trim()!==''&&!this.state.confirmed){//red if new password not confirmed
confirmStyle="h2 pl3 br2 bw1 w-100 shadow-3 b--red";confirmSpan=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'red'},' *');}else if(this.state.confirmed){//green if new password is confirmed
confirmStyle="h2 pl3 br2 bw1 w-100 shadow-3 b--green";confirmSpan=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'green'},' *');}var prompt=void 0;if(this.state.prompt!==''){prompt="*"+this.state.prompt;}if(!this.state.first){//if user has logged in before, display their chosen security question and prompt them for the answer
if(this.state.question!==''){questioncontent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:outerDiv},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:labelStyles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Security Question:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 tl pt1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'f5 b'},this.state.question),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_Input_js__["a" /* default */],{identity:'answer',inputStyle:inputStyles,onInput:this.handleInput})));// questioncontent = <div className={outerDiv}>
// 									<div>
// 										<div className={labelStyles}>
// 											<label>Security Question:</label>
// 										</div>
// 										<div>
// 											<SelectBox identity="question" options={this.state.questions} styles={inputStyles} onSelect={this.handleInput} />
// 										</div>
// 									</div>
// 										<div className={labelStyles}>
// 											<label>Security Answer:</label>
// 										</div>
// 										<div className="fl w-100 tl pt1">
// 											<Input identity="answer" inputStyle={inputStyles} onInput={this.handleInput}/>
// 										</div>
// 								</div>;
}}else{//if user has not logged in before, prompt them to choose a security question and to enter an answer for it
questioncontent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:outerDiv},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:labelStyles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Security Question (choose one):')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__component_Select_js__["a" /* default */],{identity:'question',options:this.state.questions,styles:inputStyles,onSelect:this.handleInput}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:labelStyles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Security Answer:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 tl pt1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_Input_js__["a" /* default */],{identity:'answer',inputStyle:inputStyles,onInput:this.handleInput})));}if(this.state.reset==="success"){//display success message
content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'f3 b navy tc'},'Your password has successfully been changed!'));}else if(this.state.reset==="failed"){//display error message
content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'f3 b navy tc'},'Password reset has failed. Please try again.'));}else{//display input fields
content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{minHeight:'350px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'b navy f3 tc pa0 ma0'},'Reset Password')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:outerDiv},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:labelStyles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Email: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'red'},prompt))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:inputDiv},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_Input_js__["a" /* default */],{identity:'email',inputStyle:inputStyles,onInput:this.handleInput,val:this.state.email}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:outerDiv},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:labelStyles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Password:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:inputDiv},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_Input_js__["a" /* default */],{identity:'password',inputStyle:inputStyles,onInput:this.handleInput,type:'password'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:outerDiv},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:labelStyles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'New Password:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:inputDiv},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_Input_js__["a" /* default */],{identity:'newPass',inputStyle:inputStyles,onInput:this.handleInput,type:'password'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:outerDiv},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:labelStyles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Confirm Password: ',confirmSpan)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:inputDiv},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_Input_js__["a" /* default */],{identity:'confirm',inputStyle:confirmStyle,onInput:this.handleInput,type:'password'}))),questioncontent,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 tc mt3 mb3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'fc w-40-ns w-100 br3 h2 shadow-3 bg-navy white',onClick:this.onSubmit},'Submit')));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{maxWidth:'100%',margin:'auto'}},content);}}]);return ResetPassword;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ResetPassword);

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component_Input_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__component_Select_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__routes_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Validation_js__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//used for validation
var SetUserLogin=function(_Component){_inherits(SetUserLogin,_Component);function SetUserLogin(props){_classCallCheck(this,SetUserLogin);var _this=_possibleConstructorReturn(this,(SetUserLogin.__proto__||Object.getPrototypeOf(SetUserLogin)).call(this,props));_this.handleInput=_this.handleInput.bind(_this);_this.onSubmit=_this.onSubmit.bind(_this);_this.state={questions:[],password:'',question:'',answer:'',confirm:'',confirmed:true,prompt:''};return _this;}_createClass(SetUserLogin,[{key:'handleInput',value:function handleInput(identity,value){//standard method for handling user input
var theState={};theState[identity]=value;this.setState(theState);}},{key:'componentDidMount',value:function componentDidMount(){var _this2=this;//when component mounts, retrieve list of security questions
__WEBPACK_IMPORTED_MODULE_3_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_4__routes_js__["c" /* path */],headers:{'Content-Type':'application/json'},data:{endpoint:'info',table:'question'}}).then(function(response){var data=response.data.data;_this2.setState({questions:data});_this2.setState({question:data[0].Question,password:'@#^$%!&*',confirm:''});});}},{key:'componentDidUpdate',value:function componentDidUpdate(){if(!this.state.confirmed&&this.state.password.trim()!==''&&this.state.password===this.state.confirm){//if confirm password field is the same as password field
this.setState({confirmed:true});}else if(this.state.confirmed&&this.state.password!==this.state.confirm){//if confirm password field is NOT the same as password field
this.setState({confirmed:false});}}},{key:'onSubmit',value:function onSubmit(){var _this3=this;//method for submitting updated security information for new user
var _state=this.state,questions=_state.questions,password=_state.password,question=_state.question,answer=_state.answer,confirm=_state.confirm,confirmed=_state.confirmed;if(password.trim()!==''&&question.trim()!==''&&answer.trim()!==''&&confirmed&&password.trim()===confirm.trim()&&Object(__WEBPACK_IMPORTED_MODULE_5__Validation_js__["a" /* default */])("pword",password.trim())){//if all input fields are filled out and contain valid input, continue
var qID=void 0;questions.filter(function(secquestions){//get the Id for the selected security question
if(question===secquestions.Question){qID=secquestions.Id;return;}});var info=this.props.info;__WEBPACK_IMPORTED_MODULE_3_axios___default()({method:'post',url:__WEBPACK_IMPORTED_MODULE_4__routes_js__["a" /* loginPath */],headers:{'Content-Type':'application/json'},//data:{endpoint:'create',table:'users',misc:'security',status:password.trim(),answer:answer.trim().toLowerCase(),firstID:info.userID,secondID:qID}
data:{action:'security',password:password.trim(),answer:answer.trim().toLowerCase(),firstID:info.userID,secondID:qID}}).then(function(response){console.log(response);var data=response.data.data;if(data.Message==="success"){_this3.props.success(true,info);_this3.props.close();}}).catch(function(err){return console.log(err);});}else{//set error message if any fields are blank or contain invalid input
this.setState({prompt:"Please fill out all fields correctly."});}}},{key:'render',value:function render(){var secQuestions=this.state.questions.map(function(questions){return questions.Question;});var selectStyles="h2 pa1 br2 bw1 truncate w-100 shadow-3";var inputStyles="h2 pl3 br2 bw1 w-100 shadow-3 b--light-silver";var labelStyles="fl w-100 tl pr4-ns b navy f5 mt3";var inputDiv="fl w-100 tl pt2";var outerDiv="mb5 pb3";var confirmStyle=inputStyles;var confirmSpan=void 0;var prompt=void 0;if(this.state.prompt!==''){prompt=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'red'},'*',this.state.prompt);}if(this.state.confirm.trim()!==''&&!this.state.confirmed){//highlight red if confirm password field does not equal the password field
confirmStyle="h2 pl3 br2 bw1 w-100 shadow-3 b--red";confirmSpan=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'red'},' *');}else if(this.state.confirmed){//highlight green if confirm password field equals the password field
confirmStyle="h2 pl3 br2 bw1 w-100 shadow-3 b--green";confirmSpan=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'green'},' *');}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'90%',margin:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'f3 b navy tc'},'Security Information'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:outerDiv},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:labelStyles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'New Password: ',prompt)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:inputDiv},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_Input_js__["a" /* default */],{identity:'password',inputStyle:inputStyles,onInput:this.handleInput,type:'password'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:outerDiv},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:labelStyles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Confirm Password:',confirmSpan)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:inputDiv},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_Input_js__["a" /* default */],{identity:'confirm',inputStyle:confirmStyle,onInput:this.handleInput,type:'password'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:outerDiv},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:labelStyles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Security Question:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:inputDiv},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__component_Select_js__["a" /* default */],{identity:'question',onSelect:this.handleInput,options:secQuestions,styles:selectStyles,val:this.state.question}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:outerDiv},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:labelStyles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Security Answer:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:inputDiv},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_Input_js__["a" /* default */],{identity:'answer',inputStyle:inputStyles,onInput:this.handleInput}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl w-100 tc mt3 mb3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'fc w-40-ns w-100 br3 h2 shadow-3 bg-navy white',onClick:this.onSubmit},'Submit')));}}]);return SetUserLogin;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SetUserLogin);

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL(".",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl="."+'/service-worker.js';if(isLocalhost){// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);// Add some additional logging to localhost, pointing developers to the
// service worker/PWA documentation.
navigator.serviceWorker.ready.then(function(){console.log('This web app is being served cache-first by a service '+'worker. To learn more, visit https://goo.gl/SC7cgQ');});}else{// Is not local host. Just register service worker
registerValidSW(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.bd428331.js